(function() {
  window._satellite = window._satellite || {};
  window._satellite.container = {
  "buildInfo": {
    "buildDate": "2023-12-06T13:25:09Z",
    "turbineBuildDate": "2023-02-22T20:37:26Z",
    "turbineVersion": "27.5.0"
  },
  "environment": {
    "id": "EN56faa038b9414b08a00619fd9413b372",
    "stage": "production"
  },
  "dataElements": {
    "ACDL | Qualtrics": {
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
try {
  var _prevpage = _satellite.getVar('Rule | qpv'),
    items = _satellite.getVar('Trans Qualtrics'),
    qTrans = _satellite.getVar('Trans CXDB'),
    _products = '',
    _quickpick = '',
    _totalAmount = '',
    _productName = '',
    _odds = '',
    _sport = '',
    _event = '',
    itemsArray = [],
    _url = _satellite.getVar('Content | url'),
    _site = _satellite.getVar('Content | Site');
  function resetPro() {
    _products = _productName = '';
    itemsArray.push(_products, _quickpick, _totalAmount, _productName, _odds, _sport);
  }

  if (_url == '/casino' || _url == '/casino/live' || _url == '/poker' || _url == '/livecasino' || _url == '/slots') {
    var _regextmat = new RegExp('^(?!.*(live))/casino/.*');
    if (_prevpage != undefined && _prevpage != '') {
      if (_prevpage.includes('live&provider=') && _url == '/casino/live') {
        _products += 'Live Casino';
        _productName += 'Live Casino';
        itemsArray.push(_products, _productName, '', '', _prevpage);
        return itemsArray;
      } else if (_regextmat.test(_prevpage) && _url == '/casino') {
        _products += 'Casino';
        _productName += 'Casino';
        itemsArray.push(_products, _productName, '', '', _prevpage);
        return itemsArray;
      } else if (_prevpage.includes('/spela') && _prevpage.includes('live') && _url == '/livecasino' && _site == 'momang') {
        _products += 'Momang';
        _productName += 'Momang Live Casino';
        itemsArray.push(_products, _productName, '', '', _prevpage);
        return itemsArray;
      } else if (_prevpage.includes('/spela') && _prevpage.includes('slots') && _url == '/slots' && _site == 'momang') {
        _products += 'Momang';
        _productName += 'Momang Casino';
        itemsArray.push(_products, _productName, '', '', _prevpage);
        return itemsArray;
      }
    }
  }
  if (items == undefined || items != undefined) {
    if (items != undefined && items != '') {
      for (var i = 0; i < items.length; i++) {
      if (i > 0) {
        (_products += '|'), (_quickpick += '|'),(_totalAmount += '|'), (_odds += '|'), (_sport += '|'), (_event += '|');
      }
      _products += items[i].productName;
      _odds += ((items[i].details.odds) ? items[i].details.odds : "");
      _sport += ((items[i].details.sport) ? items[i].details.sport : "");
      _event += ((items[i].details.event) ? items[i].details.event : "");
        if(qTrans.totalAmount) {
          _totalAmount = qTrans.totalAmount;
        } else if (items[i].price) {
          _totalAmount += items[i].price;
        } else {
          _totalAmount = '';
        }
        if(items[i].details.quickpick == 'WEIGHTEDQP'){
  _quickpick = 'weightedqp';
} else if(items[i].details.quickpick == 'MODIFIEDQP'){
  _quickpick = 'modifiedqp';
} else if(items[i].details.quickpick == 'PARTIALQP'){
  _quickpick = 'partialqp';
} else if(items[i].details.quickpick == '2' || items[i].details.quickpick == 2){
      _quickpick = 'weightedqp';
} else {
      _quickpick = 'no Pix';
 }
    }

      if (_products.includes('Topptipset Stryktipset') && _url.includes('/topptipset/relaterat') && _prevpage.includes('transfer')) {
        _productName += 'Stryktipset';
        _totalAmount = '';
      } else if (_products.includes('Topptipset')) {
        _productName += 'Topptipset';
      } else if (_products.includes('Stryktipset')) {
        _productName += 'Stryktipset';
      } else if (_products.includes('Europatipset')) {
        _productName += 'Europatipset';
      } else if (_products.includes('Fullträff')) {
        _productName += 'Fullträff';
      } else if (_products.includes('Måltipset')) {
        _productName += 'Måltipset';
      } else if (_products.includes('Trav & Galopp') && _url.includes('high-five')) {
        _productName += 'Trav och galopp';
        _products += ' High Five';
      } else if (_products.includes('Trav & Galopp')) {
        _productName += 'Trav och galopp';
      } else if (_products.includes('Oddset')) {
        _productName += 'Oddset';
      } else if (_products.includes('Challenge')) {
        _productName += 'Challenge';
      } else if (_products.includes('Powerplay')) {
        _productName += 'Powerplay';
      } else if (_products.includes('Bomben')) {
        _productName += 'Bomben';
      } else if (_products.includes('Matchen')) {
        _productName += 'Matchen';
      } else if (_products.includes('Bingo')) {
        _productName += 'Bingo';
      } 
      itemsArray.push(_products, _quickpick, _totalAmount, _productName, _odds, _sport, _event);
      return itemsArray;
    }

    if (_url == '/mina-spel') {
      if (_prevpage == '/bingo' || _prevpage.includes('casino') || (_regextmatch.test(_prevpage) == false && _productName == '')) {
        resetPro();
        return itemsArray;
      }
    }
    if (_url != '/bingo') {
      if (_productName == 'Bingo' || (!_url.includes('mina-spel') && !_url.includes('andelsspel') && _url != "" && _productName == '')) {
        resetPro();
        return itemsArray;
      }
    }
    if (_url == '/bingo' && !_prevpage.includes('bingo')) {
      resetPro();
      return itemsArray;
    }
  }
} catch (e) {}
}
      }
    },
    "tips sm XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event28": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar28": "%Event | Action%",
                  "eVar29": "%Event | Label%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            },
            "productInteraction": {
              "TipsSM": {
                "label": "%Event | Label%",
                "action": "%Event | Action%",
                "interactionEvent": 1
              }
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "ACDL | Consent | Personalized Browser": {
      "defaultValue": "",
      "storageDuration": "pageview",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "data.consent.personalizedBrowser"
      }
    },
    "Event | Action": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.action"
      }
    },
    "ACDL | Consent | QualtricsOk": {
      "defaultValue": "",
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.consent.QualtricsOk"
      }
    },
    "User | DevId": {
      "storageDuration": "pageview",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
  function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
  }
  var _data = adobeDataLayer.getState(),
    _dev = _data.data.user.devId, 
    _acon = _data.data.consent.analyticsBrowser,
    _pcon = _data.data.consent.personalizedBrowser,
    _pccon = _data.data.consent.personalizedCustomer,
    _gendevtoec = getCookie("gendevtoec"); 
  if (_dev != "" && _dev != undefined) {
    if (_acon == true && _pcon == true) { 
      if (_pccon != false) {
        if (_gendevtoec === null) {
          document.cookie = 'gendevtoec=' + _dev + ';path=/;domain=' + window.location.hostname;
          _satellite.setVar("newFpid", _dev);
          return _dev;
        } else {
          _satellite.setVar("newFpid", _gendevtoec);
          return _gendevtoec;
        }
      }
    }
  } else if (_gendevtoec !== null) {
    _satellite.setVar("newFpid", _gendevtoec);
    return _gendevtoec;
  }
} catch (e) {}
}
      }
    },
    "betslip complete XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event22": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar18": "%betslipType|evar18%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            },
            "productInteraction": {
              "betslipType": "%betslipType|evar18%",
              "betslipComplete": 1
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Content | utm_medium": {
      "storageDuration": "pageview",
      "modulePath": "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js",
      "settings": {
        "delimiter": "",
        "urlToCheck": "",
        "queryStringParameters": "utm_medium"
      }
    },
    "targetPayloadView XDM": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event101to200": {
                "event102": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar18": "%Event | Label%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            },
            "decisioning": {
              "propositions": "%Target | payloadview%"
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "pageview XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "pageViews": {
                "value": 1
              },
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar22": "%Content | refs%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level2%",
                  "prop2": "%Rule | PreviousValue%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "domainName": "%ACDL | Content | Domain Name%",
              "formFactor": "%Content | Form Factor%",
              "customReferrer": "%Content | ref%",
              "previousPageName": "%Rule | PreviousValue%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            },
            "privacyPreferences": "%Rule | privacyPreferences%"
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Variable event": {
      "modulePath": "adobe-alloy/dist/lib/dataElements/variable/index.js",
      "settings": {
        "cacheId": "4550a55d-b2bd-4e53-a37c-d97327c695ec"
      }
    },
    "CXDB | listed url": {
      "defaultValue": "false",
      "modulePath": "mapping-table/src/lib/dataElements/mappingTable.js",
      "settings": {
        "0": {
          "input": "/stryktipset",
          "method": "starts with",
          "output": "true"
        },
        "1": {
          "input": "/stryktipset/relaterat",
          "method": "starts with",
          "output": "true"
        },
        "2": {
          "input": "/stryktipset/mina-spel2",
          "method": "starts with",
          "output": "true"
        },
        "3": {
          "input": "/europatipset",
          "method": "starts with",
          "output": "true"
        },
        "4": {
          "input": "/europatipset/relaterat",
          "method": "starts with",
          "output": "true"
        },
        "5": {
          "input": "/mina-spel",
          "method": "starts with",
          "output": "true"
        },
        "6": {
          "input": "/fulltraff",
          "method": "starts with",
          "output": "true"
        },
        "7": {
          "input": "/fulltraff/relaterat",
          "method": "starts with",
          "output": "true"
        },
        "8": {
          "input": "/fulltraff/mina-spel",
          "method": "starts with",
          "output": "true"
        },
        "9": {
          "input": "/topptipset",
          "method": "starts with",
          "output": "true"
        },
        "10": {
          "input": "/topptipset/relaterat",
          "method": "starts with",
          "output": "true"
        },
        "11": {
          "input": "/topptipset/mina-spel2",
          "method": "starts with",
          "output": "true"
        },
        "12": {
          "input": "/maltipset",
          "method": "starts with",
          "output": "true"
        },
        "13": {
          "input": "/maltipset?flik=relaterat",
          "method": "starts with",
          "output": "true"
        },
        "14": {
          "input": "/trav-och-galopp/spela/",
          "method": "starts with",
          "output": "true"
        },
        "15": {
          "input": "/trav-och-galopp/spela/xyz",
          "method": "starts with",
          "output": "true"
        },
        "16": {
          "input": "/odds",
          "method": "starts with",
          "output": "true"
        },
        "17": {
          "input": "/odds/sports",
          "method": "starts with",
          "output": "true"
        },
        "18": {
          "input": "/challenge/spela",
          "method": "starts with",
          "output": "true"
        },
        "19": {
          "input": "/powerplay",
          "method": "starts with",
          "output": "true"
        },
        "20": {
          "input": "/powerplay/?draw=",
          "method": "starts with",
          "output": "true"
        },
        "21": {
          "input": "/powerplay/relaterat",
          "method": "starts with",
          "output": "true"
        },
        "22": {
          "input": "/powerplay/mina-spel2",
          "method": "starts with",
          "output": "true"
        },
        "23": {
          "input": "/bomben/spela",
          "method": "starts with",
          "output": "true"
        },
        "24": {
          "input": "/bomben",
          "method": "starts with",
          "output": "true"
        },
        "25": {
          "input": "/matchen/spela",
          "method": "starts with",
          "output": "true"
        },
        "26": {
          "input": "/matchen",
          "method": "starts with",
          "output": "true"
        },
        "27": {
          "input": "/bingo/spela/11",
          "method": "starts with",
          "output": "true"
        },
        "28": {
          "input": "/bingo/spela/12",
          "method": "starts with",
          "output": "true"
        },
        "29": {
          "input": "/bingo/spela/6",
          "method": "starts with",
          "output": "true"
        },
        "30": {
          "input": "/bingo/spela/2",
          "method": "starts with",
          "output": "true"
        },
        "31": {
          "input": "/bingo/spela/7",
          "method": "starts with",
          "output": "true"
        },
        "32": {
          "input": "/bingo/spela/8",
          "method": "starts with",
          "output": "true"
        },
        "33": {
          "input": "/bingo",
          "method": "starts with",
          "output": "true"
        },
        "34": {
          "input": "/poker",
          "method": "starts with",
          "output": "true"
        },
        "35": {
          "input": "/casino",
          "method": "starts with",
          "output": "true"
        },
        "36": {
          "input": "/casino/live",
          "method": "starts with",
          "output": "true"
        },
        "37": {
          "input": "/stryktipset/resultat",
          "method": "starts with",
          "output": "true"
        },
        "38": {
          "input": "/challenge/",
          "method": "starts with",
          "output": "true"
        },
        "39": {
          "input": "/livecasino",
          "method": "starts with",
          "output": "true"
        },
        "40": {
          "input": "/slots",
          "method": "starts with",
          "output": "true"
        },
        "size": 41,
        "dataElement": "%ACDL | URL%",
        "defaultValueEmpty": true
      }
    },
    "Content | Form Factor": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.site.formFactor"
      }
    },
    "cancel support XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event34": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar31": "%Event | Label%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Identity Map": {
      "storageDuration": "session",
      "modulePath": "adobe-alloy/dist/lib/dataElements/identityMap/index.js",
      "settings": {
        "FPID": [
          {
            "id": "%newFpid%",
            "primary": false,
            "authenticatedState": "ambiguous"
          }
        ],
        "declaredIdAEP": [
          {
            "id": "%User | User ID%",
            "primary": true,
            "authenticatedState": "authenticated"
          }
        ]
      }
    },
    "promoClick XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event2": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar16": "%Internal Promotion | Id%",
                  "eVar17": "%Internal Promotion | Position%",
                  "eVar22": "%Internal Promotion | Name%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%",
                  "prop8": "%Internal Promotion | Id%",
                  "prop9": "%Internal Promotion | Position%",
                  "prop10": "%Internal Promotion | Name%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            },
            "internalPromotion": {
              "id": "%Internal Promotion | Id%",
              "name": "%Internal Promotion | Name%",
              "click": 1,
              "position": "%Internal Promotion | Position%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "login success XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event4": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "yes",
                  "eVar15": "%User | User ID%",
                  "eVar45": "%Login Method%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop6": "yes",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "login": 1,
            "loginType": "%Login Method%",
            "loginStatus": "yes"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%",
              "declaredID": "%User | User ID%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "start video XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "media": {
            "mediaTimed": {
              "starts": {
                "value": 1
              },
              "recordLabel": "%Event | Label%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event23": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar21": "%Event | Label%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "withdrawal success XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event16": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "withdrawal": {
              "withdrawalSuccess": 1
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "andSpel XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event64": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "productListItems": "%Andelsspel | productListArray%",
          "_svenskaspelsportcasino": {
            "game": {
              "gameType": "%Andelsspel | gameType%"
            },
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "betslip started XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event63": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar18": "%betslipType|evar18%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            },
            "productInteraction": {
              "betslipType": "%betslipType|evar18%",
              "betslipStarted": 1
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "targetPayloadClick XDM": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event101to200": {
                "event101": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar18": "%Event | Label%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%",
                  "eVar200": "%Target | mbox%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            },
            "decisioning": {
              "propositions": "%Target | payloadclick%"
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "ACDL | Content | Domain Name": {
      "defaultValue": "",
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.site.name"
      }
    },
    "ACDL | Content | Domain": {
      "defaultValue": "",
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.site.hostname"
      }
    },
    "Target | Cache Breaker": {
      "modulePath": "core/src/lib/dataElements/randomNumber.js",
      "settings": {
        "max": 1000000000,
        "min": 0
      }
    },
    "Content | Page Name": {
      "defaultValue": "",
      "storageDuration": "pageview",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
try {
  var pageName = decodeURIComponent(_satellite.getVar("ACDL | pageName")),
    url = _satellite.getVar("ACDL | URL"),
    _pageregex = new RegExp("^[/]s|^[/]?.*");
  if (pageName == "" && _pageregex.test(url)) return "home";
  var regex = new RegExp("[?&]flik(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (results && results[2]) pageName += ":" + decodeURIComponent(results[2].replace(/\+/g, " "));
  var _regextmat = new RegExp("mina-spel|logga-in:information:|mina-spel2:|:$");
  if (_regextmat.test(pageName)) {
    regex = /:mina-spel:[0-9]+:[0-9]+/g;
    pageName = pageName.replace(regex, ":mina-spel:avslutat-spel");
    regex = /:mina-spel:[0-9]+/g;
    pageName = pageName.replace(regex, ":mina-spel:avslutat-spel");
    regex = /^logga-in:information:[0-9]+/g;
    pageName = pageName.replace(regex, "logga-in:information:fortsatt");
    regex = /.*:$/g;
    pageName = pageName.replace(regex, pageName.slice(0, -1));
  }
  if (pageName.includes("fulltraff:resultat")) {
    pageName = pageName.replace(/([0-9][0-9][0-9][0-9]\-[0-9][0-9]\-[0-9][0-9]:)+/g, "");
  } else if (pageName.includes("fulltraff:mina-spel")) {
    pageName = pageName.replace(/mina-spel:([0-9]+)/g, "mina-spel");
  } else if (pageName.includes("fulltraff:externa-systemspel:granska:")) {
    pageName = pageName.replace(/granska:(.*)+/g, "granska");
  } else if (pageName.includes("externa-systemspel:granska:fulltraff")) {
    pageName = pageName.replace(/fulltraff:(.*)+/g, "fulltraff");
  }

  if (url.includes("openStatistic=")) {
    pageName = pageName + ":statistik";
  }
  if (pageName == "") pageName = "home";
  return pageName;
} catch (e) {}
}
      }
    },
    "decCookie code": {
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
  function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
  }
  var date = new Date(),
    expiresDate = new Date(date.setTime(date.getTime() +
      1000 
      *
      60 
      *
      60 
      *
      24 
      *
      365 
    ));
  var expTime = expiresDate.toUTCString();
  var _data = adobeDataLayer.getState().data,
    didCookieValue = getCookie("dectodec"), 
    didValue = _data.user ? _data.user.userId ? _data.user.userId : "" : "", 
    _acon = _data.consent.analyticsBrowser,
    _pcon = _data.consent.personalizedBrowser,
    _pccon = _data.consent.personalizedCustomer;

  if (_acon == true && _pcon == true) { 
    if (_pccon != false) {
      if (didCookieValue === null) {
        if (didValue != "" && didValue != undefined) {
          document.cookie = 'dectodec=' + didValue + ';path=/;domain=' + window.location.hostname + ';expires=' + expTime;
          return didValue;
        }
      } else {
        return didCookieValue;
      }
    }
  }
} catch (e) {
  _satellite.logger.log("##error in declaredID set didCookie code DE " + e)
}
}
      }
    },
    "Content | Site": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.site.name"
      }
    },
    "ACDL AA suite": {
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.site.suite"
      }
    },
    "User | User ID": {
      "storageDuration": "pageview",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
  var _data1 = adobeDataLayer.getState().data,
      _userID = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";  
  if (_userID != "" && _userID != undefined) {
    return _userID;
  } else {
    return 123;
  }
} catch (e) {}
}
      }
    },
    "deposit limit increase XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event13": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "limits": "%Limit | _limits%",
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "User | Role": {
      "defaultValue": "",
      "forceLowerCase": true,
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.user.role"
      }
    },
    "Content | utm_term": {
      "storageDuration": "pageview",
      "modulePath": "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js",
      "settings": {
        "delimiter": "",
        "urlToCheck": "",
        "queryStringParameters": "utm_term"
      }
    },
    "menuClick XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event59": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar51": "%setdataelement%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "menuClick": 1,
              "formFactor": "%Content | Form Factor%",
              "navigationMenu": "%setdataelement%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Event | Label": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.label"
      }
    },
    "Content | utm_campaign": {
      "storageDuration": "pageview",
      "modulePath": "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js",
      "settings": {
        "delimiter": "",
        "urlToCheck": "",
        "queryStringParameters": "utm_campaign"
      }
    },
    "Content | utm_content": {
      "storageDuration": "pageview",
      "modulePath": "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js",
      "settings": {
        "delimiter": "",
        "urlToCheck": "",
        "queryStringParameters": "utm_content"
      }
    },
    "Content | utm_source": {
      "storageDuration": "pageview",
      "modulePath": "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js",
      "settings": {
        "delimiter": "",
        "urlToCheck": "",
        "queryStringParameters": "utm_source"
      }
    },
    "deposit limit decrease XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event14": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "limits": "%Limit | _limits%",
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "ACDL | URL": {
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.page.url"
      }
    },
    "Event | Category": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.category"
      }
    },
    "log out XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event6": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "no",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "logout": 1
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "activate spelpaus XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event20": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar27": "%spelpaus: evar27%",
                  "eVar43": "%spelpaus: type%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "game": {
              "spelPausType": "%spelpaus: type%",
              "spelPausLength": "%spelpaus: length%",
              "spelPausActivate": 1
            },
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "communication choices XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": "%communication | experience%",
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar50": "%eVar50%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "myProfile": "%communication | profile%",
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "withdrawal failure XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event17": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "withdrawal": {
              "withdrawalFailure": 1
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "deposit success XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event11": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar19": "%Event | Label%",
                  "eVar20": "%DepVal | eVar20%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "deposit": {
              "amount": "%Deposit | Value%",
              "method": "%Event | Label%",
              "depositSuccess": 1
            },
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "devCookie code": {
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
  function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
  }
  var date = new Date(), 
  expiresDate = new Date(date.setTime(date.getTime()
  + 1000 
  * 60 
  * 60 
  * 24 
  * 365 
  ));
  var expTime = expiresDate.toUTCString();
  var _data = adobeDataLayer.getState().data,
    devDecCookieValue = getCookie("gendevtoec"), 
    devValue = _data.user ? _data.user.devId ? _data.user.devId : "" : "", 
    _acon = _data.consent.analyticsBrowser,
    _pcon = _data.consent.personalizedBrowser,
    _pccon = _data.consent.personalizedCustomer;

  if (_acon == true && _pcon == true) { 
    if (_pccon != false) {
      if (devDecCookieValue === null && devValue != "" && devValue != undefined) {
        _satellite.setVar("newFpid", devValue);
        document.cookie = 'gendevtoec=' + devValue + ';path=/;domain=' + window.location.hostname + ';expires=' + expTime;
        return devValue;
      } else {
         _satellite.setVar("newFpid", devDecCookieValue);
        return devDecCookieValue;
      }
    }
  }
} catch (e) {
  _satellite.logger.log("##error in declaredID devCookie code DE " + e)
}
}
      }
    },
    "ACDL Data object": {
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": ""
      }
    },
    "registration success XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event7": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "yes",
                  "eVar15": "%User | User ID%",
                  "eVar44": "%registration: method1%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar54": "%registration: type1%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "yes"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "registration": {
              "type": "%registration: type1%",
              "method": "%registration: method1%",
              "completed": 1
            },
            "identityFields": {
              "deviceID": "%User | DevId%",
              "declaredID": "%User | User ID%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "ACDL | Consent | Personalized Customer": {
      "defaultValue": "",
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "data.consent.personalizedCustomer"
      }
    },
    "game chooser set XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event2": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar22": "%setGameChooser%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            },
            "internalPromotion": {
              "name": "%setGameChooser%",
              "click": 1
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "ACDL | Consent | Analytics Browser": {
      "defaultValue": "",
      "storageDuration": "pageview",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "data.consent.analyticsBrowser"
      }
    },
    "login failure XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event5": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "no",
                  "eVar45": "%Login Method%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop6": "no",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginType": "%Login Method%",
            "loginStatus": "no",
            "loginFailure": 1
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "deposit limit set XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event15": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "limits": "%Limit | _limits%",
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Content | ref": {
      "storageDuration": "pageview",
      "modulePath": "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js",
      "settings": {
        "delimiter": "",
        "urlToCheck": "",
        "queryStringParameters": "ref"
      }
    },
    "Content | utm_data": {
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
    var _sor = _satellite.getVar("Content | utm_source"),
    _med = _satellite.getVar("Content | utm_medium"),
    _cam = _satellite.getVar("Content | utm_campaign"),
    _ter = _satellite.getVar("Content | utm_term"),
    _con = _satellite.getVar("Content | utm_content"),
    _ref = _satellite.getVar("Content | ref"),
    _refs = _satellite.getVar("Content | refs"),
    _campaign = "";

  if (_sor) {
    var gaUTM = [];
    gaUTM.push(_sor);
    gaUTM.push(_med);
    _cam != "" ? gaUTM.push(_cam) : gaUTM.push("na");
    _ter != "" ? gaUTM.push(_ter) : gaUTM.push("na");
    _con != "" ? gaUTM.push(_con) : gaUTM.push("na");
    gaUTM.push('(ga-utm)');
    _campaign = gaUTM.join(":");
    _satellite.setVar("Content | trackingCode", _campaign ? _campaign : " ")
  }
  var a = _ref;
  if (a != "") {
    var b = _refs;
    _satellite.setVar("Content | ref", a ? a : "");
    _satellite.setVar("Content | refs", b ? b : "")
  }
} catch (e) {
  _satellite.logger.error("Error in Content | utm_data DE " + e);
}
}
      }
    },
    "Content | url": {
      "defaultValue": "",
      "storageDuration": "pageview",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
  function removeParameters(name, url) {
    var regex = new RegExp("[&|?]" + name + "(=([^(?|&)#]*))");
    url = url.replace(regex, "");
    return url;
  }
  function replaceAtIndex(_string, _index, _newValue) {
    if (_index > _string.length - 1) {
      return _string;
    } else {
      return (
        _string.substring(0, _index) + _newValue + _string.substring(_index + 1)
      );
    }
  }
  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }
  var regArr = [
    {
      pattern:
        /(\/logga-in\/information\/[0-9]+\?$|\/logga-in\/information\/[0-9]+)/g,
      value: "/logga-in/information",
    },
    {
      pattern: /(\/externa-systemspel\/mina-spel\/stryktipset\/[0-9]+)/g,
      value: "/externa-systemspel/mina-spel/stryktipset",
    },
    {
      pattern: /(\/externa-systemspel\/mina-spel\/fulltraff\/[0-9]+)/g,
      value: "/externa-systemspel/mina-spel/fulltraff",
    },
    {
      pattern: /(\/externa-systemspel\/mina-spel\/topptipset\/[0-9]+)/g,
      value: "/externa-systemspel/mina-spel/topptipset",
    },
    {
      pattern: /(\/externa-systemspel\/mina-spel\/maltipset\/[0-9]+)/g,
      value: "/externa-systemspel/mina-spel/maltipset",
    },
    {
      pattern: /(\/externa-systemspel\/mina-spel\/europatipset\/[0-9]+)/g,
      value: "/externa-systemspel/mina-spel/europatipset",
    },
    {
      pattern: /(\/externa-systemspel\/mina-spel\/powerplay\/[0-9]+)/g,
      value: "/externa-systemspel/mina-spel/powerplay",
    },
    {
      pattern: /(^\/insattning\?pr=null|^\/insattning\?$)/g,
      value: "/insattning",
    },
  ];


    var url = _satellite.getVar("ACDL | URL");
  url = decodeURIComponent(url);
  var deleteQueryParam = [
    "code_challenge",
    "gclid",
    "tduid",
    "lt",
    "ts",
    "pr",
    "sp",
    "pt",
    "code_challenge_method",
    "reference",
    "access_token",
    "ltt",
    "lis",
    "lm",
    "sbpin",
    "activatedDrawId",
    "draw",
  ];
  for (var i = 0; i < deleteQueryParam.length; i++) {
    url = removeParameters(deleteQueryParam[i], url);
  }

    url = url.replace("?&", "?");
  url = replaceAtIndex(url, getPosition(url, "?", 2), "&");
  var _regextmatch = new RegExp("logga-in|insattning|externa-systemspel|retur");
  if (_regextmatch.test(url)) {
    for (var k = 0; k < regArr.length; k++) {
      url = url.replace(regArr[k].pattern, regArr[k].value);
    }
  }

    url.length != url.split("?", 2).join("?").length ? (url = replaceAtIndex(url, getPosition(url, "?", 2), "&")) : url;
  !url.includes("&") ? url : !url.includes("?") ? (url = replaceAtIndex(url, getPosition(url, "&", 1), "?")) : url;

    if (url.endsWith("&")) {
    url = url.slice(0, -1);
  } else {
    url;
  }

  url.startsWith("/spela-tillsammans/ombud/andelsspel/") ? (url = url.replace(/\?.*/, "")) : url;
  url.startsWith("/odds/sports/") ? (url = url.replace(/\/[0-9]+/g, "")) : url;
  url.startsWith("/odds/sports/travsport/") ? (url = url.replace(/\-lopp-[0-9]+/g, "")) : url;
  url.includes("mina-spel") ? (url = url.replace(/\/[0-9]+/g, "")) : url;

  url.includes("mina-spel") && !url.includes("?") && !url.includes("&") ? (url = url.replace(/(mina-spel).*$/g, "mina-spel"))
    : url.includes("mina-spel") ? (url = url.replace(/(mina-spel).*?(?=\&|\?|$)/g, "mina-spel"))
    : url;

  url.includes("/granska/") && !url.includes("?") && !url.includes("&") ? (url = url.replace(/(granska).*$/g, "granska"))
    : url.includes("/granska/") ? (url = url.replace(/(granska).*?(?=\&|\?|$)/g, "granska"))
    : url;

    return url;
} catch (e) {}
}
      }
    },
    "pageView code": {
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
  function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
  }

  function setCookie(a, b, c) {
    document.cookie = "dectodec=" + a + ';path=/;domain=' + window.location.hostname + ';expires=' + c; 
    document.cookie = "gendevtoec=" + b + ';path=/;domain=' + window.location.hostname + ';expires=' + c; 
  }

  function clearCookie() {
    document.cookie = 'kndctr_315F75E95BFC0EE50A495C73_AdobeOrg_identity=;expires=Thu, 01 Jan 2010 00:00:00 UTC; path=/; domain=.svenskaspel.se';
    document.cookie = 'AMCV_315F75E95BFC0EE50A495C73%40AdobeOrg=;expires=Thu, 01 Jan 2010 00:00:00 UTC; path=/; domain=.svenskaspel.se';
    document.cookie = 'AMCV_315F75E95BFC0EE50A495C73%40AdobeOrg=;expires=Thu, 01 Jan 2010 00:00:00 UTC; path=/; domain=' + window.location.hostname;
    document.cookie = 'AMCVS_315F75E95BFC0EE50A495C73%40AdobeOrg=;expires=Thu, 01 Jan 2010 00:00:00 UTC; path=/; domain=' + window.location.hostname;
  }
  var date = new Date(),
    expiresDate = new Date(date.setTime(date.getTime() +
      1000 
      *
      60 
      *
      60 
      *
      24 
      *
      365 
    ));
  var expTime = expiresDate.toUTCString();

  var _data = adobeDataLayer.getState().data,
    devDecCookieValue = getCookie("gendevtoec"), 
    didCookieValue = getCookie("dectodec"), 
    didValue = _data.user ? _data.user.userId ? _data.user.userId : "" : "", 
    devValue = _data.user ? _data.user.devId ? _data.user.devId : "" : "", 
    _acon = _data.consent.analyticsBrowser,
    _pcon = _data.consent.personalizedBrowser,
    _pccon = _data.consent.personalizedCustomer;

  if (_acon == true && _pcon == true) { 
    if (_pccon != false) {
      var dec = _satellite.getVar("decCookie code"); 
      _satellite.getVar("devCookie code"); 
      if (didValue != "" && didValue != undefined) {
        if (didCookieValue != "" && didCookieValue != undefined) {
          if (didValue != didCookieValue) {
            var newFpid = crypto.randomUUID();
            _satellite.setVar("newFpid", newFpid);
            clearCookie();
            setCookie(didValue, newFpid, expTime);
          }
        } else if (dec) {
          if (didValue != dec) {
            var newFpid = crypto.randomUUID();
            _satellite.setVar("newFpid", newFpid);
            clearCookie();
            setCookie(didValue, newFpid, expTime);
          }
        }
      }
    }
  }
} catch (e) {
  _satellite.logger.log("##error in declaredID pageView code DE " + e)
}
}
      }
    },
    "deposit failure XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event12": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar19": "%Event | Label%",
                  "eVar20": "%DepVal | eVar20%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "deposit": {
              "amount": "%Deposit | Value%",
              "method": "%Event | Label%",
              "depositFailure": 1
            },
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "search XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "search": {
            "slot": "%Event | Category%",
            "keywords": "%Event | Action%"
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event60": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar32": "%Event | Action%",
                  "eVar42": "%Event | Category%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "internalSearch": 1,
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "registration started XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event62": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "yes",
                  "eVar44": "%registration: method%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar54": "%registration: type%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "yes"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "registration": {
              "type": "%registration: type%",
              "method": "%registration: method%",
              "started": 1
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Event | Value": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.value"
      }
    },
    "grasroten give support XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event33": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar31": "%Event | Label%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "grasroten": {
              "clubName": "%Event | Label%",
              "geMittStod": 1
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Content | refs": {
      "storageDuration": "pageview",
      "modulePath": "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js",
      "settings": {
        "delimiter": "",
        "urlToCheck": "",
        "queryStringParameters": "refs"
      }
    },
    "User | Loggedin": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.user.loggedIn"
      }
    },
    "ACDL | pageName": {
      "forceLowerCase": true,
      "storageDuration": "pageview",
      "modulePath": "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js",
      "settings": {
        "path": "data.page.name"
      }
    },
    "a/b test XDM map": {
      "storageDuration": "pageview",
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "_experience": {
            "analytics": {
              "session": {
                "web": {
                  "webPageDetails": {
                    "name": "%Content | Page Name%",
                    "server": "%ACDL | Content | Domain%"
                  }
                }
              },
              "event1to100": {
                "event56": {
                  "value": 1
                }
              },
              "event901to1000": {
                "event997": {
                  "value": 1
                }
              },
              "customDimensions": {
                "eVars": {
                  "eVar1": "%site section: level1%",
                  "eVar2": "%site section: level2%",
                  "eVar3": "%Content | url%",
                  "eVar4": "%Content | Page Name%",
                  "eVar5": "%Content | Form Factor%",
                  "eVar14": "%User | Loggedin%",
                  "eVar40": "%Rule | abAct%",
                  "eVar41": "%Rule | abLab%",
                  "eVar46": "%Content | Form Factor%",
                  "eVar47": "%Content | Site%",
                  "eVar48": "%User | Role%",
                  "eVar70": "%User | DevId%"
                },
                "props": {
                  "prop1": "%site section: level1%",
                  "prop3": "%Content | url%",
                  "prop4": "%Content | Page Name%",
                  "prop5": "%Content | Form Factor%",
                  "prop7": "%Content | Site%"
                }
              }
            }
          },
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "_svenskaspelsportcasino": {
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "abTest": 1,
              "hostname": "%ACDL | Content | Domain%",
              "abTestName": "%Rule | abAct%",
              "formFactor": "%Content | Form Factor%",
              "abTestVariant": "%Rule | abLab%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            }
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    },
    "Trans XDM Map": {
      "modulePath": "adobe-alloy/dist/lib/dataElements/xdmObject/index.js",
      "settings": {
        "data": {
          "web": {
            "webInteraction": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "linkClicks": {
                "value": 1
              }
            },
            "webPageDetails": {
              "URL": "%Content | url%",
              "name": "%Content | Page Name%",
              "server": "%ACDL | Content | Domain%",
              "siteSection": "%site section: level1%"
            }
          },
          "commerce": "%Transaction | commerce%",
          "_experience": "%Transaction | _experience%",
          "identityMap": "%Identity Map%",
          "userAccount": {
            "loginStatus": "%User | Loggedin%"
          },
          "productListItems": "%Transaction | productListArray%",
          "_svenskaspelsportcasino": {
            "revenue": "%Transaction | revenue%",
            "webPage": {
              "site": "%Content | Site%",
              "suite": "%ACDL AA suite%",
              "hostname": "%ACDL | Content | Domain%",
              "formFactor": "%Content | Form Factor%",
              "siteSectionLevel2": "%site section: level2%"
            },
            "identityFields": {
              "deviceID": "%User | DevId%"
            },
            "gameOrderEvents": "%Transaction | gameOrder%"
          }
        },
        "sandbox": {
          "name": "development"
        }
      }
    }
  },
  "extensions": {
    "common-web-sdk-plugins": {
      "displayName": "Common Web SDK Plugins",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP72fbeb9839644a1daa8eca9f84e02dcf/",
      "modules": {
        "common-web-sdk-plugins/src/lib/dataElements/getqueryparam.js": {
          "name": "getqueryparam",
          "displayName": "getQueryParam",
          "script": function(module, exports, require, turbine) {
'use strict';
function getQueryParam(queryStringParameters, delimiter, urlToCheck)
  {
    if(queryStringParameters === "-v") return {"plugin": "getQueryParam", "version": "5.0.0"}

    if(!queryStringParameters) return;

    delimiter = delimiter || "";

    urlToCheck = (urlToCheck || ("undefined" !== typeof s && s.pageURL) || location.href) + "";

    if((delimiter.length > 4 || delimiter.indexOf("=") > -1) && urlToCheck && urlToCheck.length < 4)
    {
      var tempURL = delimiter;
        delimiter = urlToCheck, 
        urlToCheck = tempURL;
    }	

    var parameterValue,
      returnValue = "",
      queryStringParameterList = queryStringParameters.split(","),
      qspll = queryStringParameterList.length;	

    for(var i = 0; i < qspll; i++)
    {
      parameterValue = findParameterValue(queryStringParameterList[i], urlToCheck);

      if(typeof parameterValue === "string")
      {
        parameterValue = (parameterValue.indexOf("#") > -1 ? parameterValue.substring(0, parameterValue.indexOf("#")) : parameterValue);

        returnValue += (returnValue ? delimiter + parameterValue : parameterValue);
      }

      else if(returnValue === "") returnValue = parameterValue;

      else returnValue += (delimiter + parameterValue)
    }

    return returnValue;

    function findParameterValue(parameterToFind, urlToCheck)
    {
      urlToCheck = urlToCheck.split("?").join("&");
      urlToCheck = urlToCheck.split("#").join("&");

      var searchStartLocation = urlToCheck.indexOf("&"),

        returnValue = "",
        fullQueryString,
        splitString;

      if(parameterToFind && (searchStartLocation > -1 || urlToCheck.indexOf("=") > searchStartLocation))
      {
        fullQueryString = urlToCheck.substring(searchStartLocation + 1);
        splitString = fullQueryString.split("&");
        for(var i=0, ssl=splitString.length, currentKey; i < ssl; i++)
        {
          var currentKeyValuePair = splitString[i].split("="),
          currentKeyName = currentKeyValuePair[0],
          currentKeyValue = currentKeyValuePair[1];
          if(currentKeyName.toLowerCase() === parameterToFind.toLowerCase()) return decodeURIComponent(currentKeyValue || true);
        }
      }
      return "";
    };
  }

module.exports = function(settings) {
  return getQueryParam(settings.queryStringParameters, settings.delimiter, settings.urlToCheck);
};

          }

        }
      }
    },
    "adobe-alloy": {
      "displayName": "Adobe Experience Platform Web SDK",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP028937a43efe4633a77ae8da95a60e2e/",
      "settings": {
        "instances": [
          {
            "name": "alloy",
            "edgeDomain": "smetrics.spela.svenskaspel.se",
            "edgeConfigId": "ddd3f2ab-e865-48fc-a7e2-84fdd8fedc06",
            "defaultConsent": "out",
            "onBeforeEventSend": function(content) {
const _trackingCode = _satellite.getVar("Content | trackingCode"), _site = _satellite.getVar("Content | Site"),
      regObj = _satellite.getVar("registration obj");

var _id = "";
content.xdm.identityMap ? content.xdm.identityMap.declaredIdAEP ? content.xdm.identityMap.declaredIdAEP[0].id ? _id = content.xdm.identityMap.declaredIdAEP[0].id : "" : "" : "";
if (_id == "%User | User ID1%" || _id == "%User | User ID%") { delete content.xdm.identityMap.declaredIdAEP[0]; }

if (_trackingCode != undefined && _trackingCode != "" && _trackingCode != " "){
content.xdm.marketing = {"trackingCode" : _trackingCode};
}
if (regObj != undefined && regObj != ""){
content.xdm._experience.analytics.event1to100 = {"event66" : {"value" : 1}};
content.xdm._svenskaspelsportcasino.registration = regObj; 
}
_site == "momang"? content.xdm._experience.analytics.event101to200 = {"event150" : {"value" : 1}} : "";
_site == "momang"? content.xdm._svenskaspelsportcasino = {"AAEvents" : {"momangHit" : "1"}} : "";

try {
var _consCust = _satellite.getVar('ACDL | Consent | Personalized Customer'),
    privacyPref = _satellite.getVar("Rule | privacyPreferences"),
    _qualOk = _satellite.getVar('ACDL | Consent | QualtricsOk'),
  _counter = sessionStorage.getItem("qpv");

   if (privacyPref.cookieConsentString == "y" && _qualOk == true ) {
  if (_consCust != false) {
    if (_counter) {
      if (_counter.split(",")[1] == 1) {
        if (options.xdm.web.webInteraction.type === "other" || options.xdm.web.webInteraction.type === "download" || options.xdm.web.webInteraction.type === "exit") {
        content.xdm._experience.analytics.event901to1000 ? content.xdm._experience.analytics.event901to1000["event996"] = {"value" : parseFloat(_counter.split(",")[2])} : content.xdm._experience.analytics["event901to1000"] = {"event996":{"value" : parseFloat(_counter.split(",")[2])}};
          content.xdm._svenskaspelsportcasino["AAEvents"] = {"qualtricsEvent":_counter.split(",")[2]}
        } else {
        content.xdm._experience.analytics.event901to1000 ? content.xdm._experience.analytics.event901to1000["event996"] = {"value" : parseFloat(_counter.split(",")[2])} : content.xdm._experience.analytics["event901to1000"] = {"event996":{"value" : parseFloat(_counter.split(",")[2])}};
          content.xdm._svenskaspelsportcasino["AAEvents"] = {"qualtricsEvent":_counter.split(",")[2]}
        }
        if (_counter.split(",")[2] >= 1) {
        content.xdm._experience.analytics.event901to1000 ? content.xdm._experience.analytics.event901to1000["event996"] = {"value" : parseFloat(_counter.split(",")[2])} : content.xdm._experience.analytics["event901to1000"] = {"event996":{"value" : parseFloat(_counter.split(",")[2])}};
          content.xdm._svenskaspelsportcasino["AAEvents"] = {"qualtricsEvent":_counter.split(",")[2]}
        }
        _counter = _counter.split(",")[0] + ",0,0";
        sessionStorage.setItem("qpv", _counter);
      } else if(_counter.split(",")[1] == 0 && _counter.split(",")[2] >= 1){
        _satellite.logger.log("##Entered the last else if in extension: " + _counter);
        var _count = _counter.split(",")[2].toString()
        _satellite.logger.log("##Value of _count: " + _count);
        _satellite.logger.log("##Value of _counter: " + _counter);
        content.xdm._experience.analytics.event901to1000 ? content.xdm._experience.analytics.event901to1000["event996"] = {"value" : parseFloat(_counter.split(",")[2])} : content.xdm._experience.analytics["event901to1000"] = {"event996":{"value" : parseFloat(_counter.split(",")[2])}};
        content.xdm._svenskaspelsportcasino["AAEvents"] = {"qualtricsEvent":_counter.split(",")[2]}
          _counter = _counter.split(",")[0] + ",0,0";
          _satellite.logger.log("##Value of _counter after reset: " + _counter);
          sessionStorage.setItem("qpv", _counter);
      }
    }
  }
}
} catch (e){console.log("### " + e)}
},
            "stagingEdgeConfigId": "71083df6-0cfe-432e-81a3-508002710cd2",
            "clickCollectionEnabled": false,
            "developmentEdgeConfigId": "a5aae265-e85c-48dd-91c5-589859626ab9",
            "thirdPartyCookiesEnabled": false
          }
        ]
      },
      "modules": {
        "adobe-alloy/dist/lib/dataElements/xdmObject/index.js": {
          "name": "xdm-object",
          "displayName": "XDM object",
          "script": function(module, exports, require, turbine) {
"use strict";


module.exports = function (settings) {
  return settings.data;
};
          }

        },
        "adobe-alloy/dist/lib/dataElements/variable/index.js": {
          "name": "variable",
          "displayName": "Variable",
          "script": function(module, exports, require, turbine) {
"use strict";

var _require = require("../../index"),
  variableStore = _require.variableStore;
module.exports = function (settings) {
  return variableStore[settings.cacheId] || {};
};
          }

        },
        "adobe-alloy/dist/lib/dataElements/identityMap/index.js": {
          "name": "identity-map",
          "displayName": "Identity map",
          "script": function(module, exports, require, turbine) {
"use strict";


var createIdentityMap = require("./createIdentityMap");
var identityMap = createIdentityMap({
  logger: turbine.logger
});
module.exports = function (settings) {
  return identityMap(settings);
};
          }

        },
        "adobe-alloy/dist/lib/actions/sendEvent/index.js": {
          "name": "send-event",
          "displayName": "Send event",
          "script": function(module, exports, require, turbine) {
"use strict";

var _turbine$environment;

var createSendEvent = require("./createSendEvent");
var instanceManager = require("../../instanceManager/index");
var _require = require("../../index"),
  sendEventCallbackStorage = _require.sendEventCallbackStorage;
var createGetConfigOverrides = require("../../utils/createGetConfigOverrides");
module.exports = createSendEvent({
  instanceManager: instanceManager,
  sendEventCallbackStorage: sendEventCallbackStorage,
  getConfigOverrides: createGetConfigOverrides((_turbine$environment = turbine.environment) === null || _turbine$environment === void 0 ? void 0 : _turbine$environment.stage)
});
          }

        },
        "adobe-alloy/dist/lib/actions/setConsent/index.js": {
          "name": "set-consent",
          "displayName": "Set consent",
          "script": function(module, exports, require, turbine) {
"use strict";

var _turbine$environment;

var createSetConsent = require("./createSetConsent");
var instanceManager = require("../../instanceManager/index");
var createGetConfigOverrides = require("../../utils/createGetConfigOverrides");
module.exports = createSetConsent({
  instanceManager: instanceManager,
  getConfigOverrides: createGetConfigOverrides((_turbine$environment = turbine.environment) === null || _turbine$environment === void 0 ? void 0 : _turbine$environment.stage)
});
          }

        },
        "adobe-alloy/dist/lib/instanceManager/index.js": {
          "script": function(module, exports, require, turbine) {
"use strict";

var _turbine$environment;
var _require = require("../alloy"),
  createInstance = _require.createInstance,
  createEventMergeId = _require.createEventMergeId;
var createInstanceManager = require("./createInstanceManager");
var injectWrapOnBeforeEventSend = require("./injectWrapOnBeforeEventSend");
var createGetConfigOverrides = require("../utils/createGetConfigOverrides");
var version = "2.21.3";
var wrapOnBeforeEventSend = injectWrapOnBeforeEventSend({
  version: version
});
module.exports = createInstanceManager({
  turbine: turbine,
  window: window,
  createInstance: createInstance,
  createEventMergeId: createEventMergeId,
  orgId: _satellite.company.orgId,
  wrapOnBeforeEventSend: wrapOnBeforeEventSend,
  getConfigOverrides: createGetConfigOverrides((_turbine$environment = turbine.environment) === null || _turbine$environment === void 0 ? void 0 : _turbine$environment.stage)
});
          }

        },
        "adobe-alloy/dist/lib/index.js": {
          "script": function(module, exports, require, turbine) {
"use strict";


var createEventMergeIdCache = require("./createEventMergeIdCache");
var createSendEventCallbackStorage = require("./createSendEventCallbackStorage");
var createVariableStore = require("./createVariableStore");
exports.eventMergeIdCache = createEventMergeIdCache();
exports.sendEventCallbackStorage = createSendEventCallbackStorage();
exports.variableStore = createVariableStore();
          }

        },
        "adobe-alloy/dist/lib/createEventMergeIdCache.js": {
          "script": function(module, exports, require, turbine) {
"use strict";


module.exports = function () {
  var eventMergeIdByCacheId = {};

  return {
    set: function set(cacheId, eventMergeId) {
      eventMergeIdByCacheId[cacheId] = eventMergeId;
    },
    getByCacheId: function getByCacheId(cacheId) {
      return eventMergeIdByCacheId[cacheId];
    },
    clearByEventMergeId: function clearByEventMergeId(eventMergeId) {
      Object.keys(eventMergeIdByCacheId).forEach(function (cacheId) {
        if (eventMergeIdByCacheId[cacheId] === eventMergeId) {
          delete eventMergeIdByCacheId[cacheId];
        }
      });
    }
  };
};
          }

        },
        "adobe-alloy/dist/lib/createSendEventCallbackStorage.js": {
          "script": function(module, exports, require, turbine) {
"use strict";


module.exports = function () {
  var sendEventCompleteTriggers = [];
  return {
    add: function add(trigger) {
      sendEventCompleteTriggers.push(trigger);
    },
    triggerEvent: function triggerEvent(result) {
      sendEventCompleteTriggers.forEach(function (trigger) {
        trigger(result);
      });
    }
  };
};
          }

        },
        "adobe-alloy/dist/lib/createVariableStore.js": {
          "script": function(module, exports, require, turbine) {
"use strict";



module.exports = function () {
  return {};
};
          }

        },
        "adobe-alloy/dist/lib/dataElements/identityMap/createIdentityMap.js": {
          "script": function(module, exports, require, turbine) {
"use strict";


module.exports = function (_ref) {
  var logger = _ref.logger;
  return function (settings) {
    return Object.keys(settings).reduce(function (newIdentityMap, namespace) {
      var filteredIdentifiers = settings[namespace].filter(function (_ref2, i) {
        var id = _ref2.id;
        var isValidId = typeof id === "string" && id.length;
        if (!isValidId) {
          logger.log("The identifier at ".concat(namespace, "[").concat(i, "] was removed from the identity map because its ID is not a populated string. Its ID value is:"), id);
        }
        return isValidId;
      });
      if (filteredIdentifiers.length) {
        newIdentityMap[namespace] = filteredIdentifiers;
      } else {
        logger.log("The ".concat(namespace, " namespace was removed from the identity map because it contains no identifiers."));
      }
      return newIdentityMap;
    }, {});
  };
};
          }

        },
        "adobe-alloy/dist/lib/actions/sendEvent/createSendEvent.js": {
          "script": function(module, exports, require, turbine) {
"use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var clone = require("../../utils/clone");
module.exports = function (_ref) {
  var instanceManager = _ref.instanceManager,
    sendEventCallbackStorage = _ref.sendEventCallbackStorage,
    getConfigOverrides = _ref.getConfigOverrides;
  return function (settings) {
    var instanceName = settings.instanceName,
      sendEventSettings = _objectWithoutProperties(settings, ["instanceName"]);
    sendEventSettings.edgeConfigOverrides = getConfigOverrides(sendEventSettings);
    var instance = instanceManager.getInstance(instanceName);
    if (!instance) {
      throw new Error("Failed to send event for instance \"".concat(instanceName, "\". No matching instance was configured with this name."));
    }

    if (sendEventSettings.xdm) {
      sendEventSettings.xdm = clone(sendEventSettings.xdm);
    }
    if (sendEventSettings.data) {
      sendEventSettings.data = clone(sendEventSettings.data);
    }
    return instance("sendEvent", sendEventSettings).then(function (result) {
      sendEventCallbackStorage.triggerEvent(result);
    });
  };
};
          }

        },
        "adobe-alloy/dist/lib/utils/createGetConfigOverrides.js": {
          "script": function(module, exports, require, turbine) {
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var createGetConfigOverrides = function createGetConfigOverrides(environmentName) {
  return function (settings) {
    var _computedConfigOverri, _computedConfigOverri2, _computedConfigOverri3, _computedConfigOverri4, _computedConfigOverri5;
    var edgeConfigOverrides = settings.edgeConfigOverrides;
    var computedConfigOverrides;
    if (!edgeConfigOverrides) {
      return undefined;
    }
    if (!edgeConfigOverrides[environmentName]) {
      if (edgeConfigOverrides.development || edgeConfigOverrides.staging || edgeConfigOverrides.production) {
        return undefined;
      }
      computedConfigOverrides = edgeConfigOverrides;
    } else {
      computedConfigOverrides = _objectSpread({}, edgeConfigOverrides[environmentName]);
    }
    if (Object.keys(computedConfigOverrides).length === 0) {
      return undefined;
    }
    if (((_computedConfigOverri = computedConfigOverrides.com_adobe_analytics) === null || _computedConfigOverri === void 0 ? void 0 : (_computedConfigOverri2 = _computedConfigOverri.reportSuites) === null || _computedConfigOverri2 === void 0 ? void 0 : _computedConfigOverri2.length) > 0) {
      computedConfigOverrides.com_adobe_analytics.reportSuites = computedConfigOverrides.com_adobe_analytics.reportSuites.flatMap(function (val) {
        return val.includes(",") ? val.split(/,\s*/gi) : val;
      }).map(function (rsid) {
        return rsid.trim();
      }).filter(Boolean);
    }
    if (((_computedConfigOverri3 = computedConfigOverrides.com_adobe_identity) === null || _computedConfigOverri3 === void 0 ? void 0 : _computedConfigOverri3.idSyncContainerId) !== undefined && ((_computedConfigOverri4 = computedConfigOverrides.com_adobe_identity) === null || _computedConfigOverri4 === void 0 ? void 0 : _computedConfigOverri4.idSyncContainerId) !== null && typeof ((_computedConfigOverri5 = computedConfigOverrides.com_adobe_identity) === null || _computedConfigOverri5 === void 0 ? void 0 : _computedConfigOverri5.idSyncContainerId) === "string") {
      var parsedValue = parseInt(computedConfigOverrides.com_adobe_identity.idSyncContainerId.trim(), 10);
      if (Number.isNaN(parsedValue)) {
        throw new Error("The ID sync container ID \"".concat(computedConfigOverrides.com_adobe_identity.idSyncContainerId, "\" is not a valid integer."));
      }
      computedConfigOverrides.com_adobe_identity.idSyncContainerId = parsedValue;
    }
    return computedConfigOverrides;
  };
};
module.exports = createGetConfigOverrides;
          }

        },
        "adobe-alloy/dist/lib/utils/clone.js": {
          "script": function(module, exports, require, turbine) {
"use strict";


module.exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};
          }

        },
        "adobe-alloy/dist/lib/alloy.js": {
          "script": function(module, exports, require, turbine) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepAssign = exports.createInstance = exports.createEventMergeId = void 0;
var _reactorObjectAssign = _interopRequireDefault(require("@adobe/reactor-object-assign"));
var _reactorQueryString = _interopRequireDefault(require("@adobe/reactor-query-string"));
var _reactorLoadScript = _interopRequireDefault(require("@adobe/reactor-load-script"));
var _eventTypeToPropositi, _MATCHERS, _adapters;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var CHROME = "Chrome";
var EDGE = "Edge";
var EDGE_CHROMIUM = "EdgeChromium";
var FIREFOX = "Firefox";
var IE = "IE";
var SAFARI = "Safari";
var UNKNOWN = "Unknown";


var includes = function includes(arr, item) {
  return arr.indexOf(item) !== -1;
};


var browsersSupportingThirdPartyCookie = [CHROME, EDGE, EDGE_CHROMIUM, IE, UNKNOWN];
var areThirdPartyCookiesSupportedByDefault = function areThirdPartyCookiesSupportedByDefault(browser) {
  return includes(browsersSupportingThirdPartyCookie, browser);
};


var isNil = function isNil(value) {
  return value == null;
};


var isObject = function isObject(value) {
  return !isNil(value) && !Array.isArray(value) && _typeof(value) === "object";
};

var assignConcatArrayValues = function assignConcatArrayValues() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  if (values.length < 2) {
    return _reactorObjectAssign["default"].apply(void 0, values);
  }
  return values.reduce(function (accumulator, currentValue) {
    if (isObject(currentValue)) {
      Object.keys(currentValue).forEach(function (key) {
        if (Array.isArray(currentValue[key])) {
          if (Array.isArray(accumulator[key])) {
            var _accumulator$key;
            (_accumulator$key = accumulator[key]).push.apply(_accumulator$key, _toConsumableArray(currentValue[key]));
          } else {
            accumulator[key] = _toConsumableArray(currentValue[key]);
          }
        } else {
          accumulator[key] = currentValue[key];
        }
      });
    }
    return accumulator;
  }); 
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var js_cookie = createCommonjsModule(function (module, exports) {
  (function (factory) {
    var registeredInModuleLoader;
    {
      module.exports = factory();
      registeredInModuleLoader = true;
    }
    if (!registeredInModuleLoader) {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();
      api.noConflict = function () {
        window.Cookies = OldCookies;
        return api;
      };
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};
      for (; i < arguments.length; i++) {
        var attributes = arguments[i];
        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }
      return result;
    }
    function decode(s) {
      return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
      function api() {}
      function set(key, value, attributes) {
        if (typeof document === 'undefined') {
          return;
        }
        attributes = extend({
          path: '/'
        }, api.defaults, attributes);
        if (typeof attributes.expires === 'number') {
          attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
        }

        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
        try {
          var result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}
        value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
        var stringifiedAttributes = '';
        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }
          stringifiedAttributes += '; ' + attributeName;
          if (attributes[attributeName] === true) {
            continue;
          }

          stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = key + '=' + value + stringifiedAttributes;
      }
      function get(key, json) {
        if (typeof document === 'undefined') {
          return;
        }
        var jar = {};
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var i = 0;
        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var cookie = parts.slice(1).join('=');
          if (!json && cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }
          try {
            var name = decode(parts[0]);
            cookie = (converter.read || converter)(cookie, name) || decode(cookie);
            if (json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }
            jar[name] = cookie;
            if (key === name) {
              break;
            }
          } catch (e) {}
        }
        return key ? jar[key] : jar;
      }
      api.set = set;
      api.get = function (key) {
        return get(key, false );
      };

      api.getJSON = function (key) {
        return get(key, true );
      };

      api.remove = function (key, attributes) {
        set(key, '', extend(attributes, {
          expires: -1
        }));
      };
      api.defaults = {};
      api.withConverter = init;
      return api;
    }
    return init(function () {});
  });
});

var cookieJar = {
  get: js_cookie.get,
  set: js_cookie.set,
  remove: js_cookie.remove,
  withConverter: js_cookie.withConverter
};

var deepAssignObject = function deepAssignObject(target, source) {
  Object.keys(source).forEach(function (key) {
    if (isObject(target[key]) && isObject(source[key])) {
      deepAssignObject(target[key], source[key]);
      return;
    }
    target[key] = source[key];
  });
};

var deepAssign = function deepAssign(target) {
  if (isNil(target)) {
    throw new TypeError('deepAssign "target" cannot be null or undefined');
  }
  var result = Object(target);
  for (var _len2 = arguments.length, sources = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    sources[_key2 - 1] = arguments[_key2];
  }
  sources.forEach(function (source) {
    return deepAssignObject(result, Object(source));
  });
  return result;
};


exports.deepAssign = deepAssign;
var createMerger = function createMerger(content, key) {
  return function (updates) {
    var propertyPath = key.split(".");
    var hostObjectForUpdates = propertyPath.reduce(function (obj, propertyName) {
      obj[propertyName] = obj[propertyName] || {};
      return obj[propertyName];
    }, content);
    deepAssign(hostObjectForUpdates, updates);
  };
};


var createCallbackAggregator = function createCallbackAggregator() {
  var callbacks = [];
  return {
    add: function add(callback) {
      callbacks.push(callback);
    },
    call: function call() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return Promise.all(callbacks.map(function (callback) {
        return callback.apply(void 0, args);
      }));
    }
  };
};


var createLoggingCookieJar = function createLoggingCookieJar(_ref) {
  var logger = _ref.logger,
    cookieJar = _ref.cookieJar;
  return _objectSpread(_objectSpread({}, cookieJar), {}, {
    set: function set(key, value, options) {
      logger.info("Setting cookie", _objectSpread({
        name: key,
        value: value
      }, options));
      cookieJar.set(key, value, options);
    }
  });
};


var createTaskQueue = function createTaskQueue() {
  var queueLength = 0;
  var lastPromiseInQueue = Promise.resolve();
  return {
    addTask: function addTask(task) {
      queueLength += 1;
      var lastPromiseFulfilledHandler = function lastPromiseFulfilledHandler() {
        return task()["finally"](function () {
          queueLength -= 1;
        });
      };
      lastPromiseInQueue = lastPromiseInQueue.then(lastPromiseFulfilledHandler, lastPromiseFulfilledHandler);
      return lastPromiseInQueue;
    },
    get length() {
      return queueLength;
    }
  };
};


var crc32 = function () {
  var table = [];
  for (var _i = 0; _i < 256; _i++) {
    var c = _i;
    for (var j = 0; j < 8; j++) {
      c = c & 1 ? 0xedb88320 ^ c >>> 1 : c >>> 1;
    }
    table.push(c);
  }
  return function (str, crc) {
    str = unescape(encodeURIComponent(str));
    if (!crc) crc = 0;
    crc = crc ^ -1;
    for (var _i2 = 0; _i2 < str.length; _i2++) {
      var y = (crc ^ str.charCodeAt(_i2)) & 0xff;
      crc = crc >>> 8 ^ table[y];
    }
    crc = crc ^ -1;
    return crc >>> 0;
  };
}();


var defer = function defer() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
};

var REFERENCE_EQUALITY = function REFERENCE_EQUALITY(a, b) {
  return a === b;
};
var findIndex = function findIndex(array, item, isEqual) {
  for (var _i3 = 0; _i3 < array.length; _i3 += 1) {
    if (isEqual(array[_i3], item)) {
      return _i3;
    }
  }
  return -1;
};
var deduplicateArray = function deduplicateArray(array) {
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : REFERENCE_EQUALITY;
  return array.filter(function (item, index) {
    return findIndex(array, item, isEqual) === index;
  });
};


var endsWith = function endsWith(str, suffix) {
  return str.substr(-suffix.length) === suffix;
};


var find = function find(arr, predicate) {
  for (var _i4 = 0; _i4 < arr.length; _i4 += 1) {
    var item = arr[_i4];
    if (predicate(item, _i4, arr)) {
      return item;
    }
  }
  return undefined;
};


var appendNode = function appendNode(parent, node) {
  return parent.appendChild(node);
};

var populateElementProperties = function populateElementProperties(element, props) {
  Object.keys(props).forEach(function (key) {
    if (key === "style" && isObject(props[key])) {
      var styleProps = props[key];
      Object.keys(styleProps).forEach(function (styleKey) {
        element.style[styleKey] = styleProps[styleKey];
      });
    } else {
      element[key] = props[key];
    }
  });
};
var createNode = function createNode(tag) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var doc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : document;
  var result = doc.createElement(tag);
  Object.keys(attrs).forEach(function (key) {
    result.setAttribute(key, attrs[key]);
  });
  populateElementProperties(result, props);
  children.forEach(function (child) {
    return appendNode(result, child);
  });
  return result;
};


var BODY = "BODY";
var IFRAME = "IFRAME";
var IMG = "IMG";
var DIV = "DIV";
var STYLE = "STYLE";
var SCRIPT = "SCRIPT";
var HEAD = "HEAD";


var fireImageInDocument = function fireImageInDocument(_ref2) {
  var src = _ref2.src,
    _ref2$currentDocument = _ref2.currentDocument,
    currentDocument = _ref2$currentDocument === void 0 ? document : _ref2$currentDocument;
  return new Promise(function (resolve, reject) {
    var attrs = {
      src: src
    };
    var props = {
      onload: resolve,
      onerror: reject,
      onabort: reject
    };
    createNode(IMG, attrs, props, [], currentDocument);
  });
};


var isFunction = function isFunction(value) {
  return typeof value === "function";
};


var isNonEmptyArray = function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
};


var toArray = function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (value == null) {
    return [];
  }
  return [].slice.call(value);
};

var SIBLING_PATTERN = /^\s*>/;
var querySelectorAll = function querySelectorAll(context, selector) {
  if (!SIBLING_PATTERN.test(selector)) {
    return toArray(context.querySelectorAll(selector));
  }
  var tag = "alloy-".concat(Date.now());

  try {
    context.classList.add(tag);
    return toArray(context.querySelectorAll(".".concat(tag, " ").concat(selector)));
  } finally {
    context.classList.remove(tag);
  }
};


var startsWith = function startsWith(str, prefix) {
  return str.substr(0, prefix.length) === prefix;
};


var SHADOW_SEPARATOR = ":shadow";

var splitWithShadow = function splitWithShadow(selector) {
  return selector.split(SHADOW_SEPARATOR);
};
var transformPrefix = function transformPrefix(parent, selector) {
  var result = selector;
  var hasChildCombinatorPrefix = startsWith(result, ">");
  if (!hasChildCombinatorPrefix) {
    return result;
  }

  if (window.document.documentMode) {
    return result.substring(1).trim();
  }
  var prefix = parent instanceof Element || parent instanceof HTMLDocument ? ":scope" : ":host"; 

  return "".concat(prefix, " ").concat(result);
};
var selectNodesWithShadow = function selectNodesWithShadow(context, selector) {
  if (!window.document.documentElement.attachShadow) {
    return querySelectorAll(context, selector.replace(SHADOW_SEPARATOR, ""));
  }
  var parts = splitWithShadow(selector);
  if (parts.length < 2) {
    return querySelectorAll(context, selector);
  }

  var parent = context;
  for (var _i5 = 0; _i5 < parts.length; _i5 += 1) {
    var part = parts[_i5].trim();
    if (part === "" && parent.shadowRoot) {
      parent = parent.shadowRoot;
      continue;
    }
    var _prefixed = transformPrefix(parent, part);
    var partNode = querySelectorAll(parent, _prefixed);
    if (partNode.length === 0 || !partNode[0] || !partNode[0].shadowRoot) {
      return partNode;
    }
    parent = partNode[0].shadowRoot;
  }
  return undefined;
};

var isShadowSelector = function isShadowSelector(str) {
  return str.indexOf(SHADOW_SEPARATOR) !== -1;
};


var selectNodes = function selectNodes(selector) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  if (!isShadowSelector(selector)) {
    return querySelectorAll(context, selector);
  }
  return selectNodesWithShadow(context, selector);
};

var MUTATION_OBSERVER = "MutationObserver";
var RAF = "requestAnimationFrame";
var MUTATION_OBSERVER_CONFIG = {
  childList: true,
  subtree: true
};
var VISIBILITY_STATE = "visibilityState";
var VISIBLE = "visible";
var DELAY = 100;
var MAX_POLLING_TIMEOUT = 5000;
var createError = function createError(selector) {
  return new Error("Could not find: ".concat(selector));
};
var createPromise = function createPromise(executor) {
  return new Promise(executor);
};
var canUseMutationObserver = function canUseMutationObserver(win) {
  return isFunction(win[MUTATION_OBSERVER]);
};
var awaitUsingMutationObserver = function awaitUsingMutationObserver(win, doc, selector, timeout, selectFunc) {
  return createPromise(function (resolve, reject) {
    var mutationObserver = new win[MUTATION_OBSERVER](function () {
      var nodes = selectFunc(selector);
      if (isNonEmptyArray(nodes)) {
        mutationObserver.disconnect();
        resolve(nodes);
      }
    });
    setTimeout(function () {
      mutationObserver.disconnect();
      reject(createError(selector));
    }, timeout);
    mutationObserver.observe(doc, MUTATION_OBSERVER_CONFIG);
  });
};
var canUseRequestAnimationFrame = function canUseRequestAnimationFrame(doc) {
  return doc[VISIBILITY_STATE] === VISIBLE;
};
var awaitUsingRequestAnimation = function awaitUsingRequestAnimation(win, selector, timeout, selectFunc) {
  return createPromise(function (resolve, reject) {
    var execute = function execute() {
      var nodes = selectFunc(selector);
      if (isNonEmptyArray(nodes)) {
        resolve(nodes);
        return;
      }
      win[RAF](execute);
    };
    execute();
    setTimeout(function () {
      reject(createError(selector));
    }, timeout);
  });
};
var awaitUsingTimer = function awaitUsingTimer(selector, timeout, selectFunc) {
  return createPromise(function (resolve, reject) {
    var execute = function execute() {
      var nodes = selectFunc(selector);
      if (isNonEmptyArray(nodes)) {
        resolve(nodes);
        return;
      }
      setTimeout(execute, DELAY);
    };
    execute();
    setTimeout(function () {
      reject(createError(selector));
    }, timeout);
  });
};
var awaitSelector = function awaitSelector(selector) {
  var selectFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selectNodes;
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_POLLING_TIMEOUT;
  var win = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;
  var doc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : document;
  var nodes = selectFunc(selector);
  if (isNonEmptyArray(nodes)) {
    return Promise.resolve(nodes);
  }
  if (canUseMutationObserver(win)) {
    return awaitUsingMutationObserver(win, doc, selector, timeout, selectFunc);
  }
  if (canUseRequestAnimationFrame(doc)) {
    return awaitUsingRequestAnimation(win, selector, timeout, selectFunc);
  }
  return awaitUsingTimer(selector, timeout, selectFunc);
};


var matchesSelector = function matchesSelector(selector, element) {
  if (element.matches) {
    return element.matches(selector);
  }

  return element.msMatchesSelector(selector);
};


var removeNode = function removeNode(node) {
  var parent = node.parentNode;
  if (parent) {
    return parent.removeChild(node);
  }
  return null;
};

var IFRAME_ATTRS = {
  name: "Adobe Alloy"
};
var IFRAME_PROPS = {
  style: {
    display: "none",
    width: 0,
    height: 0
  }
};
var injectFireReferrerHideableImage = function injectFireReferrerHideableImage() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$appendNode = _ref3.appendNode,
    appendNode$1 = _ref3$appendNode === void 0 ? appendNode : _ref3$appendNode,
    _ref3$awaitSelector = _ref3.awaitSelector,
    awaitSelector$1 = _ref3$awaitSelector === void 0 ? awaitSelector : _ref3$awaitSelector,
    _ref3$createNode = _ref3.createNode,
    createNode$1 = _ref3$createNode === void 0 ? createNode : _ref3$createNode,
    _ref3$fireImage = _ref3.fireImage,
    fireImage = _ref3$fireImage === void 0 ? fireImageInDocument : _ref3$fireImage;
  var fireOnPage = fireImage;
  var hiddenIframe;
  var createIframe = function createIframe() {
    return awaitSelector$1(BODY).then(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        body = _ref5[0];
      if (hiddenIframe) {
        return hiddenIframe;
      }
      hiddenIframe = createNode$1(IFRAME, IFRAME_ATTRS, IFRAME_PROPS);
      return appendNode$1(body, hiddenIframe);
    });
  };
  var fireInIframe = function fireInIframe(_ref6) {
    var src = _ref6.src;
    return createIframe().then(function (iframe) {
      var currentDocument = iframe.contentWindow.document;
      return fireImage({
        src: src,
        currentDocument: currentDocument
      });
    });
  };
  return function (request) {
    var hideReferrer = request.hideReferrer,
      url = request.url;
    return hideReferrer ? fireInIframe({
      src: url
    }) : fireOnPage({
      src: url
    });
  };
};


var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
};


var filterObject = function filterObject(obj, predicate) {
  if (isNil(obj) || !isObject(obj)) {
    return obj;
  }
  return Object.keys(obj).reduce(function (result, key) {
    var value = obj[key];
    if (isObject(value)) {
      var filteredValue = filterObject(value, predicate);
      if (isEmptyObject(filteredValue)) {
        return result;
      }
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, filteredValue));
    }
    if (predicate(value)) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, value));
    }
    return result;
  }, {});
};

var flatMap = function flatMap(array, mapFunction) {
  return Array.prototype.concat.apply([], array.map(mapFunction));
};


var baseNamespace = "com.adobe.alloy.";


var getLastArrayItems = function getLastArrayItems(arr, itemCount) {
  return arr.slice(-itemCount);
};

var cookieName = "".concat(baseNamespace, "getTld");

var getApexDomain = function getApexDomain(window, cookieJar) {
  var topLevelCookieDomain = "";

  var hostParts = window.location.hostname.toLowerCase().split(".");
  var i = 1;
  while (i < hostParts.length && !cookieJar.get(cookieName)) {
    i += 1;
    topLevelCookieDomain = getLastArrayItems(hostParts, i).join(".");
    cookieJar.set(cookieName, cookieName, {
      domain: topLevelCookieDomain
    });
  }
  cookieJar.remove(cookieName, {
    domain: topLevelCookieDomain
  });
  return topLevelCookieDomain;
};


var COOKIE_NAME_PREFIX = "kndctr";


var sanitizeOrgIdForCookieName = function sanitizeOrgIdForCookieName(orgId) {
  return orgId.replace("@", "_");
};

var getNamespacedCookieName = function getNamespacedCookieName(orgId, key) {
  return "".concat(COOKIE_NAME_PREFIX, "_").concat(sanitizeOrgIdForCookieName(orgId), "_").concat(key);
};


var groupBy = function groupBy(arr, keyGetter) {
  var result = {};
  arr.forEach(function (item) {
    var key = keyGetter(item);
    if (!result[key]) {
      result[key] = [];
    }
    result[key].push(item);
  });
  return result;
};


var IDENTITY = "identity";
var CONSENT = "consent";
var CLUSTER = "cluster";

var injectDoesIdentityCookieExist = function injectDoesIdentityCookieExist(_ref7) {
  var orgId = _ref7.orgId;
  var identityCookieName = getNamespacedCookieName(orgId, IDENTITY);
  return function () {
    return Boolean(cookieJar.get(identityCookieName));
  };
};

var getStorageByType = function getStorageByType(context, storageType, namespace) {
  return {
    getItem: function getItem(name) {
      try {
        return context[storageType].getItem(namespace + name);
      } catch (e) {
        return null;
      }
    },
    setItem: function setItem(name, value) {
      try {
        context[storageType].setItem(namespace + name, value);
        return true;
      } catch (e) {
        return false;
      }
    },
    clear: function clear() {
      try {
        Object.keys(context[storageType]).forEach(function (key) {
          if (startsWith(key, namespace)) {
            context[storageType].removeItem(key);
          }
        });
        return true;
      } catch (e) {
        return false;
      }
    }
  };
};
var injectStorage = function injectStorage(context) {
  return function (additionalNamespace) {
    var finalNamespace = baseNamespace + additionalNamespace;
    return {
      session: getStorageByType(context, "sessionStorage", finalNamespace),
      persistent: getStorageByType(context, "localStorage", finalNamespace)
    };
  };
};


var intersection = function intersection(a, b) {
  return a.filter(function (x) {
    return includes(b, x);
  });
};


var isBoolean = function isBoolean(value) {
  return typeof value === "boolean";
};


var isNumber = function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
};


var isInteger = function isInteger(value) {
  var parsed = parseInt(value, 10);
  return isNumber(parsed) && value === parsed;
};


var isNamespacedCookieName = function isNamespacedCookieName(orgId, name) {
  return name.indexOf("".concat(COOKIE_NAME_PREFIX, "_").concat(sanitizeOrgIdForCookieName(orgId), "_")) === 0;
};


var isString = function isString(value) {
  return typeof value === "string";
};


var isNonEmptyString = function isNonEmptyString(value) {
  return isString(value) && value.length > 0;
};


var memoize = function memoize(fn, keyResolver) {
  var map = new Map();
  return function () {
    var key = keyResolver ? keyResolver.apply(void 0, arguments) : arguments.length <= 0 ? undefined : arguments[0];
    if (map.has(key)) {
      return map.get(key);
    }
    var result = fn.apply(void 0, arguments);
    map.set(key, result);
    return result;
  };
};


var noop = function noop() {};


var padStart = function padStart(string, targetLength, padString) {
  var originalString = String(string);
  var repeatedPadString = String(padString);
  if (originalString.length >= targetLength || repeatedPadString.length === 0) {
    return originalString;
  }
  var lengthToAdd = targetLength - originalString.length;
  while (lengthToAdd > repeatedPadString.length) {
    repeatedPadString += repeatedPadString;
  }
  return repeatedPadString.slice(0, lengthToAdd) + originalString;
};
var src = function src(str) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!str) return undefined;
  var o = {
    key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      strict: /^(?:([^:/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?))?((((?:[^?#/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose: /^(?:(?![^:@]+:[^:@/]*@)([^:/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#/]*\.[^?#/.]+(?:[?#]|$)))*\/?)?([^?#/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  };
  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str);
  var uri = {};
  var i = 14;
  while (i--) {
    uri[o.key[i]] = m[i] || '';
  }
  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2;
  });
  return uri;
};

var parseDomainBasic = function parseDomainBasic(host) {
  var result = {};
  var domainParts = host.split(".");
  switch (domainParts.length) {
    case 1:
      result.subdomain = "";
      result.domain = host;
      result.topLevelDomain = "";
      break;
    case 2:
      result.subdomain = "";
      result.domain = host;
      result.topLevelDomain = domainParts[1];
      break;
    case 3:
      result.subdomain = domainParts[0] === "www" ? "" : domainParts[0];
      result.domain = host;
      result.topLevelDomain = domainParts[2];
      break;
    case 4:
      result.subdomain = domainParts[0] === "www" ? "" : domainParts[0];
      result.domain = host;
      result.topLevelDomain = "".concat(domainParts[2], ".").concat(domainParts[3]);
      break;
  }
  return result;
};
var parseUrl = function parseUrl(url) {
  var parseDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : parseDomainBasic;
  if (!isString(url)) {
    url = "";
  }
  var parsed = src(url) || {};
  var _parsed$host = parsed.host,
    host = _parsed$host === void 0 ? "" : _parsed$host,
    _parsed$path = parsed.path,
    path = _parsed$path === void 0 ? "" : _parsed$path,
    _parsed$query = parsed.query,
    query = _parsed$query === void 0 ? "" : _parsed$query,
    _parsed$anchor = parsed.anchor,
    anchor = _parsed$anchor === void 0 ? "" : _parsed$anchor;
  return _objectSpread({
    path: path,
    query: query,
    fragment: anchor
  }, parseDomain(host));
};


var prepareConfigOverridesForEdge = function prepareConfigOverridesForEdge(configuration) {
  if (isNil(configuration) || _typeof(configuration) !== "object") {
    return null;
  }
  var configOverrides = filterObject(configuration, function (value) {
    if (isNil(value)) {
      return false;
    }
    if (isBoolean(value)) {
      return true;
    }
    if (isNumber(value)) {
      return true;
    }
    if (isNonEmptyString(value)) {
      return true;
    }
    if (isNonEmptyArray(value)) {
      return true;
    }
    return false;
  });
  if (isEmptyObject(configOverrides)) {
    return null;
  }
  return configOverrides;
};


var toError = function toError(value) {
  return value instanceof Error ? value : new Error(value);
};


var updateErrorMessage = function updateErrorMessage(_ref8) {
  var error = _ref8.error,
    message = _ref8.message;
  try {
    error.message = message;
  } catch (e) {
  }
};


var stackError = function stackError(_ref9) {
  var error = _ref9.error,
    message = _ref9.message;
  var errorToStack = toError(error);
  var newMessage = "".concat(message, "\nCaused by: ").concat(errorToStack.message);
  updateErrorMessage({
    error: errorToStack,
    message: newMessage
  });
  return errorToStack;
};

var stringToBoolean = function stringToBoolean(str) {
  return isString(str) && str.toLowerCase() === "true";
};


var toInteger = function toInteger(value, defaultValue) {
  if (isNumber(value) || isString(value)) {
    var n = Math.round(Number(value));
    if (!isNaN(n)) {
      return n;
    }
  }
  return defaultValue;
};


var toISOStringLocal = function toISOStringLocal(date) {
  var YYYY = date.getFullYear();
  var MM = padStart(date.getMonth() + 1, 2, "0");
  var DD = padStart(date.getDate(), 2, "0");
  var hh = padStart(date.getHours(), 2, "0");
  var mm = padStart(date.getMinutes(), 2, "0");
  var ss = padStart(date.getSeconds(), 2, "0");
  var mmm = padStart(date.getMilliseconds(), 3, "0");

  var timezoneOffset = toInteger(date.getTimezoneOffset(), 0);
  var ts = timezoneOffset > 0 ? "-" : "+";
  var th = padStart(Math.floor(Math.abs(timezoneOffset) / 60), 2, "0");
  var tm = padStart(Math.abs(timezoneOffset) % 60, 2, "0");
  return "".concat(YYYY, "-").concat(MM, "-").concat(DD, "T").concat(hh, ":").concat(mm, ":").concat(ss, ".").concat(mmm).concat(ts).concat(th, ":").concat(tm);
};
var rngBrowser = createCommonjsModule(function (module) {

  var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
  if (getRandomValues) {
    var rnds8 = new Uint8Array(16); 

    module.exports = function whatwgRNG() {
      getRandomValues(rnds8);
      return rnds8;
    };
  } else {
    var rnds = new Array(16);
    module.exports = function mathRNG() {
      for (var i = 0, r; i < 16; i++) {
        if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
        rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
      }
      return rnds;
    };
  }
});

var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}
function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}
var bytesToUuid_1 = bytesToUuid;
function v4(options, buf, offset) {
  var i = buf && offset || 0;
  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rngBrowser)();

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid_1(rnds);
}
var v4_1 = v4;


var skipIfNull = function skipIfNull(validator) {
  return function skipIfNullValidator(value, path) {
    return value == null ? value : validator.call(this, value, path);
  };
};

var callSequentially = function callSequentially(firstValidator, secondValidator) {
  return function callSequentiallyValidator(value, path) {
    return secondValidator.call(this, firstValidator.call(this, value, path), path);
  };
};

var callSequentiallyJoinErrors = function callSequentiallyJoinErrors(firstValidator, secondValidator) {
  return function callSequentiallyJoinErrorsValidator(value, path) {
    var _this = this;
    var errors = [];
    var newValue = [firstValidator, secondValidator].reduce(function (memo, validator) {
      try {
        return validator.call(_this, memo, path);
      } catch (e) {
        errors.push(e);
        return memo;
      }
    }, value);
    if (errors.length) {
      throw new Error(errors.join("\n"));
    }
    return newValue;
  };
};

var chain = function chain(baseValidator, newValidator, additionalMethods) {
  return (0, _reactorObjectAssign["default"])(callSequentially(baseValidator, newValidator), baseValidator, additionalMethods);
};

var nullSafeChain = function nullSafeChain(baseValidator, newValidator, additionalMethods) {
  return (0, _reactorObjectAssign["default"])(callSequentially(baseValidator, skipIfNull(newValidator)), baseValidator, additionalMethods);
};

var reverseNullSafeChainJoinErrors = function reverseNullSafeChainJoinErrors(baseValidator, newValidator, additionalMethods) {
  return (0, _reactorObjectAssign["default"])(callSequentiallyJoinErrors(skipIfNull(newValidator), baseValidator), baseValidator, additionalMethods);
};

var assertValid = function assertValid(isValid, value, path, message) {
  if (!isValid) {
    throw new Error("'".concat(path, "': Expected ").concat(message, ", but got ").concat(JSON.stringify(value), "."));
  }
};

var booleanValidator = function booleanValidator(value, path) {
  assertValid(isBoolean(value), value, path, "true or false");
  return value;
};

var callbackValidator = function callbackValidator(value, path) {
  assertValid(isFunction(value), value, path, "a function");
  return value;
};

var createArrayOfValidator = function createArrayOfValidator(elementValidator) {
  return function arrayOf(value, path) {
    var _this2 = this;
    assertValid(Array.isArray(value), value, path, "an array");
    var errors = [];
    var validatedArray = value.map(function (subValue, i) {
      try {
        return elementValidator.call(_this2, subValue, "".concat(path, "[").concat(i, "]"), value);
      } catch (e) {
        errors.push(e.message);
        return undefined;
      }
    });
    if (errors.length) {
      throw new Error(errors.join("\n"));
    }
    return validatedArray;
  };
};


var createDefaultValidator = function createDefaultValidator(defaultValue) {
  return function (value) {
    if (value == null) {
      return defaultValue;
    }
    return value;
  };
};

var createDeprecatedValidator = function createDeprecatedValidator(oldField, oldSchema, newField) {
  return function deprecated(value, path) {
    assertValid(isObject(value), value, path, "an object");
    var oldValue = value[oldField],
      newValue = value[newField],
      otherValues = _objectWithoutProperties(value, [oldField, newField].map(_toPropertyKey));
    var validatedOldValue = oldSchema(oldValue, path);
    if (validatedOldValue !== undefined) {
      var message = "The field '".concat(oldField, "' is deprecated. Use '").concat(newField, "' instead.");
      if (path) {
        message = "'".concat(path, "': ").concat(message);
      }
      if (newValue !== undefined && newValue !== validatedOldValue) {
        throw new Error(message);
      } else if (this && this.logger) {
        this.logger.warn(message);
      }
    }
    return _objectSpread(_defineProperty({}, newField, newValue || validatedOldValue), otherValues);
  };
};

var createLiteralValidator = function createLiteralValidator(literalValue) {
  return function (value, path) {
    assertValid(value === literalValue, value, path, "".concat(literalValue));
    return value;
  };
};

var createMapOfValuesValidator = function createMapOfValuesValidator(valueValidator) {
  return function mapOfValues(value, path) {
    var _this3 = this;
    assertValid(isObject(value), value, path, "an object");
    var errors = [];
    var validatedObject = {};
    Object.keys(value).forEach(function (subKey) {
      var subValue = value[subKey];
      var subPath = path ? "".concat(path, ".").concat(subKey) : subKey;
      try {
        var validatedValue = valueValidator.call(_this3, subValue, subPath);
        if (validatedValue !== undefined) {
          validatedObject[subKey] = validatedValue;
        }
      } catch (e) {
        errors.push(e.message);
      }
    });
    if (errors.length) {
      throw new Error(errors.join("\n"));
    }
    return validatedObject;
  };
};

var createMinimumValidator = function createMinimumValidator(typeName, minimum) {
  return function (value, path) {
    assertValid(value >= minimum, value, path, "".concat(typeName, " greater than or equal to ").concat(minimum));
    return value;
  };
};


var createNoUnknownFieldsValidator = function createNoUnknownFieldsValidator(schema) {
  return function (value, path) {
    var errors = [];
    Object.keys(value).forEach(function (subKey) {
      if (!schema[subKey]) {
        var subPath = path ? "".concat(path, ".").concat(subKey) : subKey;
        errors.push("'".concat(subPath, "': Unknown field."));
      }
    });
    if (errors.length) {
      throw new Error(errors.join("\n"));
    }
    return value;
  };
};

var createNonEmptyValidator = function createNonEmptyValidator(message) {
  return function (value, path) {
    if (isObject(value)) {
      assertValid(!isEmptyObject(value), value, path, message);
    } else {
      assertValid(value.length > 0, value, path, message);
    }
    return value;
  };
};

var createObjectOfValidator = function createObjectOfValidator(schema) {
  return function objectOf(value, path) {
    var _this4 = this;
    assertValid(isObject(value), value, path, "an object");
    var errors = [];
    var validatedObject = {};
    Object.keys(schema).forEach(function (subKey) {
      var subValue = value[subKey];
      var subSchema = schema[subKey];
      var subPath = path ? "".concat(path, ".").concat(subKey) : subKey;
      try {
        var validatedValue = subSchema.call(_this4, subValue, subPath);
        if (validatedValue !== undefined) {
          validatedObject[subKey] = validatedValue;
        }
      } catch (e) {
        errors.push(e.message);
      }
    });

    Object.keys(value).forEach(function (subKey) {
      if (!Object.prototype.hasOwnProperty.call(validatedObject, subKey)) {
        validatedObject[subKey] = value[subKey];
      }
    });
    if (errors.length) {
      throw new Error(errors.join("\n"));
    }
    return validatedObject;
  };
};

var createAnyOfValidator = function createAnyOfValidator(validators, message) {
  return function anyOf(value, path) {
    var _this5 = this;
    var newValue;
    var valid = find(validators, function (validator) {
      try {
        newValue = validator.call(_this5, value, path);
        return true;
      } catch (e) {
        return false;
      }
    });
    assertValid(valid, value, path, message);
    return newValue;
  };
};

var createUniqueValidator = function createUniqueValidator() {
  var values = [];
  return function (value, path) {
    assertValid(values.indexOf(value) === -1, value, path, "a unique value across instances");
    values.push(value);
    return value;
  };
};

var isUnique = function isUnique(values) {
  var storedVals = Object.create(null);
  for (var _i6 = 0; _i6 < values.length; _i6 += 1) {
    var item = values[_i6];
    if (item in storedVals) {
      return false;
    }
    storedVals[item] = true;
  }
  return true;
};

var createUniqueItemsValidator = function createUniqueItemsValidator() {
  return function (value, path) {
    assertValid(isUnique(value), value, path, "array values to be unique");
  };
};

var DOMAIN_REGEX = /^[a-z0-9.-]{1,}$/i;
var domainValidator = function domainValidator(value, path) {
  assertValid(DOMAIN_REGEX.test(value), value, path, "a valid domain");
  return value;
};

var integerValidator = function integerValidator(value, path) {
  assertValid(isInteger(value), value, path, "an integer");
  return value;
};

var numberValidator = function numberValidator(value, path) {
  assertValid(isNumber(value), value, path, "a number");
  return value;
};


var isValidRegExp = function isValidRegExp(value) {
  try {
    return new RegExp(value) !== null;
  } catch (e) {
    return false;
  }
};

var regexpValidator = function regexpValidator(value, path) {
  assertValid(isValidRegExp(value), value, path, "a regular expression");
  return value;
};


var requiredValidator = function requiredValidator(value, path) {
  if (value == null) {
    throw new Error("'".concat(path, "' is a required option"));
  }
  return value;
};

var stringValidator = function stringValidator(value, path) {
  assertValid(isString(value), value, path, "a string");
  return value;
};


var base = function base(value) {
  return value;
};

base["default"] = function _default(defaultValue) {
  return chain(this, createDefaultValidator(defaultValue));
};
base.required = function required() {
  return chain(this, requiredValidator);
};

var domain = function domain() {
  return nullSafeChain(this, domainValidator);
};
var minimumInteger = function minimumInteger(minValue) {
  return nullSafeChain(this, createMinimumValidator("an integer", minValue));
};
var minimumNumber = function minimumNumber(minValue) {
  return nullSafeChain(this, createMinimumValidator("a number", minValue));
};
var integer = function integer() {
  return nullSafeChain(this, integerValidator, {
    minimum: minimumInteger
  });
};
var nonEmptyString = function nonEmptyString() {
  return nullSafeChain(this, createNonEmptyValidator("a non-empty string"));
};
var nonEmptyArray = function nonEmptyArray() {
  return nullSafeChain(this, createNonEmptyValidator("a non-empty array"));
};
var nonEmptyObject = function nonEmptyObject() {
  return nullSafeChain(this, createNonEmptyValidator("a non-empty object"));
};
var regexp = function regexp() {
  return nullSafeChain(this, regexpValidator);
};
var unique = function createUnique() {
  return nullSafeChain(this, createUniqueValidator());
};
var uniqueItems = function createUniqueItems() {
  return nullSafeChain(this, createUniqueItemsValidator());
};

var anyOf = function anyOf(validators, message) {
  return chain(this, createAnyOfValidator(validators, message));
};
var anything = function anything() {
  return this;
};
var arrayOf = function arrayOf(elementValidator) {
  return nullSafeChain(this, createArrayOfValidator(elementValidator), {
    nonEmpty: nonEmptyArray,
    uniqueItems: uniqueItems
  });
};
var _boolean = function _boolean2() {
  return nullSafeChain(this, booleanValidator);
};
var callback = function callback() {
  return nullSafeChain(this, callbackValidator);
};
var literal = function literal(literalValue) {
  return nullSafeChain(this, createLiteralValidator(literalValue));
};
var number = function number() {
  return nullSafeChain(this, numberValidator, {
    minimum: minimumNumber,
    integer: integer,
    unique: unique
  });
};
var mapOfValues = function mapOfValues(valuesValidator) {
  return nullSafeChain(this, createMapOfValuesValidator(valuesValidator), {
    nonEmpty: nonEmptyObject
  });
};
var createObjectOfAdditionalProperties = function createObjectOfAdditionalProperties(schema) {
  return {
    noUnknownFields: function noUnknownFields() {
      return nullSafeChain(this, createNoUnknownFieldsValidator(schema));
    },
    nonEmpty: nonEmptyObject,
    concat: function concat(otherObjectOfValidator) {
      var newSchema = _objectSpread(_objectSpread({}, schema), otherObjectOfValidator.schema);
      return nullSafeChain(this, otherObjectOfValidator, createObjectOfAdditionalProperties(newSchema));
    },
    deprecated: function deprecated(oldField, oldSchema, newField) {
      return reverseNullSafeChainJoinErrors(this, createDeprecatedValidator(oldField, oldSchema, newField));
    },
    schema: schema
  };
};
var objectOf = function objectOf(schema) {
  return nullSafeChain(this, createObjectOfValidator(schema), createObjectOfAdditionalProperties(schema));
};
var string = function string() {
  return nullSafeChain(this, stringValidator, {
    regexp: regexp,
    domain: domain,
    nonEmpty: nonEmptyString,
    unique: unique
  });
};
var boundAnyOf = anyOf.bind(base);
var boundAnything = anything.bind(base);
var boundArrayOf = arrayOf.bind(base);
var boundBoolean = _boolean.bind(base);
var boundCallback = callback.bind(base);
var boundLiteral = literal.bind(base);
number.bind(base);
var boundMapOfValues = mapOfValues.bind(base);
var boundObjectOf = objectOf.bind(base);
var boundString = string.bind(base);

var boundEnumOf = function boundEnumOf() {
  for (var _len4 = arguments.length, values = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    values[_key4] = arguments[_key4];
  }
  return boundAnyOf(values.map(boundLiteral), "one of these values: [".concat(JSON.stringify(values), "]"));
};

var AMBIGUOUS = "ambiguous";
var AUTHENTICATED = "authenticated";
var LOGGED_OUT = "loggedOut";

var validateIdentityMap = boundMapOfValues(boundArrayOf(boundObjectOf({
  authenticatedState: boundEnumOf(AMBIGUOUS, AUTHENTICATED, LOGGED_OUT),
  id: boundString(),
  namespace: boundObjectOf({
    code: boundString()
  }).noUnknownFields(),
  primary: boundBoolean(),
  xid: boundString()
}).noUnknownFields()).required());

var validateConfigOverride = boundObjectOf({});


var values = function values(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};


var debugQueryParam = "alloy_debug";

var createLogController = function createLogController(_ref10) {
  var console = _ref10.console,
    locationSearch = _ref10.locationSearch,
    createLogger = _ref10.createLogger,
    instanceName = _ref10.instanceName,
    createNamespacedStorage = _ref10.createNamespacedStorage,
    getMonitors = _ref10.getMonitors;
  var parsedQueryString = _reactorQueryString["default"].parse(locationSearch);
  var storage = createNamespacedStorage("instance.".concat(instanceName, "."));
  var debugSessionValue = storage.session.getItem("debug");
  var debugEnabled = debugSessionValue === "true";
  var debugEnabledWritableFromConfig = debugSessionValue === null;
  var getDebugEnabled = function getDebugEnabled() {
    return debugEnabled;
  };
  var setDebugEnabled = function setDebugEnabled(value, _ref11) {
    var fromConfig = _ref11.fromConfig;
    if (!fromConfig || debugEnabledWritableFromConfig) {
      debugEnabled = value;
    }
    if (!fromConfig) {
      storage.session.setItem("debug", value.toString());
      debugEnabledWritableFromConfig = false;
    }
  };
  if (parsedQueryString[debugQueryParam] !== undefined) {
    setDebugEnabled(stringToBoolean(parsedQueryString[debugQueryParam]), {
      fromConfig: false
    });
  }
  return {
    setDebugEnabled: setDebugEnabled,
    logger: createLogger({
      getDebugEnabled: getDebugEnabled,
      context: {
        instanceName: instanceName
      },
      getMonitors: getMonitors,
      console: console
    }),
    createComponentLogger: function createComponentLogger(componentName) {
      return createLogger({
        getDebugEnabled: getDebugEnabled,
        context: {
          instanceName: instanceName,
          componentName: componentName
        },
        getMonitors: getMonitors,
        console: console
      });
    }
  };
};


var hookNames = [
"onComponentsRegistered",
"onBeforeEvent",
"onBeforeRequest",
"onResponse",
"onRequestFailure",
"onClick",
"onDecision"];
var createHook = function createHook(componentRegistry, hookName) {
  return function () {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    return Promise.all(componentRegistry.getLifecycleCallbacks(hookName).map(function (callback) {
      return new Promise(function (resolve) {
        resolve(callback.apply(void 0, args));
      });
    }));
  };
};

var guardHook = function guardHook(fn) {
  return function () {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }
    return Promise.resolve().then(function () {
      return fn.apply(void 0, args);
    });
  };
};
var createLifecycle = function createLifecycle(componentRegistry) {
  return hookNames.reduce(function (memo, hookName) {
    memo[hookName] = guardHook(createHook(componentRegistry, hookName));
    return memo;
  }, {});
};

var wrapForErrorHandling = function wrapForErrorHandling(fn, stackMessage) {
  return function () {
    var result;
    try {
      result = fn.apply(void 0, arguments);
    } catch (error) {
      throw stackError({
        error: error,
        message: stackMessage
      });
    }
    if (result instanceof Promise) {
      result = result["catch"](function (error) {
        throw stackError({
          error: error,
          message: stackMessage
        });
      });
    }
    return result;
  };
};

var createComponentRegistry = function createComponentRegistry() {
  var commandsByName = {};
  var lifecycleCallbacksByName = {};
  var registerComponentCommands = function registerComponentCommands(namespace) {
    var componentCommandsByName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var conflictingCommandNames = intersection(Object.keys(commandsByName), Object.keys(componentCommandsByName));
    if (conflictingCommandNames.length) {
      throw new Error("[ComponentRegistry] Could not register ".concat(namespace, " ") + "because it has existing command(s): ".concat(conflictingCommandNames.join(",")));
    }
    Object.keys(componentCommandsByName).forEach(function (commandName) {
      var command = componentCommandsByName[commandName];
      command.commandName = commandName;
      command.run = wrapForErrorHandling(command.run, "[".concat(namespace, "] An error occurred while executing the ").concat(commandName, " command."));
      commandsByName[commandName] = command;
    });
  };
  var registerLifecycleCallbacks = function registerLifecycleCallbacks(namespace) {
    var componentLifecycleCallbacksByName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Object.keys(componentLifecycleCallbacksByName).forEach(function (hookName) {
      lifecycleCallbacksByName[hookName] = lifecycleCallbacksByName[hookName] || [];
      lifecycleCallbacksByName[hookName].push(wrapForErrorHandling(componentLifecycleCallbacksByName[hookName], "[".concat(namespace, "] An error occurred while executing the ").concat(hookName, " lifecycle hook.")));
    });
  };
  return {
    register: function register(namespace, component) {
      var commands = component.commands,
        lifecycle = component.lifecycle;
      registerComponentCommands(namespace, commands);
      registerLifecycleCallbacks(namespace, lifecycle);
    },
    getCommand: function getCommand(commandName) {
      return commandsByName[commandName];
    },
    getCommandNames: function getCommandNames() {
      return Object.keys(commandsByName);
    },
    getLifecycleCallbacks: function getLifecycleCallbacks(hookName) {
      return lifecycleCallbacksByName[hookName] || [];
    }
  };
};

var injectSendNetworkRequest = function injectSendNetworkRequest(_ref12) {
  var logger = _ref12.logger,
    sendFetchRequest = _ref12.sendFetchRequest,
    sendBeaconRequest = _ref12.sendBeaconRequest,
    isRequestRetryable = _ref12.isRequestRetryable,
    getRequestRetryDelay = _ref12.getRequestRetryDelay;
  return function (_ref13) {
    var requestId = _ref13.requestId,
      url = _ref13.url,
      payload = _ref13.payload,
      useSendBeacon = _ref13.useSendBeacon;
    var stringifiedPayload = JSON.stringify(payload);
    var parsedPayload = JSON.parse(stringifiedPayload);
    logger.logOnBeforeNetworkRequest({
      url: url,
      requestId: requestId,
      payload: parsedPayload
    });
    var executeRequest = function executeRequest() {
      var retriesAttempted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var requestMethod = useSendBeacon ? sendBeaconRequest : sendFetchRequest;
      return requestMethod(url, stringifiedPayload).then(function (response) {
        var requestIsRetryable = isRequestRetryable({
          response: response,
          retriesAttempted: retriesAttempted
        });
        if (requestIsRetryable) {
          var requestRetryDelay = getRequestRetryDelay({
            response: response,
            retriesAttempted: retriesAttempted
          });
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(executeRequest(retriesAttempted + 1));
            }, requestRetryDelay);
          });
        }
        var parsedBody;
        try {
          parsedBody = JSON.parse(response.body);
        } catch (e) {
        }
        logger.logOnNetworkResponse(_objectSpread(_objectSpread({
          requestId: requestId,
          url: url,
          payload: parsedPayload
        }, response), {}, {
          parsedBody: parsedBody,
          retriesAttempted: retriesAttempted
        }));
        return {
          statusCode: response.statusCode,
          body: response.body,
          parsedBody: parsedBody,
          getHeader: response.getHeader
        };
      });
    };
    return executeRequest()["catch"](function (error) {
      logger.logOnNetworkError({
        requestId: requestId,
        url: url,
        payload: parsedPayload,
        error: error
      });
      throw stackError({
        error: error,
        message: "Network request failed."
      });
    });
  };
};


var injectExtractEdgeInfo = function injectExtractEdgeInfo(_ref14) {
  var logger = _ref14.logger;
  return function (adobeEdgeHeader) {
    if (adobeEdgeHeader) {
      var headerParts = adobeEdgeHeader.split(";");
      if (headerParts.length >= 2 && headerParts[1].length > 0) {
        try {
          var regionId = parseInt(headerParts[1], 10);
          if (!isNaN(regionId)) {
            return {
              regionId: regionId
            };
          }
        } catch (e) {
        }
      }
      logger.warn("Invalid adobe edge: \"".concat(adobeEdgeHeader, "\""));
    }
    return {};
  };
};


var IN = "in";
var OUT = "out";
var PENDING = "pending";


var GENERAL = "general";

var DECLINED_CONSENT_ERROR_CODE = "declinedConsent";
var CONSENT_SOURCE_DEFAULT = "default";
var CONSENT_SOURCE_INITIAL = "initial";
var CONSENT_SOURCE_NEW = "new";
var createDeclinedConsentError = function createDeclinedConsentError(errorMessage) {
  var error = new Error(errorMessage);
  error.code = DECLINED_CONSENT_ERROR_CODE;
  error.message = errorMessage;
  return error;
};
var createConsentStateMachine = function createConsentStateMachine(_ref15) {
  var logger = _ref15.logger;
  var deferreds = [];
  var runAll = function runAll() {
    while (deferreds.length) {
      deferreds.shift().resolve();
    }
  };
  var discardAll = function discardAll() {
    while (deferreds.length) {
      deferreds.shift().reject(createDeclinedConsentError("The user declined consent."));
    }
  };
  var awaitInitial = function awaitInitial() {
    return Promise.reject(new Error("Consent has not been initialized."));
  };
  var awaitInDefault = function awaitInDefault() {
    return Promise.resolve();
  };
  var awaitIn = function awaitIn() {
    return Promise.resolve();
  };
  var awaitOutDefault = function awaitOutDefault() {
    return Promise.reject(createDeclinedConsentError("No consent preferences have been set."));
  };
  var awaitOut = function awaitOut() {
    return Promise.reject(createDeclinedConsentError("The user declined consent."));
  };
  var awaitPending = function awaitPending(returnImmediately) {
    if (returnImmediately) {
      return Promise.reject(new Error("Consent is pending."));
    }
    var deferred = defer();
    deferreds.push(deferred);
    return deferred.promise;
  };
  return {
    "in": function _in(source) {
      if (source === CONSENT_SOURCE_DEFAULT) {
        this.awaitConsent = awaitInDefault;
      } else {
        if (source === CONSENT_SOURCE_INITIAL) {
          logger.info("Loaded user consent preferences. The user previously consented.");
        } else if (source === CONSENT_SOURCE_NEW && this.awaitConsent !== awaitIn) {
          logger.info("User consented.");
        }
        runAll();
        this.awaitConsent = awaitIn;
      }
    },
    out: function out(source) {
      if (source === CONSENT_SOURCE_DEFAULT) {
        logger.warn("User consent preferences not found. Default consent of out will be used.");
        this.awaitConsent = awaitOutDefault;
      } else {
        if (source === CONSENT_SOURCE_INITIAL) {
          logger.warn("Loaded user consent preferences. The user previously declined consent.");
        } else if (source === CONSENT_SOURCE_NEW && this.awaitConsent !== awaitOut) {
          logger.warn("User declined consent.");
        }
        discardAll();
        this.awaitConsent = awaitOut;
      }
    },
    pending: function pending(source) {
      if (source === CONSENT_SOURCE_DEFAULT) {
        logger.info("User consent preferences not found. Default consent of pending will be used. Some commands may be delayed.");
      }
      this.awaitConsent = awaitPending;
    },
    awaitConsent: awaitInitial,
    withConsent: function withConsent() {
      return this.awaitConsent(true);
    }
  };
};

var createConsent = function createConsent(_ref16) {
  var generalConsentState = _ref16.generalConsentState,
    logger = _ref16.logger;
  var _setConsent = function setConsent(consentByPurpose, source) {
    switch (consentByPurpose[GENERAL]) {
      case IN:
        generalConsentState["in"](source);
        break;
      case OUT:
        generalConsentState.out(source);
        break;
      case PENDING:
        generalConsentState.pending(source);
        break;
      default:
        logger.warn("Unknown consent value: ".concat(consentByPurpose[GENERAL]));
        break;
    }
  };
  return {
    initializeConsent: function initializeConsent(defaultConsentByPurpose, storedConsentByPurpose) {
      if (storedConsentByPurpose[GENERAL]) {
        _setConsent(storedConsentByPurpose, CONSENT_SOURCE_INITIAL);
      } else {
        _setConsent(defaultConsentByPurpose, CONSENT_SOURCE_DEFAULT);
      }
    },
    setConsent: function setConsent(consentByPurpose) {
      _setConsent(consentByPurpose, CONSENT_SOURCE_NEW);
    },
    suspend: function suspend() {
      generalConsentState.pending();
    },
    awaitConsent: function awaitConsent() {
      return generalConsentState.awaitConsent();
    },
    withConsent: function withConsent() {
      return generalConsentState.withConsent();
    }
  };
};

var getXdmPropositions = function getXdmPropositions(xdm) {
  return xdm &&
  xdm._experience &&
  xdm._experience.decisioning &&
  isNonEmptyArray(xdm._experience.decisioning.propositions) ?
  xdm._experience.decisioning.propositions : [];
};
var createEvent = function createEvent() {
  var content = {};
  var userXdm;
  var userData;
  var _documentMayUnload = false;
  var isFinalized = false;
  var shouldSendEvent = true;
  var throwIfEventFinalized = function throwIfEventFinalized(methodName) {
    if (isFinalized) {
      throw new Error("".concat(methodName, " cannot be called after event is finalized."));
    }
  };
  var event = {
    hasQuery: function hasQuery() {
      return Object.prototype.hasOwnProperty.call(this.getContent(), "query");
    },
    getContent: function getContent() {
      var currentContent = JSON.parse(JSON.stringify(content));
      if (userXdm) {
        deepAssign(currentContent, {
          xdm: userXdm
        });
      }
      if (userData) {
        deepAssign(currentContent, {
          data: userData
        });
      }
      return currentContent;
    },
    setUserXdm: function setUserXdm(value) {
      throwIfEventFinalized("setUserXdm");
      userXdm = value;
    },
    setUserData: function setUserData(value) {
      throwIfEventFinalized("setUserData");
      userData = value;
    },
    mergeXdm: function mergeXdm(xdm) {
      throwIfEventFinalized("mergeXdm");
      if (xdm) {
        deepAssign(content, {
          xdm: xdm
        });
      }
    },
    mergeData: function mergeData(data) {
      throwIfEventFinalized("mergeData");
      if (data) {
        deepAssign(content, {
          data: data
        });
      }
    },
    mergeMeta: function mergeMeta(meta) {
      throwIfEventFinalized("mergeMeta");
      if (meta) {
        deepAssign(content, {
          meta: meta
        });
      }
    },
    mergeQuery: function mergeQuery(query) {
      throwIfEventFinalized("mergeQuery");
      if (query) {
        deepAssign(content, {
          query: query
        });
      }
    },
    documentMayUnload: function documentMayUnload() {
      _documentMayUnload = true;
    },
    finalize: function finalize(onBeforeEventSend) {
      if (isFinalized) {
        return;
      }
      var newPropositions = deduplicateArray([].concat(_toConsumableArray(getXdmPropositions(userXdm)), _toConsumableArray(getXdmPropositions(content.xdm))), function (a, b) {
        return a === b || a.id && b.id && a.id === b.id && a.scope && b.scope && a.scope === b.scope;
      });
      if (userXdm) {
        this.mergeXdm(userXdm);
      }
      if (newPropositions.length > 0) {
        content.xdm._experience.decisioning.propositions = newPropositions;
      }
      if (userData) {
        event.mergeData(userData);
      }

      isFinalized = true;
      if (onBeforeEventSend) {
        shouldSendEvent = false;

        var tempContent = {
          xdm: content.xdm || {},
          data: content.data || {}
        };
        var result = onBeforeEventSend(tempContent);
        shouldSendEvent = result !== false;
        content.xdm = tempContent.xdm || {};
        content.data = tempContent.data || {};
        if (isEmptyObject(content.xdm)) {
          delete content.xdm;
        }
        if (isEmptyObject(content.data)) {
          delete content.data;
        }
      }
    },
    getDocumentMayUnload: function getDocumentMayUnload() {
      return _documentMayUnload;
    },
    isEmpty: function isEmpty() {
      return isEmptyObject(content) && (!userXdm || isEmptyObject(userXdm)) && (!userData || isEmptyObject(userData));
    },
    shouldSend: function shouldSend() {
      return shouldSendEvent;
    },
    getViewName: function getViewName() {
      if (!userXdm || !userXdm.web || !userXdm.web.webPageDetails) {
        return undefined;
      }
      return userXdm.web.webPageDetails.viewName;
    },
    toJSON: function toJSON() {
      if (!isFinalized) {
        throw new Error("toJSON called before finalize");
      }
      return content;
    }
  };
  return event;
};


var RETRY_AFTER = "Retry-After";
var ADOBE_EDGE = "x-adobe-edge";


var injectCreateResponse = function injectCreateResponse(_ref17) {
  var extractEdgeInfo = _ref17.extractEdgeInfo;
  return function (_ref18) {
    var _ref18$content = _ref18.content,
      content = _ref18$content === void 0 ? {} : _ref18$content,
      getHeader = _ref18.getHeader;
    var _content$handle = content.handle,
      handle = _content$handle === void 0 ? [] : _content$handle,
      _content$errors = content.errors,
      errors = _content$errors === void 0 ? [] : _content$errors,
      _content$warnings = content.warnings,
      warnings = _content$warnings === void 0 ? [] : _content$warnings;
    return {
      getPayloadsByType: function getPayloadsByType(type) {
        return flatMap(handle.filter(function (fragment) {
          return fragment.type === type;
        }), function (fragment) {
          return fragment.payload;
        });
      },
      getErrors: function getErrors() {
        return errors;
      },
      getWarnings: function getWarnings() {
        return warnings;
      },
      getEdge: function getEdge() {
        return extractEdgeInfo(getHeader(ADOBE_EDGE));
      },
      toJSON: function toJSON() {
        return content;
      }
    };
  };
};


var CONFIGURE = "configure";
var SET_DEBUG = "setDebug";

var injectExecuteCommand = function injectExecuteCommand(_ref19) {
  var logger = _ref19.logger,
    configureCommand = _ref19.configureCommand,
    setDebugCommand = _ref19.setDebugCommand,
    handleError = _ref19.handleError,
    validateCommandOptions = _ref19.validateCommandOptions;
  var configurePromise;
  var getExecutor = function getExecutor(commandName, options) {
    var executor;
    if (commandName === CONFIGURE) {
      if (configurePromise) {
        throw new Error("The library has already been configured and may only be configured once.");
      }
      executor = function executor() {
        configurePromise = configureCommand(options);
        return configurePromise.then(function () {
        });
      };
    } else {
      if (!configurePromise) {
        throw new Error("The library must be configured first. Please do so by executing the configure command.");
      }
      if (commandName === SET_DEBUG) {
        executor = function executor() {
          return setDebugCommand(options);
        };
      } else {
        executor = function executor() {
          return configurePromise.then(function (componentRegistry) {
            var command = componentRegistry.getCommand(commandName);
            if (!command || !isFunction(command.run)) {
              var commandNames = [CONFIGURE, SET_DEBUG].concat(componentRegistry.getCommandNames()).join(", ");
              throw new Error("The ".concat(commandName, " command does not exist. List of available commands: ").concat(commandNames, "."));
            }
            var validatedOptions = validateCommandOptions({
              command: command,
              options: options
            });
            return command.run(validatedOptions);
          }, function () {
            logger.warn("An error during configuration is preventing the ".concat(commandName, " command from executing."));
            return new Promise(function () {});
          });
        };
      }
    }
    return executor;
  };
  return function (commandName) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve) {
      var executor = getExecutor(commandName, options);
      logger.logOnBeforeCommand({
        commandName: commandName,
        options: options
      });
      resolve(executor());
    })["catch"](function (error) {
      return handleError(error, "".concat(commandName, " command"));
    })["catch"](function (error) {
      logger.logOnCommandRejected({
        commandName: commandName,
        options: options,
        error: error
      });
      throw error;
    }).then(function (rawResult) {
      var result = isObject(rawResult) ? rawResult : {};
      logger.logOnCommandResolved({
        commandName: commandName,
        options: options,
        result: result
      });
      return result;
    });
  };
};


var COMMAND_DOC_URI = "https://adobe.ly/3sHgQHb";
var validateCommandOptions = function validateCommandOptions(_ref20) {
  var command = _ref20.command,
    options = _ref20.options;
  var commandName = command.commandName,
    _command$documentatio = command.documentationUri,
    documentationUri = _command$documentatio === void 0 ? COMMAND_DOC_URI : _command$documentatio,
    optionsValidator = command.optionsValidator;
  var validatedOptions = options;
  if (optionsValidator) {
    try {
      validatedOptions = optionsValidator(options);
    } catch (validationError) {
      var invalidOptionsMessage = "Invalid ".concat(commandName, " command options:\n\t - ").concat(validationError, " For command documentation see: ").concat(documentationUri);
      throw new Error(invalidOptionsMessage);
    }
  }
  return validatedOptions;
};

var validateUserEventOptions = function validateUserEventOptions(_ref21) {
  var options = _ref21.options;
  var eventOptionsValidator = boundObjectOf({
    type: boundString(),
    xdm: boundObjectOf({
      eventType: boundString(),
      identityMap: validateIdentityMap
    }),
    data: boundObjectOf({}),
    documentUnloading: boundBoolean(),
    renderDecisions: boundBoolean(),
    decisionScopes: boundArrayOf(boundString()).uniqueItems(),
    personalization: boundObjectOf({
      decisionScopes: boundArrayOf(boundString()).uniqueItems(),
      surfaces: boundArrayOf(boundString()).uniqueItems(),
      sendDisplayEvent: boundBoolean()["default"](true),
      includeRenderedPropositions: boundBoolean()["default"](false),
      defaultPersonalizationEnabled: boundBoolean(),
      decisionContext: boundObjectOf({})
    })["default"]({
      sendDisplayEvent: true
    }),
    datasetId: boundString(),
    mergeId: boundString(),
    edgeConfigOverrides: validateConfigOverride,
    initializePersonalization: boundBoolean()
  }).required().noUnknownFields();
  return eventOptionsValidator(options);
};

var validateApplyResponse = function validateApplyResponse(_ref22) {
  var options = _ref22.options;
  var validator = boundObjectOf({
    renderDecisions: boundBoolean(),
    responseHeaders: boundMapOfValues(boundString().required()),
    responseBody: boundObjectOf({
      handle: boundArrayOf(boundObjectOf({
        type: boundString().required(),
        payload: boundAnything().required()
      })).required()
    }).required(),
    personalization: boundObjectOf({
      sendDisplayEvent: boundBoolean()["default"](true),
      decisionContext: boundObjectOf({})
    })["default"]({
      sendDisplayEvent: true
    })
  }).noUnknownFields();
  return validator(options);
};

var createDataCollector = function createDataCollector(_ref23) {
  var eventManager = _ref23.eventManager,
    logger = _ref23.logger;
  return {
    commands: {
      sendEvent: {
        documentationUri: "https://adobe.ly/3GQ3Q7t",
        optionsValidator: function optionsValidator(options) {
          return validateUserEventOptions({
            options: options
          });
        },
        run: function run(options) {
          var xdm = options.xdm,
            data = options.data,
            documentUnloading = options.documentUnloading,
            type = options.type,
            mergeId = options.mergeId,
            datasetId = options.datasetId,
            edgeConfigOverrides = options.edgeConfigOverrides,
            eventManagerOptions = _objectWithoutProperties(options, ["xdm", "data", "documentUnloading", "type", "mergeId", "datasetId", "edgeConfigOverrides"]);
          var event = eventManager.createEvent();
          if (documentUnloading) {
            event.documentMayUnload();
          }
          event.setUserXdm(xdm);
          event.setUserData(data);
          if (type) {
            event.mergeXdm({
              eventType: type
            });
          }
          if (mergeId) {
            event.mergeXdm({
              eventMergeId: mergeId
            });
          }
          if (edgeConfigOverrides) {
            eventManagerOptions.edgeConfigOverrides = edgeConfigOverrides;
          }
          if (datasetId) {
            logger.warn("The 'datasetId' option has been deprecated. Please use 'edgeConfigOverrides.com_adobe_experience_platform.datasets.event.datasetId' instead.");
            eventManagerOptions.edgeConfigOverrides = edgeConfigOverrides || {};
            deepAssign(eventManagerOptions.edgeConfigOverrides, {
              com_adobe_experience_platform: {
                datasets: {
                  event: {
                    datasetId: datasetId
                  }
                }
              }
            });
          }
          return eventManager.sendEvent(event, eventManagerOptions);
        }
      },
      applyResponse: {
        documentationUri: "",
        optionsValidator: function optionsValidator(options) {
          return validateApplyResponse({
            options: options
          });
        },
        run: function run(options) {
          var _options$renderDecisi = options.renderDecisions,
            renderDecisions = _options$renderDecisi === void 0 ? false : _options$renderDecisi,
            _options$decisionCont = options.decisionContext,
            decisionContext = _options$decisionCont === void 0 ? {} : _options$decisionCont,
            _options$responseHead = options.responseHeaders,
            responseHeaders = _options$responseHead === void 0 ? {} : _options$responseHead,
            _options$responseBody = options.responseBody,
            responseBody = _options$responseBody === void 0 ? {
              handle: []
            } : _options$responseBody,
            personalization = options.personalization;
          var event = eventManager.createEvent();
          return eventManager.applyResponse(event, {
            renderDecisions: renderDecisions,
            decisionContext: decisionContext,
            responseHeaders: responseHeaders,
            responseBody: responseBody,
            personalization: personalization
          });
        }
      }
    }
  };
};
createDataCollector.namespace = "DataCollector";

var createClickHandler = function createClickHandler(_ref24) {
  var eventManager = _ref24.eventManager,
    lifecycle = _ref24.lifecycle,
    handleError = _ref24.handleError;
  return function (clickEvent) {
    var clickedElement = clickEvent.target;
    var event = eventManager.createEvent();
    event.documentMayUnload();
    return lifecycle.onClick({
      event: event,
      clickedElement: clickedElement
    }).then(function () {
      if (event.isEmpty()) {
        return Promise.resolve();
      }
      return eventManager.sendEvent(event);
    })
    .then(noop)["catch"](function (error) {
      handleError(error, "click collection");
    });
  };
};
var attachClickActivityCollector = function attachClickActivityCollector(_ref25) {
  var eventManager = _ref25.eventManager,
    lifecycle = _ref25.lifecycle,
    handleError = _ref25.handleError;
  var clickHandler = createClickHandler({
    eventManager: eventManager,
    lifecycle: lifecycle,
    handleError: handleError
  });
  document.addEventListener("click", clickHandler, true);
};

var downloadLinkQualifier = boundString().regexp()["default"]("\\.(exe|zip|wav|mp3|mov|mpg|avi|wmv|pdf|doc|docx|xls|xlsx|ppt|pptx)$");
var configValidators = boundObjectOf({
  clickCollectionEnabled: boundBoolean()["default"](true),
  onBeforeLinkClickSend: boundCallback(),
  downloadLinkQualifier: downloadLinkQualifier
});

var createLinkClick = function createLinkClick(_ref26) {
  var getLinkDetails = _ref26.getLinkDetails,
    config = _ref26.config,
    logger = _ref26.logger;
  var clickCollectionEnabled = config.clickCollectionEnabled;
  if (!clickCollectionEnabled) {
    return function () {
      return undefined;
    };
  }
  return function (_ref27) {
    var targetElement = _ref27.targetElement,
      event = _ref27.event;
    var linkDetails = getLinkDetails({
      targetElement: targetElement,
      config: config,
      logger: logger
    });
    if (linkDetails) {
      event.mergeXdm(linkDetails.xdm);
      event.setUserData(linkDetails.data);
    }
  };
};


var createGetLinkDetails = function createGetLinkDetails(_ref28) {
  var window = _ref28.window,
    getLinkName = _ref28.getLinkName,
    getLinkRegion = _ref28.getLinkRegion,
    getAbsoluteUrlFromAnchorElement = _ref28.getAbsoluteUrlFromAnchorElement,
    findSupportedAnchorElement = _ref28.findSupportedAnchorElement,
    determineLinkType = _ref28.determineLinkType;
  return function (_ref29) {
    var targetElement = _ref29.targetElement,
      config = _ref29.config,
      logger = _ref29.logger;
    var anchorElement = findSupportedAnchorElement(targetElement);
    if (!anchorElement) {
      logger.info("This link click event is not triggered because the HTML element is not an anchor.");
      return undefined;
    }
    var linkUrl = getAbsoluteUrlFromAnchorElement(window, anchorElement);
    if (!linkUrl) {
      logger.info("This link click event is not triggered because the HTML element doesn't have an URL.");
      return undefined;
    }
    var linkType = determineLinkType(window, config, linkUrl, anchorElement);
    var linkRegion = getLinkRegion(anchorElement);
    var linkName = getLinkName(anchorElement);
    var onBeforeLinkClickSend = config.onBeforeLinkClickSend;
    var options = {
      xdm: {
        eventType: "web.webinteraction.linkClicks",
        web: {
          webInteraction: {
            name: linkName,
            region: linkRegion,
            type: linkType,
            URL: linkUrl,
            linkClicks: {
              value: 1
            }
          }
        }
      },
      data: {},
      clickedElement: targetElement
    };
    if (!onBeforeLinkClickSend) {
      return options;
    }
    var shouldEventBeTracked = onBeforeLinkClickSend(options);
    if (shouldEventBeTracked !== false) {
      return options;
    }
    logger.info("This link click event is not triggered because it was canceled in onBeforeLinkClickSend.");
    return undefined;
  };
};


var urlStartsWithScheme = function urlStartsWithScheme(url) {
  return url && /^[a-z0-9]+:\/\//i.test(url);
};
var getAbsoluteUrlFromAnchorElement = function getAbsoluteUrlFromAnchorElement(window, element) {
  var loc = window.location;
  var url = element.href ? element.href : "";
  var protocol = element.protocol,
    host = element.host;
  if (!urlStartsWithScheme(url)) {
    if (!protocol) {
      protocol = loc.protocol ? loc.protocol : "";
    }
    protocol = protocol ? "".concat(protocol, "//") : "";
    if (!host) {
      host = loc.host ? loc.host : "";
    }
    var path = "";
    if (url.substring(0, 1) !== "/") {
      var indx = loc.pathname.lastIndexOf("/");
      indx = indx < 0 ? 0 : indx;
      path = loc.pathname.substring(0, indx);
    }
    url = "".concat(protocol).concat(host).concat(path, "/").concat(url);
  }
  return url;
};
var isSupportedAnchorElement = function isSupportedAnchorElement(element) {
  if (element.href && (element.tagName === "A" || element.tagName === "AREA") && (!element.onclick || !element.protocol || element.protocol.toLowerCase().indexOf("javascript") < 0)) {
    return true;
  }
  return false;
};
var trimQueryFromUrl = function trimQueryFromUrl(url) {
  var questionMarkIndex = url.indexOf("?");
  var hashIndex = url.indexOf("#");
  if (questionMarkIndex >= 0 && (questionMarkIndex < hashIndex || hashIndex < 0)) {
    return url.substring(0, questionMarkIndex);
  }
  if (hashIndex >= 0) {
    return url.substring(0, hashIndex);
  }
  return url;
};
var isDownloadLink = function isDownloadLink(downloadLinkQualifier, linkUrl, clickedObj) {
  var re = new RegExp(downloadLinkQualifier);
  var trimmedLinkUrl = trimQueryFromUrl(linkUrl).toLowerCase();
  return clickedObj.download ? true : re.test(trimmedLinkUrl);
};
var isExitLink = function isExitLink(window, linkUrl) {
  var currentHostname = window.location.hostname.toLowerCase();
  var trimmedLinkUrl = trimQueryFromUrl(linkUrl).toLowerCase();
  if (trimmedLinkUrl.indexOf(currentHostname) >= 0) {
    return false;
  }
  return true;
};

var truncateWhiteSpace = function truncateWhiteSpace(str) {
  return str && str.replace(/\s+/g, " ").trim();
};
var determineLinkType = function determineLinkType(window, config, linkUrl, clickedObj) {
  var linkType = "other";
  if (isDownloadLink(config.downloadLinkQualifier, linkUrl, clickedObj)) {
    linkType = "download";
  } else if (isExitLink(window, linkUrl)) {
    linkType = "exit";
  }
  return linkType;
};
var findSupportedAnchorElement = function findSupportedAnchorElement(targetElement) {
  var node = targetElement;
  while (node) {
    if (isSupportedAnchorElement(node)) {
      return node;
    }
    node = node.parentNode;
  }
  return null;
};

var unsupportedNodeNames = /^(SCRIPT|STYLE|LINK|CANVAS|NOSCRIPT|#COMMENT)$/i;

var isSupportedTextNode = function isSupportedTextNode(node) {
  if (node && node.nodeName) {
    if (node.nodeName.match(unsupportedNodeNames)) {
      return false;
    }
  }
  return true;
};

var extractSupportedNodes = function extractSupportedNodes(node) {
  var supportedNodes = [];
  var includesUnsupportedNodes = false;
  if (isSupportedTextNode(node)) {
    supportedNodes.push(node);
    if (node.childNodes) {
      var childNodes = Array.prototype.slice.call(node.childNodes);
      childNodes.forEach(function (childNode) {
        var nodes = extractSupportedNodes(childNode);
        supportedNodes = supportedNodes.concat(nodes.supportedNodes);
        includesUnsupportedNodes = includesUnsupportedNodes || nodes.includesUnsupportedNodes;
      });
    }
  } else {
    includesUnsupportedNodes = true;
  }
  return {
    supportedNodes: supportedNodes,
    includesUnsupportedNodes: includesUnsupportedNodes
  };
};

var getNodeAttributeValue = function getNodeAttributeValue(node, attributeName, nodeName) {
  var attributeValue;
  if (!nodeName || nodeName === node.nodeName.toUpperCase()) {
    attributeValue = node.getAttribute(attributeName);
  }
  return attributeValue;
};

var getChildrenAttributes = function getChildrenAttributes(nodes) {
  var attributes = {
    texts: []
  };
  nodes.supportedNodes.forEach(function (supportedNode) {
    if (supportedNode.getAttribute) {
      if (!attributes.alt) {
        attributes.alt = truncateWhiteSpace(supportedNode.getAttribute("alt"));
      }
      if (!attributes.title) {
        attributes.title = truncateWhiteSpace(supportedNode.getAttribute("title"));
      }
      if (!attributes.inputValue) {
        attributes.inputValue = truncateWhiteSpace(getNodeAttributeValue(supportedNode, "value", "INPUT"));
      }
      if (!attributes.imgSrc) {
        attributes.imgSrc = truncateWhiteSpace(getNodeAttributeValue(supportedNode, "src", "IMG"));
      }
    }
    if (supportedNode.nodeValue) {
      attributes.texts.push(supportedNode.nodeValue);
    }
  });
  return attributes;
};

var getLinkName = function getLinkName(node) {
  var nodeText = truncateWhiteSpace(node.innerText || node.textContent);
  var nodes = extractSupportedNodes(node);
  if (!nodeText || nodes.includesUnsupportedNodes) {
    var attributesMap = getChildrenAttributes(nodes);
    nodeText = truncateWhiteSpace(attributesMap.texts.join(""));
    if (!nodeText) {
      nodeText = attributesMap.alt || attributesMap.title || attributesMap.inputValue || attributesMap.imgSrc;
    }
  }
  return nodeText || "";
};

var semanticElements = /^(HEADER|MAIN|FOOTER|NAV)$/i;
var getAriaRegionLabel = function getAriaRegionLabel(node) {
  var regionLabel;
  if (node.role === "region" && isNonEmptyString(node["aria-label"])) {
    regionLabel = node["aria-label"];
  }
  return regionLabel;
};
var getSectionNodeName = function getSectionNodeName(node) {
  var nodeName;
  if (node && node.nodeName) {
    if (node.nodeName.match(semanticElements)) {
      nodeName = node.nodeName;
    }
  }
  return nodeName;
};

var getLinkRegion = function getLinkRegion(node) {
  var linkParentNode = node.parentNode;
  var regionName;
  while (linkParentNode) {
    regionName = truncateWhiteSpace(linkParentNode.id || getAriaRegionLabel(linkParentNode) || getSectionNodeName(linkParentNode));
    if (regionName) {
      return regionName;
    }
    linkParentNode = linkParentNode.parentNode;
  }
  return "BODY";
};

var _getLinkDetails = createGetLinkDetails({
  window: window,
  getLinkName: getLinkName,
  getLinkRegion: getLinkRegion,
  getAbsoluteUrlFromAnchorElement: getAbsoluteUrlFromAnchorElement,
  findSupportedAnchorElement: findSupportedAnchorElement,
  determineLinkType: determineLinkType
});
var createActivityCollector = function createActivityCollector(_ref30) {
  var config = _ref30.config,
    eventManager = _ref30.eventManager,
    handleError = _ref30.handleError,
    logger = _ref30.logger;
  var linkClick = createLinkClick({
    getLinkDetails: _getLinkDetails,
    config: config,
    logger: logger
  });
  return {
    lifecycle: {
      onComponentsRegistered: function onComponentsRegistered(tools) {
        var lifecycle = tools.lifecycle;
        attachClickActivityCollector({
          eventManager: eventManager,
          lifecycle: lifecycle,
          handleError: handleError
        });
      },
      onClick: function onClick(_ref31) {
        var event = _ref31.event,
          clickedElement = _ref31.clickedElement;
        linkClick({
          targetElement: clickedElement,
          event: event
        });
      }
    }
  };
};
createActivityCollector.namespace = "ActivityCollector";
createActivityCollector.configValidators = configValidators;
createActivityCollector.buildOnInstanceConfiguredExtraParams = function (_ref32) {
  var config = _ref32.config,
    logger = _ref32.logger;
  return {
    getLinkDetails: function getLinkDetails(targetElement) {
      return _getLinkDetails({
        targetElement: targetElement,
        config: config,
        logger: logger
      });
    }
  };
};

var createResultLogMessage = function createResultLogMessage(idSync, success) {
  return "ID sync ".concat(success ? "succeeded" : "failed", ": ").concat(idSync.spec.url);
};
var injectProcessIdSyncs = function injectProcessIdSyncs(_ref33) {
  var fireReferrerHideableImage = _ref33.fireReferrerHideableImage,
    logger = _ref33.logger;
  return function (idSyncs) {
    var urlIdSyncs = idSyncs.filter(function (idSync) {
      return idSync.type === "url";
    });
    if (!urlIdSyncs.length) {
      return Promise.resolve();
    }
    return Promise.all(urlIdSyncs.map(function (idSync) {
      return fireReferrerHideableImage(idSync.spec).then(function () {
        logger.info(createResultLogMessage(idSync, true));
      })["catch"](function () {
        logger.error(createResultLogMessage(idSync, false));
      });
    })).then(noop);
  };
};

var configValidators$1 = boundObjectOf({
  thirdPartyCookiesEnabled: boundBoolean()["default"](true),
  idMigrationEnabled: boundBoolean()["default"](true)
});

var getIdentityOptionsValidator = boundObjectOf({
  namespaces: boundArrayOf(boundLiteral("ECID")).nonEmpty().uniqueItems()["default"](["ECID"]),
  edgeConfigOverrides: validateConfigOverride
}).noUnknownFields()["default"]({
  namespaces: ["ECID"]
});

var appendIdentityToUrlOptionsValidator = boundObjectOf({
  url: boundString().required().nonEmpty(),
  edgeConfigOverrides: validateConfigOverride
}).required().noUnknownFields();

var createComponent = function createComponent(_ref34) {
  var addEcidQueryToPayload = _ref34.addEcidQueryToPayload,
    addQueryStringIdentityToPayload = _ref34.addQueryStringIdentityToPayload,
    ensureSingleIdentity = _ref34.ensureSingleIdentity,
    setLegacyEcid = _ref34.setLegacyEcid,
    handleResponseForIdSyncs = _ref34.handleResponseForIdSyncs,
    getEcidFromResponse = _ref34.getEcidFromResponse,
    getIdentity = _ref34.getIdentity,
    consent = _ref34.consent,
    appendIdentityToUrl = _ref34.appendIdentityToUrl,
    logger = _ref34.logger;
  var ecid;
  var edge = {};
  return {
    lifecycle: {
      onBeforeRequest: function onBeforeRequest(_ref35) {
        var request = _ref35.request,
          onResponse = _ref35.onResponse,
          onRequestFailure = _ref35.onRequestFailure;
        addEcidQueryToPayload(request.getPayload());
        addQueryStringIdentityToPayload(request.getPayload());
        return ensureSingleIdentity({
          request: request,
          onResponse: onResponse,
          onRequestFailure: onRequestFailure
        });
      },
      onResponse: function onResponse(_ref36) {
        var response = _ref36.response;
        if (!ecid) {
          ecid = getEcidFromResponse(response);

          if (ecid) {
            setLegacyEcid(ecid);
          }
        }
        edge = (0, _reactorObjectAssign["default"])(edge, response.getEdge());
        return handleResponseForIdSyncs(response);
      }
    },
    commands: {
      getIdentity: {
        optionsValidator: getIdentityOptionsValidator,
        run: function run(options) {
          return consent.awaitConsent().then(function () {
            return ecid ? undefined : getIdentity(options);
          }).then(function () {
            return {
              identity: {
                ECID: ecid
              },
              edge: edge
            };
          });
        }
      },
      appendIdentityToUrl: {
        optionsValidator: appendIdentityToUrlOptionsValidator,
        run: function run(options) {
          return consent.withConsent().then(function () {
            return ecid ? undefined : getIdentity(options);
          }).then(function () {
            return {
              url: appendIdentityToUrl(ecid, options.url)
            };
          })["catch"](function (error) {
            logger.warn("Unable to append identity to url. ".concat(error.message));
            return options;
          });
        }
      }
    }
  };
};


var createLegacyIdentity = function createLegacyIdentity(_ref37) {
  var config = _ref37.config,
    getEcidFromVisitor = _ref37.getEcidFromVisitor,
    apexDomain = _ref37.apexDomain,
    isPageSsl = _ref37.isPageSsl,
    cookieJar = _ref37.cookieJar;
  var idMigrationEnabled = config.idMigrationEnabled,
    orgId = config.orgId;
  var amcvCookieName = "AMCV_".concat(orgId);
  var getEcidFromLegacyCookies = function getEcidFromLegacyCookies() {
    var ecid = null;
    var secidCookieName = "s_ecid";
    var legacyEcidCookieValue = cookieJar.get(secidCookieName) || cookieJar.get(amcvCookieName);
    if (legacyEcidCookieValue) {
      var reg = /(^|\|)MCMID\|(\d+)($|\|)/;
      var matches = legacyEcidCookieValue.match(reg);
      if (matches) {
        ecid = matches[2];
      }
    }
    return ecid;
  };
  return {
    getEcid: function getEcid() {
      if (idMigrationEnabled) {
        var ecid = getEcidFromLegacyCookies();
        if (ecid) {
          return Promise.resolve(ecid);
        }
        return getEcidFromVisitor();
      }
      return Promise.resolve();
    },
    setEcid: function setEcid(ecid) {
      if (idMigrationEnabled && getEcidFromLegacyCookies() !== ecid) {
        var extraOptions = isPageSsl ? {
          sameSite: "none",
          secure: true
        } : {};
        cookieJar.set(amcvCookieName, "MCMID|".concat(ecid), _objectSpread({
          domain: apexDomain,
          expires: 390
        }, extraOptions));
      }
    }
  };
};

var awaitVisitorOptIn = function awaitVisitorOptIn(_ref38) {
  var logger = _ref38.logger;
  return new Promise(function (resolve, reject) {
    if (isObject(window.adobe) && isObject(window.adobe.optIn)) {
      var optInOld = window.adobe.optIn;
      logger.info("Delaying request while waiting for legacy opt-in to let Visitor retrieve ECID from server.");
      optInOld.fetchPermissions(function () {
        if (optInOld.isApproved([optInOld.Categories.ECID])) {
          logger.info("Received legacy opt-in approval to let Visitor retrieve ECID from server.");
          resolve();
        } else {
          reject(new Error("Legacy opt-in was declined."));
        }
      }, true);
    } else {
      resolve();
    }
  });
};

var getVisitor = function getVisitor(window) {
  var Visitor = window.Visitor;
  return isFunction(Visitor) && isFunction(Visitor.getInstance) && Visitor;
};

var injectGetEcidFromVisitor = function injectGetEcidFromVisitor(_ref39) {
  var logger = _ref39.logger,
    orgId = _ref39.orgId,
    awaitVisitorOptIn = _ref39.awaitVisitorOptIn;
  return function () {
    var Visitor = getVisitor(window);
    if (Visitor) {
      return awaitVisitorOptIn({
        logger: logger
      }).then(function () {
        logger.info("Delaying request while using Visitor to retrieve ECID from server.");
        return new Promise(function (resolve) {
          var visitor = Visitor.getInstance(orgId, {});
          visitor.getMarketingCloudVisitorID(function (ecid) {
            logger.info("Resuming previously delayed request that was waiting for ECID from Visitor.");
            resolve(ecid);
          }, true);
        });
      })["catch"](function (error) {
        if (error) {
          logger.info("".concat(error.message, ", retrieving ECID from experience edge"));
        } else {
          logger.info("An error occurred while obtaining the ECID from Visitor.");
        }
      });
    }
    return Promise.resolve();
  };
};


var injectHandleResponseForIdSyncs = function injectHandleResponseForIdSyncs(_ref40) {
  var processIdSyncs = _ref40.processIdSyncs;
  return function (response) {
    return processIdSyncs(response.getPayloadsByType("identity:exchange"));
  };
};


var injectEnsureSingleIdentity = function injectEnsureSingleIdentity(_ref41) {
  var doesIdentityCookieExist = _ref41.doesIdentityCookieExist,
    setDomainForInitialIdentityPayload = _ref41.setDomainForInitialIdentityPayload,
    addLegacyEcidToPayload = _ref41.addLegacyEcidToPayload,
    awaitIdentityCookie = _ref41.awaitIdentityCookie,
    logger = _ref41.logger;
  var obtainedIdentityPromise;
  var allowRequestToGoWithoutIdentity = function allowRequestToGoWithoutIdentity(request) {
    setDomainForInitialIdentityPayload(request);
    return addLegacyEcidToPayload(request.getPayload());
  };

  return function (_ref42) {
    var request = _ref42.request,
      onResponse = _ref42.onResponse,
      onRequestFailure = _ref42.onRequestFailure;
    if (doesIdentityCookieExist()) {
      request.setIsIdentityEstablished();
      return Promise.resolve();
    }
    if (obtainedIdentityPromise) {
      logger.info("Delaying request while retrieving ECID from server.");
      var previousObtainedIdentityPromise = obtainedIdentityPromise;

      obtainedIdentityPromise = previousObtainedIdentityPromise["catch"](function () {
        return awaitIdentityCookie({
          onResponse: onResponse,
          onRequestFailure: onRequestFailure
        });
      });

      return previousObtainedIdentityPromise.then(function () {
        logger.info("Resuming previously delayed request.");
        request.setIsIdentityEstablished();
      })
      ["catch"](function () {
        return allowRequestToGoWithoutIdentity(request);
      });
    }

    obtainedIdentityPromise = awaitIdentityCookie({
      onResponse: onResponse,
      onRequestFailure: onRequestFailure
    });
    return allowRequestToGoWithoutIdentity(request);
  };
};


var ecidNamespace = "ECID";

var addEcidQueryToPayload = function addEcidQueryToPayload(payload) {
  payload.mergeQuery({
    identity: {
      fetch: [ecidNamespace]
    }
  });
};

var matchUserAgent = function matchUserAgent(regexs) {
  return function (userAgent) {
    var keys = Object.keys(regexs);
    for (var _i7 = 0; _i7 < keys.length; _i7 += 1) {
      var key = keys[_i7];
      var regex = regexs[key];
      if (regex.test(userAgent)) {
        return key;
      }
    }
    return UNKNOWN;
  };
};
var getBrowser = memoize(function (window) {
  var _matchUserAgent;
  return matchUserAgent((_matchUserAgent = {}, _defineProperty(_matchUserAgent, EDGE, /Edge\/([0-9\._]+)/), _defineProperty(_matchUserAgent, EDGE_CHROMIUM, /Edg\/([0-9\.]+)/), _defineProperty(_matchUserAgent, CHROME, /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/), _defineProperty(_matchUserAgent, FIREFOX, /Firefox\/([0-9\.]+)(?:\s|$)/), _defineProperty(_matchUserAgent, IE, /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/), _defineProperty(_matchUserAgent, SAFARI, /Version\/([0-9\._]+).*Safari/), _matchUserAgent))(window.navigator.userAgent);
});

var injectSetDomainForInitialIdentityPayload = function injectSetDomainForInitialIdentityPayload(_ref43) {
  var thirdPartyCookiesEnabled = _ref43.thirdPartyCookiesEnabled,
    areThirdPartyCookiesSupportedByDefault = _ref43.areThirdPartyCookiesSupportedByDefault;
  return function (request) {
    if (thirdPartyCookiesEnabled && areThirdPartyCookiesSupportedByDefault(getBrowser(window))) {
      request.setUseIdThirdPartyDomain();
    }
  };
};

var injectAddLegacyEcidToPayload = function injectAddLegacyEcidToPayload(_ref44) {
  var getLegacyEcid = _ref44.getLegacyEcid,
    addEcidToPayload = _ref44.addEcidToPayload;
  return function (payload) {
    if (payload.hasIdentity(ecidNamespace)) {
      return Promise.resolve();
    }
    return getLegacyEcid().then(function (ecidToMigrate) {
      if (ecidToMigrate) {
        addEcidToPayload(payload, ecidToMigrate);
      }
    });
  };
};


var queryStringIdentityParam = "adobe_mc";

var LINK_TTL_SECONDS = 300; 

var injectAddQueryStringIdentityToPayload = function injectAddQueryStringIdentityToPayload(_ref45) {
  var locationSearch = _ref45.locationSearch,
    dateProvider = _ref45.dateProvider,
    orgId = _ref45.orgId,
    logger = _ref45.logger;
  return function (payload) {
    if (payload.hasIdentity(ecidNamespace)) {
      return;
    }
    var parsedQueryString = _reactorQueryString["default"].parse(locationSearch);
    var queryStringValue = parsedQueryString[queryStringIdentityParam];
    if (queryStringValue === undefined) {
      return;
    }
    var properties = queryStringValue.split("|").reduce(function (memo, keyValue) {
      var _keyValue$split = keyValue.split("="),
        _keyValue$split2 = _slicedToArray(_keyValue$split, 2),
        key = _keyValue$split2[0],
        value = _keyValue$split2[1];
      memo[key] = value;
      return memo;
    }, {});
    var ts = parseInt(properties.TS, 10);
    var mcmid = properties.MCMID;
    var mcorgid = decodeURIComponent(properties.MCORGID);
    if (
    dateProvider().getTime() / 1000 <= ts + LINK_TTL_SECONDS && mcorgid === orgId && mcmid) {
      logger.info("Found valid ECID identity ".concat(mcmid, " from the adobe_mc query string parameter."));
      payload.addIdentity(ecidNamespace, {
        id: mcmid
      });
    } else {
      logger.info("Detected invalid or expired adobe_mc query string parameter.");
    }
  };
};

var addEcidToPayload = function addEcidToPayload(payload, ecid) {
  payload.addIdentity(ecidNamespace, {
    id: ecid
  });
};


var injectAwaitIdentityCookie = function injectAwaitIdentityCookie(_ref46) {
  var doesIdentityCookieExist = _ref46.doesIdentityCookieExist,
    orgId = _ref46.orgId;
  return function (_ref47) {
    var onResponse = _ref47.onResponse,
      onRequestFailure = _ref47.onRequestFailure;
    return new Promise(function (resolve, reject) {
      onResponse(function () {
        if (doesIdentityCookieExist()) {
          resolve();
        } else {
          var noIdentityCookieError = new Error("An identity was not set properly. Please verify that the org ID ".concat(orgId, " configured in Alloy matches the org ID specified in the edge configuration."));

          reject(noIdentityCookieError);

          throw noIdentityCookieError;
        }
      });
      onRequestFailure(function () {
        if (doesIdentityCookieExist()) {
          resolve();
        } else {
          reject(new Error("No identity was set on response."));
        }
      });
    });
  };
};

var getEcidFromResponse = function getEcidFromResponse(response) {
  var identityResultPayloads = response.getPayloadsByType("identity:result");
  var ecidPayload = find(identityResultPayloads, function (payload) {
    return payload.namespace && payload.namespace.code === ecidNamespace;
  });
  return ecidPayload ? ecidPayload.id : undefined;
};

var createAddIdentity = function createAddIdentity(content) {
  return function (namespaceCode, identity) {
    content.xdm = content.xdm || {};
    content.xdm.identityMap = content.xdm.identityMap || {};
    content.xdm.identityMap[namespaceCode] = content.xdm.identityMap[namespaceCode] || [];
    content.xdm.identityMap[namespaceCode].push(identity);
  };
};


var createRequest = function createRequest(options) {
  var payload = options.payload,
    _getAction = options.getAction,
    _getUseSendBeacon = options.getUseSendBeacon,
    datastreamIdOverride = options.datastreamIdOverride;
  var id = v4_1();
  var shouldUseThirdPartyDomain = false;
  var isIdentityEstablished = false;
  return {
    getId: function getId() {
      return id;
    },
    getPayload: function getPayload() {
      return payload;
    },
    getAction: function getAction() {
      return _getAction({
        isIdentityEstablished: isIdentityEstablished
      });
    },
    getDatastreamIdOverride: function getDatastreamIdOverride() {
      return datastreamIdOverride;
    },
    getUseSendBeacon: function getUseSendBeacon() {
      return _getUseSendBeacon({
        isIdentityEstablished: isIdentityEstablished
      });
    },
    getUseIdThirdPartyDomain: function getUseIdThirdPartyDomain() {
      return shouldUseThirdPartyDomain;
    },
    setUseIdThirdPartyDomain: function setUseIdThirdPartyDomain() {
      shouldUseThirdPartyDomain = true;
    },
    setIsIdentityEstablished: function setIsIdentityEstablished() {
      isIdentityEstablished = true;
    }
  };
};

var createDataCollectionRequest = function createDataCollectionRequest(_ref48) {
  var dataCollectionRequestPayload = _ref48.payload,
    datastreamIdOverride = _ref48.datastreamIdOverride;
  var getUseSendBeacon = function getUseSendBeacon(_ref49) {
    var isIdentityEstablished = _ref49.isIdentityEstablished;
    return dataCollectionRequestPayload.getDocumentMayUnload() && isIdentityEstablished;
  };
  return createRequest({
    payload: dataCollectionRequestPayload,
    getAction: function getAction(_ref50) {
      var isIdentityEstablished = _ref50.isIdentityEstablished;
      return getUseSendBeacon({
        isIdentityEstablished: isIdentityEstablished
      }) ? "collect" : "interact";
    },
    getUseSendBeacon: getUseSendBeacon,
    datastreamIdOverride: datastreamIdOverride
  });
};


var createRequestPayload = function createRequestPayload(options) {
  var content = options.content,
    addIdentity = options.addIdentity,
    hasIdentity = options.hasIdentity;
  var _mergeConfigOverride = createMerger(content, "meta.configOverrides");
  return {
    mergeMeta: createMerger(content, "meta"),
    mergeState: createMerger(content, "meta.state"),
    mergeQuery: createMerger(content, "query"),
    mergeConfigOverride: function mergeConfigOverride(updates) {
      return _mergeConfigOverride(prepareConfigOverridesForEdge(updates));
    },
    addIdentity: addIdentity,
    hasIdentity: hasIdentity,
    toJSON: function toJSON() {
      return content;
    }
  };
};


var createHasIdentity = function createHasIdentity(content) {
  return function (namespaceCode) {
    return (content.xdm && content.xdm.identityMap && content.xdm.identityMap[namespaceCode]) !== undefined;
  };
};

var createDataCollectionRequestPayload = function createDataCollectionRequestPayload() {
  var content = {};
  var payload = createRequestPayload({
    content: content,
    addIdentity: createAddIdentity(content),
    hasIdentity: createHasIdentity(content)
  });
  payload.addEvent = function (event) {
    content.events = content.events || [];
    content.events.push(event);
  };
  payload.getDocumentMayUnload = function () {
    return (content.events || []).some(function (event) {
      return event.getDocumentMayUnload();
    });
  };
  return payload;
};

var createRequestParams = function createRequestParams(_ref51) {
  var localConfigOverrides = _ref51.localConfigOverrides,
    globalConfigOverrides = _ref51.globalConfigOverrides,
    payload = _ref51.payload;
  var requestParams = {
    payload: payload
  };
  var _ref52 = localConfigOverrides || {},
    datastreamId = _ref52.datastreamId,
    localConfigOverridesWithoutDatastreamId = _objectWithoutProperties(_ref52, ["datastreamId"]);
  if (datastreamId) {
    requestParams.datastreamIdOverride = datastreamId;
  }
  payload.mergeConfigOverride(globalConfigOverrides);
  payload.mergeConfigOverride(localConfigOverridesWithoutDatastreamId);
  return requestParams;
};

var ASSURANCE_VALIDATION_SESSION_URL_PARAM = "adb_validation_sessionid";
var ASSURANCE_VALIDATION_NAMESPACE = "validation.";
var CLIENT_ID = "clientId";
var getOrCreateAssuranceClientId = function getOrCreateAssuranceClientId(storage) {
  var clientId = storage.persistent.getItem(CLIENT_ID);
  if (!clientId) {
    clientId = v4_1();
    storage.persistent.setItem(CLIENT_ID, clientId);
  }
  return clientId;
};
var createGetAssuranceValidationTokenParams = function createGetAssuranceValidationTokenParams(_ref53) {
  var window = _ref53.window,
    createNamespacedStorage = _ref53.createNamespacedStorage;
  var storage = createNamespacedStorage(ASSURANCE_VALIDATION_NAMESPACE);
  return function () {
    var parsedQuery = _reactorQueryString["default"].parse(window.location.search);
    var validationSessionId = parsedQuery[ASSURANCE_VALIDATION_SESSION_URL_PARAM];
    if (!validationSessionId) {
      return "";
    }
    var clientId = getOrCreateAssuranceClientId(storage);
    var validationToken = "".concat(validationSessionId, "|").concat(clientId);
    return "&".concat(_reactorQueryString["default"].stringify({
      adobeAepValidationToken: validationToken
    }));
  };
};

var createGetIdentity = function createGetIdentity(_ref54) {
  var sendEdgeNetworkRequest = _ref54.sendEdgeNetworkRequest,
    createIdentityRequestPayload = _ref54.createIdentityRequestPayload,
    createIdentityRequest = _ref54.createIdentityRequest,
    globalConfigOverrides = _ref54.globalConfigOverrides;
  return function () {
    var _ref55 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      namespaces = _ref55.namespaces,
      localConfigOverrides = _ref55.edgeConfigOverrides;
    var requestParams = createRequestParams({
      payload: createIdentityRequestPayload(namespaces),
      globalConfigOverrides: globalConfigOverrides,
      localConfigOverrides: localConfigOverrides
    });
    var request = createIdentityRequest(requestParams);
    return sendEdgeNetworkRequest({
      request: request
    });
  };
};

var createIdentityRequest = function createIdentityRequest(_ref56) {
  var payload = _ref56.payload,
    datastreamIdOverride = _ref56.datastreamIdOverride;
  return createRequest({
    payload: payload,
    datastreamIdOverride: datastreamIdOverride,
    getAction: function getAction() {
      return "identity/acquire";
    },
    getUseSendBeacon: function getUseSendBeacon() {
      return false;
    }
  });
};

var createIdentityRequestPayload = function createIdentityRequestPayload(namespaces) {
  var content = {
    query: {
      identity: {
        fetch: namespaces
      }
    }
  };
  return createRequestPayload({
    content: content,
    addIdentity: createAddIdentity(content),
    hasIdentity: createHasIdentity(content)
  });
};

var URL_REGEX = /^([^?#]*)(\??[^#]*)(#?.*)$/;
var getSeparator = function getSeparator(queryString) {
  if (queryString === "") {
    return "?";
  }
  if (queryString === "?") {
    return "";
  }
  return "&";
};
var injectAppendIdentityToUrl = function injectAppendIdentityToUrl(_ref57) {
  var dateProvider = _ref57.dateProvider,
    orgId = _ref57.orgId;
  return function (ecid, url) {
    var ts = Math.round(dateProvider().getTime() / 1000);
    var adobemc = encodeURIComponent("TS=".concat(ts, "|MCMID=").concat(ecid, "|MCORGID=").concat(encodeURIComponent(orgId)));
    var _url$match = url.match(URL_REGEX),
      _url$match2 = _slicedToArray(_url$match, 4),
      location = _url$match2[1],
      queryString = _url$match2[2],
      fragment = _url$match2[3];
    var separator = getSeparator(queryString);
    return "".concat(location).concat(queryString).concat(separator, "adobe_mc=").concat(adobemc).concat(fragment);
  };
};

var createIdentity = function createIdentity(_ref58) {
  var config = _ref58.config,
    logger = _ref58.logger,
    consent = _ref58.consent,
    fireReferrerHideableImage = _ref58.fireReferrerHideableImage,
    sendEdgeNetworkRequest = _ref58.sendEdgeNetworkRequest,
    apexDomain = _ref58.apexDomain;
  var orgId = config.orgId,
    thirdPartyCookiesEnabled = config.thirdPartyCookiesEnabled,
    globalConfigOverrides = config.edgeConfigOverrides;
  var getEcidFromVisitor = injectGetEcidFromVisitor({
    logger: logger,
    orgId: orgId,
    awaitVisitorOptIn: awaitVisitorOptIn
  });
  var loggingCookieJar = createLoggingCookieJar({
    logger: logger,
    cookieJar: cookieJar
  });
  var legacyIdentity = createLegacyIdentity({
    config: config,
    getEcidFromVisitor: getEcidFromVisitor,
    apexDomain: apexDomain,
    cookieJar: loggingCookieJar,
    isPageSsl: window.location.protocol === "https:"
  });
  var doesIdentityCookieExist = injectDoesIdentityCookieExist({
    orgId: orgId
  });
  var getIdentity = createGetIdentity({
    sendEdgeNetworkRequest: sendEdgeNetworkRequest,
    createIdentityRequestPayload: createIdentityRequestPayload,
    createIdentityRequest: createIdentityRequest,
    globalConfigOverrides: globalConfigOverrides
  });
  var setDomainForInitialIdentityPayload = injectSetDomainForInitialIdentityPayload({
    thirdPartyCookiesEnabled: thirdPartyCookiesEnabled,
    areThirdPartyCookiesSupportedByDefault: areThirdPartyCookiesSupportedByDefault
  });
  var addLegacyEcidToPayload = injectAddLegacyEcidToPayload({
    getLegacyEcid: legacyIdentity.getEcid,
    addEcidToPayload: addEcidToPayload
  });
  var addQueryStringIdentityToPayload = injectAddQueryStringIdentityToPayload({
    locationSearch: window.document.location.search,
    dateProvider: function dateProvider() {
      return new Date();
    },
    orgId: orgId,
    logger: logger
  });
  var awaitIdentityCookie = injectAwaitIdentityCookie({
    doesIdentityCookieExist: doesIdentityCookieExist,
    orgId: orgId
  });
  var ensureSingleIdentity = injectEnsureSingleIdentity({
    doesIdentityCookieExist: doesIdentityCookieExist,
    setDomainForInitialIdentityPayload: setDomainForInitialIdentityPayload,
    addLegacyEcidToPayload: addLegacyEcidToPayload,
    awaitIdentityCookie: awaitIdentityCookie,
    logger: logger
  });
  var processIdSyncs = injectProcessIdSyncs({
    fireReferrerHideableImage: fireReferrerHideableImage,
    logger: logger
  });
  var handleResponseForIdSyncs = injectHandleResponseForIdSyncs({
    processIdSyncs: processIdSyncs
  });
  var appendIdentityToUrl = injectAppendIdentityToUrl({
    dateProvider: function dateProvider() {
      return new Date();
    },
    orgId: orgId,
    globalConfigOverrides: globalConfigOverrides
  });
  return createComponent({
    addEcidQueryToPayload: addEcidQueryToPayload,
    addQueryStringIdentityToPayload: addQueryStringIdentityToPayload,
    ensureSingleIdentity: ensureSingleIdentity,
    setLegacyEcid: legacyIdentity.setEcid,
    handleResponseForIdSyncs: handleResponseForIdSyncs,
    getEcidFromResponse: getEcidFromResponse,
    getIdentity: getIdentity,
    consent: consent,
    appendIdentityToUrl: appendIdentityToUrl,
    logger: logger,
    config: config
  });
};
createIdentity.namespace = "Identity";
createIdentity.configValidators = configValidators$1;

var createResultLogMessage$1 = function createResultLogMessage$1(urlDestination, success) {
  return "URL destination ".concat(success ? "succeeded" : "failed", ": ").concat(urlDestination.spec.url);
};
var injectProcessDestinations = function injectProcessDestinations(_ref59) {
  var fireReferrerHideableImage = _ref59.fireReferrerHideableImage,
    logger = _ref59.logger,
    cookieJar = _ref59.cookieJar,
    isPageSsl = _ref59.isPageSsl;
  var extraCookieOptions = isPageSsl ? {
    sameSite: "none",
    secure: true
  } : {};
  var processCookies = function processCookies(destinations) {
    var cookieDestinations = destinations.filter(function (dest) {
      return dest.type === "cookie";
    });
    cookieDestinations.forEach(function (dest) {
      var _dest$spec = dest.spec,
        name = _dest$spec.name,
        value = _dest$spec.value,
        domain = _dest$spec.domain,
        ttlDays = _dest$spec.ttlDays;
      cookieJar.set(name, value || "", _objectSpread({
        domain: domain || "",
        expires: ttlDays || 10
      }, extraCookieOptions));
    });
  };
  var processUrls = function processUrls(destinations) {
    var urlDestinations = destinations.filter(function (dest) {
      return dest.type === "url";
    });
    return Promise.all(urlDestinations.map(function (urlDestination) {
      return fireReferrerHideableImage(urlDestination.spec).then(function () {
        logger.info(createResultLogMessage$1(urlDestination, true));
      })["catch"](function () {
      });
    })).then(noop);
  };
  return function (destinations) {
    processCookies(destinations);
    return processUrls(destinations);
  };
};


var injectProcessResponse = function injectProcessResponse(_ref60) {
  var processDestinations = _ref60.processDestinations;
  var processPushDestinations = function processPushDestinations(_ref61) {
    var response = _ref61.response;
    var destinations = response.getPayloadsByType("activation:push");
    return processDestinations(destinations);
  };
  var retrievePullDestinations = function retrievePullDestinations(_ref62) {
    var response = _ref62.response;
    return {
      destinations: response.getPayloadsByType("activation:pull")
    };
  };
  return function (_ref63) {
    var response = _ref63.response;
    return processPushDestinations({
      response: response
    }).then(function () {
      return retrievePullDestinations({
        response: response
      });
    });
  };
};

var createAudiences = function createAudiences(_ref64) {
  var logger = _ref64.logger,
    fireReferrerHideableImage = _ref64.fireReferrerHideableImage;
  var cookieJarWithEncoding = cookieJar.withConverter({
    write: function write(value) {
      return encodeURIComponent(value);
    }
  });
  var loggingCookieJar = createLoggingCookieJar({
    logger: logger,
    cookieJar: cookieJarWithEncoding
  });
  var processDestinations = injectProcessDestinations({
    fireReferrerHideableImage: fireReferrerHideableImage,
    logger: logger,
    cookieJar: loggingCookieJar,
    isPageSsl: window.location.protocol === "https:"
  });
  var processResponse = injectProcessResponse({
    processDestinations: processDestinations
  });
  return {
    lifecycle: {
      onResponse: processResponse
    },
    commands: {}
  };
};
createAudiences.namespace = "Audiences";


var WEB = "web";
var WEBAPP = "webapp";
var SURFACE_TYPE_DELIMITER = "://";
var FRAGMENT_DELIMITER = "#";

var SURFACE_REGEX = /^(\w+):\/\/([^/#]+)(\/[^#]*)?(#.*)?$/;
var AUTHORITY_REGEX = /^(?:.*@)?(?:[a-z\d\u00a1-\uffff.-]+|\[[a-f\d:]+])(?::\d+)?$/;
var PATH_REGEX = /^\/(?:[/\w\u00a1-\uffff-.~]|%[a-fA-F\d]{2})*$/;
var FRAGMENT_REGEX = /^#(?:[/\w\u00a1-\uffff-.~]|%[a-fA-F\d]{2})+$/;
var normalizePath = function normalizePath() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var end = path.length;
  while (end > 0 && "/".indexOf(path.charAt(end - 1)) !== -1) {
    end -= 1;
  }
  return path.substring(0, end) || "/";
};
var getSurfaceType = function getSurfaceType(surfaceTypeMatch) {
  return isNonEmptyString(surfaceTypeMatch) ? surfaceTypeMatch.toLowerCase() : "";
};
var getAuthority = function getAuthority(authorityMatch) {
  return isNonEmptyString(authorityMatch) ? authorityMatch.toLowerCase() : "";
};
var getPath = function getPath(pathMatch) {
  return isNonEmptyString(pathMatch) ? normalizePath(pathMatch) : "/";
};
var parseSurface = function parseSurface(surfaceString) {
  var matched = surfaceString.match(SURFACE_REGEX);
  return matched ? {
    surfaceType: getSurfaceType(matched[1]),
    authority: getAuthority(matched[2]),
    path: getPath(matched[3]),
    fragment: matched[4]
  } : null;
};
var stringifySurface = function stringifySurface(surface) {
  return "".concat(surface.surfaceType).concat(SURFACE_TYPE_DELIMITER).concat(surface.authority).concat(surface.path || "").concat(surface.fragment || "");
};
var buildPageSurface = function buildPageSurface(getPageLocation) {
  var location = getPageLocation();
  var host = location.host.toLowerCase();
  var path = location.pathname;
  return WEB + SURFACE_TYPE_DELIMITER + host + normalizePath(path);
};
var expandFragmentSurface = function expandFragmentSurface(surface, getPageLocation) {
  return startsWith(surface, FRAGMENT_DELIMITER) ? buildPageSurface(getPageLocation) + surface : surface;
};
var validateSurface = function validateSurface(surface, getPageLocation, logger) {
  var invalidateSurface = function invalidateSurface(validationError) {
    logger.warn(validationError);
    return null;
  };
  if (!isNonEmptyString(surface)) {
    return invalidateSurface("Invalid surface: ".concat(surface));
  }
  var expanded = expandFragmentSurface(surface, getPageLocation);
  var parsed = parseSurface(expanded);
  if (parsed === null) {
    return invalidateSurface("Invalid surface: ".concat(surface));
  }
  if (!includes([WEB, WEBAPP], parsed.surfaceType)) {
    return invalidateSurface("Unsupported surface type ".concat(parsed.surfaceType, " in surface: ").concat(surface));
  }
  if (!parsed.authority || !AUTHORITY_REGEX.test(parsed.authority)) {
    return invalidateSurface("Invalid authority ".concat(parsed.authority, " in surface: ").concat(surface));
  }
  if (parsed.path && !PATH_REGEX.test(parsed.path)) {
    return invalidateSurface("Invalid path ".concat(parsed.path, " in surface: ").concat(surface));
  }
  if (parsed.fragment && !FRAGMENT_REGEX.test(parsed.fragment)) {
    return invalidateSurface("Invalid fragment ".concat(parsed.fragment, " in surface: ").concat(surface));
  }
  return parsed;
};
var isPageWideSurface = function isPageWideSurface(scope) {
  return !!scope && scope.indexOf(WEB + SURFACE_TYPE_DELIMITER) === 0 && scope.indexOf(FRAGMENT_DELIMITER) === -1;
};
var normalizeSurfaces = function normalizeSurfaces() {
  var surfaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var getPageLocation = arguments.length > 1 ? arguments[1] : undefined;
  var logger = arguments.length > 2 ? arguments[2] : undefined;
  return surfaces.map(function (surface) {
    return validateSurface(surface, getPageLocation, logger);
  }).filter(function (surface) {
    return !isNil(surface);
  }).map(stringifySurface);
};


var PAGE_WIDE_SCOPE = "__view__";


var DEFAULT_CONTENT_ITEM = "https://ns.adobe.com/personalization/default-content-item";
var DOM_ACTION = "https://ns.adobe.com/personalization/dom-action";
var HTML_CONTENT_ITEM = "https://ns.adobe.com/personalization/html-content-item";
var JSON_CONTENT_ITEM = "https://ns.adobe.com/personalization/json-content-item";
var RULESET_ITEM = "https://ns.adobe.com/personalization/ruleset-item";
var REDIRECT_ITEM = "https://ns.adobe.com/personalization/redirect-item";
var MESSAGE_IN_APP = "https://ns.adobe.com/personalization/message/in-app";
var MESSAGE_FEED_ITEM = "https://ns.adobe.com/personalization/message/feed-item";

var addPageWideScope = function addPageWideScope(scopes) {
  if (!includes(scopes, PAGE_WIDE_SCOPE)) {
    scopes.push(PAGE_WIDE_SCOPE);
  }
};
var addPageSurface = function addPageSurface(surfaces, getPageLocation) {
  var pageSurface = buildPageSurface(getPageLocation);
  if (!includes(surfaces, pageSurface)) {
    surfaces.push(pageSurface);
  }
};
var dedupe = function dedupe(array) {
  return array.filter(function (item, pos) {
    return array.indexOf(item) === pos;
  });
};
var createPersonalizationDetails = function createPersonalizationDetails(_ref65) {
  var getPageLocation = _ref65.getPageLocation,
    renderDecisions = _ref65.renderDecisions,
    decisionScopes = _ref65.decisionScopes,
    personalization = _ref65.personalization,
    event = _ref65.event,
    _isCacheInitialized = _ref65.isCacheInitialized,
    logger = _ref65.logger;
  var viewName = event.getViewName();
  return {
    isRenderDecisions: function isRenderDecisions() {
      return renderDecisions;
    },
    isSendDisplayEvent: function isSendDisplayEvent() {
      return !!personalization.sendDisplayEvent;
    },
    shouldIncludeRenderedPropositions: function shouldIncludeRenderedPropositions() {
      return !!personalization.includeRenderedPropositions;
    },
    getViewName: function getViewName() {
      return viewName;
    },
    hasScopes: function hasScopes() {
      return decisionScopes.length > 0 || isNonEmptyArray(personalization.decisionScopes);
    },
    hasSurfaces: function hasSurfaces() {
      return isNonEmptyArray(personalization.surfaces);
    },
    hasViewName: function hasViewName() {
      return isNonEmptyString(viewName);
    },
    createQueryDetails: function createQueryDetails() {
      var scopes = _toConsumableArray(decisionScopes);
      if (isNonEmptyArray(personalization.decisionScopes)) {
        scopes.push.apply(scopes, _toConsumableArray(personalization.decisionScopes));
      }
      var eventSurfaces = normalizeSurfaces(personalization.surfaces, getPageLocation, logger);
      if (this.shouldRequestDefaultPersonalization()) {
        addPageWideScope(scopes);
        addPageSurface(eventSurfaces, getPageLocation);
      }
      var schemas = [DEFAULT_CONTENT_ITEM, HTML_CONTENT_ITEM, JSON_CONTENT_ITEM, REDIRECT_ITEM, RULESET_ITEM, MESSAGE_IN_APP, MESSAGE_FEED_ITEM];
      if (includes(scopes, PAGE_WIDE_SCOPE)) {
        schemas.push(DOM_ACTION);
      }
      return {
        schemas: schemas,
        decisionScopes: dedupe(scopes),
        surfaces: dedupe(eventSurfaces)
      };
    },
    isCacheInitialized: function isCacheInitialized() {
      return _isCacheInitialized;
    },
    shouldFetchData: function shouldFetchData() {
      return this.hasScopes() || this.hasSurfaces() || this.shouldRequestDefaultPersonalization();
    },
    shouldUseCachedData: function shouldUseCachedData() {
      return this.hasViewName() && !this.shouldFetchData();
    },
    shouldRequestDefaultPersonalization: function shouldRequestDefaultPersonalization() {
      return personalization.defaultPersonalizationEnabled || !this.isCacheInitialized() && personalization.defaultPersonalizationEnabled !== false;
    }
  };
};

var AUTHORING_ENABLED = "Rendering is disabled for authoring mode.";


var DISPLAY = "decisioning.propositionDisplay";
var INTERACT = "decisioning.propositionInteract";
var TRIGGER = "decisioning.propositionTrigger";
var DISMISS = "decisioning.propositionDismiss";
var EVENT_TYPE_TRUE = 1;

var PropositionEventType = {
  DISPLAY: "display",
  INTERACT: "interact",
  TRIGGER: "trigger",
  DISMISS: "dismiss"
};
var eventTypeToPropositionEventTypeMapping = (_eventTypeToPropositi = {}, _defineProperty(_eventTypeToPropositi, DISPLAY, PropositionEventType.DISPLAY), _defineProperty(_eventTypeToPropositi, INTERACT, PropositionEventType.INTERACT), _defineProperty(_eventTypeToPropositi, TRIGGER, PropositionEventType.TRIGGER), _defineProperty(_eventTypeToPropositi, DISMISS, PropositionEventType.DISMISS), _eventTypeToPropositi);
var getPropositionEventType = function getPropositionEventType(eventType) {
  return eventTypeToPropositionEventTypeMapping[eventType];
};

var EMPTY_PROPOSITIONS = {
  propositions: []
};
var validateApplyPropositionsOptions = function validateApplyPropositionsOptions(_ref66) {
  var logger = _ref66.logger,
    options = _ref66.options;
  var applyPropositionsOptionsValidator = boundObjectOf({
    propositions: boundArrayOf(boundObjectOf(boundAnything())),
    metadata: boundObjectOf(boundAnything()),
    viewName: boundString()
  }).required();
  try {
    return applyPropositionsOptionsValidator(options);
  } catch (e) {
    logger.warn("Invalid options for applyPropositions. No propositions will be applied.", e);
    return EMPTY_PROPOSITIONS;
  }
};

var createComponent$1 = function createComponent$1(_ref67) {
  var getPageLocation = _ref67.getPageLocation,
    logger = _ref67.logger,
    fetchDataHandler = _ref67.fetchDataHandler,
    viewChangeHandler = _ref67.viewChangeHandler,
    onClickHandler = _ref67.onClickHandler,
    isAuthoringModeEnabled = _ref67.isAuthoringModeEnabled,
    mergeQuery = _ref67.mergeQuery,
    viewCache = _ref67.viewCache,
    showContainers = _ref67.showContainers,
    applyPropositions = _ref67.applyPropositions,
    setTargetMigration = _ref67.setTargetMigration,
    mergeDecisionsMeta = _ref67.mergeDecisionsMeta,
    renderedPropositions = _ref67.renderedPropositions,
    onDecisionHandler = _ref67.onDecisionHandler;
  return {
    lifecycle: {
      onDecision: onDecisionHandler,
      onBeforeRequest: function onBeforeRequest(_ref68) {
        var request = _ref68.request;
        setTargetMigration(request);
        return Promise.resolve();
      },
      onBeforeEvent: function onBeforeEvent(_ref69) {
        var event = _ref69.event,
          renderDecisions = _ref69.renderDecisions,
          _ref69$decisionScopes = _ref69.decisionScopes,
          decisionScopes = _ref69$decisionScopes === void 0 ? [] : _ref69$decisionScopes,
          _ref69$personalizatio = _ref69.personalization,
          personalization = _ref69$personalizatio === void 0 ? {} : _ref69$personalizatio,
          _ref69$onResponse = _ref69.onResponse,
          onResponse = _ref69$onResponse === void 0 ? noop : _ref69$onResponse,
          _ref69$onRequestFailu = _ref69.onRequestFailure,
          onRequestFailure = _ref69$onRequestFailu === void 0 ? noop : _ref69$onRequestFailu;
        onResponse(function () {
          return {
            propositions: []
          };
        });
        onRequestFailure(function () {
          return showContainers();
        });
        if (isAuthoringModeEnabled()) {
          logger.warn(AUTHORING_ENABLED);

          mergeQuery(event, {
            enabled: false
          });
          return Promise.resolve();
        }
        var personalizationDetails = createPersonalizationDetails({
          getPageLocation: getPageLocation,
          renderDecisions: renderDecisions,
          decisionScopes: decisionScopes,
          personalization: personalization,
          event: event,
          isCacheInitialized: viewCache.isInitialized(),
          logger: logger
        });
        var decisionsMetaPromises = [];
        if (personalizationDetails.shouldIncludeRenderedPropositions()) {
          decisionsMetaPromises.push(renderedPropositions.clear());
        }
        if (personalizationDetails.shouldFetchData()) {
          var cacheUpdate = viewCache.createCacheUpdate(personalizationDetails.getViewName());
          onRequestFailure(function () {
            return cacheUpdate.cancel();
          });
          fetchDataHandler({
            cacheUpdate: cacheUpdate,
            personalizationDetails: personalizationDetails,
            event: event,
            onResponse: onResponse
          });
        } else if (personalizationDetails.shouldUseCachedData()) {
          decisionsMetaPromises.push(viewChangeHandler({
            personalizationDetails: personalizationDetails,
            event: event,
            onResponse: onResponse,
            onRequestFailure: onRequestFailure
          }));
        }

        return Promise.all(decisionsMetaPromises).then(function (decisionsMetas) {
          var decisionsMeta = flatMap(decisionsMetas, function (dms) {
            return dms;
          });
          if (isNonEmptyArray(decisionsMeta)) {
            mergeDecisionsMeta(event, decisionsMeta, [PropositionEventType.DISPLAY]);
          }
        });
      },
      onClick: function onClick(_ref70) {
        var event = _ref70.event,
          clickedElement = _ref70.clickedElement;
        onClickHandler({
          event: event,
          clickedElement: clickedElement
        });
      }
    },
    commands: {
      applyPropositions: {
        optionsValidator: function optionsValidator(options) {
          return validateApplyPropositionsOptions({
            logger: logger,
            options: options
          });
        },
        run: applyPropositions
      }
    }
  };
};

var createFragment = function createFragment(content) {
  return createNode(DIV, {}, {
    innerHTML: content
  });
};
var css_escape = createCommonjsModule(function (module, exports) {
  (function (root, factory) {
    {
      module.exports = factory(root);
    }
  })(typeof commonjsGlobal != 'undefined' ? commonjsGlobal : commonjsGlobal, function (root) {
    if (root.CSS && root.CSS.escape) {
      return root.CSS.escape;
    }

    var cssEscape = function cssEscape(value) {
      if (arguments.length == 0) {
        throw new TypeError('`CSS.escape` requires an argument.');
      }
      var string = String(value);
      var length = string.length;
      var index = -1;
      var codeUnit;
      var result = '';
      var firstCodeUnit = string.charCodeAt(0);
      while (++index < length) {
        codeUnit = string.charCodeAt(index);

        if (codeUnit == 0x0000) {
          result += "\uFFFD";
          continue;
        }
        if (
        codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F ||
        index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 ||

        index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002D) {
          result += '\\' + codeUnit.toString(16) + ' ';
          continue;
        }
        if (
        index == 0 && length == 1 && codeUnit == 0x002D) {
          result += '\\' + string.charAt(index);
          continue;
        }

        if (codeUnit >= 0x0080 || codeUnit == 0x002D || codeUnit == 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
          result += string.charAt(index);
          continue;
        }

        result += '\\' + string.charAt(index);
      }
      return result;
    };
    if (!root.CSS) {
      root.CSS = {};
    }
    root.CSS.escape = cssEscape;
    return cssEscape;
  });
});

var EQ_START = ":eq(";
var EQ_PATTERN = /:eq\((\d+)\)/g;
var isNotEqSelector = function isNotEqSelector(str) {
  return str.indexOf(EQ_START) === -1;
};
var splitWithEq = function splitWithEq(selector) {
  return selector.split(EQ_PATTERN).filter(isNonEmptyString);
};


var CSS_IDENTIFIER_PATTERN = /(#|\.)(-?\w+)/g;
var replaceIdentifier = function replaceIdentifier(_, $1, $2) {
  return "".concat($1).concat(css_escape($2));
};
var escapeIdentifiersInSelector = function escapeIdentifiersInSelector(selector) {
  return selector.replace(CSS_IDENTIFIER_PATTERN, replaceIdentifier);
};
var parseSelector = function parseSelector(rawSelector) {
  var result = [];
  var selector = escapeIdentifiersInSelector(rawSelector.trim());
  var parts = splitWithEq(selector);
  var length = parts.length;
  var i = 0;
  while (i < length) {
    var sel = parts[i];
    var eq = parts[i + 1];
    if (eq) {
      result.push({
        sel: sel,
        eq: Number(eq)
      });
    } else {
      result.push({
        sel: sel
      });
    }
    i += 2;
  }
  return result;
};

var selectNodesWithEq = function selectNodesWithEq(selector) {
  var doc = document;
  if (isNotEqSelector(selector)) {
    return selectNodes(selector, doc);
  }
  var parts = parseSelector(selector);
  var length = parts.length;
  var result = [];
  var context = doc;
  var i = 0;
  while (i < length) {
    var _parts$i = parts[i],
      sel = _parts$i.sel,
      eq = _parts$i.eq;
    var nodes = selectNodes(sel, context);
    var nodesCount = nodes.length;
    if (nodesCount === 0) {
      break;
    }
    if (eq != null && eq > nodesCount - 1) {
      break;
    }
    if (i < length - 1) {
      if (eq == null) {
        var _nodes = _slicedToArray(nodes, 1);
        context = _nodes[0];
      } else {
        context = nodes[eq];
      }
    }
    if (i === length - 1) {
      if (eq == null) {
        result = nodes;
      } else {
        result = [nodes[eq]];
      }
    }
    i += 1;
  }
  return result;
};


var getElementById = function getElementById(id) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return context.getElementById(id);
};


var setAttribute = function setAttribute(element, name, value) {
  element.setAttribute(name, value);
};


var getAttribute = function getAttribute(element, name) {
  return element.getAttribute(name);
};


var removeAttribute = function removeAttribute(element, name) {
  element.removeAttribute(name);
};


var setStyle = function setStyle(element, name, value, priority) {
  var css;
  if (priority) {
    css = "".concat(name, ":").concat(value, " !").concat(priority, ";");
  } else {
    css = "".concat(name, ":").concat(value, ";");
  }
  element.style.cssText += ";".concat(css);
};


var getParent = function getParent(element) {
  return element.parentNode;
};


var getNextSibling = function getNextSibling(element) {
  return element.nextElementSibling;
};

var insertAfter = function insertAfter(container, element) {
  if (!container) {
    return;
  }
  var parent = getParent(container);
  if (parent) {
    parent.insertBefore(element, getNextSibling(container));
  }
};

var insertBefore = function insertBefore(container, element) {
  if (!container) {
    return;
  }
  var parent = getParent(container);
  if (parent) {
    parent.insertBefore(element, container);
  }
};

var getChildren = function getChildren(element) {
  var children = element.children;
  if (children) {
    return toArray(children);
  }
  return [];
};

var getChildNodes = function getChildNodes(element) {
  var childNodes = element.childNodes;
  if (childNodes) {
    return toArray(childNodes);
  }
  return [];
};


var getFirstChild = function getFirstChild(element) {
  return element.firstElementChild;
};


var nonce;

var getNonce = function getNonce() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  if (nonce === undefined) {
    var n = context.querySelector("[nonce]");
    nonce = n && (n.nonce || n.getAttribute("nonce"));
  }
  return nonce;
};

var PREHIDING_ID = "alloy-prehiding";
var HIDING_STYLE_DEFINITION = "{ visibility: hidden }";

var styleNodes = {};
var hideElements = function hideElements(prehidingSelector) {
  if (styleNodes[prehidingSelector]) {
    return;
  }
  var nonce = getNonce();
  var attrs = _objectSpread({}, nonce && {
    nonce: nonce
  });
  var props = {
    textContent: "".concat(prehidingSelector, " ").concat(HIDING_STYLE_DEFINITION)
  };
  var node = createNode(STYLE, attrs, props);
  appendNode(document.head, node);
  styleNodes[prehidingSelector] = node;
};
var showElements = function showElements(prehidingSelector) {
  var node = styleNodes[prehidingSelector];
  if (node) {
    removeNode(node);
    delete styleNodes[prehidingSelector];
  }
};
var hideContainers = function hideContainers(prehidingStyle) {
  if (!prehidingStyle) {
    return;
  }

  var node = getElementById(PREHIDING_ID);
  if (node) {
    return;
  }
  var nonce = getNonce();
  var attrs = _objectSpread({
    id: PREHIDING_ID
  }, nonce && {
    nonce: nonce
  });
  var props = {
    textContent: prehidingStyle
  };
  var styleNode = createNode(STYLE, attrs, props);
  appendNode(document.head, styleNode);
};
var showContainers = function showContainers() {
  var node = getElementById(PREHIDING_ID);
  if (!node) {
    return;
  }
  removeNode(node);
};


var setText = function setText(container, text) {
  container.textContent = text;
};


var SRC = "src";

var isImage = function isImage(element) {
  return element.tagName === IMG;
};
var loadImage = function loadImage(url) {
  return createNode(IMG, {
    src: url
  });
};
var loadImages = function loadImages(fragment) {
  var images = selectNodes(IMG, fragment);
  images.forEach(function (image) {
    var url = getAttribute(image, SRC);
    if (url) {
      loadImage(url);
    }
  });
};

var is = function is(element, tagName) {
  return element.tagName === tagName;
};
var isInlineStyleElement = function isInlineStyleElement(element) {
  return is(element, STYLE) && !getAttribute(element, SRC);
};
var addNonceToInlineStyleElements = function addNonceToInlineStyleElements(fragment) {
  var styleNodes = selectNodes(STYLE, fragment);
  var length = styleNodes.length;
  var nonce = getNonce();
  if (!nonce) {
    return;
  }
  for (var _i8 = 0; _i8 < length; _i8 += 1) {
    var element = styleNodes[_i8];
    if (!isInlineStyleElement(element)) {
      continue;
    }
    element.nonce = nonce;
  }
};

var is$1 = function is$1(element, tagName) {
  return !!element && element.tagName === tagName;
};
var isInlineScript = function isInlineScript(element) {
  return is$1(element, SCRIPT) && !getAttribute(element, SRC);
};
var isRemoteScript = function isRemoteScript(element) {
  return is$1(element, SCRIPT) && getAttribute(element, SRC);
};
var getInlineScripts = function getInlineScripts(fragment) {
  var scripts = selectNodes(SCRIPT, fragment);
  var result = [];
  var length = scripts.length;
  var nonce = getNonce();
  var attributes = _objectSpread({}, nonce && {
    nonce: nonce
  });

  for (var _i9 = 0; _i9 < length; _i9 += 1) {
    var element = scripts[_i9];
    if (!isInlineScript(element)) {
      continue;
    }
    var textContent = element.textContent;
    if (!textContent) {
      continue;
    }
    result.push(createNode(SCRIPT, attributes, {
      textContent: textContent
    }));
  }

  return result;
};
var getRemoteScriptsUrls = function getRemoteScriptsUrls(fragment) {
  var scripts = selectNodes(SCRIPT, fragment);
  var result = [];
  var length = scripts.length;
  for (var _i10 = 0; _i10 < length; _i10 += 1) {
    var element = scripts[_i10];
    if (!isRemoteScript(element)) {
      continue;
    }
    var url = getAttribute(element, SRC);
    if (!url) {
      continue;
    }
    result.push(url);
  }

  return result;
};
var executeInlineScripts = function executeInlineScripts(parent, scripts) {
  scripts.forEach(function (script) {
    parent.appendChild(script);
    parent.removeChild(script);
  });
};
var executeRemoteScripts = function executeRemoteScripts(urls) {
  return Promise.all(urls.map(_reactorLoadScript["default"]));
};

var appendHtml = function appendHtml(container, html) {
  var fragment = createFragment(html);
  addNonceToInlineStyleElements(fragment);
  var elements = getChildNodes(fragment);
  var scripts = getInlineScripts(fragment);
  var scriptsUrls = getRemoteScriptsUrls(fragment);
  loadImages(fragment);
  elements.forEach(function (element) {
    appendNode(container, element);
  });
  executeInlineScripts(container, scripts);
  return executeRemoteScripts(scriptsUrls);
};

var clear = function clear(container) {
  var childNodes = getChildNodes(container);
  childNodes.forEach(removeNode);
};
var setHtml = function setHtml(container, html) {
  clear(container);
  appendHtml(container, html);
};

var prependHtml = function prependHtml(container, html) {
  var fragment = createFragment(html);
  addNonceToInlineStyleElements(fragment);
  var elements = getChildNodes(fragment);
  var scripts = getInlineScripts(fragment);
  var scriptsUrls = getRemoteScriptsUrls(fragment);
  var length = elements.length;
  var i = length - 1;

  loadImages(fragment);

  while (i >= 0) {
    var element = elements[i];
    var firstChild = getFirstChild(container);
    if (firstChild) {
      insertBefore(firstChild, element);
    } else {
      appendNode(container, element);
    }
    i -= 1;
  }
  executeInlineScripts(container, scripts);
  return executeRemoteScripts(scriptsUrls);
};

var insertHtmlBefore = function insertHtmlBefore(container, html) {
  var fragment = createFragment(html);
  addNonceToInlineStyleElements(fragment);
  var elements = getChildNodes(fragment);
  var scripts = getInlineScripts(fragment);
  var scriptsUrls = getRemoteScriptsUrls(fragment);
  loadImages(fragment);
  elements.forEach(function (element) {
    insertBefore(container, element);
  });
  executeInlineScripts(container, scripts);
  return executeRemoteScripts(scriptsUrls);
};

var replaceHtml = function replaceHtml(container, html) {
  insertHtmlBefore(container, html);
  removeNode(container);
};

var insertHtmlAfter = function insertHtmlAfter(container, html) {
  var fragment = createFragment(html);
  addNonceToInlineStyleElements(fragment);
  var elements = getChildNodes(fragment);
  var scripts = getInlineScripts(fragment);
  var scriptsUrls = getRemoteScriptsUrls(fragment);
  loadImages(fragment);
  elements.forEach(function (element) {
    insertAfter(container, element);
  });
  executeInlineScripts(container, scripts);
  return executeRemoteScripts(scriptsUrls);
};

var setStyles = function setStyles(container, styles) {
  var priority = styles.priority,
    style = _objectWithoutProperties(styles, ["priority"]);
  Object.keys(style).forEach(function (key) {
    setStyle(container, key, style[key], priority);
  });
};

var setAttributes = function setAttributes(container, attributes) {
  Object.keys(attributes).forEach(function (key) {
    setAttribute(container, key, attributes[key]);
  });
};

var swapImage = function swapImage(container, url) {
  if (!isImage(container)) {
    return;
  }

  loadImage(url);

  removeAttribute(container, SRC);

  setAttribute(container, SRC, url);
};

var rearrangeChildren = function rearrangeChildren(container, _ref71) {
  var from = _ref71.from,
    to = _ref71.to;
  var children = getChildren(container);
  var elementFrom = children[from];
  var elementTo = children[to];
  if (!elementFrom || !elementTo) {
    return;
  }
  if (from < to) {
    insertAfter(elementTo, elementFrom);
  } else {
    insertBefore(elementTo, elementFrom);
  }
};

var renderContent = function renderContent(elements, content, renderFunc) {
  var executions = elements.map(function (element) {
    return renderFunc(element, content);
  });
  return Promise.all(executions);
};
var createAction = function createAction(renderFunc) {
  return function (itemData) {
    var selector = itemData.selector,
      prehidingSelector = itemData.prehidingSelector,
      content = itemData.content;
    hideElements(prehidingSelector);
    return awaitSelector(selector, selectNodesWithEq).then(function (elements) {
      return renderContent(elements, content, renderFunc);
    }).then(function () {
      showElements(prehidingSelector);
    }, function (error) {
      showElements(prehidingSelector);
      throw error;
    });
  };
};

var initDomActionsModules = function initDomActionsModules() {
  return {
    setHtml: createAction(setHtml),
    customCode: createAction(prependHtml),
    setText: createAction(setText),
    setAttribute: createAction(setAttributes),
    setImageSource: createAction(swapImage),
    setStyle: createAction(setStyles),
    move: createAction(setStyles),
    resize: createAction(setStyles),
    rearrange: createAction(rearrangeChildren),
    remove: createAction(removeNode),
    insertAfter: createAction(insertHtmlAfter),
    insertBefore: createAction(insertHtmlBefore),
    replaceHtml: createAction(replaceHtml),
    prependHtml: createAction(prependHtml),
    appendHtml: createAction(appendHtml)
  };
};

var createCollect = function createCollect(_ref72) {
  var eventManager = _ref72.eventManager,
    mergeDecisionsMeta = _ref72.mergeDecisionsMeta;
  return function (_ref73) {
    var _ref73$decisionsMeta = _ref73.decisionsMeta,
      decisionsMeta = _ref73$decisionsMeta === void 0 ? [] : _ref73$decisionsMeta,
      propositionAction = _ref73.propositionAction,
      _ref73$documentMayUnl = _ref73.documentMayUnload,
      documentMayUnload = _ref73$documentMayUnl === void 0 ? false : _ref73$documentMayUnl,
      _ref73$eventType = _ref73.eventType,
      eventType = _ref73$eventType === void 0 ? DISPLAY : _ref73$eventType,
      _ref73$propositionEve = _ref73.propositionEventTypes,
      propositionEventTypes = _ref73$propositionEve === void 0 ? [getPropositionEventType(eventType)] : _ref73$propositionEve,
      viewName = _ref73.viewName;
    var event = eventManager.createEvent();
    var data = {
      eventType: eventType
    };
    if (viewName) {
      data.web = {
        webPageDetails: {
          viewName: viewName
        }
      };
    }
    if (isNonEmptyArray(decisionsMeta)) {
      mergeDecisionsMeta(event, decisionsMeta, propositionEventTypes, propositionAction);
    }
    event.mergeXdm(data);
    if (documentMayUnload) {
      event.documentMayUnload();
    }
    return eventManager.sendEvent(event);
  };
};

var DECISIONS_HANDLE = "personalization:decisions";
var createFetchDataHandler = function createFetchDataHandler(_ref74) {
  var prehidingStyle = _ref74.prehidingStyle,
    showContainers = _ref74.showContainers,
    hideContainers = _ref74.hideContainers,
    mergeQuery = _ref74.mergeQuery,
    processPropositions = _ref74.processPropositions,
    createProposition = _ref74.createProposition,
    notificationHandler = _ref74.notificationHandler;
  return function (_ref75) {
    var cacheUpdate = _ref75.cacheUpdate,
      personalizationDetails = _ref75.personalizationDetails,
      event = _ref75.event,
      onResponse = _ref75.onResponse;
    if (personalizationDetails.isRenderDecisions()) {
      hideContainers(prehidingStyle);
    } else {
      showContainers();
    }
    mergeQuery(event, personalizationDetails.createQueryDetails());
    var handleNotifications = notificationHandler(personalizationDetails.isSendDisplayEvent(), personalizationDetails.getViewName());
    onResponse(function (_ref76) {
      var response = _ref76.response;
      var handles = response.getPayloadsByType(DECISIONS_HANDLE);
      var propositions = handles.map(function (handle) {
        return createProposition(handle);
      });
      var _groupBy = groupBy(propositions, function (p) {
          return p.getScopeType();
        }),
        _groupBy$page = _groupBy.page,
        pagePropositions = _groupBy$page === void 0 ? [] : _groupBy$page,
        _groupBy$view = _groupBy.view,
        viewPropositions = _groupBy$view === void 0 ? [] : _groupBy$view,
        _groupBy$proposition = _groupBy.proposition,
        nonRenderedPropositions = _groupBy$proposition === void 0 ? [] : _groupBy$proposition;
      var currentViewPropositions = cacheUpdate.update(viewPropositions);
      var render;
      var returnedPropositions;
      var returnedDecisions;
      if (personalizationDetails.isRenderDecisions()) {
        var _processPropositions = processPropositions([].concat(_toConsumableArray(pagePropositions), _toConsumableArray(currentViewPropositions)), nonRenderedPropositions);
        render = _processPropositions.render;
        returnedPropositions = _processPropositions.returnedPropositions;
        returnedDecisions = _processPropositions.returnedDecisions;
        render().then(handleNotifications);

        showContainers();
      } else {
        var _processPropositions2 = processPropositions([], [].concat(_toConsumableArray(pagePropositions), _toConsumableArray(currentViewPropositions), _toConsumableArray(nonRenderedPropositions)));
        returnedPropositions = _processPropositions2.returnedPropositions;
        returnedDecisions = _processPropositions2.returnedDecisions;
      }
      return {
        propositions: returnedPropositions,
        decisions: returnedDecisions
      };
    });
  };
};

var matchesSelectorWithEq = function matchesSelectorWithEq(selector, element) {
  if (isNotEqSelector(selector)) {
    return matchesSelector(selector, element);
  }

  var nodes = selectNodesWithEq(selector);
  var result = false;

  for (var _i11 = 0; _i11 < nodes.length; _i11 += 1) {
    if (nodes[_i11] === element) {
      result = true;
      break;
    }
  }
  return result;
};


var VIEW_SCOPE_TYPE = "view";
var PAGE_SCOPE_TYPE = "page";
var PROPOSITION_SCOPE_TYPE = "proposition";

var getMetasIfMatches = function getMetasIfMatches(clickedElement, selector, getClickMetasBySelector) {
  var _document = document,
    documentElement = _document.documentElement;
  var element = clickedElement;
  var i = 0;
  while (element && element !== documentElement) {
    if (matchesSelectorWithEq(selector, element)) {
      var matchedMetas = getClickMetasBySelector(selector);
      var returnValue = {
        metas: matchedMetas
      };
      var foundMetaWithLabel = matchedMetas.find(function (meta) {
        return meta.trackingLabel;
      });
      if (foundMetaWithLabel) {
        returnValue.label = foundMetaWithLabel.trackingLabel;
        returnValue.weight = i;
      }
      var foundMetaWithScopeTypeView = matchedMetas.find(function (meta) {
        return meta.scopeType === VIEW_SCOPE_TYPE;
      });
      if (foundMetaWithScopeTypeView) {
        returnValue.viewName = foundMetaWithScopeTypeView.scope;
        returnValue.weight = i;
      }
      return returnValue;
    }
    element = element.parentNode;
    i += 1;
  }
  return {
    metas: null
  };
};
var cleanMetas = function cleanMetas(metas) {
  return metas.map(function (meta) {
    var trackingLabel = meta.trackingLabel,
      scopeType = meta.scopeType,
      rest = _objectWithoutProperties(meta, ["trackingLabel", "scopeType"]);
    return rest;
  });
};
var dedupMetas = function dedupMetas(metas) {
  return metas.filter(function (meta, index) {
    var stringifiedMeta = JSON.stringify(meta);
    return index === metas.findIndex(function (innerMeta) {
      return JSON.stringify(innerMeta) === stringifiedMeta;
    });
  });
};
var collectClicks = function collectClicks(clickedElement, selectors, getClickMetasBySelector) {
  var result = [];
  var resultLabel = "";
  var resultLabelWeight = Number.MAX_SAFE_INTEGER;
  var resultViewName;
  var resultViewNameWeight = Number.MAX_SAFE_INTEGER;

  for (var _i12 = 0; _i12 < selectors.length; _i12 += 1) {
    var _getMetasIfMatches = getMetasIfMatches(clickedElement, selectors[_i12], getClickMetasBySelector),
      metas = _getMetasIfMatches.metas,
      label = _getMetasIfMatches.label,
      weight = _getMetasIfMatches.weight,
      viewName = _getMetasIfMatches.viewName;
    if (!metas) {
      continue;
    }
    if (label && weight <= resultLabelWeight) {
      resultLabel = label;
      resultLabelWeight = weight;
    }
    if (viewName && weight <= resultViewNameWeight) {
      resultViewName = viewName;
      resultViewNameWeight = weight;
    }
    result.push.apply(result, _toConsumableArray(cleanMetas(metas)));
  }
  return {
    decisionsMeta: dedupMetas(result),
    eventLabel: resultLabel,
    viewName: resultViewName
  };
};


var isAuthoringModeEnabled = function isAuthoringModeEnabled() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  return doc.location.href.indexOf("adobe_authoring_enabled") !== -1;
};


var mergeDecisionsMeta = function mergeDecisionsMeta(event, decisionsMeta, propositionEventTypes, propositionAction) {
  if (decisionsMeta.length === 0) {
    return;
  }
  var propositionEventType = {};
  propositionEventTypes.forEach(function (type) {
    propositionEventType[type] = EVENT_TYPE_TRUE;
  });
  var xdm = {
    _experience: {
      decisioning: {
        propositions: decisionsMeta,
        propositionEventType: propositionEventType
      }
    }
  };
  if (propositionAction) {
    xdm._experience.decisioning.propositionAction = propositionAction;
  }
  event.mergeXdm(xdm);
};
var mergeQuery = function mergeQuery(event, details) {
  event.mergeQuery({
    personalization: _objectSpread({}, details)
  });
};

var createOnClickHandler = function createOnClickHandler(_ref77) {
  var mergeDecisionsMeta = _ref77.mergeDecisionsMeta,
    collectClicks = _ref77.collectClicks,
    getClickSelectors = _ref77.getClickSelectors,
    getClickMetasBySelector = _ref77.getClickMetasBySelector;
  return function (_ref78) {
    var event = _ref78.event,
      clickedElement = _ref78.clickedElement;
    var selectors = getClickSelectors();
    if (isNonEmptyArray(selectors)) {
      var _collectClicks = collectClicks(clickedElement, selectors, getClickMetasBySelector),
        decisionsMeta = _collectClicks.decisionsMeta,
        eventLabel = _collectClicks.eventLabel,
        viewName = _collectClicks.viewName;
      if (isNonEmptyArray(decisionsMeta)) {
        var xdm = {
          eventType: INTERACT
        };
        if (viewName) {
          xdm.web = {
            webPageDetails: {
              viewName: viewName
            }
          };
        }
        event.mergeXdm(xdm);
        mergeDecisionsMeta(event, decisionsMeta, [PropositionEventType.INTERACT], eventLabel ? {
          label: eventLabel
        } : undefined);
      }
    }
  };
};

var createViewCacheManager = function createViewCacheManager(_ref79) {
  var createProposition = _ref79.createProposition;
  var cacheUpdateCreatedAtLeastOnce = false;
  var viewStoragePromise = Promise.resolve({});
  var getViewPropositions = function getViewPropositions(viewStorage, viewName) {
    var viewPropositions = viewStorage[viewName.toLowerCase()];
    if (viewPropositions && viewPropositions.length > 0) {
      return viewPropositions;
    }
    var emptyViewProposition = createProposition({
      scope: viewName,
      scopeDetails: {
        characteristics: {
          scopeType: VIEW_SCOPE_TYPE
        }
      },
      items: [{
        schema: DEFAULT_CONTENT_ITEM
      }]
    }, false);
    return [emptyViewProposition];
  };

  var createCacheUpdate = function createCacheUpdate(viewName) {
    var updateCacheDeferred = defer();
    cacheUpdateCreatedAtLeastOnce = true;

    viewStoragePromise = viewStoragePromise.then(function (oldViewStorage) {
      return updateCacheDeferred.promise.then(function (newViewStorage) {
        return (0, _reactorObjectAssign["default"])({}, oldViewStorage, newViewStorage);
      })["catch"](function () {
        return oldViewStorage;
      });
    });
    return {
      update: function update(viewPropositions) {
        var viewPropositionsWithScope = viewPropositions.filter(function (proposition) {
          return proposition.getScope();
        });
        var newViewStorage = groupBy(viewPropositionsWithScope, function (proposition) {
          return proposition.getScope().toLowerCase();
        });
        updateCacheDeferred.resolve(newViewStorage);
        if (viewName) {
          return getViewPropositions(newViewStorage, viewName);
        }
        return [];
      },
      cancel: function cancel() {
        updateCacheDeferred.reject();
      }
    };
  };
  var getView = function getView(viewName) {
    return viewStoragePromise.then(function (viewStorage) {
      return getViewPropositions(viewStorage, viewName);
    });
  };
  var isInitialized = function isInitialized() {
    return cacheUpdateCreatedAtLeastOnce;
  };
  return {
    createCacheUpdate: createCacheUpdate,
    getView: getView,
    isInitialized: isInitialized
  };
};


var createViewChangeHandler = function createViewChangeHandler(_ref80) {
  var processPropositions = _ref80.processPropositions,
    viewCache = _ref80.viewCache;
  return function (_ref81) {
    var personalizationDetails = _ref81.personalizationDetails,
      onResponse = _ref81.onResponse;
    var returnedPropositions;
    var returnedDecisions;
    var viewName = personalizationDetails.getViewName();
    onResponse(function () {
      return {
        propositions: returnedPropositions,
        decisions: returnedDecisions
      };
    });
    return viewCache.getView(viewName).then(function (propositions) {
      var render;
      if (personalizationDetails.isRenderDecisions()) {
        var _processPropositions3 = processPropositions(propositions);
        render = _processPropositions3.render;
        returnedPropositions = _processPropositions3.returnedPropositions;
        returnedDecisions = _processPropositions3.returnedDecisions;
        return render();
      }
      var _processPropositions4 = processPropositions([], propositions);
      returnedPropositions = _processPropositions4.returnedPropositions;
      returnedDecisions = _processPropositions4.returnedDecisions;
      return [];
    });
  };
};


var metasToArray = function metasToArray(metas) {
  return Object.keys(metas).map(function (key) {
    return _objectSpread({
      id: key
    }, metas[key]);
  });
};
var createClickStorage = function createClickStorage() {
  var clickStorage = {};
  var storeClickMetrics = function storeClickMetrics(_ref82) {
    var selector = _ref82.selector,
      _ref82$meta = _ref82.meta,
      id = _ref82$meta.id,
      scope = _ref82$meta.scope,
      scopeDetails = _ref82$meta.scopeDetails,
      trackingLabel = _ref82$meta.trackingLabel,
      scopeType = _ref82$meta.scopeType;
    if (!clickStorage[selector]) {
      clickStorage[selector] = {};
    }
    clickStorage[selector][id] = {
      scope: scope,
      scopeDetails: scopeDetails,
      trackingLabel: trackingLabel,
      scopeType: scopeType
    };
  };
  var getClickSelectors = function getClickSelectors() {
    return Object.keys(clickStorage);
  };
  var getClickMetasBySelector = function getClickMetasBySelector(selector) {
    var metas = clickStorage[selector];
    if (!metas) {
      return {};
    }
    return metasToArray(clickStorage[selector]);
  };
  return {
    storeClickMetrics: storeClickMetrics,
    getClickSelectors: getClickSelectors,
    getClickMetasBySelector: getClickMetasBySelector
  };
};

var SUPPORTED_SCHEMAS = [DOM_ACTION, HTML_CONTENT_ITEM, MESSAGE_IN_APP];
var createApplyPropositions = function createApplyPropositions(_ref83) {
  var processPropositions = _ref83.processPropositions,
    createProposition = _ref83.createProposition,
    renderedPropositions = _ref83.renderedPropositions,
    viewCache = _ref83.viewCache;
  var filterItemsPredicate = function filterItemsPredicate(item) {
    return SUPPORTED_SCHEMAS.indexOf(item.schema) > -1;
  };
  var updatePropositionItems = function updatePropositionItems(_ref84) {
    var items = _ref84.items,
      metadataForScope = _ref84.metadataForScope;
    return items.filter(filterItemsPredicate).map(function (item) {
      if (item.schema !== HTML_CONTENT_ITEM) {
        return _objectSpread({}, item);
      }
      if (isObject(metadataForScope)) {
        return _objectSpread(_objectSpread({}, item), {}, {
          data: _objectSpread(_objectSpread({}, item.data), {}, {
            selector: metadataForScope.selector,
            type: metadataForScope.actionType
          })
        });
      }
      return undefined;
    }).filter(function (item) {
      return item;
    });
  };
  var filterPropositionsPredicate = function filterPropositionsPredicate(proposition) {
    return !(proposition.scope === PAGE_WIDE_SCOPE && proposition.renderAttempted);
  };
  var preparePropositions = function preparePropositions(_ref85) {
    var propositions = _ref85.propositions,
      metadata = _ref85.metadata;
    return propositions.filter(filterPropositionsPredicate).map(function (proposition) {
      if (isNonEmptyArray(proposition.items)) {
        var id = proposition.id,
          scope = proposition.scope,
          scopeDetails = proposition.scopeDetails;
        return {
          id: id,
          scope: scope,
          scopeDetails: scopeDetails,
          items: updatePropositionItems({
            items: proposition.items,
            metadataForScope: metadata[proposition.scope]
          })
        };
      }
      return proposition;
    }).filter(function (proposition) {
      return isNonEmptyArray(proposition.items);
    });
  };
  return function (_ref86) {
    var _ref86$propositions = _ref86.propositions,
      propositions = _ref86$propositions === void 0 ? [] : _ref86$propositions,
      _ref86$metadata = _ref86.metadata,
      metadata = _ref86$metadata === void 0 ? {} : _ref86$metadata,
      viewName = _ref86.viewName;
    var renderedPropositionsDeferred = defer();
    renderedPropositions.concat(renderedPropositionsDeferred.promise);
    var propositionsToExecute = preparePropositions({
      propositions: propositions,
      metadata: metadata
    }).map(function (proposition) {
      return createProposition(proposition);
    });
    return Promise.resolve().then(function () {
      if (viewName) {
        return viewCache.getView(viewName);
      }
      return [];
    }).then(function (additionalPropositions) {
      var _processPropositions5 = processPropositions([].concat(_toConsumableArray(propositionsToExecute), _toConsumableArray(additionalPropositions))),
        render = _processPropositions5.render,
        returnedPropositions = _processPropositions5.returnedPropositions;
      render().then(renderedPropositionsDeferred.resolve);
      return {
        propositions: returnedPropositions
      };
    });
  };
};


var createGetPageLocation = function createGetPageLocation(_ref87) {
  var window = _ref87.window;
  return function () {
    return window.location;
  };
};

var createSetTargetMigration = function createSetTargetMigration(_ref88) {
  var targetMigrationEnabled = _ref88.targetMigrationEnabled;
  if (targetMigrationEnabled) {
    return function (request) {
      request.getPayload().mergeMeta({
        target: {
          migration: true
        }
      });
    };
  }
  return noop;
};

var ACTION_CUSTOM_CODE = "customCode";
var TARGET_BODY_SELECTOR = "BODY > *:eq(0)";
var remapCustomCodeOffers = function remapCustomCodeOffers(action) {
  var selector = action.selector,
    type = action.type;
  if (type !== ACTION_CUSTOM_CODE) {
    return action;
  }
  if (selector !== TARGET_BODY_SELECTOR) {
    return action;
  }
  return (0, _reactorObjectAssign["default"])({}, action, {
    selector: "BODY"
  });
};


var isBlankString = function isBlankString(value) {
  return isString(value) ? !value.trim() : true;
};

var APPEND_HTML = "appendHtml";
var HEAD_TAGS_SELECTOR = "SCRIPT,LINK,STYLE";
var filterHeadContent = function filterHeadContent(content) {
  var container = createFragment(content);
  var headNodes = selectNodes(HEAD_TAGS_SELECTOR, container);
  return headNodes.map(function (node) {
    return node.outerHTML;
  }).join("");
};
var remapHeadOffers = function remapHeadOffers(action) {
  var result = (0, _reactorObjectAssign["default"])({}, action);
  var content = result.content,
    selector = result.selector;
  if (isBlankString(content)) {
    return result;
  }
  if (selector == null) {
    return result;
  }
  var container = selectNodesWithEq(selector);
  if (!is$1(container[0], HEAD)) {
    return result;
  }
  result.type = APPEND_HTML;
  result.content = filterHeadContent(content);
  return result;
};

var createPreprocess = function createPreprocess(preprocessors) {
  return function (action) {
    if (!action) {
      return action;
    }
    return preprocessors.reduce(function (processed, fn) {
      return (0, _reactorObjectAssign["default"])(processed, fn(processed));
    }, action);
  };
};

var injectCreateProposition = function injectCreateProposition(_ref89) {
  var preprocess = _ref89.preprocess,
    isPageWideSurface = _ref89.isPageWideSurface;
  var createItem = function createItem(item, proposition) {
    var schema = item.schema,
      data = item.data,
      _item$characteristics = item.characteristics;
    _item$characteristics = _item$characteristics === void 0 ? {} : _item$characteristics;
    var trackingLabel = _item$characteristics.trackingLabel;
    var processedData = preprocess(data);
    return {
      getSchema: function getSchema() {
        return schema;
      },
      getData: function getData() {
        return processedData;
      },
      getProposition: function getProposition() {
        return proposition;
      },
      getTrackingLabel: function getTrackingLabel() {
        return trackingLabel;
      },
      getOriginalItem: function getOriginalItem() {
        return item;
      },
      toString: function toString() {
        return JSON.stringify(item);
      },
      toJSON: function toJSON() {
        return item;
      }
    };
  };
  return function (payload) {
    var visibleInReturnedItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var id = payload.id,
      scope = payload.scope,
      scopeDetails = payload.scopeDetails,
      _payload$items = payload.items,
      items = _payload$items === void 0 ? [] : _payload$items;
    var _ref90 = scopeDetails || {},
      _ref90$characteristic = _ref90.characteristics;
    _ref90$characteristic = _ref90$characteristic === void 0 ? {} : _ref90$characteristic;
    var scopeType = _ref90$characteristic.scopeType;
    return {
      getScope: function getScope() {
        if (!scope) {
          return scope;
        }
        return scope;
      },
      getScopeType: function getScopeType() {
        if (scope === PAGE_WIDE_SCOPE || isPageWideSurface(scope)) {
          return PAGE_SCOPE_TYPE;
        }
        if (scopeType === VIEW_SCOPE_TYPE) {
          return VIEW_SCOPE_TYPE;
        }
        return PROPOSITION_SCOPE_TYPE;
      },
      getItems: function getItems() {
        var _this6 = this;
        return items.map(function (item) {
          return createItem(item, _this6);
        });
      },
      getNotification: function getNotification() {
        return {
          id: id,
          scope: scope,
          scopeDetails: scopeDetails
        };
      },
      toJSON: function toJSON() {
        return payload;
      },
      addToReturnValues: function addToReturnValues(propositions, decisions, includedItems, renderAttempted) {
        if (visibleInReturnedItems) {
          propositions.push(_objectSpread(_objectSpread({}, payload), {}, {
            items: includedItems.map(function (i) {
              return i.getOriginalItem();
            }),
            renderAttempted: renderAttempted
          }));
          if (!renderAttempted) {
            decisions.push(_objectSpread(_objectSpread({}, payload), {}, {
              items: includedItems.map(function (i) {
                return i.getOriginalItem();
              })
            }));
          }
        }
      }
    };
  };
};

var createAsyncArray = function createAsyncArray() {
  var latest = Promise.resolve([]);
  return {
    concat: function concat(promise) {
      latest = latest.then(function (existingPropositions) {
        return promise.then(function (newPropositions) {
          return existingPropositions.concat(newPropositions);
        })["catch"](function () {
          return existingPropositions;
        });
      });
    },
    clear: function clear() {
      var oldLatest = latest;
      latest = Promise.resolve([]);
      return oldLatest;
    }
  };
};

var processDefaultContent = function processDefaultContent() {
  return {
    setRenderAttempted: true,
    includeInNotification: true
  };
};

var createProcessDomAction = function createProcessDomAction(_ref91) {
  var modules = _ref91.modules,
    logger = _ref91.logger,
    storeClickMetrics = _ref91.storeClickMetrics;
  return function (item) {
    var _ref92 = item.getData() || {},
      type = _ref92.type,
      selector = _ref92.selector;
    if (!type) {
      logger.warn("Invalid DOM action data: missing type.", item.getData());
      return {
        setRenderAttempted: false,
        includeInNotification: false
      };
    }
    if (type === "click") {
      if (!selector) {
        logger.warn("Invalid DOM action data: missing selector.", item.getData());
        return {
          setRenderAttempted: false,
          includeInNotification: false
        };
      }
      storeClickMetrics({
        selector: selector,
        meta: _objectSpread(_objectSpread({}, item.getProposition().getNotification()), {}, {
          trackingLabel: item.getTrackingLabel(),
          scopeType: item.getProposition().getScopeType()
        })
      });
      return {
        setRenderAttempted: true,
        includeInNotification: false
      };
    }
    if (!modules[type]) {
      logger.warn("Invalid DOM action data: unknown type.", item.getData());
      return {
        setRenderAttempted: false,
        includeInNotification: false
      };
    }
    return {
      render: function render() {
        return modules[type](item.getData());
      },
      setRenderAttempted: true,
      includeInNotification: true
    };
  };
};

var createProcessHtmlContent = function createProcessHtmlContent(_ref93) {
  var modules = _ref93.modules,
    logger = _ref93.logger;
  return function (item) {
    var _ref94 = item.getData() || {},
      type = _ref94.type,
      selector = _ref94.selector;
    if (!selector || !type) {
      return {
        setRenderAttempted: false,
        includeInNotification: false
      };
    }
    if (!modules[type]) {
      logger.warn("Invalid HTML content data", item.getData());
      return {
        setRenderAttempted: false,
        includeInNotification: false
      };
    }
    return {
      render: function render() {
        modules[type](item.getData());
      },
      setRenderAttempted: true,
      includeInNotification: true
    };
  };
};

var createProcessRedirect = function createProcessRedirect(_ref95) {
  var logger = _ref95.logger,
    executeRedirect = _ref95.executeRedirect,
    collect = _ref95.collect;
  return function (item) {
    var _ref96 = item.getData() || {},
      content = _ref96.content;
    if (!content) {
      logger.warn("Invalid Redirect data", item.getData());
      return {};
    }
    var render = function render() {
      return collect({
        decisionsMeta: [item.getProposition().getNotification()],
        documentMayUnload: true
      }).then(function () {
        return executeRedirect(content);
      });
    };

    return {
      render: render,
      setRenderAttempted: true,
      onlyRenderThis: true
    };
  };
};


var createProcessPropositions = function createProcessPropositions(_ref97) {
  var schemaProcessors = _ref97.schemaProcessors,
    logger = _ref97.logger;
  var wrapRenderWithLogging = function wrapRenderWithLogging(render, item) {
    return function () {
      return Promise.resolve().then(render).then(function () {
        if (logger.enabled) {
          logger.info("Action ".concat(item.toString(), " executed."));
        }
        return true;
      })["catch"](function (error) {
        if (logger.enabled) {
          var message = error.message,
            stack = error.stack;
          var warning = "Failed to execute action ".concat(item.toString(), ". ").concat(message, " ").concat(stack);
          logger.warn(warning);
        }
        return false;
      });
    };
  };
  var renderItems = function renderItems(renderers, meta) {
    return Promise.all(renderers.map(function (renderer) {
      return renderer();
    })).then(function (successes) {
      if (!successes.includes(true)) {
        return undefined;
      }
      return meta;
    });
  };
  var processItem = function processItem(item) {
    var processor = schemaProcessors[item.getSchema()];
    if (!processor) {
      return {};
    }
    return processor(item);
  };
  var processItems = function processItems(_ref98) {
    var existingRenderers = _ref98.renderers,
      existingReturnedPropositions = _ref98.returnedPropositions,
      existingReturnedDecisions = _ref98.returnedDecisions,
      items = _ref98.items,
      proposition = _ref98.proposition;
    var renderers = _toConsumableArray(existingRenderers);
    var returnedPropositions = _toConsumableArray(existingReturnedPropositions);
    var returnedDecisions = _toConsumableArray(existingReturnedDecisions);
    var renderedItems = [];
    var nonRenderedItems = [];
    var itemRenderers = [];
    var atLeastOneWithNotification = false;
    var render;
    var setRenderAttempted;
    var includeInNotification;
    var onlyRenderThis = false;
    var i = 0;
    var item;
    while (items.length > i) {
      item = items[i];
      var _processItem = processItem(item);
      render = _processItem.render;
      setRenderAttempted = _processItem.setRenderAttempted;
      includeInNotification = _processItem.includeInNotification;
      onlyRenderThis = _processItem.onlyRenderThis;
      if (onlyRenderThis) {
        returnedPropositions = [];
        returnedDecisions = [];
        if (setRenderAttempted) {
          renderedItems = [item];
          nonRenderedItems = [];
        } else {
          renderedItems = [];
          nonRenderedItems = [item];
        }
        renderers = [];
        itemRenderers = [render];
        atLeastOneWithNotification = includeInNotification;
        break;
      }
      if (render) {
        itemRenderers.push(wrapRenderWithLogging(render, item));
      }
      if (includeInNotification) {
        atLeastOneWithNotification = true;
      }
      if (setRenderAttempted) {
        renderedItems.push(item);
      } else {
        nonRenderedItems.push(item);
      }
      i += 1;
    }
    if (itemRenderers.length > 0) {
      var meta = atLeastOneWithNotification ? proposition.getNotification() : undefined;
      renderers.push(function () {
        return renderItems(itemRenderers, meta);
      });
    } else if (atLeastOneWithNotification) {
      renderers.push(function () {
        return proposition.getNotification();
      });
    }
    if (renderedItems.length > 0) {
      proposition.addToReturnValues(returnedPropositions, returnedDecisions, renderedItems, true);
    }
    if (nonRenderedItems.length > 0) {
      proposition.addToReturnValues(returnedPropositions, returnedDecisions, nonRenderedItems, false);
    }
    return {
      renderers: renderers,
      returnedPropositions: returnedPropositions,
      returnedDecisions: returnedDecisions,
      onlyRenderThis: onlyRenderThis
    };
  };
  return function (renderPropositions) {
    var nonRenderPropositions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var renderers = [];
    var returnedPropositions = [];
    var returnedDecisions = [];
    var onlyRenderThis;
    var i = 0;
    var proposition;
    var items;
    while (renderPropositions.length > i) {
      proposition = renderPropositions[i];
      items = proposition.getItems();
      var _processItems = processItems({
        renderers: renderers,
        returnedPropositions: returnedPropositions,
        returnedDecisions: returnedDecisions,
        items: items,
        proposition: proposition
      });
      renderers = _processItems.renderers;
      returnedPropositions = _processItems.returnedPropositions;
      returnedDecisions = _processItems.returnedDecisions;
      onlyRenderThis = _processItems.onlyRenderThis;
      if (onlyRenderThis) {
        break;
      }
      i += 1;
    }
    if (onlyRenderThis) {
      renderPropositions.forEach(function (p, index) {
        if (index !== i) {
          p.addToReturnValues(returnedPropositions, returnedDecisions, p.getItems(), false);
        }
      });
    }
    nonRenderPropositions.forEach(function (p) {
      p.addToReturnValues(returnedPropositions, returnedDecisions, p.getItems(), false);
    });
    var render = function render() {
      return Promise.all(renderers.map(function (renderer) {
        return renderer();
      })).then(function (metas) {
        return metas.filter(function (meta) {
          return meta;
        });
      });
    };
    return {
      returnedPropositions: returnedPropositions,
      returnedDecisions: returnedDecisions,
      render: render
    };
  };
};


var createOnDecisionHandler = function createOnDecisionHandler(_ref99) {
  var processPropositions = _ref99.processPropositions,
    createProposition = _ref99.createProposition,
    notificationHandler = _ref99.notificationHandler;
  return function (_ref100) {
    var renderDecisions = _ref100.renderDecisions,
      propositions = _ref100.propositions,
      event = _ref100.event,
      _ref100$personalizati = _ref100.personalization,
      personalization = _ref100$personalizati === void 0 ? {} : _ref100$personalizati;
    if (!renderDecisions) {
      return Promise.resolve();
    }
    var _personalization$send = personalization.sendDisplayEvent,
      sendDisplayEvent = _personalization$send === void 0 ? true : _personalization$send;
    var viewName = event ? event.getViewName() : undefined;
    var propositionsToExecute = propositions.map(function (proposition) {
      return createProposition(proposition, true);
    });
    var _processPropositions6 = processPropositions(propositionsToExecute),
      render = _processPropositions6.render,
      returnedPropositions = _processPropositions6.returnedPropositions;
    var handleNotifications = notificationHandler(sendDisplayEvent, viewName);
    render().then(handleNotifications);
    return Promise.resolve({
      propositions: returnedPropositions
    });
  };
};

var TEXT_HTML = "text/html";
var APPLICATION_JSON = "application/json";

var DEFAULT_CONTENT = "defaultContent";
var expectedProps = ["content", "contentType"];
var expectedContentProps = ["mobileParameters", "webParameters", "html"];
var isValidInAppMessage = function isValidInAppMessage(data, logger) {
  for (var _i13 = 0; _i13 < expectedProps.length; _i13 += 1) {
    var prop = expectedProps[_i13];
    if (!Object.prototype.hasOwnProperty.call(data, prop)) {
      logger.warn("Invalid in-app message data: missing property '".concat(prop, "'."), data);
      return false;
    }
  }
  var content = data.content,
    contentType = data.contentType;
  if (contentType === APPLICATION_JSON) {
    for (var _i14 = 0; _i14 < expectedContentProps.length; _i14 += 1) {
      var _prop = expectedContentProps[_i14];
      if (!Object.prototype.hasOwnProperty.call(content, _prop)) {
        logger.warn("Invalid in-app message data.content: missing property '".concat(_prop, "'."), data);
        return false;
      }
    }
  }
  return true;
};
var createProcessInAppMessage = function createProcessInAppMessage(_ref101) {
  var modules = _ref101.modules,
    logger = _ref101.logger;
  return function (item) {
    var data = item.getData();
    var meta = _objectSpread({}, item.getProposition().getNotification());
    if (!data) {
      logger.warn("Invalid in-app message data: undefined.", data);
      return {};
    }
    var _data$type = data.type,
      type = _data$type === void 0 ? DEFAULT_CONTENT : _data$type;
    if (!modules[type]) {
      logger.warn("Invalid in-app message data: unknown type.", data);
      return {};
    }
    if (!isValidInAppMessage(data, logger)) {
      return {};
    }
    if (!meta) {
      logger.warn("Invalid in-app message meta: undefined.", meta);
      return {};
    }
    return {
      render: function render() {
        return modules[type](_objectSpread(_objectSpread({}, data), {}, {
          meta: meta
        }));
      },
      setRenderAttempted: true,
      includeInNotification: true
    };
  };
};

var removeElementById = function removeElementById(id) {
  var element = selectNodes("#".concat(id), document);
  if (element && element.length > 0) {
    removeNode(element[0]);
  }
};
var parseAnchor = function parseAnchor(anchor) {
  var nothing = {};
  if (!anchor || anchor.tagName.toLowerCase() !== "a") {
    return nothing;
  }
  var href = anchor.href;
  if (!href || !startsWith(href, "adbinapp://")) {
    return nothing;
  }
  var hrefParts = href.split("?");
  var action = hrefParts[0].split("://")[1];
  var label = anchor.innerText;
  var uuid = anchor.getAttribute("data-uuid") || "";
  var interaction;
  var link;
  if (isNonEmptyArray(hrefParts)) {
    var queryParams = _reactorQueryString["default"].parse(hrefParts[1]);
    interaction = queryParams.interaction || "";
    link = decodeURIComponent(queryParams.link || "");
  }
  return {
    action: action,
    interaction: interaction,
    link: link,
    label: label,
    uuid: uuid
  };
};


var createRedirect = function createRedirect(window) {
  return function (url) {
    var preserveHistory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (preserveHistory) {
      window.location.href = url;
    } else {
      window.location.replace(url);
    }
    return new Promise(function () {
      return undefined;
    });
  };
};

var MESSAGING_CONTAINER_ID = "alloy-messaging-container";
var OVERLAY_CONTAINER_ID = "alloy-overlay-container";
var IFRAME_ID = "alloy-content-iframe";
var dismissMessage = function dismissMessage() {
  return [MESSAGING_CONTAINER_ID, OVERLAY_CONTAINER_ID].forEach(removeElementById);
};
var createIframeClickHandler = function createIframeClickHandler(interact) {
  var navigateToUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createRedirect(window);
  return function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var target = event.target;
    var anchor = target.tagName.toLowerCase() === "a" ? target : target.closest("a");
    if (!anchor) {
      return;
    }
    var _parseAnchor = parseAnchor(anchor),
      action = _parseAnchor.action,
      interaction = _parseAnchor.interaction,
      link = _parseAnchor.link,
      label = _parseAnchor.label,
      uuid = _parseAnchor.uuid;
    interact(action, {
      label: label,
      id: interaction,
      uuid: uuid,
      link: link
    });
    if (action === "dismiss") {
      dismissMessage();
    }
    if (isNonEmptyString(link) && link.length > 0) {
      navigateToUrl(link, true);
    }
  };
};
var createIframe = function createIframe(htmlContent, clickHandler) {
  var parser = new DOMParser();
  var htmlDocument = parser.parseFromString(htmlContent, TEXT_HTML);
  var scriptTag = htmlDocument.querySelector("script");
  if (scriptTag) {
    scriptTag.setAttribute("nonce", getNonce());
  }
  var element = createNode("iframe", {
    src: URL.createObjectURL(new Blob([htmlDocument.documentElement.outerHTML], {
      type: "text/html"
    })),
    id: IFRAME_ID
  });
  element.addEventListener("load", function () {
    var _ref102 = element.contentDocument || element.contentWindow.document,
      addEventListener = _ref102.addEventListener;
    addEventListener("click", clickHandler);
  });
  return element;
};
var renderMessage = function renderMessage(iframe, webParameters, container, overlay) {
  [{
    id: OVERLAY_CONTAINER_ID,
    element: overlay
  }, {
    id: MESSAGING_CONTAINER_ID,
    element: container
  }, {
    id: IFRAME_ID,
    element: iframe
  }].forEach(function (_ref103) {
    var id = _ref103.id,
      element = _ref103.element;
    var _webParameters$id = webParameters[id],
      _webParameters$id$sty = _webParameters$id.style,
      style = _webParameters$id$sty === void 0 ? {} : _webParameters$id$sty,
      _webParameters$id$par = _webParameters$id.params,
      params = _webParameters$id$par === void 0 ? {} : _webParameters$id$par;
    (0, _reactorObjectAssign["default"])(element.style, style);
    var _params$parentElement = params.parentElement,
      parentElement = _params$parentElement === void 0 ? "body" : _params$parentElement,
      _params$insertionMeth = params.insertionMethod,
      insertionMethod = _params$insertionMeth === void 0 ? "appendChild" : _params$insertionMeth,
      _params$enabled = params.enabled,
      enabled = _params$enabled === void 0 ? true : _params$enabled;
    var parent = document.querySelector(parentElement);
    if (enabled && parent && typeof parent[insertionMethod] === "function") {
      parent[insertionMethod](element);
    }
  });
};
var buildStyleFromMobileParameters = function buildStyleFromMobileParameters(mobileParameters) {
  var verticalAlign = mobileParameters.verticalAlign,
    width = mobileParameters.width,
    horizontalAlign = mobileParameters.horizontalAlign,
    backdropColor = mobileParameters.backdropColor,
    height = mobileParameters.height,
    cornerRadius = mobileParameters.cornerRadius,
    horizontalInset = mobileParameters.horizontalInset,
    verticalInset = mobileParameters.verticalInset,
    _mobileParameters$uiT = mobileParameters.uiTakeover,
    uiTakeover = _mobileParameters$uiT === void 0 ? false : _mobileParameters$uiT;
  var style = {
    width: width ? "".concat(width, "%") : "100%",
    backgroundColor: backdropColor || "rgba(0, 0, 0, 0.5)",
    borderRadius: cornerRadius ? "".concat(cornerRadius, "px") : "0px",
    border: "none",
    position: uiTakeover ? "fixed" : "relative",
    overflow: "hidden"
  };
  if (horizontalAlign === "left") {
    style.left = horizontalInset ? "".concat(horizontalInset, "%") : "0";
  } else if (horizontalAlign === "right") {
    style.right = horizontalInset ? "".concat(horizontalInset, "%") : "0";
  } else if (horizontalAlign === "center") {
    style.left = "50%";
    style.transform = "translateX(-50%)";
  }
  if (verticalAlign === "top") {
    style.top = verticalInset ? "".concat(verticalInset, "%") : "0";
  } else if (verticalAlign === "bottom") {
    style.position = "fixed";
    style.bottom = verticalInset ? "".concat(verticalInset, "%") : "0";
  } else if (verticalAlign === "center") {
    style.top = "50%";
    style.transform = "".concat(horizontalAlign === "center" ? "".concat(style.transform, " ") : "", "translateY(-50%)");
    style.display = "flex";
    style.alignItems = "center";
    style.justifyContent = "center";
  }
  if (height) {
    style.height = "".concat(height, "vh");
  } else {
    style.height = "100%";
  }
  return style;
};
var mobileOverlay = function mobileOverlay(mobileParameters) {
  var backdropOpacity = mobileParameters.backdropOpacity,
    backdropColor = mobileParameters.backdropColor;
  var opacity = backdropOpacity || 0.5;
  var color = backdropColor || "#FFFFFF";
  var style = {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    background: "transparent",
    opacity: opacity,
    backgroundColor: color
  };
  return style;
};
var REQUIRED_PARAMS = ["enabled", "parentElement", "insertionMethod"];
var isValidWebParameters = function isValidWebParameters(webParameters) {
  if (!webParameters) {
    return false;
  }
  var ids = Object.keys(webParameters);
  if (!includes(ids, MESSAGING_CONTAINER_ID)) {
    return false;
  }
  if (!includes(ids, OVERLAY_CONTAINER_ID)) {
    return false;
  }
  var valuesArray = values(webParameters);
  for (var _i15 = 0; _i15 < valuesArray.length; _i15 += 1) {
    if (!boundObjectOf(valuesArray[_i15], "style")) {
      return false;
    }
    if (!boundObjectOf(valuesArray[_i15], "params")) {
      return false;
    }
    for (var j = 0; j < REQUIRED_PARAMS.length; j += 1) {
      if (!boundObjectOf(valuesArray[_i15].params, REQUIRED_PARAMS[j])) {
        return false;
      }
    }
  }
  return true;
};
var generateWebParameters = function generateWebParameters(mobileParameters) {
  var _ref104;
  if (!mobileParameters) {
    return undefined;
  }
  var _mobileParameters$uiT2 = mobileParameters.uiTakeover,
    uiTakeover = _mobileParameters$uiT2 === void 0 ? false : _mobileParameters$uiT2;
  return _ref104 = {}, _defineProperty(_ref104, IFRAME_ID, {
    style: {
      border: "none",
      width: "100%",
      height: "100%"
    },
    params: {
      enabled: true,
      parentElement: "#alloy-messaging-container",
      insertionMethod: "appendChild"
    }
  }), _defineProperty(_ref104, MESSAGING_CONTAINER_ID, {
    style: buildStyleFromMobileParameters(mobileParameters),
    params: {
      enabled: true,
      parentElement: "body",
      insertionMethod: "appendChild"
    }
  }), _defineProperty(_ref104, OVERLAY_CONTAINER_ID, {
    style: mobileOverlay(mobileParameters),
    params: {
      enabled: uiTakeover === true,
      parentElement: "body",
      insertionMethod: "appendChild"
    }
  }), _ref104;
};
var displayHTMLContentInIframe = function displayHTMLContentInIframe() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var interact = arguments.length > 1 ? arguments[1] : undefined;
  dismissMessage();
  var content = settings.content,
    contentType = settings.contentType,
    mobileParameters = settings.mobileParameters;
  var webParameters = settings.webParameters;
  if (contentType !== TEXT_HTML) {
    return;
  }
  var container = createNode("div", {
    id: MESSAGING_CONTAINER_ID
  });
  var iframe = createIframe(content, createIframeClickHandler(interact));
  var overlay = createNode("div", {
    id: OVERLAY_CONTAINER_ID
  });
  if (!isValidWebParameters(webParameters)) {
    webParameters = generateWebParameters(mobileParameters);
  }
  if (!webParameters) {
    return;
  }
  renderMessage(iframe, webParameters, container, overlay);
};
var displayIframeContent = function displayIframeContent(settings, collect) {
  return new Promise(function (resolve) {
    var meta = settings.meta;
    displayHTMLContentInIframe(settings, function (action, propositionAction) {
      var propositionEventTypes = {};
      propositionEventTypes[PropositionEventType.INTERACT] = EVENT_TYPE_TRUE;
      if (Object.values(PropositionEventType).indexOf(action) !== -1) {
        propositionEventTypes[action] = EVENT_TYPE_TRUE;
      }
      collect({
        decisionsMeta: [meta],
        propositionAction: propositionAction,
        eventType: INTERACT,
        propositionEventTypes: Object.keys(propositionEventTypes)
      });
    });
    resolve({
      meta: meta
    });
  });
};

var initInAppMessageActionsModules = function initInAppMessageActionsModules(collect) {
  return {
    defaultContent: function defaultContent(settings) {
      return displayIframeContent(settings, collect);
    }
  };
};

var createNotificationHandler = function createNotificationHandler(collect, renderedPropositions) {
  return function (sendDisplayEvent, viewName) {
    if (!sendDisplayEvent) {
      var renderedPropositionsDeferred = defer();
      renderedPropositions.concat(renderedPropositionsDeferred.promise);
      return renderedPropositionsDeferred.resolve;
    }
    return function (decisionsMeta) {
      if (decisionsMeta.length > 0) {
        collect({
          decisionsMeta: decisionsMeta,
          viewName: viewName
        });
      }
    };
  };
};

var createPersonalization = function createPersonalization(_ref105) {
  var _schemaProcessors;
  var config = _ref105.config,
    logger = _ref105.logger,
    eventManager = _ref105.eventManager;
  var targetMigrationEnabled = config.targetMigrationEnabled,
    prehidingStyle = config.prehidingStyle;
  var collect = createCollect({
    eventManager: eventManager,
    mergeDecisionsMeta: mergeDecisionsMeta
  });
  var _createClickStorage = createClickStorage(),
    getClickMetasBySelector = _createClickStorage.getClickMetasBySelector,
    getClickSelectors = _createClickStorage.getClickSelectors,
    storeClickMetrics = _createClickStorage.storeClickMetrics;
  var getPageLocation = createGetPageLocation({
    window: window
  });
  var domActionsModules = initDomActionsModules();
  var preprocess = createPreprocess([remapHeadOffers, remapCustomCodeOffers]);
  var createProposition = injectCreateProposition({
    preprocess: preprocess,
    isPageWideSurface: isPageWideSurface
  });
  var viewCache = createViewCacheManager({
    createProposition: createProposition
  });
  var executeRedirect = createRedirect(window);
  var schemaProcessors = (_schemaProcessors = {}, _defineProperty(_schemaProcessors, DEFAULT_CONTENT_ITEM, processDefaultContent), _defineProperty(_schemaProcessors, DOM_ACTION, createProcessDomAction({
    modules: domActionsModules,
    logger: logger,
    storeClickMetrics: storeClickMetrics
  })), _defineProperty(_schemaProcessors, HTML_CONTENT_ITEM, createProcessHtmlContent({
    modules: domActionsModules,
    logger: logger
  })), _defineProperty(_schemaProcessors, REDIRECT_ITEM, createProcessRedirect({
    logger: logger,
    executeRedirect: executeRedirect,
    collect: collect
  })), _defineProperty(_schemaProcessors, MESSAGE_IN_APP, createProcessInAppMessage({
    modules: initInAppMessageActionsModules(collect),
    logger: logger
  })), _schemaProcessors);
  var processPropositions = createProcessPropositions({
    schemaProcessors: schemaProcessors,
    logger: logger
  });
  var renderedPropositions = createAsyncArray();
  var notificationHandler = createNotificationHandler(collect, renderedPropositions);
  var fetchDataHandler = createFetchDataHandler({
    prehidingStyle: prehidingStyle,
    showContainers: showContainers,
    hideContainers: hideContainers,
    mergeQuery: mergeQuery,
    processPropositions: processPropositions,
    createProposition: createProposition,
    notificationHandler: notificationHandler
  });
  var onClickHandler = createOnClickHandler({
    mergeDecisionsMeta: mergeDecisionsMeta,
    collectClicks: collectClicks,
    getClickSelectors: getClickSelectors,
    getClickMetasBySelector: getClickMetasBySelector
  });
  var viewChangeHandler = createViewChangeHandler({
    processPropositions: processPropositions,
    viewCache: viewCache
  });
  var applyPropositions = createApplyPropositions({
    processPropositions: processPropositions,
    createProposition: createProposition,
    renderedPropositions: renderedPropositions,
    viewCache: viewCache
  });
  var setTargetMigration = createSetTargetMigration({
    targetMigrationEnabled: targetMigrationEnabled
  });
  var onDecisionHandler = createOnDecisionHandler({
    processPropositions: processPropositions,
    createProposition: createProposition,
    notificationHandler: notificationHandler
  });
  return createComponent$1({
    getPageLocation: getPageLocation,
    logger: logger,
    fetchDataHandler: fetchDataHandler,
    viewChangeHandler: viewChangeHandler,
    onClickHandler: onClickHandler,
    isAuthoringModeEnabled: isAuthoringModeEnabled,
    mergeQuery: mergeQuery,
    viewCache: viewCache,
    showContainers: showContainers,
    applyPropositions: applyPropositions,
    setTargetMigration: setTargetMigration,
    mergeDecisionsMeta: mergeDecisionsMeta,
    renderedPropositions: renderedPropositions,
    onDecisionHandler: onDecisionHandler
  });
};
createPersonalization.namespace = "Personalization";
createPersonalization.configValidators = boundObjectOf({
  prehidingStyle: boundString().nonEmpty(),
  targetMigrationEnabled: boundBoolean()["default"](false)
});

var injectWeb = function injectWeb(window) {
  return function (xdm) {
    var web = {
      webPageDetails: {
        URL: window.location.href || window.location
      },
      webReferrer: {
        URL: window.document.referrer
      }
    };
    deepAssign(xdm, {
      web: web
    });
  };
};

var getScreenOrientationViaProperty = function getScreenOrientationViaProperty(window) {
  var orientation = window.screen.orientation;
  if (orientation == null || orientation.type == null) {
    return null;
  }
  var parts = orientation.type.split("-");
  if (parts.length === 0) {
    return null;
  }
  if (parts[0] !== "portrait" && parts[0] !== "landscape") {
    return null;
  }
  return parts[0];
};
var getScreenOrientationViaMediaQuery = function getScreenOrientationViaMediaQuery(window) {
  if (isFunction(window.matchMedia)) {
    if (window.matchMedia("(orientation: portrait)").matches) {
      return "portrait";
    }
    if (window.matchMedia("(orientation: landscape)").matches) {
      return "landscape";
    }
  }
  return null;
};
var injectDevice = function injectDevice(window) {
  return function (xdm) {
    var _window$screen = window.screen,
      width = _window$screen.width,
      height = _window$screen.height;
    var device = {};
    var screenHeight = toInteger(height);
    if (screenHeight >= 0) {
      device.screenHeight = screenHeight;
    }
    var screenWidth = toInteger(width);
    if (screenWidth >= 0) {
      device.screenWidth = screenWidth;
    }
    var orientation = getScreenOrientationViaProperty(window) || getScreenOrientationViaMediaQuery(window);
    if (orientation) {
      device.screenOrientation = orientation;
    }
    if (Object.keys(device).length > 0) {
      deepAssign(xdm, {
        device: device
      });
    }
  };
};

var injectEnvironment = function injectEnvironment(window) {
  return function (xdm) {
    var _window$document$docu = window.document.documentElement;
    _window$document$docu = _window$document$docu === void 0 ? {} : _window$document$docu;
    var clientWidth = _window$document$docu.clientWidth,
      clientHeight = _window$document$docu.clientHeight;
    var environment = {
      type: "browser"
    };
    var viewportWidth = toInteger(clientWidth);
    if (viewportWidth >= 0) {
      environment.browserDetails = {
        viewportWidth: viewportWidth
      };
    }
    var viewportHeight = toInteger(clientHeight);
    if (viewportHeight >= 0) {
      environment.browserDetails = environment.browserDetails || {};
      environment.browserDetails.viewportHeight = viewportHeight;
    }
    deepAssign(xdm, {
      environment: environment
    });
  };
};

var injectPlaceContext = function injectPlaceContext(dateProvider) {
  return function (xdm) {
    var date = dateProvider();
    var placeContext = {};
    var localTimezoneOffset = toInteger(date.getTimezoneOffset());
    if (localTimezoneOffset !== undefined) {
      placeContext.localTimezoneOffset = localTimezoneOffset;
    }
    if (localTimezoneOffset === undefined || Math.abs(localTimezoneOffset) < 6000) {
      placeContext.localTime = toISOStringLocal(date);
    }
    deepAssign(xdm, {
      placeContext: placeContext
    });
  };
};

var injectTimestamp = function injectTimestamp(dateProvider) {
  return function (xdm) {
    var timestamp = dateProvider().toISOString();
    deepAssign(xdm, {
      timestamp: timestamp
    });
  };
};


var libraryName = "https://ns.adobe.com/experience/alloy";



var libraryVersion = "2.19.1";

var implementationDetails = function implementationDetails(xdm) {
  var implementationDetails = {
    name: libraryName,
    version: libraryVersion,
    environment: "browser"
  };
  deepAssign(xdm, {
    implementationDetails: implementationDetails
  });
};

var createComponent$2 = function createComponent$2(config, logger, optionalContexts, requiredContexts) {
  var configuredContexts = config.context;
  var contexts = flatMap(configuredContexts, function (context, i) {
    if (optionalContexts[context]) {
      return [optionalContexts[context]];
    }
    logger.warn("Invalid context[".concat(i, "]: '").concat(context, "' is not available."));
    return [];
  }).concat(requiredContexts);
  return {
    namespace: "Context",
    lifecycle: {
      onBeforeEvent: function onBeforeEvent(_ref106) {
        var event = _ref106.event;
        var xdm = {};
        return Promise.all(contexts.map(function (context) {
          return Promise.resolve(context(xdm, logger));
        })).then(function () {
          return event.mergeXdm(xdm);
        });
      }
    }
  };
};


var highEntropyUserAgentHints = [["architecture", "string"], ["bitness", "string"], ["model", "string"], ["platformVersion", "string"], ["wow64", "boolean"]];

var browserSupportsUserAgentClientHints = function browserSupportsUserAgentClientHints(navigator) {
  return typeof navigator.userAgentData !== "undefined";
};
var injectHighEntropyUserAgentHints = function injectHighEntropyUserAgentHints(navigator) {
  if (!browserSupportsUserAgentClientHints(navigator)) {
    return noop;
  }
  return function (xdm, logger) {
    try {
      return navigator.userAgentData.getHighEntropyValues(highEntropyUserAgentHints.map(function (hint) {
        return hint[0];
      })).then(function (hints) {
        var userAgentClientHints = {};
        highEntropyUserAgentHints.forEach(function (_ref107) {
          var _ref108 = _slicedToArray(_ref107, 2),
            hintName = _ref108[0],
            hintType = _ref108[1];
          if (Object.prototype.hasOwnProperty.call(hints, hintName) && 
          _typeof(hints[hintName]) === hintType) {
            userAgentClientHints[hintName] = hints[hintName];
          }
        });
        deepAssign(xdm, {
          environment: {
            browserDetails: {
              userAgentClientHints: userAgentClientHints
            }
          }
        });
      });
    } catch (error) {
      logger.warn("Unable to collect user-agent client hints. ".concat(error.message));
      return noop;
    }
  };
};

var web = injectWeb(window);
var device = injectDevice(window);
var environment = injectEnvironment(window);
var placeContext = injectPlaceContext(function () {
  return new Date();
});
var timestamp = injectTimestamp(function () {
  return new Date();
});
var highEntropyUserAgentHints$1 = injectHighEntropyUserAgentHints(navigator);
var defaultEnabledContexts = {
  web: web,
  device: device,
  environment: environment,
  placeContext: placeContext
};
var defaultDisabledContexts = {
  highEntropyUserAgentHints: highEntropyUserAgentHints$1
};
var optionalContexts = _objectSpread(_objectSpread({}, defaultEnabledContexts), defaultDisabledContexts);
var requiredContexts = [timestamp, implementationDetails];
var createContext = function createContext(_ref109) {
  var config = _ref109.config,
    logger = _ref109.logger;
  return createComponent$2(config, logger, optionalContexts, requiredContexts);
};
createContext.namespace = "Context";
createContext.configValidators = boundObjectOf({
  context: boundArrayOf(boundString())["default"](Object.keys(defaultEnabledContexts))
});

var createComponent$3 = function createComponent$3(_ref110) {
  var storedConsent = _ref110.storedConsent,
    taskQueue = _ref110.taskQueue,
    defaultConsent = _ref110.defaultConsent,
    consent = _ref110.consent,
    sendSetConsentRequest = _ref110.sendSetConsentRequest,
    validateSetConsentOptions = _ref110.validateSetConsentOptions,
    consentHashStore = _ref110.consentHashStore,
    doesIdentityCookieExist = _ref110.doesIdentityCookieExist;
  var defaultConsentByPurpose = _defineProperty({}, GENERAL, defaultConsent);
  var storedConsentByPurpose = storedConsent.read();
  var identityCookieExists = doesIdentityCookieExist();
  var consentCookieExists = storedConsentByPurpose[GENERAL] !== undefined;
  if (!identityCookieExists || !consentCookieExists) {
    consentHashStore.clear();
  }
  if (!identityCookieExists) {
    storedConsent.clear();
    storedConsentByPurpose = {};
  }
  consent.initializeConsent(defaultConsentByPurpose, storedConsentByPurpose);
  var readCookieIfQueueEmpty = function readCookieIfQueueEmpty() {
    if (taskQueue.length === 0) {
      var storedConsentObject = storedConsent.read();
      if (storedConsentObject[GENERAL] !== undefined) {
        consent.setConsent(storedConsentObject);
      }
    }
  };
  return {
    commands: {
      setConsent: {
        optionsValidator: validateSetConsentOptions,
        run: function run(_ref111) {
          var consentOptions = _ref111.consent,
            identityMap = _ref111.identityMap,
            edgeConfigOverrides = _ref111.edgeConfigOverrides;
          consent.suspend();
          var consentHashes = consentHashStore.lookup(consentOptions);
          return taskQueue.addTask(function () {
            if (consentHashes.isNew()) {
              return sendSetConsentRequest({
                consentOptions: consentOptions,
                identityMap: identityMap,
                edgeConfigOverrides: edgeConfigOverrides
              });
            }
            return Promise.resolve();
          }).then(function () {
            return consentHashes.save();
          })["finally"](readCookieIfQueueEmpty);
        }
      }
    },
    lifecycle: {
      onResponse: readCookieIfQueueEmpty,
      onRequestFailure: readCookieIfQueueEmpty
    }
  };
};


var serialize = function serialize(obj) {
  if (Array.isArray(obj)) {
    return obj.map(function (i) {
      return serialize(i);
    });
  }
  if (_typeof(obj) === "object" && obj !== null) {
    return Object.keys(obj).sort().reduce(function (memo, key) {
      memo[key] = serialize(obj[key]);
      return memo;
    }, {});
  }
  return obj;
};
var computeConsentHash = function computeConsentHash(obj) {
  return crc32(JSON.stringify(serialize(obj)));
};

var getKey = function getKey(_ref112) {
  var standard = _ref112.standard,
    version = _ref112.version;
  return "".concat(standard, ".").concat(version);
};
var createConsentHashStore = function createConsentHashStore(_ref113) {
  var storage = _ref113.storage;
  return {
    clear: function clear() {
      storage.clear();
    },
    lookup: function lookup(consentObjects) {
      var currentHashes = {};
      var getCurrentHash = function getCurrentHash(consentObject) {
        var key = getKey(consentObject);
        var standard = consentObject.standard,
          version = consentObject.version,
          rest = _objectWithoutProperties(consentObject, ["standard", "version"]);
        if (!currentHashes[key]) {
          currentHashes[key] = computeConsentHash(rest).toString();
        }
        return currentHashes[key];
      };
      return {
        isNew: function isNew() {
          return consentObjects.some(function (consentObject) {
            var key = getKey(consentObject);
            var previousHash = storage.getItem(key);
            return previousHash === null || previousHash !== getCurrentHash(consentObject);
          });
        },
        save: function save() {
          consentObjects.forEach(function (consentObject) {
            var key = getKey(consentObject);
            storage.setItem(key, getCurrentHash(consentObject));
          });
        }
      };
    }
  };
};

var createConsentRequestPayload = function createConsentRequestPayload() {
  var content = {};
  var payload = createRequestPayload({
    content: content,
    addIdentity: function addIdentity(namespaceCode, identity) {
      content.identityMap = content.identityMap || {};
      content.identityMap[namespaceCode] = content.identityMap[namespaceCode] || [];
      content.identityMap[namespaceCode].push(identity);
    },
    hasIdentity: function hasIdentity(namespaceCode) {
      return (content.identityMap && content.identityMap[namespaceCode]) !== undefined;
    }
  });
  payload.setConsent = function (consent) {
    content.consent = consent;
  };
  return payload;
};

var createConsentRequest = function createConsentRequest(_ref114) {
  var payload = _ref114.payload,
    datastreamIdOverride = _ref114.datastreamIdOverride;
  return createRequest({
    payload: payload,
    datastreamIdOverride: datastreamIdOverride,
    getAction: function getAction() {
      return "privacy/set-consent";
    },
    getUseSendBeacon: function getUseSendBeacon() {
      return false;
    }
  });
};

var createStoredConsent = function createStoredConsent(_ref115) {
  var parseConsentCookie = _ref115.parseConsentCookie,
    orgId = _ref115.orgId,
    cookieJar = _ref115.cookieJar;
  var consentCookieName = getNamespacedCookieName(orgId, CONSENT);
  return {
    read: function read() {
      var cookieValue = cookieJar.get(consentCookieName);
      return cookieValue ? parseConsentCookie(cookieValue) : {};
    },
    clear: function clear() {
      cookieJar.remove(consentCookieName);
    }
  };
};

var injectSendSetConsentRequest = function injectSendSetConsentRequest(_ref116) {
  var createConsentRequestPayload = _ref116.createConsentRequestPayload,
    createConsentRequest = _ref116.createConsentRequest,
    sendEdgeNetworkRequest = _ref116.sendEdgeNetworkRequest,
    globalConfigOverrides = _ref116.edgeConfigOverrides;
  return function (_ref117) {
    var consentOptions = _ref117.consentOptions,
      identityMap = _ref117.identityMap,
      localConfigOverrides = _ref117.edgeConfigOverrides;
    var requestParams = createRequestParams({
      payload: createConsentRequestPayload(),
      globalConfigOverrides: globalConfigOverrides,
      localConfigOverrides: localConfigOverrides
    });
    requestParams.payload.setConsent(consentOptions);
    if (isObject(identityMap)) {
      Object.keys(identityMap).forEach(function (key) {
        identityMap[key].forEach(function (identity) {
          requestParams.payload.addIdentity(key, identity);
        });
      });
    }
    var request = createConsentRequest(requestParams);
    return sendEdgeNetworkRequest({
      request: request
    }).then(function () {
    });
  };
};


var parseConsentCookie = function parseConsentCookie(cookieValue) {
  var categoryPairs = cookieValue.split(";");
  return categoryPairs.reduce(function (consentByPurpose, categoryPair) {
    var _categoryPair$split = categoryPair.split("="),
      _categoryPair$split2 = _slicedToArray(_categoryPair$split, 2),
      name = _categoryPair$split2[0],
      value = _categoryPair$split2[1];
    consentByPurpose[name] = value;
    return consentByPurpose;
  }, {});
};

var validateSetConsentOptions = boundObjectOf({
  consent: boundArrayOf(boundAnything()).required().nonEmpty(),
  identityMap: validateIdentityMap,
  edgeConfigOverrides: validateConfigOverride
}).noUnknownFields().required();

var createPrivacy = function createPrivacy(_ref118) {
  var config = _ref118.config,
    consent = _ref118.consent,
    sendEdgeNetworkRequest = _ref118.sendEdgeNetworkRequest,
    createNamespacedStorage = _ref118.createNamespacedStorage;
  var orgId = config.orgId,
    defaultConsent = config.defaultConsent;
  var storedConsent = createStoredConsent({
    parseConsentCookie: parseConsentCookie,
    orgId: orgId,
    cookieJar: cookieJar
  });
  var taskQueue = createTaskQueue();
  var sendSetConsentRequest = injectSendSetConsentRequest({
    createConsentRequestPayload: createConsentRequestPayload,
    createConsentRequest: createConsentRequest,
    sendEdgeNetworkRequest: sendEdgeNetworkRequest,
    edgeConfigOverrides: config.edgeConfigOverrides
  });
  var storage = createNamespacedStorage("".concat(sanitizeOrgIdForCookieName(orgId), ".consentHashes."));
  var consentHashStore = createConsentHashStore({
    storage: storage.persistent
  });
  var doesIdentityCookieExist = injectDoesIdentityCookieExist({
    orgId: orgId
  });
  return createComponent$3({
    storedConsent: storedConsent,
    taskQueue: taskQueue,
    defaultConsent: defaultConsent,
    consent: consent,
    sendSetConsentRequest: sendSetConsentRequest,
    validateSetConsentOptions: validateSetConsentOptions,
    consentHashStore: consentHashStore,
    doesIdentityCookieExist: doesIdentityCookieExist
  });
};
createPrivacy.namespace = "Privacy";

var createEventMergeId = function createEventMergeId() {
  return {
    eventMergeId: v4_1()
  };
};

exports.createEventMergeId = createEventMergeId;
var createComponent$4 = function createComponent$4(_ref119) {
  var createEventMergeId = _ref119.createEventMergeId;
  return {
    commands: {
      createEventMergeId: {
        run: createEventMergeId
      }
    }
  };
};

var createEventMerge = function createEventMerge() {
  return createComponent$4({
    createEventMergeId: createEventMergeId
  });
};
createEventMerge.namespace = "EventMerge";

var prepareLibraryInfo = function prepareLibraryInfo(_ref120) {
  var config = _ref120.config,
    componentRegistry = _ref120.componentRegistry;
  var allCommands = [].concat(_toConsumableArray(componentRegistry.getCommandNames()), [CONFIGURE, SET_DEBUG]).sort();
  var resultConfig = _objectSpread({}, config);
  Object.keys(config).forEach(function (key) {
    var value = config[key];
    if (typeof value !== "function") {
      return;
    }
    resultConfig[key] = value.toString();
  });
  return {
    version: libraryVersion,
    configs: resultConfig,
    commands: allCommands
  };
};
var createLibraryInfo = function createLibraryInfo(_ref121) {
  var config = _ref121.config,
    componentRegistry = _ref121.componentRegistry;
  var libraryInfo = prepareLibraryInfo({
    config: config,
    componentRegistry: componentRegistry
  });
  return {
    commands: {
      getLibraryInfo: {
        run: function run() {
          return {
            libraryInfo: libraryInfo
          };
        }
      }
    }
  };
};
createLibraryInfo.namespace = "LibraryInfo";

var PERSONALIZATION_DECISIONS_HANDLE = "personalization:decisions";

var isPlainObject = function isPlainObject(obj) {
  return obj !== null && _typeof(obj) === "object" && Object.getPrototypeOf(obj) === Object.prototype;
};
var flattenObject = function flattenObject(obj) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  Object.keys(obj).forEach(function (key) {
    if (isPlainObject(obj[key]) || Array.isArray(obj[key])) {
      flattenObject(obj[key], result, [].concat(_toConsumableArray(keys), [key]));
    } else {
      result[[].concat(_toConsumableArray(keys), [key]).join(".")] = obj[key];
    }
  });
  return result;
};
var flattenObject$1 = function flattenObject$1(obj) {
  if (!isPlainObject(obj)) {
    return obj;
  }
  return flattenObject(obj);
};

var createOnResponseHandler = function createOnResponseHandler(_ref122) {
  var renderDecisions = _ref122.renderDecisions,
    decisionProvider = _ref122.decisionProvider,
    applyResponse = _ref122.applyResponse,
    event = _ref122.event,
    personalization = _ref122.personalization,
    decisionContext = _ref122.decisionContext;
  var context = _objectSpread(_objectSpread({}, flattenObject$1(event.getContent())), decisionContext);
  return function (_ref123) {
    var response = _ref123.response;
    decisionProvider.addPayloads(response.getPayloadsByType(PERSONALIZATION_DECISIONS_HANDLE));

    if (!event.hasQuery()) {
      return {
        propositions: []
      };
    }
    var propositions = decisionProvider.evaluate(context);
    return applyResponse({
      renderDecisions: renderDecisions,
      propositions: propositions,
      event: event,
      personalization: personalization
    });
  };
};
var ConditionType = {
  MATCHER: "matcher",
  GROUP: "group",
  HISTORICAL: "historical"
};
var MatcherType = {
  EQUALS: "eq",
  NOT_EQUALS: "ne",
  EXISTS: "ex",
  NOT_EXISTS: "nx",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "ge",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "le",
  CONTAINS: "co",
  NOT_CONTAINS: "nc",
  STARTS_WITH: "sw",
  ENDS_WITH: "ew"
};
var LogicType = {
  AND: "and",
  OR: "or"
};
var SearchType = {
  ANY: "any",
  ORDERED: "ordered"
};
function isObjectOrUndefined(value) {
  return _typeof(value) === "object" || typeof value === "undefined";
}
function createEquals() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      var contextValue = String(context[key]).toLowerCase();
      for (var _i16 = 0; _i16 < values.length; _i16 += 1) {
        if (!isObjectOrUndefined(values[_i16]) && contextValue === String(values[_i16]).toLowerCase()) {
          return true;
        }
      }
      return false;
    }
  };
}
function createNotEquals() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      var contextValue = String(context[key]).toLowerCase();
      for (var _i17 = 0; _i17 < values.length; _i17 += 1) {
        if (!isObjectOrUndefined(values[_i17]) && contextValue === String(values[_i17]).toLowerCase()) {
          return false;
        }
      }
      return true;
    }
  };
}
function createExists() {
  return {
    matches: function matches(context, key) {
      return typeof context[key] !== "undefined" && context[key] !== null;
    }
  };
}
function createNotExists() {
  return {
    matches: function matches(context, key) {
      return typeof context[key] === "undefined" || context[key] === null;
    }
  };
}
function isNumber$1(value) {
  return typeof value === "number";
}
function createGreaterThan() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var needle = context[key];
      if (!isNumber$1(needle)) {
        return false;
      }
      for (var _i18 = 0; _i18 < values.length; _i18 += 1) {
        if (isNumber$1(values[_i18]) && needle > values[_i18]) {
          return true;
        }
      }
      return false;
    }
  };
}
function createGreaterThanEquals() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var needle = context[key];
      if (!isNumber$1(needle)) {
        return false;
      }
      for (var _i19 = 0; _i19 < values.length; _i19 += 1) {
        if (isNumber$1(values[_i19]) && needle >= values[_i19]) {
          return true;
        }
      }
      return false;
    }
  };
}
function createLessThan() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var needle = context[key];
      if (!isNumber$1(needle)) {
        return false;
      }
      for (var _i20 = 0; _i20 < values.length; _i20 += 1) {
        if (isNumber$1(values[_i20]) && needle < values[_i20]) {
          return true;
        }
      }
      return false;
    }
  };
}
function createLessThanEquals() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var needle = context[key];
      if (!isNumber$1(needle)) {
        return false;
      }
      for (var _i21 = 0; _i21 < values.length; _i21 += 1) {
        if (isNumber$1(values[_i21]) && needle <= values[_i21]) {
          return true;
        }
      }
      return false;
    }
  };
}
function createContains() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      var contextValue = String(context[key]).toLowerCase();
      for (var _i22 = 0; _i22 < values.length; _i22 += 1) {
        if (!isObjectOrUndefined(values[_i22]) && contextValue.indexOf(String(values[_i22]).toLowerCase()) !== -1) {
          return true;
        }
      }
      return false;
    }
  };
}
function createNotContains() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      var contextValue = String(context[key]).toLowerCase();
      for (var _i23 = 0; _i23 < values.length; _i23 += 1) {
        if (!isObjectOrUndefined(values[_i23]) && contextValue.indexOf(String(values[_i23]).toLowerCase()) !== -1) {
          return false;
        }
      }
      return true;
    }
  };
}
function createStartsWith() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      var contextValue = String(context[key]).toLowerCase();
      for (var _i24 = 0; _i24 < values.length; _i24 += 1) {
        if (!isObjectOrUndefined(values[_i24]) && contextValue.startsWith(String(values[_i24]).toLowerCase())) {
          return true;
        }
      }
      return false;
    }
  };
}
function createEndsWith() {
  return {
    matches: function matches(context, key) {
      var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      var contextValue = String(context[key]).toLowerCase();
      for (var _i25 = 0; _i25 < values.length; _i25 += 1) {
        if (!isObjectOrUndefined(values[_i25]) && contextValue.endsWith(values[_i25].toLowerCase())) {
          return true;
        }
      }
      return false;
    }
  };
}
var MATCHERS = (_MATCHERS = {}, _defineProperty(_MATCHERS, MatcherType.EQUALS, createEquals()), _defineProperty(_MATCHERS, MatcherType.NOT_EQUALS, createNotEquals()), _defineProperty(_MATCHERS, MatcherType.EXISTS, createExists()), _defineProperty(_MATCHERS, MatcherType.NOT_EXISTS, createNotExists()), _defineProperty(_MATCHERS, MatcherType.GREATER_THAN, createGreaterThan()), _defineProperty(_MATCHERS, MatcherType.GREATER_THAN_OR_EQUAL_TO, createGreaterThanEquals()), _defineProperty(_MATCHERS, MatcherType.LESS_THAN, createLessThan()), _defineProperty(_MATCHERS, MatcherType.LESS_THAN_OR_EQUAL_TO, createLessThanEquals()), _defineProperty(_MATCHERS, MatcherType.CONTAINS, createContains()), _defineProperty(_MATCHERS, MatcherType.NOT_CONTAINS, createNotContains()), _defineProperty(_MATCHERS, MatcherType.STARTS_WITH, createStartsWith()), _defineProperty(_MATCHERS, MatcherType.ENDS_WITH, createEndsWith()), _MATCHERS);
function getMatcher(key) {
  return MATCHERS[key];
}
function isUndefined(value) {
  return typeof value === "undefined";
}
var IAM_ID = "iam.id";
var ID = "id";
var IAM_EVENT_TYPE = "iam.eventType";
var EVENT_TYPE = "eventType";
var TYPE = "type";
var VALID_EVENT_TYPES = [IAM_EVENT_TYPE, EVENT_TYPE, TYPE];
var VALID_EVENT_IDS = [IAM_ID, ID];
function checkForHistoricalMatcher(eventCount, matcherKey, value) {
  switch (matcherKey) {
    case MatcherType.GREATER_THAN:
      return eventCount > value;
    case MatcherType.GREATER_THAN_OR_EQUAL_TO:
      return eventCount >= value;
    case MatcherType.LESS_THAN:
      return eventCount < value;
    case MatcherType.LESS_THAN_OR_EQUAL_TO:
      return eventCount <= value;
    case MatcherType.EQUALS:
      return eventCount === value;
    case MatcherType.NOT_EQUALS:
      return eventCount !== value;
    default:
      return false;
  }
}
function oneOf(context, properties) {
  for (var _i26 = 0; _i26 < properties.length; _i26 += 1) {
    if (!isUndefined(context[properties[_i26]])) {
      return context[properties[_i26]];
    }
  }
  return undefined;
}
function eventSatisfiesCondition(historicalEventCondition, eventContext) {
  var eventKeys = Object.keys(historicalEventCondition);
  for (var _i27 = 0; _i27 < eventKeys.length; _i27 += 1) {
    var key = eventKeys[_i27];
    var _eventContext$event = eventContext.event,
      event = _eventContext$event === void 0 ? {} : _eventContext$event;
    if (event[eventKeys[_i27]] !== historicalEventCondition[key]) {
      return false;
    }
  }
  return true;
}
function queryAndCountAnyEvent(events, context, from, to) {
  return events.reduce(function (countTotal, event) {
    var eventType = oneOf(event, VALID_EVENT_TYPES);
    if (!eventType) {
      return countTotal;
    }
    var eventsOfType = context.events[eventType];
    if (!eventsOfType) {
      return countTotal;
    }
    var eventId = oneOf(event, VALID_EVENT_IDS);
    if (!eventId) {
      return countTotal;
    }
    var contextEvent = eventsOfType[eventId];
    if (!contextEvent) {
      return countTotal;
    }
    if (!eventSatisfiesCondition(event, contextEvent)) {
      return countTotal;
    }
    var _contextEvent$count = contextEvent.count,
      eventCount = _contextEvent$count === void 0 ? 1 : _contextEvent$count;
    if (isUndefined(from) || isUndefined(to) || contextEvent.timestamp >= from && contextEvent.timestamp <= to) {
      return countTotal + eventCount;
    }
    return countTotal;
  }, 0);
}
function queryAndCountOrderedEvent(events, context, from, to) {
  var previousEventTimestamp = from;
  var sameSequence = events.every(function (event) {
    var eventType = oneOf(event, VALID_EVENT_TYPES);
    if (!eventType) {
      return false;
    }
    var eventsOfType = context.events[eventType];
    if (!eventsOfType) {
      return false;
    }
    var eventId = oneOf(event, VALID_EVENT_IDS);
    if (!eventId) {
      return false;
    }
    var contextEvent = eventsOfType[eventId];
    if (!eventSatisfiesCondition(event, contextEvent)) {
      return false;
    }
    if (contextEvent === null || isUndefined(contextEvent) || contextEvent.count === 0) {
      return false;
    }
    var ordered = (isUndefined(previousEventTimestamp) || contextEvent.timestamp >= previousEventTimestamp) && (isUndefined(to) || contextEvent.timestamp <= to);
    previousEventTimestamp = contextEvent.timestamp;
    return ordered;
  });
  return sameSequence ? 1 : 0;
}
function evaluateAnd(context, conditions) {
  var result = true;
  for (var _i28 = 0; _i28 < conditions.length; _i28 += 1) {
    result = result && conditions[_i28].evaluate(context);
  }
  return result;
}
function evaluateOr(context, conditions) {
  var result = false;
  for (var _i29 = 0; _i29 < conditions.length; _i29 += 1) {
    result = result || conditions[_i29].evaluate(context);
    if (result) {
      return true;
    }
  }
  return false;
}
function createRules(version, rules) {
  return {
    version: version,
    rules: rules
  };
}
function createRule(condition, consequences) {
  return {
    execute: function execute(context) {
      if (condition.evaluate(context)) {
        return consequences;
      }
      return [];
    },
    toString: function toString() {
      return "Rule{condition=".concat(condition, ", consequences=").concat(consequences, "}");
    }
  };
}
function createCondition(type, definition) {
  return {
    evaluate: function evaluate(context) {
      return definition.evaluate(context);
    },
    toString: function toString() {
      return "Condition{type=".concat(type, ", definition=").concat(definition, "}");
    }
  };
}
function createConsequence(id, type, detail) {
  return {
    id: id,
    type: type,
    detail: detail
  };
}
function createGroupDefinition(logic, conditions) {
  return {
    evaluate: function evaluate(context) {
      if (LogicType.AND === logic) {
        return evaluateAnd(context, conditions);
      }
      if (LogicType.OR === logic) {
        return evaluateOr(context, conditions);
      }
      return false;
    }
  };
}
function createMatcherDefinition(key, matcherKey, values) {
  return {
    evaluate: function evaluate(context) {
      var matcher = getMatcher(matcherKey);
      if (!matcher) {
        return false;
      }
      return matcher.matches(context, key, values);
    }
  };
}
function createHistoricalDefinition(events, matcherKey, value, from, to, searchType) {
  return {
    evaluate: function evaluate(context) {
      var eventCount;
      if (SearchType.ORDERED === searchType) {
        eventCount = queryAndCountOrderedEvent(events, context, from, to);
      } else {
        eventCount = queryAndCountAnyEvent(events, context, from, to);
      }
      return checkForHistoricalMatcher(eventCount, matcherKey, value);
    }
  };
}
function parseMatcherDefinition(definition) {
  var key = definition.key,
    matcher = definition.matcher,
    values = definition.values;
  return createMatcherDefinition(key, matcher, values);
}
function parseGroupDefinition(definition) {
  var logic = definition.logic,
    conditions = definition.conditions;
  return createGroupDefinition(logic, conditions.map(parseCondition));
}
function parseHistoricalDefinition(definition) {
  var events = definition.events,
    from = definition.from,
    to = definition.to,
    matcher = definition.matcher,
    value = definition.value,
    searchType = definition.searchType;
  return createHistoricalDefinition(events, matcher, value, from, to, searchType);
}
function parseCondition(condition) {
  var type = condition.type,
    definition = condition.definition;
  if (ConditionType.MATCHER === type) {
    return createCondition(type, parseMatcherDefinition(definition));
  }
  if (ConditionType.GROUP === type) {
    return createCondition(type, parseGroupDefinition(definition));
  }
  if (ConditionType.HISTORICAL === type) {
    return createCondition(type, parseHistoricalDefinition(definition));
  }
  throw new Error("Can not parse condition");
}
function parseConsequence(consequence) {
  var id = consequence.id,
    type = consequence.type,
    detail = consequence.detail;
  return createConsequence(id, type, detail);
}
function parseRule(rule) {
  var condition = rule.condition,
    consequences = rule.consequences;
  return createRule(parseCondition(condition), consequences.map(parseConsequence));
}
function parseRules(ruleset) {
  var version = ruleset.version,
    rules = ruleset.rules;
  return createRules(version, rules.map(parseRule));
}
function RulesEngine(ruleset) {
  var _parseRules = parseRules(ruleset),
    version = _parseRules.version,
    rules = _parseRules.rules;
  return {
    execute: function execute(context) {
      return rules.map(function (rule) {
        return rule.execute(context);
      }).filter(function (arr) {
        return arr.length > 0;
      });
    },
    getVersion: function getVersion() {
      return version;
    },
    numRules: function numRules() {
      return rules.length;
    }
  };
}


var createRestoreStorage = function createRestoreStorage(storage, storageKey) {
  return function (defaultValue) {
    var stored = storage.getItem(storageKey);
    if (!stored) {
      return defaultValue;
    }
    try {
      return JSON.parse(stored);
    } catch (e) {
      return defaultValue;
    }
  };
};
var createSaveStorage = function createSaveStorage(storage, storageKey) {
  var prepareFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (value) {
    return value;
  };
  return function (value) {
    storage.setItem(storageKey, JSON.stringify(prepareFn(value)));
  };
};
var getExpirationDate = function getExpirationDate(retentionPeriod) {
  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() - retentionPeriod);
  return expirationDate;
};
var getActivityId = function getActivityId(proposition) {
  var _proposition$scopeDet = proposition.scopeDetails,
    scopeDetails = _proposition$scopeDet === void 0 ? {} : _proposition$scopeDet;
  var _scopeDetails$activit = scopeDetails.activity,
    activity = _scopeDetails$activit === void 0 ? {} : _scopeDetails$activit;
  var id = activity.id;
  return id;
};
var createInMemoryStorage = function createInMemoryStorage() {
  var inMemoryStorage = {};
  return {
    getItem: function getItem(key) {
      return key in inMemoryStorage ? inMemoryStorage[key] : null;
    },
    setItem: function setItem(key, value) {
      inMemoryStorage[key] = value;
    }
  };
};
var clearLocalStorage = function clearLocalStorage(storage) {
  storage.clear();
};
var hasExperienceData = function hasExperienceData(xdm) {
  var _xdm$eventType = xdm.eventType,
    eventType = _xdm$eventType === void 0 ? "" : _xdm$eventType,
    _experience = xdm._experience;
  if (!eventType || eventType === "") {
    return false;
  }
  if (!_experience || _typeof(_experience) !== "object") {
    return false;
  }
  return true;
};
var getDecisionProvider = function getDecisionProvider(proposition) {
  var _proposition$scopeDet2 = proposition.scopeDetails,
    scopeDetails = _proposition$scopeDet2 === void 0 ? {} : _proposition$scopeDet2;
  var decisionProvider = scopeDetails.decisionProvider;
  return decisionProvider;
};

var flattenArray = function flattenArray() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var flat = [];
  if (!Array.isArray(items)) {
    return items;
  }
  items.forEach(function (item) {
    if (Array.isArray(item)) {
      flat.push.apply(flat, _toConsumableArray(flattenArray(item)));
    } else {
      flat.push(item);
    }
  });
  return flat;
};

var inAppMessageConsequenceAdapter = function inAppMessageConsequenceAdapter(id, type, detail) {
  var html = detail.html,
    mobileParameters = detail.mobileParameters;
  var webParameters = {};
  return {
    schema: MESSAGE_IN_APP,
    data: {
      mobileParameters: mobileParameters,
      webParameters: webParameters,
      content: html,
      contentType: TEXT_HTML
    },
    id: id
  };
};


var schemaTypeConsequenceAdapter = function schemaTypeConsequenceAdapter(id, type, detail) {
  var schema = detail.schema,
    data = detail.data,
    detailId = detail.id;
  return {
    schema: schema,
    data: data,
    id: detailId || id
  };
};

var CJM_IN_APP_MESSAGE_TYPE = "cjmiam";
var SCHEMA = "schema";
var adapters = (_adapters = {}, _defineProperty(_adapters, CJM_IN_APP_MESSAGE_TYPE, inAppMessageConsequenceAdapter), _defineProperty(_adapters, SCHEMA, schemaTypeConsequenceAdapter), _adapters);
var createConsequenceAdapter = function createConsequenceAdapter() {
  return function (consequence) {
    var id = consequence.id,
      type = consequence.type,
      detail = consequence.detail;
    return typeof adapters[type] === "function" ? adapters[type](id, type, detail) : detail;
  };
};

var isRulesetItem = function isRulesetItem(item) {
  var schema = item.schema,
    data = item.data;
  if (schema === RULESET_ITEM) {
    return true;
  }
  if (schema !== JSON_CONTENT_ITEM) {
    return false;
  }
  try {
    var content = typeof data.content === "string" ? JSON.parse(data.content) : data.content;
    return content && Object.prototype.hasOwnProperty.call(content, "version") && Object.prototype.hasOwnProperty.call(content, "rules");
  } catch (error) {
    return false;
  }
};
var createEvaluableRulesetPayload = function createEvaluableRulesetPayload(payload, eventRegistry, decisionHistory) {
  var consequenceAdapter = createConsequenceAdapter();
  var activityId = getActivityId(payload);
  var items = [];
  var addItem = function addItem(item) {
    var _item$data = item.data,
      data = _item$data === void 0 ? {} : _item$data,
      schema = item.schema;
    var content = schema === RULESET_ITEM ? data : data.content;
    if (!content) {
      return;
    }
    items.push(RulesEngine(typeof content === "string" ? JSON.parse(content) : content));
  };
  var evaluate = function evaluate(context) {
    var displayEvent = eventRegistry.getEvent(DISPLAY, activityId);
    var displayedDate = displayEvent ? displayEvent.firstTimestamp : undefined;
    var qualifyingItems = flattenArray(items.map(function (item) {
      return item.execute(context);
    })).map(consequenceAdapter).map(function (item) {
      var _ref124 = decisionHistory.recordQualified(activityId) || {},
        qualifiedDate = _ref124.firstTimestamp;
      return _objectSpread(_objectSpread({}, item), {}, {
        data: _objectSpread(_objectSpread({}, item.data), {}, {
          qualifiedDate: qualifiedDate,
          displayedDate: displayedDate
        })
      });
    });
    return _objectSpread(_objectSpread({}, payload), {}, {
      items: qualifyingItems
    });
  };
  if (Array.isArray(payload.items)) {
    payload.items.filter(isRulesetItem).forEach(addItem);
  }
  return {
    evaluate: evaluate,
    isEvaluable: items.length > 0
  };
};

var createDecisionHistory = function createDecisionHistory(_ref125) {
  var eventRegistry = _ref125.eventRegistry;
  var recordQualified = function recordQualified(id) {
    if (!id) {
      return undefined;
    }
    return eventRegistry.addEvent({}, PropositionEventType.TRIGGER, id);
  };
  return {
    recordQualified: recordQualified
  };
};

var createDecisionProvider = function createDecisionProvider(_ref126) {
  var eventRegistry = _ref126.eventRegistry;
  var payloadsBasedOnActivityId = {};
  var decisionHistory = createDecisionHistory({
    eventRegistry: eventRegistry
  });
  var addPayload = function addPayload(payload) {
    var activityId = getActivityId(payload);
    if (!activityId) {
      return;
    }
    var evaluableRulesetPayload = createEvaluableRulesetPayload(payload, eventRegistry, decisionHistory);
    if (evaluableRulesetPayload.isEvaluable) {
      payloadsBasedOnActivityId[activityId] = evaluableRulesetPayload;
    }
  };
  var evaluate = function evaluate() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.values(payloadsBasedOnActivityId).map(function (payload) {
      return payload.evaluate(context);
    }).filter(function (payload) {
      return payload.items.length > 0;
    });
  };
  var addPayloads = function addPayloads(personalizationPayloads) {
    personalizationPayloads.forEach(addPayload);
  };
  return {
    addPayload: addPayload,
    addPayloads: addPayloads,
    evaluate: evaluate
  };
};

var createApplyResponse = function createApplyResponse(lifecycle) {
  return function (_ref127) {
    var _ref127$renderDecisio = _ref127.renderDecisions,
      renderDecisions = _ref127$renderDecisio === void 0 ? false : _ref127$renderDecisio,
      _ref127$propositions = _ref127.propositions,
      propositions = _ref127$propositions === void 0 ? [] : _ref127$propositions,
      event = _ref127.event,
      personalization = _ref127.personalization;
    if (propositions.length > 0 && lifecycle) {
      lifecycle.onDecision({
        renderDecisions: renderDecisions,
        propositions: propositions,
        event: event,
        personalization: personalization
      });
    }
    return {
      propositions: propositions
    };
  };
};

var ADOBE_JOURNEY_OPTIMIZER = "AJO";

var STORAGE_KEY = "events";
var MAX_EVENT_RECORDS = 1000;
var RETENTION_PERIOD = 30;
var prefixed = function prefixed(key) {
  return "iam.".concat(key);
};
var createEventPruner = function createEventPruner() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MAX_EVENT_RECORDS;
  var retentionPeriod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RETENTION_PERIOD;
  return function (events) {
    var pruned = {};
    Object.keys(events).forEach(function (eventType) {
      pruned[eventType] = {};
      Object.values(events[eventType]).filter(function (entry) {
        return new Date(entry.firstTimestamp) >= getExpirationDate(retentionPeriod);
      }).sort(function (a, b) {
        return a.firstTimestamp - b.firstTimestamp;
      }).slice(-1 * limit).forEach(function (entry) {
        pruned[eventType][entry.event[prefixed("id")]] = entry;
      });
    });
    return pruned;
  };
};
var createEventRegistry = function createEventRegistry(_ref128) {
  var storage = _ref128.storage;
  var currentStorage = storage;
  var restore;
  var save;
  var events;
  var setStorage = function setStorage(newStorage) {
    currentStorage = newStorage;
    restore = createRestoreStorage(currentStorage, STORAGE_KEY);
    save = createSaveStorage(currentStorage, STORAGE_KEY, createEventPruner(MAX_EVENT_RECORDS, RETENTION_PERIOD));
    events = restore({});
  };
  setStorage(storage);
  var addEvent = function addEvent(event, eventType, eventId, action) {
    var _objectSpread5;
    if (!eventType || !eventId) {
      return undefined;
    }
    if (!events[eventType]) {
      events[eventType] = {};
    }
    var existingEvent = events[eventType][eventId];
    var count = existingEvent ? existingEvent.count : 0;
    var timestamp = new Date().getTime();
    var firstTimestamp = existingEvent ? existingEvent.firstTimestamp || existingEvent.timestamp : timestamp;
    events[eventType][eventId] = {
      event: _objectSpread(_objectSpread({}, event), {}, (_objectSpread5 = {}, _defineProperty(_objectSpread5, prefixed("id"), eventId), _defineProperty(_objectSpread5, prefixed("eventType"), eventType), _defineProperty(_objectSpread5, prefixed("action"), action), _objectSpread5)),
      firstTimestamp: firstTimestamp,
      timestamp: timestamp,
      count: count + 1
    };
    save(events);
    return events[eventType][eventId];
  };
  var addExperienceEdgeEvent = function addExperienceEdgeEvent(event) {
    var _event$getContent = event.getContent(),
      _event$getContent$xdm = _event$getContent.xdm,
      xdm = _event$getContent$xdm === void 0 ? {} : _event$getContent$xdm;
    var _experience = xdm._experience;
    if (!hasExperienceData(xdm)) {
      return;
    }
    var _experience$decisioni = _experience.decisioning,
      decisioning = _experience$decisioni === void 0 ? {} : _experience$decisioni;
    var _decisioning$proposit = decisioning.propositionEventType,
      propositionEventTypeObj = _decisioning$proposit === void 0 ? {} : _decisioning$proposit,
      _decisioning$proposit2 = decisioning.propositionAction,
      propositionAction = _decisioning$proposit2 === void 0 ? {} : _decisioning$proposit2,
      _decisioning$proposit3 = decisioning.propositions,
      propositions = _decisioning$proposit3 === void 0 ? [] : _decisioning$proposit3;
    var propositionEventTypesList = Object.keys(propositionEventTypeObj);

    if (propositionEventTypesList.length === 0) {
      return;
    }
    var validPropositionEventType = function validPropositionEventType(propositionEventType) {
      return propositionEventTypeObj[propositionEventType] === EVENT_TYPE_TRUE;
    };
    var action = propositionAction.id;
    propositionEventTypesList.filter(validPropositionEventType).forEach(function (propositionEventType) {
      propositions.forEach(function (proposition) {
        if (getDecisionProvider(proposition) !== ADOBE_JOURNEY_OPTIMIZER) {
          return;
        }
        addEvent({}, propositionEventType, getActivityId(proposition), action);
      });
    });
  };
  var getEvent = function getEvent(eventType, eventId) {
    if (!events[eventType]) {
      return undefined;
    }
    return events[eventType][eventId];
  };
  return {
    addExperienceEdgeEvent: addExperienceEdgeEvent,
    addEvent: addEvent,
    getEvent: getEvent,
    toJSON: function toJSON() {
      return events;
    },
    setStorage: setStorage
  };
};

var createContextProvider = function createContextProvider(_ref129) {
  var eventRegistry = _ref129.eventRegistry,
    window = _ref129.window;
  var pageLoadTimestamp = new Date().getTime();
  var getBrowserContext = function getBrowserContext() {
    return {
      name: getBrowser(window)
    };
  };
  var getPageContext = function getPageContext() {
    return _objectSpread({
      title: window.title,
      url: window.url
    }, parseUrl(window.url));
  };
  var getReferrerContext = function getReferrerContext() {
    return _objectSpread({
      url: window.referrer
    }, parseUrl(window.referrer));
  };
  var getTimeContext = function getTimeContext() {
    var now = new Date();
    var currentTimestamp = now.getTime();
    return {
      pageLoadTimestamp: pageLoadTimestamp,
      currentTimestamp: currentTimestamp,
      currentDate: now.getDate(),
      "~state.com.adobe.module.lifecycle/lifecyclecontextdata.dayofweek": now.getDay() + 1,
      "~state.com.adobe.module.lifecycle/lifecyclecontextdata.hourofday": now.getHours(),
      currentMinute: now.getMinutes(),
      currentMonth: now.getMonth(),
      currentYear: now.getFullYear(),
      pageVisitDuration: currentTimestamp - pageLoadTimestamp,
      "~timestampu": currentTimestamp / 1000,
      "~timestampz": now.toISOString()
    };
  };
  var getWindowContext = function getWindowContext() {
    var height = window.height;
    var width = window.width;
    var scrollY = window.scrollY;
    var scrollX = window.scrollX;
    return {
      height: height,
      width: width,
      scrollY: scrollY,
      scrollX: scrollX
    };
  };
  var coreGlobalContext = {
    browser: getBrowserContext(),
    page: getPageContext(),
    referringPage: getReferrerContext()
  };
  var getGlobalContext = function getGlobalContext() {
    return _objectSpread(_objectSpread(_objectSpread({}, coreGlobalContext), getTimeContext()), {}, {
      window: getWindowContext(),
      "~sdkver": libraryVersion
    });
  };
  var getContext = function getContext() {
    var addedContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = _objectSpread(_objectSpread({}, getGlobalContext()), addedContext);
    return _objectSpread(_objectSpread({}, flattenObject$1(context)), {}, {
      events: eventRegistry.toJSON()
    });
  };
  return {
    getContext: getContext
  };
};

var defaultPreprocessor = function defaultPreprocessor(params) {
  for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }
  return args;
};

var defaultEmissionCondition = function defaultEmissionCondition(params) {
  return true;
};
var createSubscription = function createSubscription() {
  var preprocessor = defaultPreprocessor;
  var emissionCondition = defaultEmissionCondition;
  var counter = 0;
  var subscriptions = {};
  var createUnsubscribe = function createUnsubscribe(id) {
    return function () {
      delete subscriptions[id];
    };
  };
  var add = function add(callback) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    if (typeof callback !== "function") {
      return function () {
        return undefined;
      };
    }
    counter += 1;
    subscriptions[counter] = {
      callback: callback,
      params: params
    };
    return createUnsubscribe(counter);
  };
  var setEmissionPreprocessor = function setEmissionPreprocessor(value) {
    if (typeof value === "function") {
      preprocessor = value;
    }
  };
  var setEmissionCondition = function setEmissionCondition(value) {
    if (typeof value === "function") {
      emissionCondition = value;
    }
  };
  var emit = function emit() {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }
    values(subscriptions).forEach(function (_ref130) {
      var callback = _ref130.callback,
        params = _ref130.params;
      var result = preprocessor.apply(void 0, [params].concat(args));
      if (emissionCondition.apply(void 0, [params].concat(_toConsumableArray(result)))) {
        callback.apply(void 0, _toConsumableArray(result));
      }
    });
  };
  var hasSubscriptions = function hasSubscriptions() {
    return Object.keys(subscriptions).length > 0;
  };
  return {
    add: add,
    emit: emit,
    hasSubscriptions: hasSubscriptions,
    setEmissionPreprocessor: setEmissionPreprocessor,
    setEmissionCondition: setEmissionCondition
  };
};

var validateOptions = function validateOptions(_ref131) {
  var options = _ref131.options;
  var validator = boundObjectOf({
    surfaces: boundArrayOf(boundString()).uniqueItems(),
    schemas: boundArrayOf(boundString()).uniqueItems(),
    callback: boundCallback().required()
  }).noUnknownFields();
  return validator(options);
};
var emissionPreprocessor = function emissionPreprocessor(params, propositions) {
  var surfacesFilter = params.surfacesFilter,
    schemasFilter = params.schemasFilter;
  var result = {
    propositions: propositions.filter(function (payload) {
      return surfacesFilter ? includes(surfacesFilter, payload.scope) : true;
    }).map(function (payload) {
      var _payload$items2 = payload.items,
        items = _payload$items2 === void 0 ? [] : _payload$items2;
      return _objectSpread(_objectSpread({}, payload), {}, {
        items: items.filter(function (item) {
          return schemasFilter ? includes(schemasFilter, item.schema) : true;
        })
      });
    }).filter(function (payload) {
      return payload.items.length > 0;
    })
  };
  return [result];
};
var emissionCondition = function emissionCondition(params, result) {
  return result.propositions.length > 0;
};
var createSubscribeRulesetItems = function createSubscribeRulesetItems() {
  var subscription = createSubscription();
  subscription.setEmissionPreprocessor(emissionPreprocessor);
  subscription.setEmissionCondition(emissionCondition);
  var run = function run(_ref132) {
    var surfaces = _ref132.surfaces,
      schemas = _ref132.schemas,
      callback = _ref132.callback;
    var unsubscribe = subscription.add(callback, {
      surfacesFilter: surfaces instanceof Array ? surfaces : undefined,
      schemasFilter: schemas instanceof Array ? schemas : undefined
    });
    return Promise.resolve({
      unsubscribe: unsubscribe
    });
  };
  var optionsValidator = function optionsValidator(options) {
    return validateOptions({
      options: options
    });
  };
  var refresh = function refresh(propositions) {
    if (!subscription.hasSubscriptions()) {
      return;
    }
    subscription.emit(propositions);
  };
  return {
    refresh: refresh,
    command: {
      optionsValidator: optionsValidator,
      run: run
    }
  };
};

var CONTEXT_KEY = {
  TYPE: "~type",
  SOURCE: "~source"
};
var CONTEXT_EVENT_TYPE = {
  LIFECYCLE: "com.adobe.eventType.lifecycle",
  TRACK: "com.adobe.eventType.generic.track",
  EDGE: "com.adobe.eventType.edge",
  RULES_ENGINE: "com.adobe.eventType.rulesEngine"
};
var CONTEXT_EVENT_SOURCE = {
  LAUNCH: "com.adobe.eventSource.applicationLaunch",
  REQUEST: "com.adobe.eventSource.requestContent"
};

var validateOptions$1 = function validateOptions$1(_ref133) {
  var options = _ref133.options;
  var validator = boundObjectOf({
    renderDecisions: boundBoolean(),
    personalization: boundObjectOf({
      decisionContext: boundObjectOf({})
    })
  }).noUnknownFields();
  return validator(options);
};
var createEvaluateRulesetsCommand = function createEvaluateRulesetsCommand(_ref134) {
  var contextProvider = _ref134.contextProvider,
    decisionProvider = _ref134.decisionProvider;
  var run = function run(_ref135) {
    var renderDecisions = _ref135.renderDecisions,
      decisionContext = _ref135.decisionContext,
      applyResponse = _ref135.applyResponse;
    return applyResponse({
      renderDecisions: renderDecisions,
      propositions: decisionProvider.evaluate(contextProvider.getContext(decisionContext))
    });
  };
  var optionsValidator = function optionsValidator(options) {
    return validateOptions$1({
      options: options
    });
  };
  return {
    optionsValidator: optionsValidator,
    run: run
  };
};

var createDecisioningEngine = function createDecisioningEngine(_ref136) {
  var config = _ref136.config,
    createNamespacedStorage = _ref136.createNamespacedStorage,
    consent = _ref136.consent;
  var orgId = config.orgId,
    personalizationStorageEnabled = config.personalizationStorageEnabled;
  var storage = createNamespacedStorage("".concat(sanitizeOrgIdForCookieName(orgId), ".decisioning."));
  if (!personalizationStorageEnabled) {
    clearLocalStorage(storage.persistent);
  }
  var eventRegistry = createEventRegistry({
    storage: createInMemoryStorage()
  });
  var decisionProvider = createDecisionProvider({
    eventRegistry: eventRegistry
  });
  var contextProvider = createContextProvider({
    eventRegistry: eventRegistry,
    window: window
  });
  var evaluateRulesetsCommand = createEvaluateRulesetsCommand({
    contextProvider: contextProvider,
    decisionProvider: decisionProvider
  });
  var subscribeRulesetItems = createSubscribeRulesetItems();
  var applyResponse;
  return {
    lifecycle: {
      onDecision: function onDecision(_ref137) {
        var propositions = _ref137.propositions;
        subscribeRulesetItems.refresh(propositions);
      },
      onComponentsRegistered: function onComponentsRegistered(tools) {
        applyResponse = createApplyResponse(tools.lifecycle);
        if (personalizationStorageEnabled) {
          consent.awaitConsent().then(function () {
            eventRegistry.setStorage(storage.persistent);
          })["catch"](function () {
            if (storage) {
              clearLocalStorage(storage.persistent);
            }
          });
        }
      },
      onBeforeEvent: function onBeforeEvent(_ref138) {
        var _objectSpread6;
        var event = _ref138.event,
          renderDecisions = _ref138.renderDecisions,
          _ref138$personalizati = _ref138.personalization,
          personalization = _ref138$personalizati === void 0 ? {} : _ref138$personalizati,
          _ref138$onResponse = _ref138.onResponse,
          onResponse = _ref138$onResponse === void 0 ? noop : _ref138$onResponse;
        var _personalization$deci = personalization.decisionContext,
          decisionContext = _personalization$deci === void 0 ? {} : _personalization$deci;
        onResponse(createOnResponseHandler({
          renderDecisions: renderDecisions,
          decisionProvider: decisionProvider,
          applyResponse: applyResponse,
          event: event,
          personalization: personalization,
          decisionContext: contextProvider.getContext(_objectSpread((_objectSpread6 = {}, _defineProperty(_objectSpread6, CONTEXT_KEY.TYPE, CONTEXT_EVENT_TYPE.EDGE), _defineProperty(_objectSpread6, CONTEXT_KEY.SOURCE, CONTEXT_EVENT_SOURCE.REQUEST), _objectSpread6), decisionContext))
        }));
        eventRegistry.addExperienceEdgeEvent(event);
      }
    },
    commands: {
      evaluateRulesets: {
        run: function run(_ref139) {
          var _objectSpread7;
          var renderDecisions = _ref139.renderDecisions,
            _ref139$personalizati = _ref139.personalization,
            personalization = _ref139$personalizati === void 0 ? {} : _ref139$personalizati;
          var _personalization$deci2 = personalization.decisionContext,
            decisionContext = _personalization$deci2 === void 0 ? {} : _personalization$deci2;
          return evaluateRulesetsCommand.run({
            renderDecisions: renderDecisions,
            decisionContext: _objectSpread((_objectSpread7 = {}, _defineProperty(_objectSpread7, CONTEXT_KEY.TYPE, CONTEXT_EVENT_TYPE.RULES_ENGINE), _defineProperty(_objectSpread7, CONTEXT_KEY.SOURCE, CONTEXT_EVENT_SOURCE.REQUEST), _objectSpread7), decisionContext),
            applyResponse: applyResponse
          });
        },
        optionsValidator: evaluateRulesetsCommand.optionsValidator
      },
      subscribeRulesetItems: subscribeRulesetItems.command
    }
  };
};
createDecisioningEngine.namespace = "DecisioningEngine";
createDecisioningEngine.configValidators = boundObjectOf({
  personalizationStorageEnabled: boundBoolean()["default"](false)
});


var processResponse = function processResponse(_ref140) {
  var response = _ref140.response;
  return {
    inferences: response.getPayloadsByType("rtml:inferences")
  };
};

var createMachineLearning = function createMachineLearning() {
  return {
    lifecycle: {
      onResponse: processResponse
    },
    commands: {}
  };
};
createMachineLearning.namespace = "MachineLearning";


var componentCreators = [createDataCollector, createActivityCollector, createIdentity, createAudiences, createPersonalization, createContext, createPrivacy, createEventMerge, createLibraryInfo, createMachineLearning, createDecisioningEngine];

var CONFIG_DOC_URI = "https://adobe.ly/3sHh553";
var transformOptions = function transformOptions(_ref141) {
  var combinedConfigValidator = _ref141.combinedConfigValidator,
    options = _ref141.options,
    logger = _ref141.logger;
  try {
    var validator = combinedConfigValidator.noUnknownFields().required();
    return validator.call({
      logger: logger
    }, options);
  } catch (e) {
    throw new Error("Resolve these configuration problems:\n\t - ".concat(e.message.split("\n").join("\n\t - "), "\nFor configuration documentation see: ").concat(CONFIG_DOC_URI));
  }
};
var buildAllOnInstanceConfiguredExtraParams = function buildAllOnInstanceConfiguredExtraParams(config, logger, componentCreators) {
  return componentCreators.reduce(function (memo, _ref142) {
    var buildOnInstanceConfiguredExtraParams = _ref142.buildOnInstanceConfiguredExtraParams;
    if (buildOnInstanceConfiguredExtraParams) {
      (0, _reactorObjectAssign["default"])(memo, buildOnInstanceConfiguredExtraParams({
        config: config,
        logger: logger
      }));
    }
    return memo;
  }, {});
};
var wrapLoggerInQueue = function wrapLoggerInQueue(logger) {
  var queue = [];
  var queuedLogger = {
    get enabled() {
      return logger.enabled;
    },
    flush: function flush() {
      queue.forEach(function (_ref143) {
        var method = _ref143.method,
          args = _ref143.args;
        return logger[method].apply(logger, _toConsumableArray(args));
      });
    }
  };
  Object.keys(logger).filter(function (key) {
    return typeof logger[key] === "function";
  }).forEach(function (method) {
    queuedLogger[method] = function () {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }
      queue.push({
        method: method,
        args: args
      });
    };
  });
  return queuedLogger;
};
var buildAndValidateConfig = function buildAndValidateConfig(_ref144) {
  var options = _ref144.options,
    componentCreators = _ref144.componentCreators,
    coreConfigValidators = _ref144.coreConfigValidators,
    createConfig = _ref144.createConfig,
    logger = _ref144.logger,
    setDebugEnabled = _ref144.setDebugEnabled;
  var queuedLogger = wrapLoggerInQueue(logger);
  var combinedConfigValidator = componentCreators.map(function (_ref145) {
    var configValidators = _ref145.configValidators;
    return configValidators;
  }).filter(function (configValidators) {
    return configValidators;
  }).reduce(function (validator, configValidators) {
    return validator.concat(configValidators);
  }, coreConfigValidators);
  var config = createConfig(transformOptions({
    combinedConfigValidator: combinedConfigValidator,
    options: options,
    logger: queuedLogger
  }));
  setDebugEnabled(config.debugEnabled, {
    fromConfig: true
  });
  queuedLogger.flush();
  var extraParams = buildAllOnInstanceConfiguredExtraParams(config, logger, componentCreators);
  logger.logOnInstanceConfigured(_objectSpread(_objectSpread({}, extraParams), {}, {
    config: config
  }));
  return config;
};

var initializeComponents = function initializeComponents(_ref146) {
  var componentCreators = _ref146.componentCreators,
    lifecycle = _ref146.lifecycle,
    componentRegistry = _ref146.componentRegistry,
    getImmediatelyAvailableTools = _ref146.getImmediatelyAvailableTools;
  componentCreators.forEach(function (createComponent) {
    var namespace = createComponent.namespace; 
    var tools = getImmediatelyAvailableTools(namespace);
    var component;
    try {
      component = createComponent(tools);
    } catch (error) {
      throw stackError({
        error: error,
        message: "[".concat(namespace, "] An error occurred during component creation.")
      });
    }
    componentRegistry.register(namespace, component);
  });
  return lifecycle.onComponentsRegistered({
    lifecycle: lifecycle
  }).then(function () {
    return componentRegistry;
  });
};

var createConfig = function createConfig(options) {
  return (0, _reactorObjectAssign["default"])({}, options);
};


var EDGE$1 = "edge.adobedc.net";
var ID_THIRD_PARTY = "adobedc.demdex.net";

var EDGE_BASE_PATH = "ee";

var createCoreConfigs = function createCoreConfigs() {
  return boundObjectOf({
    debugEnabled: boundBoolean()["default"](false),
    defaultConsent: boundEnumOf(IN, OUT, PENDING)["default"](IN),
    datastreamId: boundString().unique().required(),
    edgeDomain: boundString().domain()["default"](EDGE$1),
    edgeBasePath: boundString().nonEmpty()["default"](EDGE_BASE_PATH),
    orgId: boundString().unique().required(),
    onBeforeEventSend: boundCallback()["default"](noop),
    edgeConfigOverrides: validateConfigOverride
  }).deprecated("edgeConfigId", boundString().unique(), "datastreamId");
};

var injectHandleError = function injectHandleError(_ref147) {
  var errorPrefix = _ref147.errorPrefix,
    logger = _ref147.logger;
  return function (error, operation) {
    var err = toError(error);

    if (err.code === DECLINED_CONSENT_ERROR_CODE) {
      logger.warn("The ".concat(operation, " could not fully complete. ").concat(err.message));
      return {};
    }
    updateErrorMessage({
      error: err,
      message: "".concat(errorPrefix, " ").concat(err.message)
    });
    throw err;
  };
};


var injectSendFetchRequest = function injectSendFetchRequest(_ref148) {
  var fetch = _ref148.fetch;
  return function (url, body) {
    return fetch(url, {
      method: "POST",
      cache: "no-cache",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain; charset=UTF-8"
      },
      referrerPolicy: "no-referrer-when-downgrade",
      body: body
    }).then(function (response) {
      return response.text().then(function (responseBody) {
        return {
          statusCode: response.status,
          getHeader: function getHeader(name) {
            return response.headers.get(name);
          },
          body: responseBody
        };
      });
    });
  };
};


var injectSendXhrRequest = function injectSendXhrRequest(_ref149) {
  var XMLHttpRequest = _ref149.XMLHttpRequest;
  return function (url, body) {
    return new Promise(function (resolve, reject) {
      var request = new XMLHttpRequest();
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status === 0) {
            reject(new Error("Request aborted."));
          } else {
            resolve({
              statusCode: request.status,
              getHeader: function getHeader(name) {
                return request.getResponseHeader(name);
              },
              body: request.responseText
            });
          }
        }
      };
      request.onloadstart = function () {
        request.responseType = "text";
      };
      request.open("POST", url, true);
      request.setRequestHeader("Content-Type", "text/plain; charset=UTF-8");
      request.withCredentials = true;
      request.onerror = reject;
      request.onabort = reject;
      request.send(body);
    });
  };
};


var injectSendBeaconRequest = function injectSendBeaconRequest(_ref150) {
  var sendBeacon = _ref150.sendBeacon,
    sendFetchRequest = _ref150.sendFetchRequest,
    logger = _ref150.logger;
  return function (url, body) {
    var blob = new Blob([body], {
      type: "text/plain; charset=UTF-8"
    });
    if (!sendBeacon(url, blob)) {
      logger.info("Unable to use `sendBeacon`; falling back to `fetch`.");
      return sendFetchRequest(url, body);
    }

    return Promise.resolve({
      statusCode: 204,
      getHeader: function getHeader() {
        return null;
      },
      body: ""
    });
  };
};

var createLogger = function createLogger(_ref151) {
  var getDebugEnabled = _ref151.getDebugEnabled,
    console = _ref151.console,
    getMonitors = _ref151.getMonitors,
    context = _ref151.context;
  var prefix = "[".concat(context.instanceName, "]");
  if (context.componentName) {
    prefix += " [".concat(context.componentName, "]");
  }
  var notifyMonitors = function notifyMonitors(method, data) {
    var monitors = getMonitors();
    if (monitors.length > 0) {
      var dataWithContext = (0, _reactorObjectAssign["default"])({}, context, data);
      monitors.forEach(function (monitor) {
        if (monitor[method]) {
          monitor[method](dataWithContext);
        }
      });
    }
  };
  var log = function log(level) {
    for (var _len10 = arguments.length, rest = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
      rest[_key10 - 1] = arguments[_key10];
    }
    notifyMonitors("onBeforeLog", {
      level: level,
      arguments: rest
    });
    if (getDebugEnabled()) {
      console[level].apply(console, [prefix].concat(rest));
    }
  };
  return {
    get enabled() {
      return getMonitors().length > 0 || getDebugEnabled();
    },
    logOnInstanceCreated: function logOnInstanceCreated(data) {
      notifyMonitors("onInstanceCreated", data);
      log("info", "Instance initialized.");
    },
    logOnInstanceConfigured: function logOnInstanceConfigured(data) {
      notifyMonitors("onInstanceConfigured", data);
      log("info", "Instance configured. Computed configuration:", data.config);
    },
    logOnBeforeCommand: function logOnBeforeCommand(data) {
      notifyMonitors("onBeforeCommand", data);
      log("info", "Executing ".concat(data.commandName, " command. Options:"), data.options);
    },
    logOnCommandResolved: function logOnCommandResolved(data) {
      notifyMonitors("onCommandResolved", data);
      log("info", "".concat(data.commandName, " command resolved. Result:"), data.result);
    },
    logOnCommandRejected: function logOnCommandRejected(data) {
      notifyMonitors("onCommandRejected", data);
      log("error", "".concat(data.commandName, " command was rejected. Error:"), data.error);
    },
    logOnBeforeNetworkRequest: function logOnBeforeNetworkRequest(data) {
      notifyMonitors("onBeforeNetworkRequest", data);
      log("info", "Request ".concat(data.requestId, ": Sending request."), data.payload);
    },
    logOnNetworkResponse: function logOnNetworkResponse(data) {
      notifyMonitors("onNetworkResponse", data);
      var messagesSuffix = data.parsedBody || data.body ? "response body:" : "no response body.";
      log("info", "Request ".concat(data.requestId, ": Received response with status code ").concat(data.statusCode, " and ").concat(messagesSuffix), data.parsedBody || data.body);
    },
    logOnNetworkError: function logOnNetworkError(data) {
      notifyMonitors("onNetworkError", data);
      log("error", "Request ".concat(data.requestId, ": Network request failed."), data.error);
    },
    info: log.bind(null, "info"),
    warn: log.bind(null, "warn"),
    error: log.bind(null, "error")
  };
};

var EVENT_CANCELLATION_MESSAGE = "Event was canceled because the onBeforeEventSend callback returned false.";
var createEventManager = function createEventManager(_ref152) {
  var config = _ref152.config,
    logger = _ref152.logger,
    lifecycle = _ref152.lifecycle,
    consent = _ref152.consent,
    createEvent = _ref152.createEvent,
    createDataCollectionRequestPayload = _ref152.createDataCollectionRequestPayload,
    createDataCollectionRequest = _ref152.createDataCollectionRequest,
    sendEdgeNetworkRequest = _ref152.sendEdgeNetworkRequest,
    _applyResponse = _ref152.applyResponse;
  var onBeforeEventSend = config.onBeforeEventSend,
    globalConfigOverrides = config.edgeConfigOverrides;
  return {
    createEvent: createEvent,
    sendEvent: function sendEvent(event) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var localConfigOverrides = options.edgeConfigOverrides,
        otherOptions = _objectWithoutProperties(options, ["edgeConfigOverrides"]);
      var requestParams = createRequestParams({
        payload: createDataCollectionRequestPayload(),
        localConfigOverrides: localConfigOverrides,
        globalConfigOverrides: globalConfigOverrides
      });
      var request = createDataCollectionRequest(requestParams);
      var onResponseCallbackAggregator = createCallbackAggregator();
      var onRequestFailureCallbackAggregator = createCallbackAggregator();
      return lifecycle.onBeforeEvent(_objectSpread(_objectSpread({}, otherOptions), {}, {
        event: event,
        onResponse: onResponseCallbackAggregator.add,
        onRequestFailure: onRequestFailureCallbackAggregator.add
      })).then(function () {
        requestParams.payload.addEvent(event);
        return consent.awaitConsent();
      }).then(function () {
        try {
          event.finalize(onBeforeEventSend);
        } catch (error) {
          var throwError = function throwError() {
            throw error;
          };
          onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
          return onRequestFailureCallbackAggregator.call({
            error: error
          }).then(throwError, throwError);
        }

        if (!event.shouldSend()) {
          onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
          logger.info(EVENT_CANCELLATION_MESSAGE);
          var error = new Error(EVENT_CANCELLATION_MESSAGE);
          return onRequestFailureCallbackAggregator.call({
            error: error
          }).then(function () {
          });
        }
        return sendEdgeNetworkRequest({
          request: request,
          runOnResponseCallbacks: onResponseCallbackAggregator.call,
          runOnRequestFailureCallbacks: onRequestFailureCallbackAggregator.call
        });
      });
    },
    applyResponse: function applyResponse(event) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$renderDecisi2 = options.renderDecisions,
        renderDecisions = _options$renderDecisi2 === void 0 ? false : _options$renderDecisi2,
        _options$decisionCont2 = options.decisionContext,
        decisionContext = _options$decisionCont2 === void 0 ? {} : _options$decisionCont2,
        _options$responseHead2 = options.responseHeaders,
        responseHeaders = _options$responseHead2 === void 0 ? {} : _options$responseHead2,
        _options$responseBody2 = options.responseBody,
        responseBody = _options$responseBody2 === void 0 ? {
          handle: []
        } : _options$responseBody2,
        personalization = options.personalization;
      var payload = createDataCollectionRequestPayload();
      var request = createDataCollectionRequest({
        payload: payload
      });
      var onResponseCallbackAggregator = createCallbackAggregator();
      return lifecycle.onBeforeEvent({
        event: event,
        renderDecisions: renderDecisions,
        decisionContext: decisionContext,
        decisionScopes: [PAGE_WIDE_SCOPE],
        personalization: personalization,
        onResponse: onResponseCallbackAggregator.add,
        onRequestFailure: noop
      }).then(function () {
        payload.addEvent(event);
        return _applyResponse({
          request: request,
          responseHeaders: responseHeaders,
          responseBody: responseBody,
          runOnResponseCallbacks: onResponseCallbackAggregator.call
        });
      });
    }
  };
};

var STATE_STORE_HANDLE_TYPE = "state:store";
var createCookieTransfer = function createCookieTransfer(_ref153) {
  var cookieJar = _ref153.cookieJar,
    shouldTransferCookie = _ref153.shouldTransferCookie,
    apexDomain = _ref153.apexDomain,
    dateProvider = _ref153.dateProvider;
  return {
    cookiesToPayload: function cookiesToPayload(payload, endpointDomain) {
      var isEndpointFirstParty = endsWith(endpointDomain, apexDomain);
      var state = {
        domain: apexDomain,
        cookiesEnabled: true
      };

      if (!isEndpointFirstParty) {
        var cookies = cookieJar.get();
        var entries = Object.keys(cookies).filter(shouldTransferCookie).map(function (qualifyingCookieName) {
          return {
            key: qualifyingCookieName,
            value: cookies[qualifyingCookieName]
          };
        });
        if (entries.length) {
          state.entries = entries;
        }
      }
      payload.mergeState(state);
    },
    responseToCookies: function responseToCookies(response) {
      response.getPayloadsByType(STATE_STORE_HANDLE_TYPE).forEach(function (stateItem) {
        var options = {
          domain: apexDomain
        };
        var sameSite = stateItem.attrs && stateItem.attrs.SameSite && stateItem.attrs.SameSite.toLowerCase();
        if (stateItem.maxAge !== undefined) {
          options.expires = new Date(dateProvider().getTime() + stateItem.maxAge * 1000);
        }
        if (sameSite !== undefined) {
          options.sameSite = sameSite;
        }
        if (sameSite === "none") {
          options.secure = true;
        }
        cookieJar.set(stateItem.key, stateItem.value, options);
      });
    }
  };
};


var MBOX_EDGE_CLUSTER = "mboxEdgeCluster";
var AT_QA_MODE = "at_qa_mode";
var MBOX = "mbox";

var injectShouldTransferCookie = function injectShouldTransferCookie(_ref154) {
  var orgId = _ref154.orgId,
    targetMigrationEnabled = _ref154.targetMigrationEnabled;
  return function (name) {
    return isNamespacedCookieName(orgId, name) || name === AT_QA_MODE || targetMigrationEnabled && name === MBOX;
  };
};

var apiVersion = "v1";

var mergeLifecycleResponses = function mergeLifecycleResponses(returnValues) {
  var lifecycleOnResponseReturnValues = returnValues.shift() || [];
  var consumerOnResponseReturnValues = returnValues.shift() || [];
  var lifecycleOnBeforeRequestReturnValues = returnValues;
  return assignConcatArrayValues.apply(void 0, [{}].concat(_toConsumableArray(lifecycleOnResponseReturnValues), _toConsumableArray(consumerOnResponseReturnValues), _toConsumableArray(lifecycleOnBeforeRequestReturnValues)));
};

var handleRequestFailure = function handleRequestFailure(onRequestFailureCallbackAggregator) {
  return function (error) {
    var throwError = function throwError() {
      throw error;
    };
    return onRequestFailureCallbackAggregator.call({
      error: error
    }).then(throwError, throwError);
  };
};

var injectSendEdgeNetworkRequest = function injectSendEdgeNetworkRequest(_ref155) {
  var config = _ref155.config,
    lifecycle = _ref155.lifecycle,
    cookieTransfer = _ref155.cookieTransfer,
    sendNetworkRequest = _ref155.sendNetworkRequest,
    createResponse = _ref155.createResponse,
    processWarningsAndErrors = _ref155.processWarningsAndErrors,
    getLocationHint = _ref155.getLocationHint,
    getAssuranceValidationTokenParams = _ref155.getAssuranceValidationTokenParams;
  var edgeDomain = config.edgeDomain,
    edgeBasePath = config.edgeBasePath,
    datastreamId = config.datastreamId;
  return function (_ref156) {
    var request = _ref156.request,
      _ref156$runOnResponse = _ref156.runOnResponseCallbacks,
      runOnResponseCallbacks = _ref156$runOnResponse === void 0 ? noop : _ref156$runOnResponse,
      _ref156$runOnRequestF = _ref156.runOnRequestFailureCallbacks,
      runOnRequestFailureCallbacks = _ref156$runOnRequestF === void 0 ? noop : _ref156$runOnRequestF;
    var onResponseCallbackAggregator = createCallbackAggregator();
    onResponseCallbackAggregator.add(lifecycle.onResponse);
    onResponseCallbackAggregator.add(runOnResponseCallbacks);
    var onRequestFailureCallbackAggregator = createCallbackAggregator();
    onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
    onRequestFailureCallbackAggregator.add(runOnRequestFailureCallbacks);
    return lifecycle.onBeforeRequest({
      request: request,
      onResponse: onResponseCallbackAggregator.add,
      onRequestFailure: onRequestFailureCallbackAggregator.add
    }).then(function () {
      var endpointDomain = request.getUseIdThirdPartyDomain() ? ID_THIRD_PARTY : edgeDomain;
      var locationHint = getLocationHint();
      var edgeBasePathWithLocationHint = locationHint ? "".concat(edgeBasePath, "/").concat(locationHint) : edgeBasePath;
      var configId = request.getDatastreamIdOverride() || datastreamId;
      var payload = request.getPayload();
      if (configId !== datastreamId) {
        payload.mergeMeta({
          sdkConfig: {
            datastream: {
              original: datastreamId
            }
          }
        });
      }
      var url = "https://".concat(endpointDomain, "/").concat(edgeBasePathWithLocationHint, "/").concat(apiVersion, "/").concat(request.getAction(), "?configId=").concat(configId, "&requestId=").concat(request.getId()).concat(getAssuranceValidationTokenParams());
      cookieTransfer.cookiesToPayload(payload, endpointDomain);
      return sendNetworkRequest({
        requestId: request.getId(),
        url: url,
        payload: payload,
        useSendBeacon: request.getUseSendBeacon()
      });
    }).then(function (networkResponse) {
      processWarningsAndErrors(networkResponse);
      return networkResponse;
    })["catch"](handleRequestFailure(onRequestFailureCallbackAggregator)).then(function (_ref157) {
      var parsedBody = _ref157.parsedBody,
        getHeader = _ref157.getHeader;
      var response = createResponse({
        content: parsedBody,
        getHeader: getHeader
      });
      cookieTransfer.responseToCookies(response);

      return onResponseCallbackAggregator.call({
        response: response
      }).then(mergeLifecycleResponses);
    });
  };
};


var NO_CONTENT = 204;
var TOO_MANY_REQUESTS = 429;
var BAD_GATEWAY = 502;
var SERVICE_UNAVAILABLE = 503;
var GATEWAY_TIMEOUT = 504;

var MESSAGE_PREFIX = "The server responded with a";
var injectProcessWarningsAndErrors = function injectProcessWarningsAndErrors(_ref158) {
  var logger = _ref158.logger;
  return function (networkResponse) {
    var statusCode = networkResponse.statusCode,
      body = networkResponse.body,
      parsedBody = networkResponse.parsedBody;
    if (statusCode < 200 || statusCode >= 300 || !parsedBody && statusCode !== NO_CONTENT || parsedBody && !Array.isArray(parsedBody.handle)) {
      var bodyToLog = parsedBody ? JSON.stringify(parsedBody, null, 2) : body;
      var messageSuffix = bodyToLog ? "response body:\n".concat(bodyToLog) : "no response body.";
      throw new Error("".concat(MESSAGE_PREFIX, " status code ").concat(statusCode, " and ").concat(messageSuffix));
    }
    if (parsedBody) {
      var _parsedBody$warnings = parsedBody.warnings,
        warnings = _parsedBody$warnings === void 0 ? [] : _parsedBody$warnings,
        _parsedBody$errors = parsedBody.errors,
        errors = _parsedBody$errors === void 0 ? [] : _parsedBody$errors;
      warnings.forEach(function (warning) {
        logger.warn("".concat(MESSAGE_PREFIX, " warning:"), warning);
      });
      errors.forEach(function (error) {
        logger.error("".concat(MESSAGE_PREFIX, " non-fatal error:"), error);
      });
    }
  };
};

var injectGetLocationHint = function injectGetLocationHint(_ref159) {
  var orgId = _ref159.orgId,
    cookieJar = _ref159.cookieJar;
  var clusterCookieName = getNamespacedCookieName(orgId, CLUSTER);
  var fromClusterCookie = function fromClusterCookie() {
    return cookieJar.get(clusterCookieName);
  };
  var fromTarget = function fromTarget() {
    var mboxEdgeCluster = cookieJar.get(MBOX_EDGE_CLUSTER);
    if (mboxEdgeCluster) {
      return "t".concat(mboxEdgeCluster);
    }
    return undefined;
  };
  return function () {
    return fromClusterCookie() || fromTarget();
  };
};

var MAX_RETRIES = 3;
var RETRYABLE_STATUS_CODES = [TOO_MANY_REQUESTS, SERVICE_UNAVAILABLE, BAD_GATEWAY, GATEWAY_TIMEOUT];

var isRequestRetryable = function isRequestRetryable(_ref160) {
  var response = _ref160.response,
    retriesAttempted = _ref160.retriesAttempted;
  return retriesAttempted < MAX_RETRIES && includes(RETRYABLE_STATUS_CODES, response.statusCode);
};


var FIRST_DELAY_MILLIS = 1000;
var INCREMENTAL_DELAY_MILLIS = 1000;

var MAX_RANDOM_VARIANCE_PERCENTAGE = 0.3;
var calculateRetryDelay = function calculateRetryDelay(retriesAttempted) {
  var targetDelay = FIRST_DELAY_MILLIS + retriesAttempted * INCREMENTAL_DELAY_MILLIS;
  var maxVariance = targetDelay * MAX_RANDOM_VARIANCE_PERCENTAGE;
  var minDelay = targetDelay - maxVariance;
  var maxDelay = targetDelay + maxVariance;
  var randomizedDelayWithinRange = Math.round(minDelay + Math.random() * (maxDelay - minDelay));
  return randomizedDelayWithinRange;
};
var getDelayFromHeader = function getDelayFromHeader(response) {
  var headerValue = response.getHeader(RETRY_AFTER);
  var delayInMillis;
  if (headerValue) {
    var headerValueInt = parseInt(headerValue, 10);
    if (isInteger(headerValueInt)) {
      delayInMillis = headerValueInt * 1000;
    } else {
      delayInMillis = Math.max(0, new Date(headerValue).getTime() - new Date().getTime());
    }
  }
  return delayInMillis;
};

var getRequestRetryDelay = function getRequestRetryDelay(_ref161) {
  var response = _ref161.response,
    retriesAttempted = _ref161.retriesAttempted;
  var delayInMillis = getDelayFromHeader(response);

  if (delayInMillis === undefined) {
    delayInMillis = calculateRetryDelay(retriesAttempted);
  }
  return delayInMillis;
};

var HTTP_STATUS_OK = 200;
var injectApplyResponse = function injectApplyResponse(_ref162) {
  var cookieTransfer = _ref162.cookieTransfer,
    lifecycle = _ref162.lifecycle,
    createResponse = _ref162.createResponse,
    processWarningsAndErrors = _ref162.processWarningsAndErrors;
  return function (_ref163) {
    var request = _ref163.request,
      responseHeaders = _ref163.responseHeaders,
      responseBody = _ref163.responseBody,
      _ref163$runOnResponse = _ref163.runOnResponseCallbacks,
      runOnResponseCallbacks = _ref163$runOnResponse === void 0 ? noop : _ref163$runOnResponse,
      _ref163$runOnRequestF = _ref163.runOnRequestFailureCallbacks,
      runOnRequestFailureCallbacks = _ref163$runOnRequestF === void 0 ? noop : _ref163$runOnRequestF;
    var onResponseCallbackAggregator = createCallbackAggregator();
    onResponseCallbackAggregator.add(lifecycle.onResponse);
    onResponseCallbackAggregator.add(runOnResponseCallbacks);
    var onRequestFailureCallbackAggregator = createCallbackAggregator();
    onRequestFailureCallbackAggregator.add(lifecycle.onRequestFailure);
    onRequestFailureCallbackAggregator.add(runOnRequestFailureCallbacks);
    var getHeader = function getHeader(key) {
      return responseHeaders[key];
    };
    return lifecycle.onBeforeRequest({
      request: request,
      onResponse: onResponseCallbackAggregator.add,
      onRequestFailure: onRequestFailureCallbackAggregator.add
    }).then(function () {
      return processWarningsAndErrors({
        statusCode: HTTP_STATUS_OK,
        getHeader: getHeader,
        body: JSON.stringify(responseBody),
        parsedBody: responseBody
      });
    })["catch"](handleRequestFailure(onRequestFailureCallbackAggregator)).then(function () {
      var response = createResponse({
        content: responseBody,
        getHeader: getHeader
      });

      cookieTransfer.responseToCookies(response);
      return onResponseCallbackAggregator.call({
        response: response
      }).then(mergeLifecycleResponses);
    });
  };
};

var createNamespacedStorage = injectStorage(window);
var _window = window,
  console = _window.console,
  fetch = _window.fetch,
  navigator$1 = _window.navigator,
  XMLHttpRequest = _window.XMLHttpRequest;
var coreConfigValidators = createCoreConfigs();
var apexDomain = getApexDomain(window, cookieJar);
var sendFetchRequest = isFunction(fetch) ? injectSendFetchRequest({
  fetch: fetch
}) : injectSendXhrRequest({
  XMLHttpRequest: XMLHttpRequest
});
var fireReferrerHideableImage = injectFireReferrerHideableImage();
var getAssuranceValidationTokenParams = createGetAssuranceValidationTokenParams({
  window: window,
  createNamespacedStorage: createNamespacedStorage
});
var createExecuteCommand = function createExecuteCommand(_ref164) {
  var instanceName = _ref164.instanceName,
    _ref164$logController = _ref164.logController,
    setDebugEnabled = _ref164$logController.setDebugEnabled,
    logger = _ref164$logController.logger,
    createComponentLogger = _ref164$logController.createComponentLogger;
  var componentRegistry = createComponentRegistry();
  var lifecycle = createLifecycle(componentRegistry);
  var setDebugCommand = function setDebugCommand(options) {
    setDebugEnabled(options.enabled, {
      fromConfig: false
    });
  };
  var loggingCookieJar = createLoggingCookieJar({
    logger: logger,
    cookieJar: cookieJar
  });
  var configureCommand = function configureCommand(options) {
    var config = buildAndValidateConfig({
      options: options,
      componentCreators: componentCreators,
      coreConfigValidators: coreConfigValidators,
      createConfig: createConfig,
      logger: logger,
      setDebugEnabled: setDebugEnabled
    });
    var orgId = config.orgId,
      targetMigrationEnabled = config.targetMigrationEnabled;
    var shouldTransferCookie = injectShouldTransferCookie({
      orgId: orgId,
      targetMigrationEnabled: targetMigrationEnabled
    });
    var cookieTransfer = createCookieTransfer({
      cookieJar: loggingCookieJar,
      shouldTransferCookie: shouldTransferCookie,
      apexDomain: apexDomain,
      dateProvider: function dateProvider() {
        return new Date();
      }
    });
    var sendBeaconRequest = isFunction(navigator$1.sendBeacon) ? injectSendBeaconRequest({
      sendBeacon: navigator$1.sendBeacon.bind(navigator$1),
      sendFetchRequest: sendFetchRequest,
      logger: logger
    }) : sendFetchRequest;
    var sendNetworkRequest = injectSendNetworkRequest({
      logger: logger,
      sendFetchRequest: sendFetchRequest,
      sendBeaconRequest: sendBeaconRequest,
      isRequestRetryable: isRequestRetryable,
      getRequestRetryDelay: getRequestRetryDelay
    });
    var processWarningsAndErrors = injectProcessWarningsAndErrors({
      logger: logger
    });
    var extractEdgeInfo = injectExtractEdgeInfo({
      logger: logger
    });
    var createResponse = injectCreateResponse({
      extractEdgeInfo: extractEdgeInfo
    });
    var getLocationHint = injectGetLocationHint({
      orgId: orgId,
      cookieJar: cookieJar
    });
    var sendEdgeNetworkRequest = injectSendEdgeNetworkRequest({
      config: config,
      lifecycle: lifecycle,
      cookieTransfer: cookieTransfer,
      sendNetworkRequest: sendNetworkRequest,
      createResponse: createResponse,
      processWarningsAndErrors: processWarningsAndErrors,
      getLocationHint: getLocationHint,
      getAssuranceValidationTokenParams: getAssuranceValidationTokenParams
    });
    var applyResponse = injectApplyResponse({
      lifecycle: lifecycle,
      cookieTransfer: cookieTransfer,
      createResponse: createResponse,
      processWarningsAndErrors: processWarningsAndErrors
    });
    var generalConsentState = createConsentStateMachine({
      logger: logger
    });
    var consent = createConsent({
      generalConsentState: generalConsentState,
      logger: logger
    });
    var eventManager = createEventManager({
      config: config,
      logger: logger,
      lifecycle: lifecycle,
      consent: consent,
      createEvent: createEvent,
      createDataCollectionRequestPayload: createDataCollectionRequestPayload,
      createDataCollectionRequest: createDataCollectionRequest,
      sendEdgeNetworkRequest: sendEdgeNetworkRequest,
      applyResponse: applyResponse
    });
    return initializeComponents({
      componentCreators: componentCreators,
      lifecycle: lifecycle,
      componentRegistry: componentRegistry,
      getImmediatelyAvailableTools: function getImmediatelyAvailableTools(componentName) {
        var componentLogger = createComponentLogger(componentName);
        return {
          config: config,
          componentRegistry: componentRegistry,
          consent: consent,
          eventManager: eventManager,
          fireReferrerHideableImage: fireReferrerHideableImage,
          logger: componentLogger,
          lifecycle: lifecycle,
          sendEdgeNetworkRequest: sendEdgeNetworkRequest,
          handleError: injectHandleError({
            errorPrefix: "[".concat(instanceName, "] [").concat(componentName, "]"),
            logger: componentLogger
          }),
          createNamespacedStorage: createNamespacedStorage,
          apexDomain: apexDomain
        };
      }
    });
  };
  var handleError = injectHandleError({
    errorPrefix: "[".concat(instanceName, "]"),
    logger: logger
  });
  var executeCommand = injectExecuteCommand({
    logger: logger,
    configureCommand: configureCommand,
    setDebugCommand: setDebugCommand,
    handleError: handleError,
    validateCommandOptions: validateCommandOptions
  });
  return executeCommand;
};

var _window2 = window,
  console$1 = _window2.console;
var createNamespacedStorage$1 = injectStorage(window);
var createInstance = function createInstance() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var eventOptionsValidator = boundObjectOf({
    name: boundString()["default"]("alloy"),
    monitors: boundArrayOf(boundObjectOf({}))["default"]([])
  }).noUnknownFields();
  var _eventOptionsValidato = eventOptionsValidator(options),
    name = _eventOptionsValidato.name,
    monitors = _eventOptionsValidato.monitors; 
  var getMonitors = function getMonitors() {
    return (window.__alloyMonitors || []).concat(monitors);
  };
  var logController = createLogController({
    console: console$1,
    locationSearch: window.location.search,
    createLogger: createLogger,
    instanceName: name,
    createNamespacedStorage: createNamespacedStorage$1,
    getMonitors: getMonitors
  });
  var instance = createExecuteCommand({
    instanceName: name,
    logController: logController
  });
  logController.logger.logOnInstanceCreated({
    instance: instance
  });
  return instance;
};
exports.createInstance = createInstance;
          }

        },
        "adobe-alloy/dist/lib/instanceManager/createInstanceManager.js": {
          "script": function(module, exports, require, turbine) {
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
module.exports = function (_ref) {
  var turbine = _ref.turbine,
    window = _ref.window,
    createInstance = _ref.createInstance,
    _createEventMergeId = _ref.createEventMergeId,
    orgId = _ref.orgId,
    wrapOnBeforeEventSend = _ref.wrapOnBeforeEventSend,
    getConfigOverrides = _ref.getConfigOverrides;
  var _turbine$getExtension = turbine.getExtensionSettings(),
    instancesSettings = _turbine$getExtension.instances;
  var instanceByName = {};
  instancesSettings.forEach(function (_ref2) {
    var name = _ref2.name,
      edgeConfigId = _ref2.edgeConfigId,
      stagingEdgeConfigId = _ref2.stagingEdgeConfigId,
      developmentEdgeConfigId = _ref2.developmentEdgeConfigId,
      onBeforeEventSend = _ref2.onBeforeEventSend,
      options = _objectWithoutProperties(_ref2, ["name", "edgeConfigId", "stagingEdgeConfigId", "developmentEdgeConfigId", "onBeforeEventSend"]);
    var instance = createInstance({
      name: name
    });
    window[name] = instance;
    if (!window.__alloyNS) {
      window.__alloyNS = [];
    }
    window.__alloyNS.push(name);
    instanceByName[name] = instance;
    var environment = turbine.environment && turbine.environment.stage;
    var computedEdgeConfigId = environment === "development" && developmentEdgeConfigId || environment === "staging" && stagingEdgeConfigId || edgeConfigId;
    options.edgeConfigOverrides = getConfigOverrides(options);
    instance("configure", _objectSpread(_objectSpread({}, options), {}, {
      datastreamId: computedEdgeConfigId,
      debugEnabled: turbine.debugEnabled,
      orgId: options.orgId || orgId,
      onBeforeEventSend: wrapOnBeforeEventSend(onBeforeEventSend)
    }));
    turbine.onDebugChanged(function (enabled) {
      instance("setDebug", {
        enabled: enabled
      });
    });
  });
  return {
    getInstance: function getInstance(name) {
      return instanceByName[name];
    },
    createEventMergeId: function createEventMergeId() {
      return _createEventMergeId();
    }
  };
};
          }

        },
        "adobe-alloy/dist/lib/instanceManager/injectWrapOnBeforeEventSend.js": {
          "script": function(module, exports, require, turbine) {
"use strict";


module.exports = function (_ref) {
  var version = _ref.version;
  return function (onBeforeEventSend) {
    return function (content) {
      content.xdm.implementationDetails.name = "".concat(content.xdm.implementationDetails.name, "/reactor");
      content.xdm.implementationDetails.version = "".concat(content.xdm.implementationDetails.version, "+").concat(version);
      if (onBeforeEventSend) {
        return onBeforeEventSend(content);
      }
      return undefined;
    };
  };
};
          }

        },
        "adobe-alloy/dist/lib/actions/setConsent/createSetConsent.js": {
          "script": function(module, exports, require, turbine) {
"use strict";

module.exports = function (_ref) {
  var instanceManager = _ref.instanceManager,
    getConfigOverrides = _ref.getConfigOverrides;
  return function (settings) {
    var instanceName = settings.instanceName,
      identityMap = settings.identityMap,
      consent = settings.consent;
    var edgeConfigOverrides = getConfigOverrides(settings);
    var instance = instanceManager.getInstance(instanceName);
    if (!instance) {
      throw new Error("Failed to set consent for instance \"".concat(instanceName, "\". No matching instance was configured with this name."));
    }
    if (identityMap) {
      return instance("setConsent", {
        identityMap: identityMap,
        consent: consent,
        edgeConfigOverrides: edgeConfigOverrides
      });
    }
    return instance("setConsent", {
      consent: consent,
      edgeConfigOverrides: edgeConfigOverrides
    });
  };
};
          }

        }
      }
    },
    "mapping-table": {
      "displayName": "Mapping Table",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP29c1cfa85ec74c28b3ef1369f262762b/",
      "modules": {
        "mapping-table/src/lib/dataElements/mappingTable.js": {
          "name": "mapping-table",
          "displayName": "Mapping Table",
          "script": function(module, exports, require, turbine) {
'use strict';

module.exports = function (settings) {
    if (typeof settings !== 'undefined' && settings !== null) {
        var dataElemValue = settings.dataElement;
        addStartsWithToIE();

        try {
            for (var i = 0; i < settings.size; i++) {
                var method = settings[i].method;
                var out = settings[i].output;
                var inp = settings[i].input;

                if (method === 'exact match') {
                    if (dataElemValue === inp) {
                        return out;
                    }
                } else if (method === 'exact match i') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (dataElemValue.toLowerCase() === inp.toLowerCase()) {
                        return out;
                    }
                } else if (method === 'starts with') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (dataElemValue.startsWith(inp)) {
                        return out;
                    }
                } else if (method === 'contains') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (dataElemValue.indexOf(inp) > -1) {
                        return out;
                    }
                } else if (method === 'regex') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (new RegExp(inp).test(dataElemValue)) {
                        return out;
                    }
                } else if (method === 'regex matching') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    var match = dataElemValue.match(new RegExp(inp));
                    if (match !== null) {
                        for (var j = (match.length - 1); j >= 1; j--) {
                            out = out.split('$' + j).join(match[j]);
                        }
                        return out;
                    }
                } else if (method === 'is true') {
                    if (dataElemValue === true) {
                        return out;
                    }
                } else if (method === 'is false') {
                    if (dataElemValue === false) {
                        return out;
                    }
                }
            }
        } catch (e) {
            turbine.logger.error('Error during evaluation: ' + e.message);
        }

        if (settings.defaultValueEmpty === true) {
            return undefined;
        }
        return dataElemValue;
    }
};

var addStartsWithToIE = function () {
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        };
    }
};


          }

        }
      }
    },
    "core": {
      "displayName": "Core",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP1fdd2a6ec2ae468fb1d2cac08df65f83/",
      "modules": {
        "core/src/lib/dataElements/customCode.js": {
          "name": "custom-code",
          "displayName": "Custom Code",
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (settings, event) {
  return settings.source(event);
};

          }

        },
        "core/src/lib/dataElements/javascriptVariable.js": {
          "name": "javascript-variable",
          "displayName": "JavaScript Variable",
          "script": function(module, exports, require, turbine) {

'use strict';
var getObjectProperty = require('../helpers/getObjectProperty.js');

module.exports = function (settings) {
  return getObjectProperty(window, settings.path);
};

          }

        },
        "core/src/lib/dataElements/randomNumber.js": {
          "name": "random-number",
          "displayName": "Random Number",
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (settings) {
  var min = Math.ceil(settings.min);
  var max = Math.floor(settings.max);

  return min > max ? NaN : Math.floor(Math.random() * (max - min + 1)) + min;
};

          }

        },
        "core/src/lib/actions/customCode.js": {
          "name": "custom-code",
          "displayName": "Custom Code",
          "script": function(module, exports, require, turbine) {

'use strict';

var document = require('@adobe/reactor-document');
var Promise = require('@adobe/reactor-promise');
var decorateCode = require('./helpers/decorateCode');
var loadCodeSequentially = require('./helpers/loadCodeSequentially');
var postscribe = require('../../../node_modules/postscribe/dist/postscribe');
var unescapeHTMLEntities = require('./helpers/unescapeHtmlCode');
var getTurbineScript = require('../helpers/findPageScript').getTurbine;

var cspNonce;

var postscribeWrite = (function () {
  var write = function (source) {
    postscribe(document.body, source, {
      beforeWriteToken: function (token) {
        var tagName = token.tagName && token.tagName.toLowerCase();

        if (cspNonce && tagName === 'script') {
          token.attrs.nonce = cspNonce;
        }

        if (tagName === 'script' || tagName === 'style') {
          Object.keys(token.attrs || {}).forEach(function (key) {
            token.attrs[key] = unescapeHTMLEntities(token.attrs[key]);
          });

          if (token.src) {
            token.src = unescapeHTMLEntities(token.src);
          }
        }

        return token;
      },
      error: function (error) {
        turbine.logger.error(error.msg);
      }
    });
  };

  var queue = [];

  var flushQueue = function () {
    if (document.body) {
      while (queue.length) {
        write(queue.shift());
      }
    } else {
      setTimeout(flushQueue, 20);
    }
  };

  return function (source) {
    queue.push(source);
    flushQueue();
  };
})();

var libraryWasLoadedAsynchronously = (function () {
  if (document.currentScript) {
    return document.currentScript.async;
  } else {
    var script = getTurbineScript();
    if (script) {
      return script.async;
    }
    return true;
  }
})();

module.exports = function (settings, event) {
  cspNonce = turbine.getExtensionSettings().cspNonce;

  var decoratedResult;

  var action = {
    settings: settings,
    event: event
  };

  var source = action.settings.source;
  if (!source) {
    return;
  }

  if (action.settings.isExternal) {
    return loadCodeSequentially(source).then(function (source) {
      if (source) {
        decoratedResult = decorateCode(action, source);
        postscribeWrite(decoratedResult.code);
        return decoratedResult.promise;
      }

      return Promise.resolve();
    });
  } else {
    decoratedResult = decorateCode(action, source);

    if (!libraryWasLoadedAsynchronously && document.readyState === 'loading') {
      if (
        document.write &&
        turbine.propertySettings.ruleComponentSequencingEnabled === false
      ) {
        document.write(decoratedResult.code);
      } else {
        postscribeWrite(decoratedResult.code);
      }
    } else {
      postscribeWrite(decoratedResult.code);
    }

    return decoratedResult.promise;
  }
};

          }

        },
        "core/src/lib/conditions/valueComparison.js": {
          "name": "value-comparison",
          "displayName": "Value Comparison",
          "script": function(module, exports, require, turbine) {

'use strict';

var isString = require('../helpers/stringAndNumberUtils').isString;
var isNumber = require('../helpers/stringAndNumberUtils').isNumber;
var castToStringIfNumber =
  require('../helpers/stringAndNumberUtils').castToStringIfNumber;
var castToNumberIfString =
  require('../helpers/stringAndNumberUtils').castToNumberIfString;

var updateCase = function (operand, caseInsensitive) {
  return caseInsensitive && isString(operand) ? operand.toLowerCase() : operand;
};

var guardStringCompare = function (compare) {
  return function (leftOperand, rightOperand, caseInsensitive) {
    leftOperand = castToStringIfNumber(leftOperand);
    rightOperand = castToStringIfNumber(rightOperand);

    return (
      isString(leftOperand) &&
      isString(rightOperand) &&
      compare(leftOperand, rightOperand, caseInsensitive)
    );
  };
};

var guardNumberCompare = function (compare) {
  return function (leftOperand, rightOperand) {
    leftOperand = castToNumberIfString(leftOperand);
    rightOperand = castToNumberIfString(rightOperand);

    return (
      isNumber(leftOperand) &&
      isNumber(rightOperand) &&
      compare(leftOperand, rightOperand)
    );
  };
};

var guardCaseSensitivity = function (compare) {
  return function (leftOperand, rightOperand, caseInsensitive) {
    return compare(
      updateCase(leftOperand, caseInsensitive),
      updateCase(rightOperand, caseInsensitive)
    );
  };
};

var conditions = {
  equals: guardCaseSensitivity(function (leftOperand, rightOperand) {
    return leftOperand == rightOperand;
  }),
  doesNotEqual: function () {
    return !conditions.equals.apply(null, arguments);
  },
  contains: guardStringCompare(
    guardCaseSensitivity(function (leftOperand, rightOperand) {
      return leftOperand.indexOf(rightOperand) !== -1;
    })
  ),
  doesNotContain: function () {
    return !conditions.contains.apply(null, arguments);
  },
  startsWith: guardStringCompare(
    guardCaseSensitivity(function (leftOperand, rightOperand) {
      return leftOperand.indexOf(rightOperand) === 0;
    })
  ),
  doesNotStartWith: function () {
    return !conditions.startsWith.apply(null, arguments);
  },
  endsWith: guardStringCompare(
    guardCaseSensitivity(function (leftOperand, rightOperand) {
      return (
        leftOperand.substring(
          leftOperand.length - rightOperand.length,
          leftOperand.length
        ) === rightOperand
      );
    })
  ),
  doesNotEndWith: function () {
    return !conditions.endsWith.apply(null, arguments);
  },
  matchesRegex: guardStringCompare(function (
    leftOperand,
    rightOperand,
    caseInsensitive
  ) {
    return new RegExp(rightOperand, caseInsensitive ? 'i' : '').test(
      leftOperand
    );
  }),
  doesNotMatchRegex: function () {
    return !conditions.matchesRegex.apply(null, arguments);
  },
  lessThan: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand < rightOperand;
  }),
  lessThanOrEqual: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand <= rightOperand;
  }),
  greaterThan: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand > rightOperand;
  }),
  greaterThanOrEqual: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand >= rightOperand;
  }),
  isTrue: function (leftOperand) {
    return leftOperand === true;
  },
  isTruthy: function (leftOperand) {
    return Boolean(leftOperand);
  },
  isFalse: function (leftOperand) {
    return leftOperand === false;
  },
  isFalsy: function (leftOperand) {
    return !leftOperand;
  }
};

module.exports = function (settings) {
  return conditions[settings.comparison.operator](
    settings.leftOperand,
    settings.rightOperand,
    Boolean(settings.comparison.caseInsensitive)
  );
};

          }

        },
        "core/src/lib/conditions/sampling.js": {
          "name": "sampling",
          "displayName": "Sampling",
          "script": function(module, exports, require, turbine) {

'use strict';

var getNamespacedStorage = require('../helpers/getNamespacedStorage');
var samplingLocalStorage = getNamespacedStorage('localStorage', 'sampling');

module.exports = function (settings, event) {
  var includeInCohort = Math.random() < settings.rate;

  if (settings.persistCohort) {
    var storageKey = 'cohorts.' + event.$rule.id + '.' + settings.rate;
    var includedInCohort = samplingLocalStorage.getItem(storageKey);

    if (includedInCohort === 'true') {
      return true;
    } else if (includedInCohort === 'false') {
      return false;
    } else {
      samplingLocalStorage.setItem(storageKey, includeInCohort);
    }
  }

  return includeInCohort;
};

          }

        },
        "core/src/lib/conditions/customCode.js": {
          "name": "custom-code",
          "displayName": "Custom Code",
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (settings, event) {
  return settings.source.call(event.element, event, event.target);
};

          }

        },
        "core/src/lib/conditions/dateRange.js": {
          "name": "date-range",
          "displayName": "Date Range",
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (settings) {
  var now = new Date();

  if (settings.start && now < new Date(settings.start)) {
    return false;
  }

  if (settings.end && now > new Date(settings.end)) {
    return false;
  }

  return true;
};

          }

        },
        "core/src/lib/events/directCall.js": {
          "name": "direct-call",
          "displayName": "Direct Call",
          "script": function(module, exports, require, turbine) {

'use strict';

var triggersByIdentifier = {};

window._satellite = window._satellite || {};

window._satellite.track = function (identifier, detail) {
  identifier = identifier.trim();
  var triggers = triggersByIdentifier[identifier];
  if (triggers) {
    var syntheticEvent = {
      identifier: identifier,
      detail: detail
    };

    triggers.forEach(function (trigger) {
      trigger(syntheticEvent);
    });

    var logMessage =
      'Rules using the direct call event type with identifier "' +
      identifier +
      '" have been triggered' +
      (detail ? ' with additional detail:' : '.');
    var logArgs = [logMessage];

    if (detail) {
      logArgs.push(detail);
    }

    turbine.logger.log.apply(turbine.logger, logArgs);
  } else {
    turbine.logger.log(
      '"' + identifier + '" does not match any direct call identifiers.'
    );
  }
};

module.exports = function (settings, trigger) {
  var triggers = triggersByIdentifier[settings.identifier];

  if (!triggers) {
    triggers = triggersByIdentifier[settings.identifier] = [];
  }

  triggers.push(trigger);
};

          }

        },
        "core/src/lib/helpers/getObjectProperty.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (obj, property) {
  var propertyChain = property.split('.');
  var currentValue = obj;

  for (var i = 0, len = propertyChain.length; i < len; i++) {
    if (currentValue == null) {
      return undefined;
    }

    currentValue = currentValue[propertyChain[i]];
  }

  return currentValue;
};

          }

        },
        "core/src/lib/actions/helpers/decorateCode.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var decorateGlobalJavaScriptCode = require('./decorators/decorateGlobalJavaScriptCode');
var decorateNonGlobalJavaScriptCode = require('./decorators/decorateNonGlobalJavaScriptCode');
var decorateHtmlCode = require('./decorators/decorateHtmlCode');

var decorators = {
  javascript: function (action, source) {
    return action.settings.global
      ? decorateGlobalJavaScriptCode(action, source)
      : decorateNonGlobalJavaScriptCode(action, source);
  },
  html: decorateHtmlCode
};

module.exports = function (action, source) {
  return decorators[action.settings.language](action, source);
};

          }

        },
        "core/src/lib/actions/helpers/loadCodeSequentially.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var Promise = require('@adobe/reactor-promise');
var getSourceByUrl = require('./getSourceByUrl');

var previousExecuteCodePromise = Promise.resolve();

module.exports = function (sourceUrl) {
  var sequentiallyLoadCodePromise = new Promise(function (resolve) {
    var loadCodePromise = getSourceByUrl(sourceUrl);

    Promise.all([loadCodePromise, previousExecuteCodePromise]).then(function (
      values
    ) {
      var source = values[0];
      resolve(source);
    });
  });

  previousExecuteCodePromise = sequentiallyLoadCodePromise;
  return sequentiallyLoadCodePromise;
};

          }

        },
        "core/node_modules/postscribe/dist/postscribe.js": {
          "script": function(module, exports, require, turbine) {
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["postscribe"] = factory();
	else
		root["postscribe"] = factory();
})(this, function() {
return  (function(modules) { 
 	var installedModules = {};
 	function __webpack_require__(moduleId) {
 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;
 		var module = installedModules[moduleId] = {
 			exports: {},
 			id: moduleId,
 			loaded: false
 		};
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 		module.loaded = true;
 		return module.exports;
 	}
 	__webpack_require__.m = modules;
 	__webpack_require__.c = installedModules;
 	__webpack_require__.p = "";
 	return __webpack_require__(0);
 })
 ([
 function(module, exports, __webpack_require__) {

	'use strict';

		var _postscribe = __webpack_require__(1);

		var _postscribe2 = _interopRequireDefault(_postscribe);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

		module.exports = _postscribe2['default'];

 },
 function(module, exports, __webpack_require__) {

	'use strict';

		exports.__esModule = true;

		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

		exports['default'] = postscribe;

		var _writeStream = __webpack_require__(2);

		var _writeStream2 = _interopRequireDefault(_writeStream);

		var _utils = __webpack_require__(4);

		var utils = _interopRequireWildcard(_utils);

		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function doNothing() {}

	var OPTIONS = {
	  afterAsync: doNothing,

	  afterDequeue: doNothing,

	  afterStreamStart: doNothing,

	  afterWrite: doNothing,

	  autoFix: true,

	  beforeEnqueue: doNothing,

	  beforeWriteToken: function beforeWriteToken(tok) {
	    return tok;
	  },

	  beforeWrite: function beforeWrite(str) {
	    return str;
	  },

	  done: doNothing,

	  error: function error(e) {
	    throw new Error(e.msg);
	  },


	  releaseAsync: false
	};

		var nextId = 0;
	var queue = [];
	var active = null;

		function nextStream() {
	  var args = queue.shift();
	  if (args) {
	    var options = utils.last(args);

		    options.afterDequeue();
	    args.stream = runStream.apply(undefined, args);
	    options.afterStreamStart();
	  }
	}

		function runStream(el, html, options) {
	  active = new _writeStream2['default'](el, options);

	  active.id = nextId++;
	  active.name = options.name || active.id;
	  postscribe.streams[active.name] = active;

	  var doc = el.ownerDocument;

		  var stash = {
	    close: doc.close,
	    open: doc.open,
	    write: doc.write,
	    writeln: doc.writeln
	  };

		  function _write(str) {
	    str = options.beforeWrite(str);
	    active.write(str);
	    options.afterWrite(str);
	  }

		  _extends(doc, {
	    close: doNothing,
	    open: doNothing,
	    write: function write() {
	      for (var _len = arguments.length, str = Array(_len), _key = 0; _key < _len; _key++) {
	        str[_key] = arguments[_key];
	      }

		      return _write(str.join(''));
	    },
	    writeln: function writeln() {
	      for (var _len2 = arguments.length, str = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        str[_key2] = arguments[_key2];
	      }

		      return _write(str.join('') + '\n');
	    }
	  });

	  var oldOnError = active.win.onerror || doNothing;

	  active.win.onerror = function (msg, url, line) {
	    options.error({ msg: msg + ' - ' + url + ': ' + line });
	    oldOnError.apply(active.win, [msg, url, line]);
	  };

	  active.write(html, function () {
	    _extends(doc, stash);

	    active.win.onerror = oldOnError;

		    options.done();
	    active = null;
	    nextStream();
	  });

		  return active;
	}

		function postscribe(el, html, options) {
	  if (utils.isFunction(options)) {
	    options = { done: options };
	  } else if (options === 'clear') {
	    queue = [];
	    active = null;
	    nextId = 0;
	    return;
	  }

		  options = utils.defaults(options, OPTIONS);

	  if (/^#/.test(el)) {
	    el = window.document.getElementById(el.substr(1));
	  } else {
	    el = el.jquery ? el[0] : el;
	  }

		  var args = [el, html, options];

		  el.postscribe = {
	    cancel: function cancel() {
	      if (args.stream) {
	        args.stream.abort();
	      } else {
	        args[1] = doNothing;
	      }
	    }
	  };

		  options.beforeEnqueue(args);
	  queue.push(args);

		  if (!active) {
	    nextStream();
	  }

		  return el.postscribe;
	}

		_extends(postscribe, {
	  streams: {},
	  queue: queue,
	  WriteStream: _writeStream2['default']
	});

 },
 function(module, exports, __webpack_require__) {

	'use strict';

		exports.__esModule = true;

		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

		var _prescribe = __webpack_require__(3);

		var _prescribe2 = _interopRequireDefault(_prescribe);

		var _utils = __webpack_require__(4);

		var utils = _interopRequireWildcard(_utils);

		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DEBUG_CHUNK = false;

	var BASEATTR = 'data-ps-';

	var PROXY_STYLE = 'ps-style';

	var PROXY_SCRIPT = 'ps-script';

	function getData(el, name) {
	  var attr = BASEATTR + name;

		  var val = el.getAttribute(attr);

	  return !utils.existy(val) ? val : String(val);
	}

	function setData(el, name) {
	  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		  var attr = BASEATTR + name;

		  if (utils.existy(value) && value !== '') {
	    el.setAttribute(attr, value);
	  } else {
	    el.removeAttribute(attr);
	  }
	}


		var WriteStream = function () {
	  function WriteStream(root) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		    _classCallCheck(this, WriteStream);

		    this.root = root;
	    this.options = options;
	    this.doc = root.ownerDocument;
	    this.win = this.doc.defaultView || this.doc.parentWindow;
	    this.parser = new _prescribe2['default']('', { autoFix: options.autoFix });

	    this.actuals = [root];

	    this.proxyHistory = '';

	    this.proxyRoot = this.doc.createElement(root.nodeName);

		    this.scriptStack = [];
	    this.writeQueue = [];

		    setData(this.proxyRoot, 'proxyof', 0);
	  }



			  WriteStream.prototype.write = function write() {
	    var _writeQueue;

		    (_writeQueue = this.writeQueue).push.apply(_writeQueue, arguments);

	    while (!this.deferredRemote && this.writeQueue.length) {
	      var arg = this.writeQueue.shift();

		      if (utils.isFunction(arg)) {
	        this._callFunction(arg);
	      } else {
	        this._writeImpl(arg);
	      }
	    }
	  };



			  WriteStream.prototype._callFunction = function _callFunction(fn) {
	    var tok = { type: 'function', value: fn.name || fn.toString() };
	    this._onScriptStart(tok);
	    fn.call(this.win, this.doc);
	    this._onScriptDone(tok);
	  };



			  WriteStream.prototype._writeImpl = function _writeImpl(html) {
	    this.parser.append(html);

		    var tok = void 0;
	    var script = void 0;
	    var style = void 0;
	    var tokens = [];

	    while ((tok = this.parser.readToken()) && !(script = utils.isScript(tok)) && !(style = utils.isStyle(tok))) {
	      tok = this.options.beforeWriteToken(tok);

		      if (tok) {
	        tokens.push(tok);
	      }
	    }

		    if (tokens.length > 0) {
	      this._writeStaticTokens(tokens);
	    }

		    if (script) {
	      this._handleScriptToken(tok);
	    }

		    if (style) {
	      this._handleStyleToken(tok);
	    }
	  };



			  WriteStream.prototype._writeStaticTokens = function _writeStaticTokens(tokens) {
	    var chunk = this._buildChunk(tokens);

		    if (!chunk.actual) {
	      return null;
	    }

		    chunk.html = this.proxyHistory + chunk.actual;
	    this.proxyHistory += chunk.proxy;
	    this.proxyRoot.innerHTML = chunk.html;

		    if (DEBUG_CHUNK) {
	      chunk.proxyInnerHTML = this.proxyRoot.innerHTML;
	    }

		    this._walkChunk();

		    if (DEBUG_CHUNK) {
	      chunk.actualInnerHTML = this.root.innerHTML;
	    }

		    return chunk;
	  };



			  WriteStream.prototype._buildChunk = function _buildChunk(tokens) {
	    var nextId = this.actuals.length;

	    var raw = [];

	    var actual = [];

	    var proxy = [];

		    var len = tokens.length;
	    for (var i = 0; i < len; i++) {
	      var tok = tokens[i];
	      var tokenRaw = tok.toString();

		      raw.push(tokenRaw);

		      if (tok.attrs) {
	        if (!/^noscript$/i.test(tok.tagName)) {
	          var id = nextId++;

	          actual.push(tokenRaw.replace(/(\/?>)/, ' ' + BASEATTR + 'id=' + id + ' $1'));

	          if (tok.attrs.id !== PROXY_SCRIPT && tok.attrs.id !== PROXY_STYLE) {
	            proxy.push(
	            tok.type === 'atomicTag' ? '' : '<' + tok.tagName + ' ' + BASEATTR + 'proxyof=' + id + (tok.unary ? ' />' : '>'));
	          }
	        }
	      } else {
	        actual.push(tokenRaw);

	        proxy.push(tok.type === 'endTag' ? tokenRaw : '');
	      }
	    }

		    return {
	      tokens: tokens,
	      raw: raw.join(''),
	      actual: actual.join(''),
	      proxy: proxy.join('')
	    };
	  };



			  WriteStream.prototype._walkChunk = function _walkChunk() {
	    var node = void 0;
	    var stack = [this.proxyRoot];

	    while (utils.existy(node = stack.shift())) {
	      var isElement = node.nodeType === 1;
	      var isProxy = isElement && getData(node, 'proxyof');

	      if (!isProxy) {
	        if (isElement) {
	          this.actuals[getData(node, 'id')] = node;
	          setData(node, 'id');
	        }

	        var parentIsProxyOf = node.parentNode && getData(node.parentNode, 'proxyof');
	        if (parentIsProxyOf) {
	          this.actuals[parentIsProxyOf].appendChild(node);
	        }
	      }

	      stack.unshift.apply(stack, utils.toArray(node.childNodes));
	    }
	  };



			  WriteStream.prototype._handleScriptToken = function _handleScriptToken(tok) {
	    var _this = this;

		    var remainder = this.parser.clear();

		    if (remainder) {
	      this.writeQueue.unshift(remainder);
	    }

		    tok.src = tok.attrs.src || tok.attrs.SRC;

		    tok = this.options.beforeWriteToken(tok);
	    if (!tok) {
	      return;
	    }

		    if (tok.src && this.scriptStack.length) {
	      this.deferredRemote = tok;
	    } else {
	      this._onScriptStart(tok);
	    }

	    this._writeScriptToken(tok, function () {
	      _this._onScriptDone(tok);
	    });
	  };



			  WriteStream.prototype._handleStyleToken = function _handleStyleToken(tok) {
	    var remainder = this.parser.clear();

		    if (remainder) {
	      this.writeQueue.unshift(remainder);
	    }

		    tok.type = tok.attrs.type || tok.attrs.TYPE || 'text/css';

		    tok = this.options.beforeWriteToken(tok);

		    if (tok) {
	      this._writeStyleToken(tok);
	    }

		    if (remainder) {
	      this.write();
	    }
	  };



			  WriteStream.prototype._writeStyleToken = function _writeStyleToken(tok) {
	    var el = this._buildStyle(tok);

		    this._insertCursor(el, PROXY_STYLE);

	    if (tok.content) {
	      if (el.styleSheet && !el.sheet) {
	        el.styleSheet.cssText = tok.content;
	      } else {
	        el.appendChild(this.doc.createTextNode(tok.content));
	      }
	    }
	  };



			  WriteStream.prototype._buildStyle = function _buildStyle(tok) {
	    var el = this.doc.createElement(tok.tagName);

		    el.setAttribute('type', tok.type);

	    utils.eachKey(tok.attrs, function (name, value) {
	      el.setAttribute(name, value);
	    });

		    return el;
	  };



			  WriteStream.prototype._insertCursor = function _insertCursor(el, which) {
	    this._writeImpl('<span id="' + which + '"/>');

		    var cursor = this.doc.getElementById(which);

		    if (cursor) {
	      cursor.parentNode.replaceChild(el, cursor);
	    }
	  };



			  WriteStream.prototype._onScriptStart = function _onScriptStart(tok) {
	    tok.outerWrites = this.writeQueue;
	    this.writeQueue = [];
	    this.scriptStack.unshift(tok);
	  };



			  WriteStream.prototype._onScriptDone = function _onScriptDone(tok) {
	    if (tok !== this.scriptStack[0]) {
	      this.options.error({ msg: 'Bad script nesting or script finished twice' });
	      return;
	    }

		    this.scriptStack.shift();

	    this.write.apply(this, tok.outerWrites);


	    if (!this.scriptStack.length && this.deferredRemote) {
	      this._onScriptStart(this.deferredRemote);
	      this.deferredRemote = null;
	    }
	  };



			  WriteStream.prototype._writeScriptToken = function _writeScriptToken(tok, done) {
	    var el = this._buildScript(tok);
	    var asyncRelease = this._shouldRelease(el);
	    var afterAsync = this.options.afterAsync;

		    if (tok.src) {
	      el.src = tok.src;
	      this._scriptLoadHandler(el, !asyncRelease ? function () {
	        done();
	        afterAsync();
	      } : afterAsync);
	    }

		    try {
	      this._insertCursor(el, PROXY_SCRIPT);
	      if (!el.src || asyncRelease) {
	        done();
	      }
	    } catch (e) {
	      this.options.error(e);
	      done();
	    }
	  };



			  WriteStream.prototype._buildScript = function _buildScript(tok) {
	    var el = this.doc.createElement(tok.tagName);

	    utils.eachKey(tok.attrs, function (name, value) {
	      el.setAttribute(name, value);
	    });

	    if (tok.content) {
	      el.text = tok.content;
	    }

		    return el;
	  };



			  WriteStream.prototype._scriptLoadHandler = function _scriptLoadHandler(el, done) {
	    function cleanup() {
	      el = el.onload = el.onreadystatechange = el.onerror = null;
	    }

		    var error = this.options.error;

		    function success() {
	      cleanup();
	      if (done != null) {
	        done();
	      }
	      done = null;
	    }

		    function failure(err) {
	      cleanup();
	      error(err);
	      if (done != null) {
	        done();
	      }
	      done = null;
	    }

		    function reattachEventListener(el, evt) {
	      var handler = el['on' + evt];
	      if (handler != null) {
	        el['_on' + evt] = handler;
	      }
	    }

		    reattachEventListener(el, 'load');
	    reattachEventListener(el, 'error');

		    _extends(el, {
	      onload: function onload() {
	        if (el._onload) {
	          try {
	            el._onload.apply(this, Array.prototype.slice.call(arguments, 0));
	          } catch (err) {
	            failure({ msg: 'onload handler failed ' + err + ' @ ' + el.src });
	          }
	        }
	        success();
	      },
	      onerror: function onerror() {
	        if (el._onerror) {
	          try {
	            el._onerror.apply(this, Array.prototype.slice.call(arguments, 0));
	          } catch (err) {
	            failure({ msg: 'onerror handler failed ' + err + ' @ ' + el.src });
	            return;
	          }
	        }
	        failure({ msg: 'remote script failed ' + el.src });
	      },
	      onreadystatechange: function onreadystatechange() {
	        if (/^(loaded|complete)$/.test(el.readyState)) {
	          success();
	        }
	      }
	    });
	  };



			  WriteStream.prototype._shouldRelease = function _shouldRelease(el) {
	    var isScript = /^script$/i.test(el.nodeName);
	    return !isScript || !!(this.options.releaseAsync && el.src && el.hasAttribute('async'));
	  };

		  return WriteStream;
	}();

		exports['default'] = WriteStream;

 },
 function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Prescribe"] = factory();
		else
			root["Prescribe"] = factory();
	})(this, function() {
	return  (function(modules) { 
 	var installedModules = {};

 	function __webpack_require__(moduleId) {

 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;

 		var module = installedModules[moduleId] = {
 			exports: {},
 			id: moduleId,
 			loaded: false
 		};

 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		module.loaded = true;

 		return module.exports;
 	}


 	__webpack_require__.m = modules;

 	__webpack_require__.c = installedModules;

 	__webpack_require__.p = "";

 	return __webpack_require__(0);
 })
 ([
 function(module, exports, __webpack_require__) {

			'use strict';

			var _HtmlParser = __webpack_require__(1);

			var _HtmlParser2 = _interopRequireDefault(_HtmlParser);

			function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

			module.exports = _HtmlParser2['default'];

 },
 function(module, exports, __webpack_require__) {

			'use strict';

			exports.__esModule = true;

			var _supports = __webpack_require__(2);

			var supports = _interopRequireWildcard(_supports);

			var _streamReaders = __webpack_require__(3);

			var streamReaders = _interopRequireWildcard(_streamReaders);

			var _fixedReadTokenFactory = __webpack_require__(6);

			var _fixedReadTokenFactory2 = _interopRequireDefault(_fixedReadTokenFactory);

			var _utils = __webpack_require__(5);

			function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

			function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		var detect = {
		  comment: /^<!--/,
		  endTag: /^<\//,
		  atomicTag: /^<\s*(script|style|noscript|iframe|textarea)[\s\/>]/i,
		  startTag: /^</,
		  chars: /^[^<]/
		};


			var HtmlParser = function () {
		  function HtmlParser() {
		    var _this = this;

			    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			    _classCallCheck(this, HtmlParser);

			    this.stream = stream;

			    var fix = false;
		    var fixedTokenOptions = {};

			    for (var key in supports) {
		      if (supports.hasOwnProperty(key)) {
		        if (options.autoFix) {
		          fixedTokenOptions[key + 'Fix'] = true; 
		        }
		        fix = fix || fixedTokenOptions[key + 'Fix'];
		      }
		    }

			    if (fix) {
		      this._readToken = (0, _fixedReadTokenFactory2['default'])(this, fixedTokenOptions, function () {
		        return _this._readTokenImpl();
		      });
		      this._peekToken = (0, _fixedReadTokenFactory2['default'])(this, fixedTokenOptions, function () {
		        return _this._peekTokenImpl();
		      });
		    } else {
		      this._readToken = this._readTokenImpl;
		      this._peekToken = this._peekTokenImpl;
		    }
		  }



				  HtmlParser.prototype.append = function append(str) {
		    this.stream += str;
		  };



				  HtmlParser.prototype.prepend = function prepend(str) {
		    this.stream = str + this.stream;
		  };



				  HtmlParser.prototype._readTokenImpl = function _readTokenImpl() {
		    var token = this._peekTokenImpl();
		    if (token) {
		      this.stream = this.stream.slice(token.length);
		      return token;
		    }
		  };



				  HtmlParser.prototype._peekTokenImpl = function _peekTokenImpl() {
		    for (var type in detect) {
		      if (detect.hasOwnProperty(type)) {
		        if (detect[type].test(this.stream)) {
		          var token = streamReaders[type](this.stream);

			          if (token) {
		            if (token.type === 'startTag' && /script|style/i.test(token.tagName)) {
		              return null;
		            } else {
		              token.text = this.stream.substr(0, token.length);
		              return token;
		            }
		          }
		        }
		      }
		    }
		  };



				  HtmlParser.prototype.peekToken = function peekToken() {
		    return this._peekToken();
		  };



				  HtmlParser.prototype.readToken = function readToken() {
		    return this._readToken();
		  };



				  HtmlParser.prototype.readTokens = function readTokens(handlers) {
		    var tok = void 0;
		    while (tok = this.readToken()) {
		      if (handlers[tok.type] && handlers[tok.type](tok) === false) {
		        return;
		      }
		    }
		  };



				  HtmlParser.prototype.clear = function clear() {
		    var rest = this.stream;
		    this.stream = '';
		    return rest;
		  };



				  HtmlParser.prototype.rest = function rest() {
		    return this.stream;
		  };

			  return HtmlParser;
		}();

			exports['default'] = HtmlParser;


				HtmlParser.tokenToString = function (tok) {
		  return tok.toString();
		};

			HtmlParser.escapeAttributes = function (attrs) {
		  var escapedAttrs = {};

			  for (var name in attrs) {
		    if (attrs.hasOwnProperty(name)) {
		      escapedAttrs[name] = (0, _utils.escapeQuotes)(attrs[name], null);
		    }
		  }

			  return escapedAttrs;
		};

			HtmlParser.supports = supports;

			for (var key in supports) {
		  if (supports.hasOwnProperty(key)) {
		    HtmlParser.browserHasFlaw = HtmlParser.browserHasFlaw || !supports[key] && key;
		  }
		}

 },
 function(module, exports) {

			'use strict';

			exports.__esModule = true;
		var tagSoup = false;
		var selfClose = false;

			var work = window.document.createElement('div');

			try {
		  var html = '<P><I></P></I>';
		  work.innerHTML = html;
		  exports.tagSoup = tagSoup = work.innerHTML !== html;
		} catch (e) {
		  exports.tagSoup = tagSoup = false;
		}

			try {
		  work.innerHTML = '<P><i><P></P></i></P>';
		  exports.selfClose = selfClose = work.childNodes.length === 2;
		} catch (e) {
		  exports.selfClose = selfClose = false;
		}

			work = null;

			exports.tagSoup = tagSoup;
		exports.selfClose = selfClose;

 },
 function(module, exports, __webpack_require__) {

			'use strict';

			exports.__esModule = true;

			var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

			exports.comment = comment;
		exports.chars = chars;
		exports.startTag = startTag;
		exports.atomicTag = atomicTag;
		exports.endTag = endTag;

			var _tokens = __webpack_require__(4);

		var REGEXES = {
		  startTag: /^<([\-A-Za-z0-9_]+)((?:\s+[\w\-]+(?:\s*=?\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/,
		  endTag: /^<\/([\-A-Za-z0-9_]+)[^>]*>/,
		  attr: /(?:([\-A-Za-z0-9_]+)\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))|(?:([\-A-Za-z0-9_]+)(\s|$)+)/g,
		  fillAttr: /^(checked|compact|declare|defer|disabled|ismap|multiple|nohref|noresize|noshade|nowrap|readonly|selected)$/i
		};

		function comment(stream) {
		  var index = stream.indexOf('-->');
		  if (index >= 0) {
		    return new _tokens.CommentToken(stream.substr(4, index - 1), index + 3);
		  }
		}

		function chars(stream) {
		  var index = stream.indexOf('<');
		  return new _tokens.CharsToken(index >= 0 ? index : stream.length);
		}

		function startTag(stream) {
		  var endTagIndex = stream.indexOf('>');
		  if (endTagIndex !== -1) {
		    var match = stream.match(REGEXES.startTag);
		    if (match) {
		      var _ret = function () {
		        var attrs = {};
		        var booleanAttrs = {};
		        var rest = match[2];

			        match[2].replace(REGEXES.attr, function (match, name) {
		          if (!(arguments[2] || arguments[3] || arguments[4] || arguments[5])) {
		            attrs[name] = '';
		          } else if (arguments[5]) {
		            attrs[arguments[5]] = '';
		            booleanAttrs[arguments[5]] = true;
		          } else {
		            attrs[name] = arguments[2] || arguments[3] || arguments[4] || REGEXES.fillAttr.test(name) && name || '';
		          }

			          rest = rest.replace(match, '');
		        });

			        return {
		          v: new _tokens.StartTagToken(match[1], match[0].length, attrs, booleanAttrs, !!match[3], rest.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''))
		        };
		      }();

			      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    }
		  }
		}

		function atomicTag(stream) {
		  var start = startTag(stream);
		  if (start) {
		    var rest = stream.slice(start.length);
		    if (rest.match(new RegExp('<\/\\s*' + start.tagName + '\\s*>', 'i'))) {
		      var match = rest.match(new RegExp('([\\s\\S]*?)<\/\\s*' + start.tagName + '\\s*>', 'i'));
		      if (match) {
		        return new _tokens.AtomicTagToken(start.tagName, match[0].length + start.length, start.attrs, start.booleanAttrs, match[1]);
		      }
		    }
		  }
		}

		function endTag(stream) {
		  var match = stream.match(REGEXES.endTag);
		  if (match) {
		    return new _tokens.EndTagToken(match[1], match[0].length);
		  }
		}

 },
 function(module, exports, __webpack_require__) {

			'use strict';

			exports.__esModule = true;
		exports.EndTagToken = exports.AtomicTagToken = exports.StartTagToken = exports.TagToken = exports.CharsToken = exports.CommentToken = exports.Token = undefined;

			var _utils = __webpack_require__(5);

			function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		var Token =
		exports.Token = function Token(type, length) {
		  _classCallCheck(this, Token);

			  this.type = type;
		  this.length = length;
		  this.text = '';
		};



				var CommentToken = exports.CommentToken = function () {
		  function CommentToken(content, length) {
		    _classCallCheck(this, CommentToken);

			    this.type = 'comment';
		    this.length = length || (content ? content.length : 0);
		    this.text = '';
		    this.content = content;
		  }

			  CommentToken.prototype.toString = function toString() {
		    return '<!--' + this.content;
		  };

			  return CommentToken;
		}();



				var CharsToken = exports.CharsToken = function () {
		  function CharsToken(length) {
		    _classCallCheck(this, CharsToken);

			    this.type = 'chars';
		    this.length = length;
		    this.text = '';
		  }

			  CharsToken.prototype.toString = function toString() {
		    return this.text;
		  };

			  return CharsToken;
		}();



				var TagToken = exports.TagToken = function () {
		  function TagToken(type, tagName, length, attrs, booleanAttrs) {
		    _classCallCheck(this, TagToken);

			    this.type = type;
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		    this.attrs = attrs;
		    this.booleanAttrs = booleanAttrs;
		    this.unary = false;
		    this.html5Unary = false;
		  }



				  TagToken.formatTag = function formatTag(tok) {
		    var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			    var str = '<' + tok.tagName;
		    for (var key in tok.attrs) {
		      if (tok.attrs.hasOwnProperty(key)) {
		        str += ' ' + key;

			        var val = tok.attrs[key];
		        if (typeof tok.booleanAttrs === 'undefined' || typeof tok.booleanAttrs[key] === 'undefined') {
		          str += '="' + (0, _utils.escapeQuotes)(val) + '"';
		        }
		      }
		    }

			    if (tok.rest) {
		      str += ' ' + tok.rest;
		    }

			    if (tok.unary && !tok.html5Unary) {
		      str += '/>';
		    } else {
		      str += '>';
		    }

			    if (content !== undefined && content !== null) {
		      str += content + '</' + tok.tagName + '>';
		    }

			    return str;
		  };

			  return TagToken;
		}();



				var StartTagToken = exports.StartTagToken = function () {
		  function StartTagToken(tagName, length, attrs, booleanAttrs, unary, rest) {
		    _classCallCheck(this, StartTagToken);

			    this.type = 'startTag';
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		    this.attrs = attrs;
		    this.booleanAttrs = booleanAttrs;
		    this.html5Unary = false;
		    this.unary = unary;
		    this.rest = rest;
		  }

			  StartTagToken.prototype.toString = function toString() {
		    return TagToken.formatTag(this);
		  };

			  return StartTagToken;
		}();



				var AtomicTagToken = exports.AtomicTagToken = function () {
		  function AtomicTagToken(tagName, length, attrs, booleanAttrs, content) {
		    _classCallCheck(this, AtomicTagToken);

			    this.type = 'atomicTag';
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		    this.attrs = attrs;
		    this.booleanAttrs = booleanAttrs;
		    this.unary = false;
		    this.html5Unary = false;
		    this.content = content;
		  }

			  AtomicTagToken.prototype.toString = function toString() {
		    return TagToken.formatTag(this, this.content);
		  };

			  return AtomicTagToken;
		}();



				var EndTagToken = exports.EndTagToken = function () {
		  function EndTagToken(tagName, length) {
		    _classCallCheck(this, EndTagToken);

			    this.type = 'endTag';
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		  }

			  EndTagToken.prototype.toString = function toString() {
		    return '</' + this.tagName + '>';
		  };

			  return EndTagToken;
		}();

 },
 function(module, exports) {

			'use strict';

			exports.__esModule = true;
		exports.escapeQuotes = escapeQuotes;

		function escapeQuotes(value) {
		  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

		  return !value ? defaultValue : value.replace(/([^"]*)"/g, function (_, prefix) {
		    return (/\\/.test(prefix) ? prefix + '"' : prefix + '\\"'
		    );
		  });
		}

 },
 function(module, exports) {

			'use strict';

			exports.__esModule = true;
		exports['default'] = fixedReadTokenFactory;
		var EMPTY = /^(AREA|BASE|BASEFONT|BR|COL|FRAME|HR|IMG|INPUT|ISINDEX|LINK|META|PARAM|EMBED)$/i;

		var CLOSESELF = /^(COLGROUP|DD|DT|LI|OPTIONS|P|TD|TFOOT|TH|THEAD|TR)$/i;

		function correct(tok) {
		  if (tok && tok.type === 'startTag') {
		    tok.unary = EMPTY.test(tok.tagName) || tok.unary;
		    tok.html5Unary = !/\/>$/.test(tok.text);
		  }
		  return tok;
		}

		function peekToken(parser, readTokenImpl) {
		  var tmp = parser.stream;
		  var tok = correct(readTokenImpl());
		  parser.stream = tmp;
		  return tok;
		}

		function closeLast(parser, stack) {
		  var tok = stack.pop();

		  parser.prepend('</' + tok.tagName + '>');
		}

		function newStack() {
		  var stack = [];

			  stack.last = function () {
		    return this[this.length - 1];
		  };

			  stack.lastTagNameEq = function (tagName) {
		    var last = this.last();
		    return last && last.tagName && last.tagName.toUpperCase() === tagName.toUpperCase();
		  };

			  stack.containsTagName = function (tagName) {
		    for (var i = 0, tok; tok = this[i]; i++) {
		      if (tok.tagName === tagName) {
		        return true;
		      }
		    }
		    return false;
		  };

			  return stack;
		}

		function fixedReadTokenFactory(parser, options, readTokenImpl) {
		  var stack = newStack();

			  var handlers = {
		    startTag: function startTag(tok) {
		      var tagName = tok.tagName;

			      if (tagName.toUpperCase() === 'TR' && stack.lastTagNameEq('TABLE')) {
		        parser.prepend('<TBODY>');
		        prepareNextToken();
		      } else if (options.selfCloseFix && CLOSESELF.test(tagName) && stack.containsTagName(tagName)) {
		        if (stack.lastTagNameEq(tagName)) {
		          closeLast(parser, stack);
		        } else {
		          parser.prepend('</' + tok.tagName + '>');
		          prepareNextToken();
		        }
		      } else if (!tok.unary) {
		        stack.push(tok);
		      }
		    },
		    endTag: function endTag(tok) {
		      var last = stack.last();
		      if (last) {
		        if (options.tagSoupFix && !stack.lastTagNameEq(tok.tagName)) {
		          closeLast(parser, stack);
		        } else {
		          stack.pop();
		        }
		      } else if (options.tagSoupFix) {
		        readTokenImpl();
		        prepareNextToken();
		      }
		    }
		  };

			  function prepareNextToken() {
		    var tok = peekToken(parser, readTokenImpl);
		    if (tok && handlers[tok.type]) {
		      handlers[tok.type](tok);
		    }
		  }

			  return function fixedReadToken() {
		    prepareNextToken();
		    return correct(readTokenImpl());
		  };
		}

 }
 ])
	});
	;

 },
 function(module, exports) {

	'use strict';

		exports.__esModule = true;

		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

		exports.existy = existy;
	exports.isFunction = isFunction;
	exports.each = each;
	exports.eachKey = eachKey;
	exports.defaults = defaults;
	exports.toArray = toArray;
	exports.last = last;
	exports.isTag = isTag;
	exports.isScript = isScript;
	exports.isStyle = isStyle;
	function existy(thing) {
	  return thing !== void 0 && thing !== null;
	}

	function isFunction(x) {
	  return 'function' === typeof x;
	}

	function each(arr, fn, target) {
	  var i = void 0;
	  var len = arr && arr.length || 0;
	  for (i = 0; i < len; i++) {
	    fn.call(target, arr[i], i);
	  }
	}

	function eachKey(obj, fn, target) {
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      fn.call(target, key, obj[key]);
	    }
	  }
	}

	function defaults(options, _defaults) {
	  options = options || {};
	  eachKey(_defaults, function (key, val) {
	    if (!existy(options[key])) {
	      options[key] = val;
	    }
	  });
	  return options;
	}

	function toArray(obj) {
	  try {
	    return Array.prototype.slice.call(obj);
	  } catch (e) {
	    var _ret = function () {
	      var ret = [];
	      each(obj, function (val) {
	        ret.push(val);
	      });
	      return {
	        v: ret
	      };
	    }();

		    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}

	function last(array) {
	  return array[array.length - 1];
	}

	function isTag(tok, tag) {
	  return !tok || !(tok.type === 'startTag' || tok.type === 'atomicTag') || !('tagName' in tok) ? !1 : !!~tok.tagName.toLowerCase().indexOf(tag);
	}

	function isScript(tok) {
	  return isTag(tok, 'script');
	}

	function isStyle(tok) {
	  return isTag(tok, 'style');
	}

 }
 ])
});
;
          }

        },
        "core/src/lib/actions/helpers/unescapeHtmlCode.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var document = require('@adobe/reactor-document');
var el = document.createElement('div');

module.exports = function (html) {
  el.innerHTML = html;

  return el.textContent || el.innerText || html;
};

          }

        },
        "core/src/lib/helpers/findPageScript.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var document = require('@adobe/reactor-document');

var byRegexPattern = function (regexScriptSrcPattern) {
  var scripts = document.querySelectorAll('script');

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];
    if (regexScriptSrcPattern.test(script.src)) {
      return script;
    }
  }
};

var getTurbine = function () {
  return byRegexPattern(new RegExp(/(launch|satelliteLib)-[^\/]+.js(\?.*)?$/));
};

module.exports = {
  getTurbine: getTurbine,
  byRegexPattern: byRegexPattern
};

          }

        },
        "core/src/lib/actions/helpers/decorators/decorateGlobalJavaScriptCode.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

var Promise = require('@adobe/reactor-promise');

module.exports = function (_, source) {
  return {
    code: '<scr' + 'ipt>\n' + source + '\n</scr' + 'ipt>',
    promise: Promise.resolve()
  };
};

          }

        },
        "core/src/lib/actions/helpers/decorators/decorateNonGlobalJavaScriptCode.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

var Promise = require('@adobe/reactor-promise');
var id = 0;

module.exports = function (action, source) {
  var runScriptFnName = '_runScript' + ++id;

  var promise = new Promise(function (resolve, reject) {
    _satellite[runScriptFnName] = function (fn) {
      delete _satellite[runScriptFnName];

      new Promise(function (_resolve) {
        _resolve(
          fn.call(
            action.event.element,
            action.event,
            action.event.target,
            Promise
          )
        );
      }).then(resolve, reject);
    };
  });

  var code =
    '<scr' +
    'ipt>_satellite["' +
    runScriptFnName +
    '"](function(event, target, Promise) {\n' +
    source +
    '\n});</scr' +
    'ipt>';

  return {
    code: code,
    promise: promise
  };
};

          }

        },
        "core/src/lib/actions/helpers/decorators/decorateHtmlCode.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var Promise = require('@adobe/reactor-promise');

var callbackId = 0;
var htmlCodePromises = {};

window._satellite = window._satellite || {};

window._satellite._onCustomCodeSuccess = function (callbackId) {
  var promiseHandlers = htmlCodePromises[callbackId];
  if (!promiseHandlers) {
    return;
  }

  delete htmlCodePromises[callbackId];
  promiseHandlers.resolve();
};

window._satellite._onCustomCodeFailure = function (callbackId) {
  var promiseHandlers = htmlCodePromises[callbackId];
  if (!promiseHandlers) {
    return;
  }

  delete htmlCodePromises[callbackId];
  promiseHandlers.reject();
};

var reactorCallbackIdShouldBeReplaced = function (source) {
  return source.indexOf('${reactorCallbackId}') !== -1;
};

var replaceCallbacksIds = function (source, callbackId) {
  return source.replace(/\${reactorCallbackId}/g, callbackId);
};

var isSourceLoadedFromFile = function (action) {
  return action.settings.isExternal;
};

module.exports = function (action, source) {
  if (isSourceLoadedFromFile(action)) {
    source = turbine.replaceTokens(source, action.event);
  }

  var promise;

  if (reactorCallbackIdShouldBeReplaced(source)) {
    promise = new Promise(function (resolve, reject) {
      htmlCodePromises[String(callbackId)] = {
        resolve: resolve,
        reject: reject
      };
    });

    source = replaceCallbacksIds(source, callbackId);
    callbackId += 1;
  } else {
    promise = Promise.resolve();
  }

  return {
    code: source,
    promise: promise
  };
};

          }

        },
        "core/src/lib/actions/helpers/getSourceByUrl.js": {
          "script": function(module, exports, require, turbine) {

'use strict';
var loadScript = require('@adobe/reactor-load-script');
var Promise = require('@adobe/reactor-promise');
var findScriptByRegexPattern =
  require('../../helpers/findPageScript').byRegexPattern;

var codeBySourceUrl = {};
var scriptStore = {};

var loadScriptOnlyOnce = function (url) {
  if (!scriptStore[url]) {
    scriptStore[url] = loadScript(url);
  }

  return scriptStore[url];
};

_satellite.__registerScript = function (scriptGuid, code) {
  var scriptUrl;
  if (document.currentScript) {
    scriptUrl = document.currentScript.getAttribute('src');
  } else {
    var pattern = new RegExp('.*' + scriptGuid + '.*');
    scriptUrl = findScriptByRegexPattern(pattern).getAttribute('src');
  }
  codeBySourceUrl[scriptUrl] = code;
};

module.exports = function (sourceUrl) {
  if (codeBySourceUrl[sourceUrl]) {
    return Promise.resolve(codeBySourceUrl[sourceUrl]);
  } else {
    return new Promise(function (resolve) {
      loadScriptOnlyOnce(sourceUrl).then(
        function () {
          resolve(codeBySourceUrl[sourceUrl]);
        },
        function () {
          resolve();
        }
      );
    });
  }
};

          }

        },
        "core/src/lib/helpers/stringAndNumberUtils.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

var isNumber = function (value) {
  return typeof value === 'number' && isFinite(value); 
};

var isString = function (value) {
  return typeof value === 'string' || value instanceof String;
};

var castToStringIfNumber = function (value) {
  return isNumber(value) ? String(value) : value;
};

var castToNumberIfString = function (value) {
  return isString(value) ? Number(value) : value;
};

module.exports = {
  isNumber: isNumber,
  isString: isString,
  castToStringIfNumber: castToStringIfNumber,
  castToNumberIfString: castToNumberIfString
};

          }

        },
        "core/src/lib/helpers/getNamespacedStorage.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

var window = require('@adobe/reactor-window');
var BASE_NAMESPACE = 'com.adobe.reactor.core';

module.exports = function (storageType, additionalNamespace) {
  var STORAGE_TYPE_UNAVAILABLE_ERROR =
    '"' + storageType + '" is not available on the window object.';
  var namespace = BASE_NAMESPACE + '.' + additionalNamespace;

  return {
    getItem: function (name) {
      try {
        return window[storageType].getItem(namespace + '.' + name);
      } catch (e) {
        turbine.logger.warn(STORAGE_TYPE_UNAVAILABLE_ERROR);
        return null;
      }
    },
    setItem: function (name, value) {
      try {
        window[storageType].setItem(namespace + '.' + name, value);
        return true;
      } catch (e) {
        turbine.logger.warn(STORAGE_TYPE_UNAVAILABLE_ERROR);
        return false;
      }
    }
  };
};

          }

        }
      }
    },
    "gcoe-adobe-client-data-layer": {
      "displayName": "Adobe Client Data Layer",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP6e4c031a8b7640d7ac3fab013fa28b17/",
      "settings": {
        "dataLayerName": "adobeDataLayer",
        "injectLibrary": true
      },
      "modules": {
        "gcoe-adobe-client-data-layer/src/lib/dataElements/datalayerComputedState.js": {
          "name": "datalayer-computed-state",
          "displayName": "Data Layer Computed State",
          "script": function(module, exports, require, turbine) {
'use strict';
function index(obj, i) { return obj[i] }
module.exports = function (settings, event) {
    if (typeof settings !== 'undefined' && settings !== null) {
        var dl = getDataLayer();
        if (typeof dl !== 'undefined') {
            if (settings.path !== '') {
                return dl.getState(settings.path);
            } else {
                return dl.getState();
            }
        }
    }
};

var getDataLayer = require('../util/getDataLayer');
          }

        },
        "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js": {
          "name": "datalayer-push",
          "displayName": "Data Pushed",
          "script": function(module, exports, require, turbine) {
'use strict';

module.exports = function (settings, trigger) {
    if (typeof settings !== 'undefined' && settings !== null) {
        var method = settings.method;
        var eventKey = settings.eventKey;
        var scope = settings.scope;
        var dl = getDataLayer();


        var handler = function (event) {
            var result = {
                message: event,
                beforeState: {},
                afterState: {},
                fullState: dl.getState()
            };
            trigger(result);
        };

        var options = {};
        if (typeof scope !== 'undefined') {
            options.scope = scope;
        }

        if (method === 'allData') {
            dl.push(function (dl) {
                dl.addEventListener("adobeDataLayer:change", handler, options);
            });
        }

        else if (method === 'allEvents') {
            dl.push(function (dl) {
                dl.addEventListener("adobeDataLayer:event", handler, options);
            });
        }

        else if (method === 'specificEvent' && eventKey !== '') {
            dl.push(function (dl) {
                dl.addEventListener(eventKey, handler, options);
            });
        }
    }
};

var getDataLayer = require('../util/getDataLayer');
          }

        },
        "gcoe-adobe-client-data-layer/src/lib/main.js": {
          "script": function(module, exports, require, turbine) {
var globalSettings = turbine.getExtensionSettings();
var dataLayerName = globalSettings.dataLayerName;
var injectLibrary = globalSettings.injectLibrary;

window.adobeDataLayer = window.adobeDataLayer || [];

if ('object' !== typeof (window.adobeDataLayer)) {
    turbine.logger.log('Initializing adobeDataLayer to [] as it isn\'t an object yet.');
    window.adobeDataLayer = [];
}

if ('adobeDataLayer' !== dataLayerName) {
    if(typeof window[dataLayerName] === 'object') {
        turbine.logger.log('Using "' + dataLayerName + '" instead of "adobeDataLayer" as data layer name.');
        window.adobeDataLayer.push(function (dl) {
            for (var i = 0; i < window[dataLayerName].length; i++) {
                dl.push(window[dataLayerName][i]);
            }

            window[dataLayerName] = dl
        });
    } else {
        turbine.logger.warn('Could not use "' + dataLayerName + '" instead of "adobeDataLayer", because the object does not exist!');
    }
}

if(injectLibrary) {
	if ("undefined" === typeof window.adobeDataLayer.getState) {
		turbine.logger.log('Initializing adobeDataLayer as it wasn\'t found during the initialization.');
        "use strict";function _slicedToArray(t,e){return _arrayWithHoles(t)||_iterableToArrayLimit(t,e)||_unsupportedIterableToArray(t,e)||_nonIterableRest()}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function _iterableToArrayLimit(t,e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t)){var n=[],r=!0,o=!1,a=void 0;try{for(var i,u=t[Symbol.iterator]();!(r=(i=u.next()).done)&&(n.push(i.value),!e||n.length!==e);r=!0);}catch(t){o=!0,a=t}finally{try{r||null==u.return||u.return()}finally{if(o)throw a}}return n}}function _arrayWithHoles(t){if(Array.isArray(t))return t}function _createForOfIteratorHelper(t){if("undefined"==typeof Symbol||null==t[Symbol.iterator]){if(Array.isArray(t)||(t=_unsupportedIterableToArray(t))){var e=0,n=function(){};return{s:n,n:function(){return e>=t.length?{done:!0}:{done:!1,value:t[e++]}},e:function(t){throw t},f:n}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var r,o,a=!0,i=!1;return{s:function(){r=t[Symbol.iterator]()},n:function(){var t=r.next();return a=t.done,t},e:function(t){i=!0,o=t},f:function(){try{a||null==r.return||r.return()}finally{if(i)throw o}}}}function _unsupportedIterableToArray(t,e){if(t){if("string"==typeof t)return _arrayLikeToArray(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?_arrayLikeToArray(t,e):void 0}}function _arrayLikeToArray(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function a(i,u,c){function f(e,t){if(!u[e]){if(!i[e]){var n="function"==typeof require&&require;if(!t&&n)return n(e,!0);if(s)return s(e,!0);var r=new Error("Cannot find module '"+e+"'");throw r.code="MODULE_NOT_FOUND",r}var o=u[e]={exports:{}};i[e][0].call(o.exports,function(t){return f(i[e][1][t]||t)},o,o.exports,a,i,u,c)}return u[e].exports}for(var s="function"==typeof require&&require,t=0;t<c.length;t++)f(c[t]);return f}({1:[function(t,wn,En){(function(On){(function(){function n(t,e){for(var n=-1,r=null==t?0:t.length,o=0,a=[];++n<r;){var i=t[n];e(i,n,t)&&(a[o++]=i)}return a}function a(t,e){for(var n=-1,r=null==t?0:t.length,o=Array(r);++n<r;)o[n]=e(t[n],n,t);return o}function f(t,e){for(var n=-1,r=e.length,o=t.length;++n<r;)t[o+n]=e[n];return t}function b(t,e){for(var n=-1,r=null==t?0:t.length;++n<r;)if(e(t[n],n,t))return!0;return!1}function o(t,e,n){var r=t.length;for(n+=-1;++n<r;)if(e(t[n],n,t))return n;return-1}function i(t){return t!=t}function t(e){return function(t){return e(t)}}function h(t){var n=-1,r=Array(t.size);return t.forEach(function(t,e){r[++n]=[e,t]}),r}function e(e){var n=Object;return function(t){return e(n(t))}}function v(t){var e=-1,n=Array(t.size);return t.forEach(function(t){n[++e]=t}),n}function r(){}function u(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}function s(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}function d(t){var e=-1,n=null==t?0:t.length;for(this.__data__=new s;++e<n;)this.add(t[e])}function g(t){this.size=(this.__data__=new c(t)).size}function l(t,e){var n=hn(t),r=!n&&bn(t),o=!n&&!r&&vn(t),a=!n&&!r&&!o&&_n(t);if(n=n||r||o||a){r=t.length;for(var i=String,u=-1,c=Array(r);++u<r;)c[u]=i(u);r=c}else r=[];var f;i=r.length;for(f in t)!e&&!be.call(t,f)||n&&("length"==f||o&&("offset"==f||"parent"==f)||a&&("buffer"==f||"byteLength"==f||"byteOffset"==f)||Q(f,i))||r.push(f);return r}function _(t,e,n){(n===Mt||ft(t[e],n))&&(n!==Mt||e in t)||j(t,e,n)}function y(t,e,n){var r=t[e];be.call(t,e)&&ft(r,n)&&(n!==Mt||e in t)||j(t,e,n)}function p(t,e){for(var n=t.length;n--;)if(ft(t[n][0],e))return n;return-1}function j(t,e,n){"__proto__"==e&&xe?xe(t,e,{configurable:!0,enumerable:!0,value:n,writable:!0}):t[e]=n}function m(n,r,o,t,e,a){var i,u=1&r,c=2&r,f=4&r;if(o&&(i=e?o(n,t,e,a):o(n)),i!==Mt)return i;if(!bt(n))return n;if(t=hn(n)){if(i=function(t){var e=t.length,n=new t.constructor(e);return e&&"string"==typeof t[0]&&be.call(t,"index")&&(n.index=t.index,n.input=t.input),n}(n),!u)return U(n,i)}else{var s=nn(n),l="[object Function]"==s||"[object GeneratorFunction]"==s;if(vn(n))return M(n,u);if("[object Object]"==s||"[object Arguments]"==s||l&&!e){if(i=c||l?{}:Y(n),!u)return c?function(t,e){return P(t,en(t),e)}(n,function(t,e){return t&&P(e,St(e),t)}(i,n)):function(t,e){return P(t,tn(t),e)}(n,function(t,e){return t&&P(e,Lt(e),t)}(i,n))}else{if(!Kt[s])return e?n:{};i=function(t,e,n){var r=t.constructor;switch(e){case"[object ArrayBuffer]":return z(t);case"[object Boolean]":case"[object Date]":return new r(+t);case"[object DataView]":return e=n?z(t.buffer):t.buffer,new t.constructor(e,t.byteOffset,t.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":case"[object Uint16Array]":case"[object Uint32Array]":return C(t,n);case"[object Map]":return new r;case"[object Number]":case"[object String]":return new r(t);case"[object RegExp]":return(e=new t.constructor(t.source,Ht.exec(t))).lastIndex=t.lastIndex,e;case"[object Set]":return new r;case"[object Symbol]":return qe?Object(qe.call(t)):{}}}(n,s,u)}}if(e=(a=a||new g).get(n))return e;if(a.set(n,i),gn(n))return n.forEach(function(t){i.add(m(t,r,o,t,n,a))}),i;if(dn(n))return n.forEach(function(t,e){i.set(e,m(t,r,o,e,n,a))}),i;c=f?c?B:H:c?St:Lt;var p=t?Mt:c(n);return function(t,e){for(var n=-1,r=null==t?0:t.length;++n<r&&!1!==e(t[n],n,t););}(p||n,function(t,e){p&&(t=n[e=t]),y(i,e,m(t,r,o,e,n,a))}),i}function A(t,e){for(var n=0,r=(e=F(e,t)).length;null!=t&&n<r;)t=t[nt(e[n++])];return n&&n==r?t:Mt}function O(t,e,n){return e=e(t),hn(t)?e:f(e,n(t))}function w(t){if(null==t)t=t===Mt?"[object Undefined]":"[object Null]";else if(Te&&Te in Object(t)){var e=be.call(t,Te),n=t[Te];try{t[Te]=Mt;var r=!0}catch(t){}var o=ve.call(t);r&&(e?t[Te]=n:delete t[Te]),t=o}else t=ve.call(t);return t}function E(t,e){return null!=t&&be.call(t,e)}function L(t,e){return null!=t&&e in Object(t)}function S(t){return ht(t)&&"[object Arguments]"==w(t)}function T(t,e,n,r,o){if(t===e)e=!0;else if(null==t||null==e||!ht(t)&&!ht(e))e=t!=t&&e!=e;else t:{var a,i,u=hn(t),c=hn(e),f="[object Object]"==(a="[object Arguments]"==(a=u?"[object Array]":nn(t))?"[object Object]":a);c="[object Object]"==(i="[object Arguments]"==(i=c?"[object Array]":nn(e))?"[object Object]":i);if((i=a==i)&&vn(t)){if(!vn(e)){e=!1;break t}f=!(u=!0)}if(i&&!f)o=o||new g,e=u||_n(t)?V(t,e,n,r,T,o):function(t,e,n,r,o,a,i){switch(n){case"[object DataView]":if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)break;t=t.buffer,e=e.buffer;case"[object ArrayBuffer]":if(t.byteLength!=e.byteLength||!a(new me(t),new me(e)))break;return!0;case"[object Boolean]":case"[object Date]":case"[object Number]":return ft(+t,+e);case"[object Error]":return t.name==e.name&&t.message==e.message;case"[object RegExp]":case"[object String]":return t==e+"";case"[object Map]":var u=h;case"[object Set]":if(u=u||v,t.size!=e.size&&!(1&r))break;return(n=i.get(t))?n==e:(r|=2,i.set(t,e),e=V(u(t),u(e),r,o,a,i),i.delete(t),e);case"[object Symbol]":if(qe)return qe.call(t)==qe.call(e)}return!1}(t,e,a,n,r,T,o);else{if(!(1&n)&&(u=f&&be.call(t,"__wrapped__"),a=c&&be.call(e,"__wrapped__"),u||a)){e=T(t=u?t.value():t,e=a?e.value():e,n,r,o=o||new g);break t}if(i)e:if(o=o||new g,u=1&n,a=H(t),c=a.length,i=H(e).length,c==i||u){for(f=c;f--;){var s=a[f];if(!(u?s in e:be.call(e,s))){e=!1;break e}}if((i=o.get(t))&&o.get(e))e=i==e;else{i=!0,o.set(t,e),o.set(e,t);for(var l=u;++f<c;){var p=t[s=a[f]],y=e[s];if(r)var b=u?r(y,p,s,e,t,o):r(p,y,s,t,e,o);if(b===Mt?p!==y&&!T(p,y,n,r,o):!b){i=!1;break}l=l||"constructor"==s}i&&!l&&((n=t.constructor)!=(r=e.constructor)&&"constructor"in t&&"constructor"in e&&!("function"==typeof n&&n instanceof n&&"function"==typeof r&&r instanceof r)&&(i=!1)),o.delete(t),o.delete(e),e=i}}else e=!1;else e=!1}}return e}function x(t){return"function"==typeof t?t:null==t?It:"object"==_typeof(t)?hn(t)?function(n,r){return X(n)&&r==r&&!bt(r)?tt(nt(n),r):function(t){var e=wt(t,n);return e===Mt&&e===r?Et(t,n):T(r,e,3)}}(t[0],t[1]):function(e){var n=function(t){for(var e=Lt(t),n=e.length;n--;){var r=e[n],o=t[r];e[n]=[r,o,o==o&&!bt(o)]}return e}(e);return 1==n.length&&n[0][2]?tt(n[0][0],n[0][1]):function(t){return t===e||function(t,e){var n=e.length,r=n;if(null==t)return!r;for(t=Object(t);n--;){if((o=e[n])[2]?o[1]!==t[o[0]]:!(o[0]in t))return!1}for(;++n<r;){var o,a=(o=e[n])[0],i=t[a],u=o[1];if(o[2]){if(i===Mt&&!(a in t))return!1}else if(o=new g,void 0!==Mt||!T(u,i,3,void 0,o))return!1}return!0}(t,n)}}(t):Nt(t)}function I(t){if(!Z(t))return Ne(t);var e,n=[];for(e in Object(t))be.call(t,e)&&"constructor"!=e&&n.push(e);return n}function k(s,l,p,y,b){s!==l&&Xe(l,function(t,e){if(bt(t)){var n=b=b||new g,r="__proto__"==e?Mt:s[e],o="__proto__"==e?Mt:l[e];if(f=n.get(o))_(s,e,f);else{var a=(f=y?y(r,o,e+"",s,l,n):Mt)===Mt;if(a){var i=hn(o),u=!i&&vn(o),c=!i&&!u&&_n(o),f=o;i||u||c?f=hn(r)?r:lt(r)?U(r):u?M(o,!(a=!1)):c?C(o,!(a=!1)):[]:vt(o)||bn(o)?bn(f=r)?f=At(r):(!bt(r)||p&&pt(r))&&(f=Y(o)):a=!1}a&&(n.set(o,f),k(f,o,p,y,n),n.delete(o)),_(s,e,f)}}else(n=y?y("__proto__"==e?Mt:s[e],t,e+"",s,l,b):Mt)===Mt&&(n=t),_(s,e,n)},St)}function N(t){if("string"==typeof t)return t;if(hn(t))return a(t,N)+"";if(gt(t))return Je?Je.call(t):"";var e=t+"";return"0"==e&&1/t==-zt?"-0":e}function D(t,e){var n;if((e=F(e,t)).length<2)n=t;else{var r=0,o=-1,a=-1,i=(n=e).length;for(r<0&&(r=i<-r?0:i+r),(o=i<o?i:o)<0&&(o+=i),i=o<r?0:o-r>>>0,r>>>=0,o=Array(i);++a<i;)o[a]=n[a+r];n=A(t,o)}null==(t=n)||delete t[nt(it(e))]}function F(t,e){return hn(t)?t:X(t,e)?[t]:ln(Ot(t))}function M(t,e){if(e)return t.slice();var n=t.length;n=Ae?Ae(n):new t.constructor(n);return t.copy(n),n}function z(t){var e=new t.constructor(t.byteLength);return new me(e).set(new me(t)),e}function C(t,e){return new t.constructor(e?z(t.buffer):t.buffer,t.byteOffset,t.length)}function U(t,e){var n=-1,r=t.length;for(e=e||Array(r);++n<r;)e[n]=t[n];return e}function P(t,e,n){var r=!n;n=n||{};for(var o=-1,a=e.length;++o<a;){var i=e[o],u=Mt;u===Mt&&(u=t[i]),r?j(n,i,u):y(n,i,u)}return n}function R(f){return function(t){return sn(et(t,void 0,It),t+"")}(function(t,e){var n,r=-1,o=e.length,a=1<o?e[o-1]:Mt,i=2<o?e[2]:Mt;a=3<f.length&&"function"==typeof a?(o--,a):Mt;if(n=i){n=e[0];var u=e[1];if(bt(i)){var c=_typeof(u);n=!!("number"==c?st(i)&&Q(u,i.length):"string"==c&&u in i)&&ft(i[u],n)}else n=!1}for(n&&(a=o<3?Mt:a,o=1),t=Object(t);++r<o;)(i=e[r])&&f(t,i,r,a);return t})}function $(t){return vt(t)?Mt:t}function V(t,e,n,r,o,a){var i=1&n,u=t.length;if(u!=(c=e.length)&&!(i&&u<c))return!1;if((c=a.get(t))&&a.get(e))return c==e;var c=-1,f=!0,s=2&n?new d:Mt;for(a.set(t,e),a.set(e,t);++c<u;){var l=t[c],p=e[c];if(r)var y=i?r(p,l,c,e,t,a):r(l,p,c,t,e,a);if(y!==Mt){if(y)continue;f=!1;break}if(s){if(!b(e,function(t,e){if(!s.has(e)&&(l===t||o(l,t,n,r,a)))return s.push(e)})){f=!1;break}}else if(l!==p&&!o(l,p,n,r,a)){f=!1;break}}return a.delete(t),a.delete(e),f}function H(t){return O(t,Lt,tn)}function B(t){return O(t,St,en)}function W(t,e){var n=(n=r.iteratee||kt)===kt?x:n;return arguments.length?n(t,e):n}function G(t,e){var n=t.__data__,r=_typeof(e);return("string"==r||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==e:null===e)?n["string"==typeof e?"string":"hash"]:n.map}function q(t,e){var n=null==t?Mt:t[e];return!bt(n)||he&&he in n||!(pt(n)?ge:Gt).test(rt(n))?Mt:n}function J(t,e,n){for(var r=-1,o=(e=F(e,t)).length,a=!1;++r<o;){var i=nt(e[r]);if(!(a=null!=t&&n(t,i)))break;t=t[i]}return a||++r!=o?a:!!(o=null==t?0:t.length)&&yt(o)&&Q(i,o)&&(hn(t)||bn(t))}function Y(t){return"function"!=typeof t.constructor||Z(t)?{}:Ye(Oe(t))}function K(t){return hn(t)||bn(t)||!!(Se&&t&&t[Se])}function Q(t,e){var n=_typeof(t);return!!(e=null==e?9007199254740991:e)&&("number"==n||"symbol"!=n&&Jt.test(t))&&-1<t&&0==t%1&&t<e}function X(t,e){if(hn(t))return!1;var n=_typeof(t);return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=t&&!gt(t))||Pt.test(t)||!Ut.test(t)||null!=e&&t in Object(e)}function Z(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||le)}function tt(e,n){return function(t){return null!=t&&t[e]===n&&(n!==Mt||e in Object(t))}}function et(o,a,i){return a=De(a===Mt?o.length-1:a,0),function(){for(var t=arguments,e=-1,n=De(t.length-a,0),r=Array(n);++e<n;)r[e]=t[a+e];for(e=-1,n=Array(a+1);++e<a;)n[e]=t[e];return n[a]=i(r),function(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)}(o,this,n)}}function nt(t){if("string"==typeof t||gt(t))return t;var e=t+"";return"0"==e&&1/t==-zt?"-0":e}function rt(t){if(null==t)return"";try{return ye.call(t)}catch(t){}return t+""}function ot(t,e,n){var r=null==t?0:t.length;return r?((n=null==n?0:jt(n))<0&&(n=De(r+n,0)),o(t,W(e,3),n)):-1}function at(t){return null!=t&&t.length?function t(e,n,r,o,a){var i=-1,u=e.length;for(r=r||K,a=a||[];++i<u;){var c=e[i];0<n&&r(c)?1<n?t(c,n-1,r,o,a):f(a,c):o||(a[a.length]=c)}return a}(t,1):[]}function it(t){var e=null==t?0:t.length;return e?t[e-1]:Mt}function ut(r,o){function a(){var t=arguments,e=o?o.apply(this,t):t[0],n=a.cache;return n.has(e)?n.get(e):(t=r.apply(this,t),a.cache=n.set(e,t)||n,t)}if("function"!=typeof r||null!=o&&"function"!=typeof o)throw new TypeError("Expected a function");return a.cache=new(ut.Cache||s),a}function ct(e){if("function"!=typeof e)throw new TypeError("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!e.call(this);case 1:return!e.call(this,t[0]);case 2:return!e.call(this,t[0],t[1]);case 3:return!e.call(this,t[0],t[1],t[2])}return!e.apply(this,t)}}function ft(t,e){return t===e||t!=t&&e!=e}function st(t){return null!=t&&yt(t.length)&&!pt(t)}function lt(t){return ht(t)&&st(t)}function pt(t){return!!bt(t)&&("[object Function]"==(t=w(t))||"[object GeneratorFunction]"==t||"[object AsyncFunction]"==t||"[object Proxy]"==t)}function yt(t){return"number"==typeof t&&-1<t&&0==t%1&&t<=9007199254740991}function bt(t){var e=_typeof(t);return null!=t&&("object"==e||"function"==e)}function ht(t){return null!=t&&"object"==_typeof(t)}function vt(t){return!(!ht(t)||"[object Object]"!=w(t))&&(null===(t=Oe(t))||"function"==typeof(t=be.call(t,"constructor")&&t.constructor)&&t instanceof t&&ye.call(t)==de)}function dt(t){return"string"==typeof t||!hn(t)&&ht(t)&&"[object String]"==w(t)}function gt(t){return"symbol"==_typeof(t)||ht(t)&&"[object Symbol]"==w(t)}function _t(t){return t?(t=mt(t))===zt||t===-zt?17976931348623157e292*(t<0?-1:1):t==t?t:0:0===t?t:0}function jt(t){var e=(t=_t(t))%1;return t==t?e?t-e:t:0}function mt(t){if("number"==typeof t)return t;if(gt(t))return Ct;if(bt(t)&&(t=bt(t="function"==typeof t.valueOf?t.valueOf():t)?t+"":t),"string"!=typeof t)return 0===t?t:+t;t=t.replace($t,"");var e=Wt.test(t);return e||qt.test(t)?Xt(t.slice(2),e?2:8):Bt.test(t)?Ct:+t}function At(t){return P(t,St(t))}function Ot(t){return null==t?"":N(t)}function wt(t,e,n){return(t=null==t?Mt:A(t,e))===Mt?n:t}function Et(t,e){return null!=t&&J(t,e,L)}function Lt(t){return st(t)?l(t):I(t)}function St(t){if(st(t))t=l(t,!0);else if(bt(t)){var e,n=Z(t),r=[];for(e in t)("constructor"!=e||!n&&be.call(t,e))&&r.push(e);t=r}else{if(e=[],null!=t)for(n in Object(t))e.push(n);t=e}return t}function Tt(t){return null==t?[]:function(e,t){return a(t,function(t){return e[t]})}(t,Lt(t))}function xt(t){return function(){return t}}function It(t){return t}function kt(t){return x("function"==typeof t?t:m(t,1))}function Nt(t){return X(t)?function(e){return function(t){return null==t?Mt:t[e]}}(nt(t)):function(e){return function(t){return A(t,e)}}(t)}function Dt(){return[]}function Ft(){return!1}var Mt,zt=1/0,Ct=NaN,Ut=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,Pt=/^\w*$/,Rt=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,$t=/^\s+|\s+$/g,Vt=/\\(\\)?/g,Ht=/\w*$/,Bt=/^[-+]0x[0-9a-f]+$/i,Wt=/^0b[01]+$/i,Gt=/^\[object .+?Constructor\]$/,qt=/^0o[0-7]+$/i,Jt=/^(?:0|[1-9]\d*)$/,Yt={};Yt["[object Float32Array]"]=Yt["[object Float64Array]"]=Yt["[object Int8Array]"]=Yt["[object Int16Array]"]=Yt["[object Int32Array]"]=Yt["[object Uint8Array]"]=Yt["[object Uint8ClampedArray]"]=Yt["[object Uint16Array]"]=Yt["[object Uint32Array]"]=!0,Yt["[object Arguments]"]=Yt["[object Array]"]=Yt["[object ArrayBuffer]"]=Yt["[object Boolean]"]=Yt["[object DataView]"]=Yt["[object Date]"]=Yt["[object Error]"]=Yt["[object Function]"]=Yt["[object Map]"]=Yt["[object Number]"]=Yt["[object Object]"]=Yt["[object RegExp]"]=Yt["[object Set]"]=Yt["[object String]"]=Yt["[object WeakMap]"]=!1;var Kt={};Kt["[object Arguments]"]=Kt["[object Array]"]=Kt["[object ArrayBuffer]"]=Kt["[object DataView]"]=Kt["[object Boolean]"]=Kt["[object Date]"]=Kt["[object Float32Array]"]=Kt["[object Float64Array]"]=Kt["[object Int8Array]"]=Kt["[object Int16Array]"]=Kt["[object Int32Array]"]=Kt["[object Map]"]=Kt["[object Number]"]=Kt["[object Object]"]=Kt["[object RegExp]"]=Kt["[object Set]"]=Kt["[object String]"]=Kt["[object Symbol]"]=Kt["[object Uint8Array]"]=Kt["[object Uint8ClampedArray]"]=Kt["[object Uint16Array]"]=Kt["[object Uint32Array]"]=!0,Kt["[object Error]"]=Kt["[object Function]"]=Kt["[object WeakMap]"]=!1;var Qt,Xt=parseInt,Zt="object"==_typeof(On)&&On&&On.Object===Object&&On,te="object"==("undefined"==typeof self?"undefined":_typeof(self))&&self&&self.Object===Object&&self,ee=Zt||te||Function("return this")(),ne="object"==_typeof(En)&&En&&!En.nodeType&&En,re=ne&&"object"==_typeof(wn)&&wn&&!wn.nodeType&&wn,oe=re&&re.exports===ne,ae=oe&&Zt.process;t:{try{Qt=ae&&ae.binding&&ae.binding("util");break t}catch(t){}Qt=void 0}var ie,ue=Qt&&Qt.isMap,ce=Qt&&Qt.isSet,fe=Qt&&Qt.isTypedArray,se=Array.prototype,le=Object.prototype,pe=ee["__core-js_shared__"],ye=Function.prototype.toString,be=le.hasOwnProperty,he=(ie=/[^.]+$/.exec(pe&&pe.keys&&pe.keys.IE_PROTO||""))?"Symbol(src)_1."+ie:"",ve=le.toString,de=ye.call(Object),ge=RegExp("^"+ye.call(be).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),_e=oe?ee.Buffer:Mt,je=ee.Symbol,me=ee.Uint8Array,Ae=_e?_e.a:Mt,Oe=e(Object.getPrototypeOf),we=Object.create,Ee=le.propertyIsEnumerable,Le=se.splice,Se=je?je.isConcatSpreadable:Mt,Te=je?je.toStringTag:Mt,xe=function(){try{var t=q(Object,"defineProperty");return t({},"",{}),t}catch(t){}}(),Ie=Object.getOwnPropertySymbols,ke=_e?_e.isBuffer:Mt,Ne=e(Object.keys),De=Math.max,Fe=Date.now,Me=q(ee,"DataView"),ze=q(ee,"Map"),Ce=q(ee,"Promise"),Ue=q(ee,"Set"),Pe=q(ee,"WeakMap"),Re=q(Object,"create"),$e=rt(Me),Ve=rt(ze),He=rt(Ce),Be=rt(Ue),We=rt(Pe),Ge=je?je.prototype:Mt,qe=Ge?Ge.valueOf:Mt,Je=Ge?Ge.toString:Mt,Ye=function(t){return bt(t)?we?we(t):(Ke.prototype=t,t=new Ke,Ke.prototype=Mt,t):{}};function Ke(){}u.prototype.clear=function(){this.__data__=Re?Re(null):{},this.size=0},u.prototype.delete=function(t){return t=this.has(t)&&delete this.__data__[t],this.size-=t?1:0,t},u.prototype.get=function(t){var e=this.__data__;return Re?"__lodash_hash_undefined__"===(t=e[t])?Mt:t:be.call(e,t)?e[t]:Mt},u.prototype.has=function(t){var e=this.__data__;return Re?e[t]!==Mt:be.call(e,t)},u.prototype.set=function(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=Re&&e===Mt?"__lodash_hash_undefined__":e,this},c.prototype.clear=function(){this.__data__=[],this.size=0},c.prototype.delete=function(t){var e=this.__data__;return!((t=p(e,t))<0||(t==e.length-1?e.pop():Le.call(e,t,1),--this.size,0))},c.prototype.get=function(t){var e=this.__data__;return(t=p(e,t))<0?Mt:e[t][1]},c.prototype.has=function(t){return-1<p(this.__data__,t)},c.prototype.set=function(t,e){var n=this.__data__,r=p(n,t);return r<0?(++this.size,n.push([t,e])):n[r][1]=e,this},s.prototype.clear=function(){this.size=0,this.__data__={hash:new u,map:new(ze||c),string:new u}},s.prototype.delete=function(t){return t=G(this,t).delete(t),this.size-=t?1:0,t},s.prototype.get=function(t){return G(this,t).get(t)},s.prototype.has=function(t){return G(this,t).has(t)},s.prototype.set=function(t,e){var n=G(this,t),r=n.size;return n.set(t,e),this.size+=n.size==r?0:1,this},d.prototype.add=d.prototype.push=function(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this},d.prototype.has=function(t){return this.__data__.has(t)},g.prototype.clear=function(){this.__data__=new c,this.size=0},g.prototype.delete=function(t){var e=this.__data__;return t=e.delete(t),this.size=e.size,t},g.prototype.get=function(t){return this.__data__.get(t)},g.prototype.has=function(t){return this.__data__.has(t)},g.prototype.set=function(t,e){var n=this.__data__;if(n instanceof c){var r=n.__data__;if(!ze||r.length<199)return r.push([t,e]),this.size=++n.size,this;n=this.__data__=new s(r)}return n.set(t,e),this.size=n.size,this};var Qe=function(t,e){if(null==t)return t;if(!st(t))return function(t,e){return t&&Xe(t,e,Lt)}(t,e);for(var n=t.length,r=-1,o=Object(t);++r<n&&!1!==e(o[r],r,o););return t},Xe=function(t,e,n){for(var r=-1,o=Object(t),a=(n=n(t)).length;a--;){var i=n[++r];if(!1===e(o[i],i,o))break}return t},Ze=xe?function(t,e){return xe(t,"toString",{configurable:!0,enumerable:!1,value:xt(e),writable:!0})}:It,tn=Ie?function(e){return null==e?[]:(e=Object(e),n(Ie(e),function(t){return Ee.call(e,t)}))}:Dt,en=Ie?function(t){for(var e=[];t;)f(e,tn(t)),t=Oe(t);return e}:Dt,nn=w;(Me&&"[object DataView]"!=nn(new Me(new ArrayBuffer(1)))||ze&&"[object Map]"!=nn(new ze)||Ce&&"[object Promise]"!=nn(Ce.resolve())||Ue&&"[object Set]"!=nn(new Ue)||Pe&&"[object WeakMap]"!=nn(new Pe))&&(nn=function(t){var e=w(t);if(t=(t="[object Object]"==e?t.constructor:Mt)?rt(t):"")switch(t){case $e:return"[object DataView]";case Ve:return"[object Map]";case He:return"[object Promise]";case Be:return"[object Set]";case We:return"[object WeakMap]"}return e});var rn,on,an,un,cn,fn,sn=(un=Ze,fn=cn=0,function(){var t=Fe(),e=16-(t-fn);if(fn=t,0<e){if(800<=++cn)return arguments[0]}else cn=0;return un.apply(Mt,arguments)}),ln=(an=(on=ut(on=function(t){var o=[];return 46===t.charCodeAt(0)&&o.push(""),t.replace(Rt,function(t,e,n,r){o.push(n?r.replace(Vt,"$1"):e||t)}),o},function(t){return 500===an.size&&an.clear(),t})).cache,on),pn=(rn=ot,function(t,e,n){var r=Object(t);if(!st(t)){var o=W(e,3);t=Lt(t),e=function(t){return o(r[t],t,r)}}return-1<(e=rn(t,e,n))?r[o?t[e]:e]:Mt});ut.Cache=s;var yn,bn=S(function(){return arguments}())?S:function(t){return ht(t)&&be.call(t,"callee")&&!Ee.call(t,"callee")},hn=Array.isArray,vn=ke||Ft,dn=ue?t(ue):function(t){return ht(t)&&"[object Map]"==nn(t)},gn=ce?t(ce):function(t){return ht(t)&&"[object Set]"==nn(t)},_n=fe?t(fe):function(t){return ht(t)&&yt(t.length)&&!!Yt[w(t)]},jn=R(function(t,e,n){k(t,e,n)}),mn=R(function(t,e,n,r){k(t,e,n,r)}),An=sn(et(yn=function(e,t){var n={};if(null==e)return n;var r=!1;t=a(t,function(t){return t=F(t,e),r=r||1<t.length,t}),P(e,B(e),n),r&&(n=m(n,7,$));for(var o=t.length;o--;)D(n,t[o]);return n},Mt,at),yn+"");r.constant=xt,r.flatten=at,r.iteratee=kt,r.keys=Lt,r.keysIn=St,r.memoize=ut,r.merge=jn,r.mergeWith=mn,r.negate=ct,r.omit=An,r.property=Nt,r.reject=function(t,e){return(hn(t)?n:function(t,r){var o=[];return Qe(t,function(t,e,n){r(t,e,n)&&o.push(t)}),o})(t,ct(W(e,3)))},r.toPlainObject=At,r.values=Tt,r.cloneDeep=function(t){return m(t,5)},r.cloneDeepWith=function(t,e){return m(t,5,e="function"==typeof e?e:Mt)},r.eq=ft,r.find=pn,r.findIndex=ot,r.get=wt,r.has=function(t,e){return null!=t&&J(t,e,E)},r.hasIn=Et,r.identity=It,r.includes=function(t,e,n,r){if(t=st(t)?t:Tt(t),n=n&&!r?jt(n):0,r=t.length,n<0&&(n=De(r+n,0)),dt(t))t=n<=r&&-1<t.indexOf(e,n);else{if(r=!!r){if(e==e)t:{for(n-=1,r=t.length;++n<r;)if(t[n]===e){t=n;break t}t=-1}else t=o(t,i,n);r=-1<t}t=r}return t},r.isArguments=bn,r.isArray=hn,r.isArrayLike=st,r.isArrayLikeObject=lt,r.isBuffer=vn,r.isEmpty=function(t){if(null==t)return!0;if(st(t)&&(hn(t)||"string"==typeof t||"function"==typeof t.splice||vn(t)||_n(t)||bn(t)))return!t.length;var e=nn(t);if("[object Map]"==e||"[object Set]"==e)return!t.size;if(Z(t))return!I(t).length;for(var n in t)if(be.call(t,n))return!1;return!0},r.isEqual=function(t,e){return T(t,e)},r.isFunction=pt,r.isLength=yt,r.isMap=dn,r.isNull=function(t){return null===t},r.isObject=bt,r.isObjectLike=ht,r.isPlainObject=vt,r.isSet=gn,r.isString=dt,r.isSymbol=gt,r.isTypedArray=_n,r.last=it,r.stubArray=Dt,r.stubFalse=Ft,r.toFinite=_t,r.toInteger=jt,r.toNumber=mt,r.toString=Ot,r.VERSION="4.17.5",re&&((re.exports=r)._=r,ne._=r)}).call(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){e.exports={itemType:{DATA:"data",FCTN:"fctn",EVENT:"event",LISTENER_ON:"listenerOn",LISTENER_OFF:"listenerOff"},dataLayerEvent:{CHANGE:"adobeDataLayer:change",EVENT:"adobeDataLayer:event"},listenerScope:{PAST:"past",FUTURE:"future",ALL:"all"}}},{}],3:[function(t,e,n){var r=t("../custom-lodash"),c=t("../version.json").version,l=r.cloneDeep,p=r.get,y=t("./item"),b=t("./listener"),h=t("./listenerManager"),v=t("./constants"),d=t("./utils/customMerge");e.exports=function(t){var f,e=t||{},n=[],r=[],o={},a={getState:function(){return o},getDataLayer:function(){return n}};function i(t){o=d(o,t.data)}function u(t){t.valid?{data:function(t){i(t),f.triggerListeners(t)},fctn:function(t){t.config.call(n,n)},event:function(t){t.data&&i(t),f.triggerListeners(t)},listenerOn:function(t){var e=b(t);switch(e.scope){case v.listenerScope.PAST:var n,r=_createForOfIteratorHelper(c(t));try{for(r.s();!(n=r.n()).done;){var o=n.value;f.triggerListener(e,o)}}catch(t){r.e(t)}finally{r.f()}break;case v.listenerScope.FUTURE:f.register(e);break;case v.listenerScope.ALL:if(f.register(e)){var a,i=_createForOfIteratorHelper(c(t));try{for(i.s();!(a=i.n()).done;){var u=a.value;f.triggerListener(e,u)}}catch(t){i.e(t)}finally{i.f()}}}},listenerOff:function(t){f.unregister(b(t))}}[t.type](t):s(t);function c(t){return 0===n.length||t.index>n.length-1?[]:n.slice(0,t.index).map(function(t){return y(t)})}}function s(t){var e="The following item cannot be handled by the data layer because it does not have a valid format: "+JSON.stringify(t.config);console.error(e)}return function(){Array.isArray(e.dataLayer)||(e.dataLayer=[]);r=e.dataLayer.splice(0,e.dataLayer.length),(n=e.dataLayer).version=c,o={},f=h(a)}(),n.push=function(t){var n=arguments,r=arguments;if(Object.keys(n).forEach(function(t){var e=y(n[t]);switch(e.valid||(s(e),delete r[t]),e.type){case v.itemType.DATA:case v.itemType.EVENT:u(e);break;case v.itemType.FCTN:delete r[t],u(e);break;case v.itemType.LISTENER_ON:case v.itemType.LISTENER_OFF:delete r[t]}}),r[0])return Array.prototype.push.apply(this,r)},n.getState=function(t){return t?p(l(o),t):l(o)},n.addEventListener=function(t,e,n){u(y({on:t,handler:e,scope:n&&n.scope,path:n&&n.path}))},n.removeEventListener=function(t,e){u(y({off:t,handler:e}))},function(){for(var t=0;t<r.length;t++)n.push(r[t])}(),a}},{"../custom-lodash":1,"../version.json":14,"./constants":2,"./item":5,"./listener":7,"./listenerManager":8,"./utils/customMerge":10}],4:[function(t,e,n){var r={Manager:t("./dataLayerManager")};window.adobeDataLayer=window.adobeDataLayer||[],window.adobeDataLayer.version?console.warn("Adobe Client Data Layer v".concat(window.adobeDataLayer.version," has already been imported/initialized on this page. You may be erroneously loading it a second time.")):r.Manager({dataLayer:window.adobeDataLayer}),e.exports=r},{"./dataLayerManager":3}],5:[function(t,e,n){var r=t("../custom-lodash"),i=r.isPlainObject,u=r.isEmpty,c=r.omit,f=r.find,s=t("./utils/dataMatchesContraints"),l=t("./itemConstraints"),p=t("./constants");e.exports=function(t,e){var n=t,r=e,o=f(Object.keys(l),function(t){return s(n,l[t])})||"function"==typeof n&&p.itemType.FCTN||i(n)&&p.itemType.DATA,a=function(){var t=c(n,Object.keys(l.event));if(!u(t))return t}();return{config:n,type:o,data:a,valid:!!o,index:r}}},{"../custom-lodash":1,"./constants":2,"./itemConstraints":6,"./utils/dataMatchesContraints":11}],6:[function(t,e,n){e.exports={event:{event:{type:"string"},eventInfo:{optional:!0}},listenerOn:{on:{type:"string"},handler:{type:"function"},scope:{type:"string",values:["past","future","all"],optional:!0},path:{type:"string",optional:!0}},listenerOff:{off:{type:"string"},handler:{type:"function",optional:!0},scope:{type:"string",values:["past","future","all"],optional:!0},path:{type:"string",optional:!0}}}},{}],7:[function(t,e,n){var r=t("./constants");e.exports=function(t){return{event:t.config.on||t.config.off,handler:t.config.handler||null,scope:t.config.scope||t.config.on&&r.listenerScope.ALL||null,path:t.config.path||null}}},{"./constants":2}],8:[function(t,e,n){var u=t("../custom-lodash").cloneDeep,c=t("./constants"),f=t("./utils/listenerMatch"),s=t("./utils/indexOfListener");e.exports=function(t){var o={},r=t,a=s.bind(null,o);function i(t,e){if(f(t,e)){var n=[u(e.config)];t.handler.apply(r.getDataLayer(),n)}}return{register:function(t){var e=t.event;return Object.prototype.hasOwnProperty.call(o,e)?-1===a(t)&&(o[t.event].push(t),!0):(o[t.event]=[t],!0)},unregister:function(t){var e=t.event;if(Object.prototype.hasOwnProperty.call(o,e))if(t.handler||t.scope||t.path){var n=a(t);-1<n&&o[e].splice(n,1)}else o[e]=[]},triggerListeners:function(r){(function(t){var e=[];switch(t.type){case c.itemType.DATA:e.push(c.dataLayerEvent.CHANGE);break;case c.itemType.EVENT:e.push(c.dataLayerEvent.EVENT),t.data&&e.push(c.dataLayerEvent.CHANGE),t.config.event!==c.dataLayerEvent.CHANGE&&e.push(t.config.event)}return e})(r).forEach(function(t){if(Object.prototype.hasOwnProperty.call(o,t)){var e,n=_createForOfIteratorHelper(o[t]);try{for(n.s();!(e=n.n()).done;){i(e.value,r)}}catch(t){n.e(t)}finally{n.f()}}})},triggerListener:function(t,e){i(t,e)}}}},{"../custom-lodash":1,"./constants":2,"./utils/indexOfListener":12,"./utils/listenerMatch":13}],9:[function(t,e,n){var r=t("../../custom-lodash"),o=r.has,a=r.get;e.exports=function(t,e){for(var n=e.substring(0,e.lastIndexOf("."));n;){if(o(t,n)){var r=a(t,n);if(null==r)return!0}n=n.substring(0,n.lastIndexOf("."))}return!1}},{"../../custom-lodash":1}],10:[function(t,e,n){var r=t("../../custom-lodash"),s=r.cloneDeepWith,l=r.isObject,p=r.isArray,y=r.reject,o=r.mergeWith,a=r.isNull;e.exports=function(t,e){return o(t,e,function(t,e,n,r){if(null==e)return null}),t=function(t,e){return s(t,function(f){return function e(t,n,r,o){if(l(t)){if(p(t))return y(t,f).map(function(t){return s(t,e)});for(var a={},i=0,u=Object.keys(t);i<u.length;i++){var c=u[i];f(t[c])||(a[c]=s(t[c],e))}return a}}}(1<arguments.length&&void 0!==e?e:function(t){return!t}))}(t,a)}},{"../../custom-lodash":1}],11:[function(t,e,n){var r=t("../../custom-lodash"),o=r.find,s=r.includes;e.exports=function(c,f){return void 0===o(Object.keys(f),function(t){var e=f[t].type,n=t&&f[t].values,r=!f[t].optional,o=c[t],a=_typeof(o),i=e&&a!==e,u=n&&!s(n,o);return r?!o||i||u:o&&(i||u)})}},{"../../custom-lodash":1}],12:[function(t,e,n){var c=t("../../custom-lodash").isEqual;e.exports=function(t,e){var n=e.event;if(Object.prototype.hasOwnProperty.call(t,n)){var r,o=_createForOfIteratorHelper(t[n].entries());try{for(o.s();!(r=o.n()).done;){var a=_slicedToArray(r.value,2),i=a[0],u=a[1];if(c(u.handler,e.handler))return i}}catch(t){o.e(t)}finally{o.f()}}return-1}},{"../../custom-lodash":1}],13:[function(t,e,n){var r=t("../../custom-lodash").has,a=t("../constants"),o=t("./ancestorRemoved");function i(t,e){return!e.data||!t.path||(r(e.data,t.path)||o(e.data,t.path))}e.exports=function(t,e){var n=t.event,r=e.config,o=!1;return e.type===a.itemType.DATA?n===a.dataLayerEvent.CHANGE&&(o=i(t,e)):e.type===a.itemType.EVENT&&(n!==a.dataLayerEvent.EVENT&&n!==r.event||(o=i(t,e)),e.data&&n===a.dataLayerEvent.CHANGE&&(o=i(t,e))),o}},{"../../custom-lodash":1,"../constants":2,"./ancestorRemoved":9}],14:[function(t,e,n){e.exports={version:"2.0.2"}},{}]},{},[4]);
	}
}
          }

        },
        "gcoe-adobe-client-data-layer/src/lib/util/getDataLayer.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

module.exports = function () {
    var extensionSettings = turbine.getExtensionSettings();
    return window[extensionSettings.dataLayerName];
};
          }

        }
      }
    },
    "qualtrics-website-feedback": {
      "displayName": "Qualtrics Website Feedback",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP3037080b2f514c82a49a8eab77b5a00e/",
      "modules": {
        "qualtrics-website-feedback/src/lib/actions/loadProject.js": {
          "name": "load-project",
          "displayName": "Load Project",
          "script": function(module, exports, require, turbine) {
'use strict';

module.exports = function(settings) {
    try {

        var brandID = settings.brandID;
        var projectID = settings.projectID;
        var strippedProjectID = projectID.replace("_", "").toLowerCase();

        var appendDiv = function() {
            var projectDiv = document.createElement('div');
            projectDiv.id = projectID;
            document.body.appendChild(projectDiv);
        }

        if ("undefined"===typeof window.QSI) {
            window.QSI= {
                clientTypeVariant: 'AdobeLaunch'
            };
        }

        var runCode = function() {
            (function(){
                var CodeInserter = function(rate, type, cookieName, url){
                    this.get = function (name)
                    {
                        var e = name + '=';
                        var ca = document.cookie.split(';');
                        for (var i = 0, ilen = ca.length; i < ilen; i++)
                        {
                            var c = ca[i];
                            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                            if (c.indexOf(e) == 0) {
                                return c.substring(e.length, c.length);
                            }
                        }
                        return null;
                    };
                    this.set = function (name, value)
                    {
                        var expiresString = '', expiresTime;
                        expiresTime = new Date();
                        expiresTime.setTime(expiresTime.getTime() + (7 * 86400000));
                        expiresString = '; expires=' + expiresTime.toGMTString();
                        document.cookie = name + '=' + value + expiresString + '; path=/; ';
                    };      
                    this.check = function ()
                    {
                        var cookieValue = this.get(cookieName);
                        if (!cookieValue)
                        {
                            cookieValue = [type, rate, 0];
                            if (rate != 100)
                            {
                                if (type == 'v') {
                                    rate = (Math.random() >= rate / 100) ? 0 : 100;
                                }
                                cookieValue = [type, rate, 0];
                                this.set(cookieName, cookieValue.join(':'));
                            }
                            else
                                return true;
                        }
                        else
                        {
                            cookieValue = cookieValue.split(':');
                        }
                        var percentage = cookieValue[1];
                        if (percentage == 100) {
                            return true;
                        }
                        switch (cookieValue[0])
                        {
                            case 'v':
                                return false;
                                break;
                            case 'r':
                                var chk = cookieValue[2] % Math.floor(100 / percentage);
                                cookieValue[2]++;
                                this.set(cookieName, cookieValue.join(':'));
                                return !chk;
                                break;
                        }
                        return true;
                    };
                    this.go = function ()
                    {
                        if (!this.check()) {
                            return;
                        }
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = url;
                        if (document.body) {
                            document.body.appendChild(script);
                        }
                    };
                };
                try {
                    var codeInserter = new CodeInserter(100, "r", "QSI_S_" + projectID, "https://" + strippedProjectID + "-" + brandID + ".siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=" + projectID);
                    codeInserter.go()
                } catch (e) {}
            })();
        }

        if (brandID && projectID &&strippedProjectID) {
            appendDiv();
            runCode();

                        turbine.logger.log("Loaded Site Intercept Project: " + projectID);
        }
    } catch (e) {
        turbine.logger.error("Could not load Intercept Project: " + e);
    }
};
          }

        }
      }
    }
  },
  "company": {
    "orgId": "315F75E95BFC0EE50A495C73@AdobeOrg",
    "dynamicCdnEnabled": false
  },
  "property": {
    "name": "Svenska Spel  SoC - webSDK",
    "settings": {
      "domains": [
        "svenskaspel.se"
      ],
      "undefinedVarsReturnEmpty": false,
      "ruleComponentSequencingEnabled": true
    },
    "id": "PR525a529e093c492ba232625a79663bdc"
  },
  "rules": [
    {
      "id": "RL003b1e63ce7e4d47adadc785c195ea36",
      "name": "ACDL | Qualtrics | AllTime | eddlChangedpageView (production)",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "pageView"
          },
          "ruleOrder": 51.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-12-11T01:00:00Z",
            "start": "2023-11-23T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^PROD$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$|momang$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _pCheckTB = _satellite.getVar('ACDL | Qualtrics')[3], 
      _pCheckCasino = _satellite.getVar('ACDL | Qualtrics')[1]; 

  if (_pCheckTB == 'Trav och galopp' ||  _pCheckCasino == 'Live Casino' ||  _pCheckCasino == 'Momang Live Casino' || _pCheckCasino == 'Momang Casino') {
    return true
    } else {
      return false
    }
} catch (e) {}

}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/sampling.js",
          "settings": {
            "rate": 1
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_2aDLvC1gL9CQg2q"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCf1323d76ef3d42feae4392ec1c1c7aba-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL0114731326784bc39427b13955ae1a50",
      "name": "AA | Communication choices | DCevent - kommunikationsval",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "kommunikationsval"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCc42aa6d2adac4a6ca9ddd724a8471e1c-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%communication choices XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL017673e7dc074a9a9d7cc23688cadd55",
      "name": "ACDL | Set data element | websdk - events",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "event"
          },
          "ruleOrder": 3.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "spela|applb"
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC58163095170b45508739fc671ce5c46a-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL018ce311103341c49820f5bc7ccb9050",
      "name": "AA | Deposit Failure | DCevent - depositFailure",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "depositFailure"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit failure XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL0afa8077cea64cda93854dfae4f81e69",
      "name": "AA | Log out | DCevent - logOut",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "logOut"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%log out XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL0e585ec486074197aee9d8853ea68e65",
      "name": "AA | Withdrawal Success | DCevent - withdrawalSuccess",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "withdrawalSuccess"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%withdrawal success XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL1549e6700a0d47cb8443c358477aa14a",
      "name": "MO | AA | Content | Page View | pageView websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "pageView"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _data = adobeDataLayer.getState().data,
    _site = _data.site.name;
  if (_site == 'momang') { 
    var _acon = _data.consent.analyticsBrowser,
      _pcon = _data.consent.personalizedBrowser,
      _pccon = _data.consent.personalizedCustomer,
      _lab = _data.label;

    if (_acon == true && _pcon == true) { 
      if (_pccon != false) {
          return true;
      } else {
        _satellite.logger.log(" pccon false ");
        return false;
      }
    } else {
      _satellite.logger.log(" momang reg no consent ");
      return false;
    }
  } else {
    _satellite.logger.log(" momang site not true ");
    return false;
  }
} catch (e) {}
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _data = adobeDataLayer.getState().data,
    pid = decodeURIComponent(_data.page.url.toLowerCase()),
    _url = decodeURIComponent(_data.page.url.toLowerCase()),
    _pagename = _data.page.name.toLowerCase();

  function _pv() {
    sessionStorage.setItem("s_gpv", _pagename)
  }

  function _getpv(_a) {
    return sessionStorage.getItem(_a)
  }
  var getqpv = _getpv("s_gpv"),
    _reg = _getpv("reg_s"); 
  if (getqpv == undefined || getqpv == null) { 
    _pv();
    _satellite.setVar("Rule | PreviousValue", _pagename);
  } else {
    _satellite.setVar("Rule | PreviousValue", getqpv);
    _pv();
  }
  if (_reg != undefined || _reg != null) { 
    sessionStorage.removeItem("reg_s"); 
    _labData = _reg.split("_");
    var _obj = {
      "completed": 1,
      "method": _labData[1],
      "type": _labData[0]
    };
    _satellite.setVar("registration obj", _obj);
  }
  pid = pid.substring(0, (c = pid.indexOf("?")) > -1 ? c : pid.length);
  var cat = pid.split('/');
  if (pid == "/") {
    cat[1] = cat[2] = "home";
  }
  _satellite.setVar("site section: level1", cat[1] ? cat[1] : "");
  _satellite.setVar("site section: level2", cat[2] ? cat[2] : cat[1] ? cat[1] : "");
  _satellite.setVar("site section: pageID", pid);

  var regex1 = new RegExp(/.*:mina-spel:[0-9]+:[0-9]+/g),
    regex2 = new RegExp(/.*:mina-spel:[0-9]+/g),
    pn = _pagename;
  var _res1 = regex1.exec(pn),
    _res2 = regex2.exec(pn);
  if (pn != "" && (pn.indexOf("logga-in:bankid:poll") != -1 || pn.indexOf(":avslutat-spel") != -1 || pn.indexOf(":pagaende") != -1 || _res1 || _res2)) {
    _res1 = _res2 = undefined;
    return false;
  }
  var _pageregex1 = new RegExp('^[\/]\s|^[\/]\?.*');
  if (typeof(pn) == undefined && _pageregex1.test(_url)) {
    return false;
  }
  return true;
} catch (e) {
  _satellite.logger.log(e);
}
return true;
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%pageview XDM map%",
            "data": "%ACDL Data object%",
            "type": "web.webpagedetails.pageViews",
            "instanceName": "alloy",
            "personalization": {
              "includeRenderedPropositions": true
            },
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL1fb511bf41fd443ab40929e78e8532d2",
      "name": "MO | AA | Log out | DCevent - mologOut",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "mologOut"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%log out XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL24bae33b2ff840ef8f4f0163fa87c4e8",
      "name": "AA | Global | Promo click | DCevent - promoClick",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "promoClick"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
var _data = event.message.data;
_satellite.setVar("Internal Promotion | Name", _data.action.toString().toLowerCase());
_satellite.setVar("Internal Promotion | Id", _data.category.toString().toLowerCase());
_satellite.setVar("Internal Promotion | Position", _data.label.toString().toLowerCase());
  return true;
} catch (e) {}
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%promoClick XDM map%",
            "data": "%ACDL Data object%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL2c0ce2799cc742bc9c7a8cf3c1bcb8bd",
      "name": "ACDL | Qualtrics | AllTime | eddlChangedpageView (test)",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "pageView"
          },
          "ruleOrder": 51.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-11-02T01:00:00Z",
            "start": "2023-11-01T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^DEV|STAGE$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$|momang$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _pCheckTB = _satellite.getVar('ACDL | Qualtrics')[3],
      _pCheckCasino = _satellite.getVar('ACDL | Qualtrics')[1];

  if (_pCheckTB == 'Trav och galopp' ||  _pCheckCasino == 'Live Casino' ||  _pCheckCasino == 'Momang Live Casino' || _pCheckCasino == 'Momang Casino') {
    return true
    } else {
      return false
    }
} catch (e) {}

}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_9A08Zt4EqAWcJWS"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC36779268243a4a8280b412f4312cec92-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL2c8270fcc5f24349aa231d190e4d0a2e",
      "name": "MO | AA | Deposit Decrease | DCevent - modepositDecrease",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "modepositDecrease"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCc50b1d4a0f9a49ca8cff71676742aedb-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit limit decrease XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL32162c844b134e1e89fb0a802c8c6f44",
      "name": "AA | Deposit Increase | DCevent - depositIncrease",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "depositIncrease"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCef7ef3a01ad34af4896632b9b58e1c9a-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit limit increase XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL32cb3aa5e4e942c3b854ba5b438af5ab",
      "name": "AA | Andelsspel Reserve Share | DCevent - andSpel",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "andSpel"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC131f9cc946c046bebad5d970be0ef5ac-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%andSpel XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL373dd4f7c5414d10b37ca14c8fb1e242",
      "name": "MO | AA | Login Success | DCevent - mologinSuccess",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "mologinSuccess"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%login success XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL39a0d06e3f2d430498cea51a2934b20c",
      "name": "ACDL | Qualtrics | AllTime | DC Event (test)",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "qTriggerAllTimes"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-11-02T01:00:00Z",
            "start": "2023-11-01T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^DEV|STAGE$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_9A08Zt4EqAWcJWS"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC274e172ec0fb4419a6e213979af2d531-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL3a53ab2707b94e95b20cfb38f81960ea",
      "name": "AA | Cancel Support | DCevent - cancelSupport",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "cancelSupport"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%cancel support XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL3acc4c4cd6bb4d5584caf2d0ab94dfa6",
      "name": "MO | AA | Menu click | DCevent - momenuClick",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "momenuClick"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%menuClick XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL43106513ea8d49a6b875c76854f1ec5b",
      "name": "AA | Game Chooser | DCevent - gameChooser",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "gameChooser"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%game chooser set XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL434ab0046ac14c21b3a05a6c2166a30a",
      "name": "ACDL | Qualtrics | eddlChangedpageView (test)",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "pageView"
          },
          "ruleOrder": 51.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-11-02T01:00:00Z",
            "start": "2023-11-01T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^DEV|STAGE$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _pCheckTB = _satellite.getVar('ACDL | Qualtrics')[3],
      _pCheckCasino = _satellite.getVar('ACDL | Qualtrics')[1]; 

  if (_pCheckTB != 'Trav och galopp' && _pCheckTB != 'Bingo' && _pCheckTB != 'Challenge' && _pCheckCasino != 'Live Casino' &&  _pCheckCasino != 'Momang Live Casino' && _pCheckCasino != 'Momang Casino') {
    return true
    } else {
      return false
    }
} catch (e) {}

}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_9A08Zt4EqAWcJWS"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC22691d52aad748ce98dc7d6a48be498c-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL45165e54f3bf4140a555c41742a77028",
      "name": "ACDL | Products | tranx | Oddset | trans - Qualtrics trigger",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "trans"
          },
          "ruleOrder": 51.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
var items = _satellite.getVar('Trans Qualtrics'), _url = _satellite.getVar('Content | url');
if (items) {
  for (var i = 0; i < items.length; i++) {
    if (items[i].productName == 'Oddset' && _url.includes('/odds/sports')) {
      return true;
    } else {
      return false;
    }
  }
}
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCa648bdda65d54f5ea3f851fa28308f82-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL4af6286c985c49e3a7c500dbb918e04d",
      "name": "AA | Grasroten Give Support | DCevent - giveSupport",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "giveSupport"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%grasroten give support XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL4e98f6dd20d94556a4f77ff2aa65a8f1",
      "name": "AA | Start Video | DCevent - startVideo",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "startVideo"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "spela|applb"
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%start video XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL52613034ef0f4f5da3f07e6ea8a13308",
      "name": "AA | A4T | Target Click | targetPayloadClick - websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "targetPayloadClick"
          },
          "ruleOrder": 5.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCd8e5d6aba14f4e819912bc5f4e4e275e-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%targetPayloadClick XDM%",
            "type": "decisioning.propositionInteract",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL535453717af2466394fcd18b7261da7f",
      "name": "AA | Customer Registration Success | event - reg",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "reg"
          },
          "ruleOrder": 5.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _data = event.message.data,
    _site = _data.site.name,
    _labData = "",
    _lab = _data.label;
    _satellite.getVar("decCookie code"); 
 if (_site == 'spela' || _site == 'applb') { 
       _satellite.getVar("pageView code"); 
        if (_lab != undefined || _lab != "") {
          if (_lab == "new_bankid" || _lab == "retail_bankid" || _lab == "new_freja" || _lab == "retail_freja") {
            sessionStorage.setItem("reg_s", _lab);
            _labData = _lab.split("_");
            _satellite.setVar("registration: type1", _labData[0]);
            _satellite.setVar("registration: method1", _labData[1]);
            return true;
          }
        }
  } else {
    _satellite.logger.log(" spela site not true ");
    return false;
  }
} catch (e) {}
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%registration success XDM map%",
            "data": "%ACDL Data object%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "personalization": {
              "defaultPersonalizationEnabled": false
            },
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL53fc64c13e44483b8373acb606828a0d",
      "name": "MO | AA | Deposit Success | DCevent - modepositSuccess",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "modepositSuccess"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit success XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL56a01e9852254f69973e10e7c0197751",
      "name": "MO | AA | Deposit Failure | DCevent - modepositFailure",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "modepositFailure"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit failure XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL608257c873f94633b0ffcf6e1691a227",
      "name": "AA | A4T | Target View | targetPayloadView - websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "targetPayloadView"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  _satellite.getVar("devCookie code"); 
  _satellite.getVar("decCookie code");
  var _data = adobeDataLayer.getState().data,
    pid = decodeURIComponent(_data.page.url.toLowerCase()),
    _url = decodeURIComponent(_data.page.url.toLowerCase()),
    _pagename = _data.page.name.toLowerCase();
    _satellite.setVar("Target | payloadview",_data.payload);
    _satellite.getVar("pageView code"); 
  pid = pid.substring(0, (c = pid.indexOf("?")) > -1 ? c : pid.length);
  var cat = pid.split('/');
  if (pid == "/") {
    cat[1] = cat[2] = "home";
  }
  _satellite.setVar("site section: level1", cat[1] ? cat[1] : "");
  _satellite.setVar("site section: level2", cat[2] ? cat[2] : cat[1] ? cat[1] : "");
  _satellite.setVar("site section: pageID", pid);

  var regex1 = new RegExp(/.*:mina-spel:[0-9]+:[0-9]+/g),
    regex2 = new RegExp(/.*:mina-spel:[0-9]+/g),
    pn = _pagename;
  var _res1 = regex1.exec(pn),
    _res2 = regex2.exec(pn);
  if (pn != "" && (pn.indexOf("logga-in:bankid:poll") != -1 || pn.indexOf(":avslutat-spel") != -1 || pn.indexOf(":pagaende") != -1 || _res1 || _res2)) {
    _res1 = _res2 = undefined;
    return false;
  }
  var _pageregex1 = new RegExp('^[\/]\s|^[\/]\?.*');
  if (typeof(pn) == undefined && _pageregex1.test(_url)) {
    return false;
  }
  return true;
} catch (e) {
  _satellite.logger.log(e);
}
return true;
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC26089a604fcf482fa86bdc7661233009-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%targetPayloadView XDM%",
            "type": "decisioning.propositionDisplay",
            "instanceName": "alloy",
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL616a5908b70d479086700c4ae52f124d",
      "name": "AA | Betslip Started | DCevent - betslipStarted",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "betslipStarted"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%betslip started XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL6439a1c47b464631967de50f813bb81d",
      "name": "AA | Deposit Success | DCevent - depositSuccess",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "depositSuccess"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit success XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL671898431dd94b378fcf7f8d45ec810f",
      "name": "MO | AA | Login Failure | DCevent - mologinFailure",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "mologinFailure"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%login failure XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL6e2b7add54b84bd783180b475b2d9f6e",
      "name": "MO | AA | Deposit Set | DCevent - modepositSet",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "modepositSet"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCdeed57e605e74ba9b466266c26eab5d1-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit limit set XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL71fd2bc1c7d74f12aa5097992a6e8eb0",
      "name": "MO | AA | Search | event - search",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "search"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "momang"
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%search XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL76c1b3374352403bb4c0f3927e7a024d",
      "name": "AA | Deposit Set | DCevent - depositSet",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "depositSet"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC2ec8e6c52e8b42e6ab434ae9ebb442ff-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit limit set XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL784c75176f7e4d40b43a2361aa47f7b0",
      "name": "AA | Transaction | Complete | trans websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "trans"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCfb46edf667cf46a0a5f99e0fe8a429ef-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%Trans XDM Map%",
            "type": "commerce.purchases",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL78afb44e07bc43c491d5f4d4b7b82767",
      "name": "ACDL | Qualtrics | DC Event (test) ",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "qualtricsTrigger"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-11-02T01:00:00Z",
            "start": "2023-11-01T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^DEV|STAGE$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$|momang$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_9A08Zt4EqAWcJWS"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC07f2d5f559b14b5ea88fb3df831e5424-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL7901a71a855c4660a0e000fa16b3194e",
      "name": "AA | Withdrawal Failure | DCevent - withdrawalFailure",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "withdrawalFailure"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%withdrawal failure XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL799a66ab84f043f993e401ababaf4d93",
      "name": "MO | AA | Withdrawal Success | DCevent - mowithdrawalSuccess",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "mowithdrawalSuccess"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%withdrawal success XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL7a4563f920344b54bdec309fa4e44ced",
      "name": "MO | AA | Withdrawal Failure | DCevent - mowithdrawalFailure",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "mowithdrawalFailure"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%withdrawal failure XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL7c58bbd5e42d40f18ed7f0081fe8b36a",
      "name": "AA | Search | event - search",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "search"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "spela|applb"
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%search XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL870d43e1aefc46908f90147d3870e900",
      "name": "AA | Content | Page View | pageView global websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "pageView"
          },
          "ruleOrder": 2.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _data = event.message.data,
    _acon = _data.consent.analyticsBrowser,
    _pcon = _data.consent.personalizedBrowser,
    _pccon = _data.consent.personalizedCustomer,
    _val = "",
    _dataString = new Date().toISOString(),
    _obj = {},
    _privacyPreferences = {};
    _satellite.getVar("devCookie code"); 
    _satellite.getVar("decCookie code"); 

    if (_acon == true && _pcon == true) { 
    if (_pccon != false) { 
      _obj = {
        "collect": {
          "val": "y"
        },
        "metadata": {
          "time": _dataString
        }
      }
      _satellite.setVar("Rule | consent", _obj);
      _privacyPreferences = {
        "cookieConsentString": "y",
        "consentSettings": {
          "consents": {
            "collect": {
              "val": "y"
            },
            "personalize": {
              "content": {
                "val": "y"
              }
            }
          }

        }
      }
      _satellite.setVar("Rule | privacyPreferences", _privacyPreferences);
      _satellite.getVar("pageView code"); 
      _satellite.getVar("Content | utm_data"); 
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
} catch (e) {}
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try{
      var _url = decodeURIComponent(event.message.data.page.url),_prevpage = '';
    _satellite.getVar('Content | url');
    function _qpv (){sessionStorage.setItem("qpv", _url+",0,0")}
    function _getqpv (){return sessionStorage.getItem("qpv")}
    function _qpv1 (i){sessionStorage.setItem("qpv", i)}
    var getqpv = _getqpv();
    if (getqpv == undefined || getqpv == null) {_qpv()}
    if(getqpv){
    var _prevpage = getqpv.split(",")[0], _qcount = getqpv.split(",")[1]+","+getqpv.split(",")[2];
    _satellite.setVar('Rule | qpv',_prevpage);
    _prevpage = _url + "," + _qcount;
    _qpv1(_prevpage);
    }
    return true;
} catch (e){}
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/setConsent/index.js",
          "settings": {
            "consent": [
              {
                "value": "%Rule | consent%",
                "version": "2.0",
                "standard": "Adobe"
              }
            ],
            "instanceName": "alloy",
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL87c15882950f478e99d7f8747e933d7f",
      "name": "MO | AA | A/B Test | DCevent - moTesta/b",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "moTesta/b"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  _satellite.getVar("pageView code"); 
return true;


}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%a/b test XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RL9806c6423af24985963dc89fd731ee34",
      "name": "MO | ACDL | Set data element | websdk - events",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "event"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "momang"
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCb0c6a9692dea42baaf35242315f5926e-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLa0877efa94f745399c0306a14a8c16f3",
      "name": "AA | Activate Spelpaus | DCevent - activateSpaus",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "activateSpaus"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%activate spelpaus XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLa4ceb9070b86472a93743a5ae6556303",
      "name": "MO | AA | Customer Registration Success | event - reg",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "reg"
          },
          "ruleOrder": 10.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _data = event.message.data,
    _site = _data.site.name,
    _labData = "",
    _lab = _data.label;
    _satellite.getVar("decCookie code"); 
  if (_site == 'momang') { 
    _satellite.getVar("pageView code"); 
    if (_lab != undefined || _lab != "") {
      if (_lab == "new_bankid" || _lab == "retail_bankid" || _lab == "new_freja" || _lab == "retail_freja") {
        _labData = _lab.split("_");
        _satellite.setVar("registration: type1", _labData[0]);
        _satellite.setVar("registration: method1", _labData[1]);
        return true;
      }
    }
  } else {
    _satellite.logger.log(" momang site not true ");
    return false;
  }
} catch (e) {}
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%registration success XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLa79f7d5456964552be58354fe4823051",
      "name": "AA | Users | Registration Start | event - reg websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "reg"
          },
          "ruleOrder": 5.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  var _data = event.message.data,
  _site = _data.site.name;
if (_site == 'spela' || _site == 'applb') {
  var _act = _data.action,
    _lab = _data.label;
  if (_lab != undefined || _lab != "") {
    if (_lab == "started_new_customer_bankid" || _lab == "started_retail_customer_bankid" || _lab == "started_new_customer_freja" || _lab == "started_retail_customer_freja") {
      var data = _lab.split("_");
      _satellite.setVar("registration: type", data[1]);
      _satellite.setVar("registration: method", data[3]);
      return true;
    }
  }
} else return false;
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%registration started XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLa9cf939a41254c359a8059136fedb3c6",
      "name": "AA | A/B Test | DCevent - testa/b",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "testa/b"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  _satellite.getVar("pageView code"); 
return true;


}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%a/b test XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLb4c5eb293d62401c87871d8bc2138b00",
      "name": "AA | Betslip Complete | DCevent - betslipComplete",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "betslipComplete"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%betslip complete XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLb650ce9a06eb4d6fa237f93a9b5bdb41",
      "name": "ACDL | Qualtrics | AllTime | DC Event (production)",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "qTriggerAllTimes"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-12-11T01:00:00Z",
            "start": "2023-11-23T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^PROD$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/sampling.js",
          "settings": {
            "rate": 1
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_2aDLvC1gL9CQg2q"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC41a6fea29c8347d193745ff9e9edff17-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLb8db6420cf614fdb988a58130de694b4",
      "name": "AA | TipsSM | All actions | DCevent - tipsSM",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "tipsSM"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%tips sm XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLbfef89941bdc4aa49c3f44393d03b888",
      "name": "ACDL | Qualtrics | DC Event (production)",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "qualtricsTrigger"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-12-08T01:00:00Z",
            "start": "2023-11-23T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^PROD$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$|momang$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/sampling.js",
          "settings": {
            "rate": 0.3
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_2aDLvC1gL9CQg2q"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RCaf2ee00bd5f64db99e7a65ea82375b8f-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLc8507975ae364c539dad3cce2b43e599",
      "name": "AA | Deposit Decrease | DCevent - depositDecrease",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "depositDecrease"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC609dc695b2b94c0c8eac619b950b63bf-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit limit decrease XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLcff3014c0ecf498982f2ad5a46ae60ef",
      "name": "AA | Menu click | DCevent - menuClick",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "menuClick"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%menuClick XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLd3bba13ede2841638da7180b2d736d3b",
      "name": "MO | AA | Deposit Increase | DCevent - modepositIncrease",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "modepositIncrease"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC3ffeba396f4e4ae8a586cf090bc41642-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%deposit limit increase XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLd5040b078b8d41ce897dd727713d8052",
      "name": "ACDL | Qualtrics | eddlChangedpageView (production)",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "pageView"
          },
          "ruleOrder": 51.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/dateRange.js",
          "settings": {
            "end": "2023-12-08T01:00:00Z",
            "start": "2023-11-23T01:00:00Z"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%ACDL AA suite%",
            "rightOperand": "^PROD$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%ACDL | Consent | QualtricsOk%"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%Content | Site%",
            "rightOperand": "^spela$|applb$"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _pCheckTB = _satellite.getVar('ACDL | Qualtrics')[3],
      _pCheckCasino = _satellite.getVar('ACDL | Qualtrics')[1]; 

  if (_pCheckTB != 'Trav och galopp' && _pCheckTB != 'Bingo' && _pCheckTB != 'Challenge' && _pCheckCasino != 'Live Casino' &&  _pCheckCasino != 'Momang Live Casino' && _pCheckCasino != 'Momang Casino') {
    return true
    } else {
      return false
    }
} catch (e) {}

}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%CXDB | listed url%",
            "rightOperand": "true"
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
try {
  var _data1 = adobeDataLayer.getState().data,
      extRef = _data1.user ?_data1.user.userId? _data1.user.userId: "": "";


  if (typeof QSI === "undefined") {
    QSI = {};
    QSI.config = {
      externalReference: extRef
    };
  } else if (QSI) {
    if (QSI.config) {
      QSI.config.externalReference = extRef;
    } else {
      QSI.config = {};
      QSI.config.externalReference = extRef;
    }
  }
} catch (e) {}
return true;
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/sampling.js",
          "settings": {
            "rate": 0.3
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "qualtrics-website-feedback/src/lib/actions/loadProject.js",
          "settings": {
            "brandID": "svenskaspelsoc",
            "projectID": "ZN_2aDLvC1gL9CQg2q"
          },
          "timeout": 2000,
          "delayNext": true
        },
        {
          "modulePath": "core/src/lib/actions/customCode.js",
          "settings": {
            "source": 'https://assets.adobedtm.com/de1cfb1de36f/36f9d843b2a3/0b7f473d22c8/RC9a6693ca1408478ebd049147b3547915-source.js',
            "language": "javascript",
            "isExternal": true
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLd85d89fa4825425283138cce1d961f02",
      "name": "MO | AA | Users | Registration Start | event - reg websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "reg"
          },
          "ruleOrder": 5.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  var _data = event.message.data,
  _site = _data.site.name;
if (_site == 'momang') {
  var _act = _data.action,
    _lab = _data.label;
  if (_lab != undefined || _lab != "") {
    if (_lab == "started_new_customer_bankid" || _lab == "started_retail_customer_bankid" || _lab == "started_new_customer_freja" || _lab == "started_retail_customer_freja") {
      var data = _lab.split("_");
      _satellite.setVar("registration: type", data[1]);
      _satellite.setVar("registration: method", data[3]);
      return true;
    }
  }
} else return false;
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%registration started XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLe425d9c21232471a8eefeaae5b9454f9",
      "name": "AA | Content | Page View | pageView websdk",
      "events": [
        {
          "modulePath": "gcoe-adobe-client-data-layer/src/lib/events/datalayerPushListener.js",
          "settings": {
            "scope": "all",
            "method": "specificEvent",
            "eventKey": "pageView"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _data = event.message.data,
      _site = _data.site.name;
 if (_site == 'spela' || _site == 'applb') { 
  var  _acon = _data.consent.analyticsBrowser,
    _pcon = _data.consent.personalizedBrowser,
    _pccon = _data.consent.personalizedCustomer;
 if (_acon == true && _pcon == true) { 
      if (_pccon != false) {
          return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
 }
} catch (e) {}
}
          },
          "timeout": 2000
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _data = adobeDataLayer.getState().data,
    pid = decodeURIComponent(_data.page.url.toLowerCase()),
    _url = decodeURIComponent(_data.page.url.toLowerCase()),
    _pagename = _data.page.name.toLowerCase();

  function _pv() {
    sessionStorage.setItem("s_gpv", _pagename)
  }

  function _getpv(_a) {
    return sessionStorage.getItem(_a)
  }
  var getqpv = _getpv("s_gpv"),
    _reg = _getpv("reg_s"); 
  if (getqpv == undefined || getqpv == null) { 
    _pv();
    _satellite.setVar("Rule | PreviousValue", _pagename);
  } else {
    _satellite.setVar("Rule | PreviousValue", getqpv);
    _pv();
  }
  if (_reg != undefined || _reg != null) { 
    sessionStorage.removeItem("reg_s"); 
    _labData = _reg.split("_");
    var _obj = {
      "completed": 1,
      "method": _labData[1],
      "type": _labData[0]
    };
    _satellite.setVar("registration obj", _obj);
  }
  pid = pid.substring(0, (c = pid.indexOf("?")) > -1 ? c : pid.length);
  var cat = pid.split('/');
  if (pid == "/") {
    cat[1] = cat[2] = "home";
  }
  _satellite.setVar("site section: level1", cat[1] ? cat[1] : "");
  _satellite.setVar("site section: level2", cat[2] ? cat[2] : cat[1] ? cat[1] : "");
  _satellite.setVar("site section: pageID", pid);

  var regex1 = new RegExp(/.*:mina-spel:[0-9]+:[0-9]+/g),
    regex2 = new RegExp(/.*:mina-spel:[0-9]+/g),
    pn = _pagename;
  var _res1 = regex1.exec(pn),
    _res2 = regex2.exec(pn);
  if (pn != "" && (pn.indexOf("logga-in:bankid:poll") != -1 || pn.indexOf(":avslutat-spel") != -1 || pn.indexOf(":pagaende") != -1 || _res1 || _res2)) {
    _res1 = _res2 = undefined;
    return false;
  }
  var _pageregex1 = new RegExp('^[\/]\s|^[\/]\?.*');
  if (typeof(pn) == undefined && _pageregex1.test(_url)) {
    return false;
  }
  return true;
} catch (e) {
  _satellite.logger.log(e);
}
return true;
}
          },
          "timeout": 2000
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%pageview XDM map%",
            "data": "%ACDL Data object%",
            "type": "web.webpagedetails.pageViews",
            "instanceName": "alloy",
            "edgeConfigOverrides": {
              "development": {
              }
            }
          }
        }
      ]
    },
    {
      "id": "RLf6ec54ddad8c40d7b5c4acc4bd3955ac",
      "name": "AA | Login Success | DCevent - loginSuccess",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "loginSuccess"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%login success XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          }
        }
      ]
    },
    {
      "id": "RLf7bf8d72c9954014b9523a8997792cb0",
      "name": "MO | AA | Activate Spelpaus | DCevent - moactivateSpaus",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "moactivateSpaus"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%activate spelpaus XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    },
    {
      "id": "RLffe4abcc575149819ab7e3f9117348fa",
      "name": "AA | Login Failure | DCevent - loginFailure",
      "events": [
        {
          "modulePath": "core/src/lib/events/directCall.js",
          "settings": {
            "identifier": "loginFailure"
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [

      ],
      "actions": [
        {
          "modulePath": "adobe-alloy/dist/lib/actions/sendEvent/index.js",
          "settings": {
            "xdm": "%login failure XDM map%",
            "type": "web.webinteraction.linkClicks",
            "instanceName": "alloy",
            "documentUnloading": true,
            "edgeConfigOverrides": {
              "development": {
              }
            }
          },
          "timeout": 2000,
          "delayNext": true
        }
      ]
    }
  ]
}
})();

var _satellite = (function () {
	'use strict';

	if (!window.atob) { console.warn('Adobe Launch is unsupported in IE 9 and below.'); return; }

	var reactorDocument = document;

	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}


			var test1 = new String('abc');  
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			return false;
		}
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty$1.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};

	var reactorObjectAssign = objectAssign;

	var reactorWindow = window;


	var createDynamicHostResolver = function (
	  turbineEmbedCode,
	  dynamicCdnEnabled,
	  cdnAllowList,
	  debugController
	) {
	  var isDynamicEnforced = Boolean(
	    dynamicCdnEnabled && Array.isArray(cdnAllowList)
	  );
	  var shouldAugment = Boolean(isDynamicEnforced && turbineEmbedCode);

	  var turbineUrl = document.createElement('a');
	  if (isDynamicEnforced) {
	    var throwUnavailableEmbedCode = function () {
	      var missingEmbedCodeError = new Error(
	        'Unable to find the Library Embed Code for Dynamic Host Resolution.'
	      );
	      missingEmbedCodeError.code = 'dynamic_host_resolver_constructor_error';
	      throw missingEmbedCodeError;
	    };
	    if (turbineEmbedCode) {
	      if (!/^((https?:)?\/\/).+/.test(turbineEmbedCode)) {
	        throwUnavailableEmbedCode();
	      }
	      if (/^\/\/.+/.test(turbineEmbedCode)) {
	        turbineUrl.href = reactorWindow.location.protocol + turbineEmbedCode;
	      } else {
	        turbineUrl.href = turbineEmbedCode;
	      }
	    }

	    if (!turbineUrl.hostname) {
	      throwUnavailableEmbedCode();
	    }
	    if (cdnAllowList.indexOf(turbineUrl.hostname) === -1) {
	      var dynamicDeniedError = new Error(
	        'This library is not authorized for this domain. ' +
	          'Please contact your CSM for more information.'
	      );
	      dynamicDeniedError.code = 'dynamic_host_not_allowed';
	      throw dynamicDeniedError;
	    }
	  }

	  var memoizedHostResult;
	  var getTurbineHost = function () {
	    if (memoizedHostResult != null) {
	      return memoizedHostResult;
	    }

	    if (shouldAugment) {
	      var sanitizedHost = turbineUrl.host;
	      if (/:80$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':80', '');
	      } else if (/:80\/$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':80/', '');
	      } else if (/:443$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':443', '');
	      } else if (/:443\/$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':443/', '');
	      }

	      memoizedHostResult = turbineUrl.protocol + '//' + sanitizedHost;
	    } else {
	      memoizedHostResult = '';
	    }

	    return memoizedHostResult;
	  };

	  var decorateWithDynamicHost = function (sourceUrl) {
	    if (shouldAugment && typeof sourceUrl === 'string') {
	      var urlParts = [
	        getTurbineHost(),
	        sourceUrl.charAt(0) === '/' ? sourceUrl.slice(1) : sourceUrl
	      ];

	      return urlParts.join('/');
	    }

	    return sourceUrl;
	  };

	  var dynamicHostResolver = {
	    getTurbineHost: getTurbineHost,
	    decorateWithDynamicHost: decorateWithDynamicHost,
	    get isDynamicEnforced() {
	      return isDynamicEnforced;
	    }
	  };

	  if (reactorWindow) {
	    debugController.onDebugChanged(function (isEnabled) {
	      if (isEnabled) {
	        reactorWindow.dynamicHostResolver = dynamicHostResolver;
	      } else {
	        delete reactorWindow.dynamicHostResolver;
	      }
	    });
	  }

	  return dynamicHostResolver;
	};

	var buildRuleExecutionOrder = function (rules) {
	  var ruleEventPairs = [];

	  rules.forEach(function (rule) {
	    if (rule.events) {
	      rule.events.forEach(function (event) {
	        ruleEventPairs.push({
	          rule: rule,
	          event: event
	        });
	      });
	    }
	  });

	  return ruleEventPairs.sort(function (ruleEventPairA, ruleEventPairB) {
	    return ruleEventPairA.event.ruleOrder - ruleEventPairB.event.ruleOrder;
	  });
	};

	var DEBUG_LOCAL_STORAGE_NAME = 'debug';

	var createDebugController = function (localStorage, logger) {
	  var getPersistedDebugEnabled = function () {
	    return localStorage.getItem(DEBUG_LOCAL_STORAGE_NAME) === 'true';
	  };

	  var setPersistedDebugEnabled = function (enabled) {
	    localStorage.setItem(DEBUG_LOCAL_STORAGE_NAME, enabled);
	  };

	  var debugChangedCallbacks = [];
	  var onDebugChanged = function (callback) {
	    debugChangedCallbacks.push(callback);
	  };

	  logger.outputEnabled = getPersistedDebugEnabled();

	  return {
	    onDebugChanged: onDebugChanged,
	    getDebugEnabled: getPersistedDebugEnabled,
	    setDebugEnabled: function (enabled) {
	      if (getPersistedDebugEnabled() !== enabled) {
	        setPersistedDebugEnabled(enabled);
	        logger.outputEnabled = enabled;
	        debugChangedCallbacks.forEach(function (callback) {
	          callback(enabled);
	        });
	      }
	    }
	  };
	};

	var MODULE_NOT_FUNCTION_ERROR = 'Module did not export a function.';

	var createExecuteDelegateModule = function (
	  moduleProvider,
	  replaceTokens,
	  settingsFileTransformer
	) {
	  return function (moduleDescriptor, syntheticEvent, moduleCallParameters) {
	    moduleCallParameters = moduleCallParameters || [];
	    var moduleExports = moduleProvider.getModuleExports(
	      moduleDescriptor.modulePath
	    );

	    if (typeof moduleExports !== 'function') {
	      throw new Error(MODULE_NOT_FUNCTION_ERROR);
	    }

	    var moduleDefinition = moduleProvider.getModuleDefinition(
	      moduleDescriptor.modulePath
	    );

	    var moduleSettings = moduleDescriptor.settings || {};
	    if (
	      !moduleDescriptor.hasTransformedFilePaths &&
	      moduleDefinition.filePaths
	    ) {
	      settingsFileTransformer(
	        moduleSettings,
	        moduleDefinition.filePaths,
	        moduleDescriptor.modulePath
	      );
	      moduleDescriptor.hasTransformedFilePaths = true;
	    }

	    var moduleDescriptorSettings = replaceTokens(
	      moduleSettings,
	      syntheticEvent
	    );
	    return moduleExports
	      .bind(null, moduleDescriptorSettings)
	      .apply(null, moduleCallParameters);
	  };
	};

	var cleanText = function (str) {
	  return typeof str === 'string' ? str.replace(/\s+/g, ' ').trim() : str;
	};

	var levels = {
	  LOG: 'log',
	  INFO: 'info',
	  DEBUG: 'debug',
	  WARN: 'warn',
	  ERROR: 'error'
	};

	var ROCKET = '\uD83D\uDE80';

	var ieVersion = parseInt(
	  (/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]
	);

	var launchPrefix = ieVersion === 10 ? '[Launch]' : ROCKET;

	var outputEnabled = false;

	var process = function (level) {
	  if (outputEnabled && window.console) {
	    var logArguments = Array.prototype.slice.call(arguments, 1);
	    logArguments.unshift(launchPrefix);
	    if (level === levels.DEBUG && !window.console[level]) {
	      level = levels.INFO;
	    }
	    window.console[level].apply(window.console, logArguments);
	  }
	};

	var log = process.bind(null, levels.LOG);

	var info = process.bind(null, levels.INFO);

	var debug = process.bind(null, levels.DEBUG);

	var warn = process.bind(null, levels.WARN);

	var error = process.bind(null, levels.ERROR);

	var logDeprecation = function () {
	  var wasEnabled = outputEnabled;
	  outputEnabled = true;

	  process.apply(
	    null,
	    Array.prototype.concat(levels.WARN, Array.prototype.slice.call(arguments))
	  );

	  if (!wasEnabled) {
	    outputEnabled = false;
	  }
	};

	var logger = {
	  log: log,
	  info: info,
	  debug: debug,
	  warn: warn,
	  error: error,
	  deprecation: logDeprecation,
	  get outputEnabled() {
	    return outputEnabled;
	  },
	  set outputEnabled(value) {
	    outputEnabled = value;
	  },
	  createPrefixedLogger: function (identifier) {
	    var loggerSpecificPrefix = '[' + identifier + ']';

	    return {
	      log: log.bind(null, loggerSpecificPrefix),
	      info: info.bind(null, loggerSpecificPrefix),
	      debug: debug.bind(null, loggerSpecificPrefix),
	      warn: warn.bind(null, loggerSpecificPrefix),
	      error: error.bind(null, loggerSpecificPrefix)
	    };
	  }
	};


	var NAMESPACE = 'com.adobe.reactor.';

	var getNamespacedStorage = function (storageType, additionalNamespace) {
	  var finalNamespace = NAMESPACE + (additionalNamespace || '');

	  return {
	    getItem: function (name) {
	      try {
	        return reactorWindow[storageType].getItem(finalNamespace + name);
	      } catch (e) {
	        return null;
	      }
	    },
	    setItem: function (name, value) {
	      try {
	        reactorWindow[storageType].setItem(finalNamespace + name, value);
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }
	  };
	};


	var DATA_ELEMENTS_NAMESPACE = 'dataElements.';

	var dataElementSessionStorage = getNamespacedStorage(
	  'sessionStorage',
	  DATA_ELEMENTS_NAMESPACE
	);
	var dataElementLocalStorage = getNamespacedStorage(
	  'localStorage',
	  DATA_ELEMENTS_NAMESPACE
	);

	var storageDurations = {
	  PAGEVIEW: 'pageview',
	  SESSION: 'session',
	  VISITOR: 'visitor'
	};

	var pageviewCache = {};

	var serialize = function (value) {
	  var serialized;

	  try {
	    serialized = JSON.stringify(value);
	  } catch (e) {}

	  return serialized;
	};

	var setValue = function (key, storageDuration, value) {
	  var serializedValue;

	  switch (storageDuration) {
	    case storageDurations.PAGEVIEW:
	      pageviewCache[key] = value;
	      return;
	    case storageDurations.SESSION:
	      serializedValue = serialize(value);
	      if (serializedValue) {
	        dataElementSessionStorage.setItem(key, serializedValue);
	      }
	      return;
	    case storageDurations.VISITOR:
	      serializedValue = serialize(value);
	      if (serializedValue) {
	        dataElementLocalStorage.setItem(key, serializedValue);
	      }
	      return;
	  }
	};

	var getValue = function (key, storageDuration) {
	  var value;

	  switch (storageDuration) {
	    case storageDurations.PAGEVIEW:
	      return pageviewCache.hasOwnProperty(key) ? pageviewCache[key] : null;
	    case storageDurations.SESSION:
	      value = dataElementSessionStorage.getItem(key);
	      return value === null ? value : JSON.parse(value);
	    case storageDurations.VISITOR:
	      value = dataElementLocalStorage.getItem(key);
	      return value === null ? value : JSON.parse(value);
	  }
	};

	var dataElementSafe = {
	  setValue: setValue,
	  getValue: getValue
	};


	var getErrorMessage = function (
	  dataDef,
	  dataElementName,
	  errorMessage,
	  errorStack
	) {
	  return (
	    'Failed to execute data element module ' +
	    dataDef.modulePath +
	    ' for data element ' +
	    dataElementName +
	    '. ' +
	    errorMessage +
	    (errorStack ? '\n' + errorStack : '')
	  );
	};

	var createGetDataElementValue = function (
	  moduleProvider,
	  getDataElementDefinition,
	  replaceTokens,
	  undefinedVarsReturnEmpty,
	  settingsFileTransformer
	) {
	  return function (name, syntheticEvent) {
	    var dataDef = getDataElementDefinition(name);

	    if (!dataDef) {
	      return undefinedVarsReturnEmpty ? '' : undefined;
	    }

	    var storageDuration = dataDef.storageDuration;
	    var moduleExports;
	    var moduleDefinition;

	    try {
	      moduleExports = moduleProvider.getModuleExports(dataDef.modulePath);
	      moduleDefinition = moduleProvider.getModuleDefinition(dataDef.modulePath);
	    } catch (e) {
	      logger.error(getErrorMessage(dataDef, name, e.message, e.stack));
	      return;
	    }

	    if (typeof moduleExports !== 'function') {
	      logger.error(
	        getErrorMessage(dataDef, name, 'Module did not export a function.')
	      );
	      return;
	    }

	    var value;

	    var dataElementSettings = dataDef.settings || {};
	    if (!dataDef.hasTransformedFilePaths && moduleDefinition.filePaths) {
	      settingsFileTransformer(
	        dataElementSettings,
	        moduleDefinition.filePaths,
	        dataDef.modulePath
	      );
	      dataDef.hasTransformedFilePaths = true;
	    }

	    try {
	      value = moduleExports(
	        replaceTokens(dataElementSettings, syntheticEvent),
	        syntheticEvent
	      );
	    } catch (e) {
	      logger.error(getErrorMessage(dataDef, name, e.message, e.stack));
	      return;
	    }

	    if (storageDuration) {
	      if (value != null) {
	        dataElementSafe.setValue(name, storageDuration, value);
	      } else {
	        value = dataElementSafe.getValue(name, storageDuration);
	      }
	    }

	    if (value == null && dataDef.defaultValue != null) {
	      value = dataDef.defaultValue;
	    }

	    if (typeof value === 'string') {
	      if (dataDef.cleanText) {
	        value = cleanText(value);
	      }

	      if (dataDef.forceLowerCase) {
	        value = value.toLowerCase();
	      }
	    }

	    return value;
	  };
	};


	var specialPropertyAccessors = {
	  text: function (obj) {
	    return obj.textContent;
	  },
	  cleanText: function (obj) {
	    return cleanText(obj.textContent);
	  }
	};

	var getObjectProperty = function (host, propChain, supportSpecial) {
	  var value = host;
	  var attrMatch;
	  for (var i = 0, len = propChain.length; i < len; i++) {
	    if (value == null) {
	      return undefined;
	    }
	    var prop = propChain[i];
	    if (supportSpecial && prop.charAt(0) === '@') {
	      var specialProp = prop.slice(1);
	      value = specialPropertyAccessors[specialProp](value);
	      continue;
	    }
	    if (
	      value.getAttribute &&
	      (attrMatch = prop.match(/^getAttribute\((.+)\)$/))
	    ) {
	      var attr = attrMatch[1];
	      value = value.getAttribute(attr);
	      continue;
	    }
	    value = value[prop];
	  }
	  return value;
	};

	var createGetVar = function (
	  customVars,
	  getDataElementDefinition,
	  getDataElementValue
	) {
	  return function (variable, syntheticEvent) {
	    var value;

	    if (getDataElementDefinition(variable)) {
	      value = getDataElementValue(variable, syntheticEvent);
	    } else {
	      var propChain = variable.split('.');
	      var variableHostName = propChain.shift();

	      if (variableHostName === 'this') {
	        if (syntheticEvent) {
	          value = getObjectProperty(syntheticEvent.element, propChain, true);
	        }
	      } else if (variableHostName === 'event') {
	        if (syntheticEvent) {
	          value = getObjectProperty(syntheticEvent, propChain);
	        }
	      } else if (variableHostName === 'target') {
	        if (syntheticEvent) {
	          value = getObjectProperty(syntheticEvent.target, propChain);
	        }
	      } else {
	        value = getObjectProperty(customVars[variableHostName], propChain);
	      }
	    }

	    return value;
	  };
	};

	var createIsVar = function (customVars, getDataElementDefinition) {
	  return function (variableName) {
	    var nameBeforeDot = variableName.split('.')[0];

	    return Boolean(
	      getDataElementDefinition(variableName) ||
	        nameBeforeDot === 'this' ||
	        nameBeforeDot === 'event' ||
	        nameBeforeDot === 'target' ||
	        customVars.hasOwnProperty(nameBeforeDot)
	    );
	  };
	};

	var extractModuleExports = function (script, require, turbine) {
	  var module = {
	    exports: {}
	  };

	  script.call(module.exports, module, module.exports, require, turbine);

	  return module.exports;
	};


	var createModuleProvider = function () {
	  var moduleByReferencePath = {};

	  var getModule = function (referencePath) {
	    var module = moduleByReferencePath[referencePath];

	    if (!module) {
	      throw new Error('Module ' + referencePath + ' not found.');
	    }

	    return module;
	  };

	  var registerModule = function (
	    referencePath,
	    moduleDefinition,
	    extensionName,
	    require,
	    turbine
	  ) {
	    var module = {
	      definition: moduleDefinition,
	      extensionName: extensionName,
	      require: require,
	      turbine: turbine
	    };
	    module.require = require;
	    moduleByReferencePath[referencePath] = module;
	  };

	  var hydrateCache = function () {
	    Object.keys(moduleByReferencePath).forEach(function (referencePath) {
	      try {
	        getModuleExports(referencePath);
	      } catch (e) {
	        var errorMessage =
	          'Error initializing module ' +
	          referencePath +
	          '. ' +
	          e.message +
	          (e.stack ? '\n' + e.stack : '');
	        logger.error(errorMessage);
	      }
	    });
	  };

	  var getModuleExports = function (referencePath) {
	    var module = getModule(referencePath);

	    if (!module.hasOwnProperty('exports')) {
	      module.exports = extractModuleExports(
	        module.definition.script,
	        module.require,
	        module.turbine
	      );
	    }

	    return module.exports;
	  };

	  var getModuleDefinition = function (referencePath) {
	    return getModule(referencePath).definition;
	  };

	  var getModuleExtensionName = function (referencePath) {
	    return getModule(referencePath).extensionName;
	  };

	  return {
	    registerModule: registerModule,
	    hydrateCache: hydrateCache,
	    getModuleExports: getModuleExports,
	    getModuleDefinition: getModuleDefinition,
	    getModuleExtensionName: getModuleExtensionName
	  };
	};


	var warningLogged = false;

	var createNotifyMonitors = function (_satellite) {
	  return function (type, event) {
	    var monitors = _satellite._monitors;

	    if (monitors) {
	      if (!warningLogged) {
	        logger.warn(
	          'The _satellite._monitors API may change at any time and should only ' +
	            'be used for debugging.'
	        );
	        warningLogged = true;
	      }

	      monitors.forEach(function (monitor) {
	        if (monitor[type]) {
	          monitor[type](event);
	        }
	      });
	    }
	  };
	};


	var createReplaceTokens = function (isVar, getVar, undefinedVarsReturnEmpty) {
	  var replaceTokensInString;
	  var replaceTokensInObject;
	  var replaceTokensInArray;
	  var replaceTokens;
	  var variablesBeingRetrieved = [];

	  var getVarValue = function (token, variableName, syntheticEvent) {
	    if (!isVar(variableName)) {
	      return token;
	    }

	    variablesBeingRetrieved.push(variableName);
	    var val = getVar(variableName, syntheticEvent);
	    variablesBeingRetrieved.pop();
	    return val == null && undefinedVarsReturnEmpty ? '' : val;
	  };

	  replaceTokensInString = function (str, syntheticEvent) {
	    var result = /^%([^%]+)%$/.exec(str);

	    if (result) {
	      return getVarValue(str, result[1], syntheticEvent);
	    } else {
	      return str.replace(/%(.+?)%/g, function (token, variableName) {
	        return getVarValue(token, variableName, syntheticEvent);
	      });
	    }
	  };

	  replaceTokensInObject = function (obj, syntheticEvent) {
	    var ret = {};
	    var keys = Object.keys(obj);
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      ret[key] = replaceTokens(value, syntheticEvent);
	    }
	    return ret;
	  };

	  replaceTokensInArray = function (arr, syntheticEvent) {
	    var ret = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      ret.push(replaceTokens(arr[i], syntheticEvent));
	    }
	    return ret;
	  };

	  replaceTokens = function (thing, syntheticEvent) {
	    if (typeof thing === 'string') {
	      return replaceTokensInString(thing, syntheticEvent);
	    } else if (Array.isArray(thing)) {
	      return replaceTokensInArray(thing, syntheticEvent);
	    } else if (typeof thing === 'object' && thing !== null) {
	      return replaceTokensInObject(thing, syntheticEvent);
	    }

	    return thing;
	  };

	  return function (thing, syntheticEvent) {
	    if (variablesBeingRetrieved.length > 10) {
	      logger.error(
	        'Data element circular reference detected: ' +
	          variablesBeingRetrieved.join(' -> ')
	      );
	      return thing;
	    }

	    return replaceTokens(thing, syntheticEvent);
	  };
	};

	var createSetCustomVar = function (customVars) {
	  return function () {
	    if (typeof arguments[0] === 'string') {
	      customVars[arguments[0]] = arguments[1];
	    } else if (arguments[0]) {
	      var mapping = arguments[0];
	      for (var key in mapping) {
	        customVars[key] = mapping[key];
	      }
	    }
	  };
	};

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getAugmentedNamespace(n) {
		if (n.__esModule) return n;
		var a = Object.defineProperty({}, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	function createCommonjsModule(fn) {
	  var module = { exports: {} };
		return fn(module, module.exports), module.exports;
	}

	function finallyConstructor(callback) {
	  var constructor = this.constructor;
	  return this.then(
	    function(value) {
	      return constructor.resolve(callback()).then(function() {
	        return value;
	      });
	    },
	    function(reason) {
	      return constructor.resolve(callback()).then(function() {
	        return constructor.reject(reason);
	      });
	    }
	  );
	}

	var setTimeoutFunc = setTimeout;

	function isArray(x) {
	  return Boolean(x && typeof x.length !== 'undefined');
	}

	function noop() {}

	function bind(fn, thisArg) {
	  return function() {
	    fn.apply(thisArg, arguments);
	  };
	}

	function Promise$1(fn) {
	  if (!(this instanceof Promise$1))
	    throw new TypeError('Promises must be constructed via new');
	  if (typeof fn !== 'function') throw new TypeError('not a function');
	  this._state = 0;
	  this._handled = false;
	  this._value = undefined;
	  this._deferreds = [];

	  doResolve(fn, this);
	}

	function handle(self, deferred) {
	  while (self._state === 3) {
	    self = self._value;
	  }
	  if (self._state === 0) {
	    self._deferreds.push(deferred);
	    return;
	  }
	  self._handled = true;
	  Promise$1._immediateFn(function() {
	    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	      return;
	    }
	    var ret;
	    try {
	      ret = cb(self._value);
	    } catch (e) {
	      reject(deferred.promise, e);
	      return;
	    }
	    resolve(deferred.promise, ret);
	  });
	}

	function resolve(self, newValue) {
	  try {
	    if (newValue === self)
	      throw new TypeError('A promise cannot be resolved with itself.');
	    if (
	      newValue &&
	      (typeof newValue === 'object' || typeof newValue === 'function')
	    ) {
	      var then = newValue.then;
	      if (newValue instanceof Promise$1) {
	        self._state = 3;
	        self._value = newValue;
	        finale(self);
	        return;
	      } else if (typeof then === 'function') {
	        doResolve(bind(then, newValue), self);
	        return;
	      }
	    }
	    self._state = 1;
	    self._value = newValue;
	    finale(self);
	  } catch (e) {
	    reject(self, e);
	  }
	}

	function reject(self, newValue) {
	  self._state = 2;
	  self._value = newValue;
	  finale(self);
	}

	function finale(self) {
	  if (self._state === 2 && self._deferreds.length === 0) {
	    Promise$1._immediateFn(function() {
	      if (!self._handled) {
	        Promise$1._unhandledRejectionFn(self._value);
	      }
	    });
	  }

	  for (var i = 0, len = self._deferreds.length; i < len; i++) {
	    handle(self, self._deferreds[i]);
	  }
	  self._deferreds = null;
	}

	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}

	function doResolve(fn, self) {
	  var done = false;
	  try {
	    fn(
	      function(value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      },
	      function(reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      }
	    );
	  } catch (ex) {
	    if (done) return;
	    done = true;
	    reject(self, ex);
	  }
	}

	Promise$1.prototype['catch'] = function(onRejected) {
	  return this.then(null, onRejected);
	};

	Promise$1.prototype.then = function(onFulfilled, onRejected) {
	  var prom = new this.constructor(noop);

	  handle(this, new Handler(onFulfilled, onRejected, prom));
	  return prom;
	};

	Promise$1.prototype['finally'] = finallyConstructor;

	Promise$1.all = function(arr) {
	  return new Promise$1(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.all accepts an array'));
	    }

	    var args = Array.prototype.slice.call(arr);
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;

	    function res(i, val) {
	      try {
	        if (val && (typeof val === 'object' || typeof val === 'function')) {
	          var then = val.then;
	          if (typeof then === 'function') {
	            then.call(
	              val,
	              function(val) {
	                res(i, val);
	              },
	              reject
	            );
	            return;
	          }
	        }
	        args[i] = val;
	        if (--remaining === 0) {
	          resolve(args);
	        }
	      } catch (ex) {
	        reject(ex);
	      }
	    }

	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};

	Promise$1.resolve = function(value) {
	  if (value && typeof value === 'object' && value.constructor === Promise$1) {
	    return value;
	  }

	  return new Promise$1(function(resolve) {
	    resolve(value);
	  });
	};

	Promise$1.reject = function(value) {
	  return new Promise$1(function(resolve, reject) {
	    reject(value);
	  });
	};

	Promise$1.race = function(arr) {
	  return new Promise$1(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.race accepts an array'));
	    }

	    for (var i = 0, len = arr.length; i < len; i++) {
	      Promise$1.resolve(arr[i]).then(resolve, reject);
	    }
	  });
	};

	Promise$1._immediateFn =
	  (typeof setImmediate === 'function' &&
	    function(fn) {
	      setImmediate(fn);
	    }) ||
	  function(fn) {
	    setTimeoutFunc(fn, 0);
	  };

	Promise$1._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	  if (typeof console !== 'undefined' && console) {
	    console.warn('Possible Unhandled Promise Rejection:', err); 
	  }
	};

	var src$1 = Object.freeze({
		__proto__: null,
		'default': Promise$1
	});

	var require$$0 = getAugmentedNamespace(src$1);


	var reactorPromise =
	  (typeof window !== 'undefined' && window.Promise) ||
	  (typeof commonjsGlobal !== 'undefined' && commonjsGlobal.Promise) ||
	  require$$0.default ||
	  require$$0;


	var createAddActionToQueue = function (
	  executeDelegateModule,
	  normalizeRuleComponentError,
	  logActionError
	) {
	  return function (action, rule, syntheticEvent, lastPromiseInQueue) {
	    return lastPromiseInQueue.then(function () {

	      var delayNextAction = action.delayNext;
	      var actionTimeoutId;

	      return new reactorPromise(function (resolve, reject) {
	        var moduleResult = executeDelegateModule(action, syntheticEvent, [
	          syntheticEvent
	        ]);

	        if (!delayNextAction) {
	          return resolve();
	        }

	        var promiseTimeoutMs = action.timeout;
	        var timeoutPromise = new reactorPromise(function (resolve, reject) {
	          actionTimeoutId = setTimeout(function () {
	            reject(
	              new Error(
	                'A timeout occurred because the action took longer than ' +
	                  promiseTimeoutMs / 1000 +
	                  ' seconds to complete. '
	              )
	            );
	          }, promiseTimeoutMs);
	        });

	        reactorPromise.race([moduleResult, timeoutPromise]).then(resolve, reject);
	      })
	        .catch(function (e) {
	          clearTimeout(actionTimeoutId);
	          e = normalizeRuleComponentError(e);
	          logActionError(action, rule, e);
	          return reactorPromise.reject(e);
	        })
	        .then(function () {
	          clearTimeout(actionTimeoutId);
	        });
	    });
	  };
	};


	var createAddConditionToQueue = function (
	  executeDelegateModule,
	  normalizeRuleComponentError,
	  isConditionMet,
	  logConditionError,
	  logConditionNotMet
	) {
	  return function (condition, rule, syntheticEvent, lastPromiseInQueue) {
	    return lastPromiseInQueue.then(function () {
	      var conditionTimeoutId;

	      return new reactorPromise(function (resolve, reject) {
	        var moduleResult = executeDelegateModule(condition, syntheticEvent, [
	          syntheticEvent
	        ]);

	        var promiseTimeoutMs = condition.timeout;
	        var timeoutPromise = new reactorPromise(function (resolve, reject) {
	          conditionTimeoutId = setTimeout(function () {
	            reject(
	              new Error(
	                'A timeout occurred because the condition took longer than ' +
	                  promiseTimeoutMs / 1000 +
	                  ' seconds to complete. '
	              )
	            );
	          }, promiseTimeoutMs);
	        });

	        reactorPromise.race([moduleResult, timeoutPromise]).then(resolve, reject);
	      })
	        .catch(function (e) {
	          clearTimeout(conditionTimeoutId);
	          e = normalizeRuleComponentError(e);
	          logConditionError(condition, rule, e);
	          return reactorPromise.reject(e);
	        })
	        .then(function (result) {
	          clearTimeout(conditionTimeoutId);
	          if (!isConditionMet(condition, result)) {
	            logConditionNotMet(condition, rule);
	            return reactorPromise.reject();
	          }
	        });
	    });
	  };
	};


	var lastPromiseInQueue = reactorPromise.resolve();

	var createAddRuleToQueue = function (
	  addConditionToQueue,
	  addActionToQueue,
	  logRuleCompleted
	) {
	  return function (rule, syntheticEvent) {
	    if (rule.conditions) {
	      rule.conditions.forEach(function (condition) {
	        lastPromiseInQueue = addConditionToQueue(
	          condition,
	          rule,
	          syntheticEvent,
	          lastPromiseInQueue
	        );
	      });
	    }

	    if (rule.actions) {
	      rule.actions.forEach(function (action) {
	        lastPromiseInQueue = addActionToQueue(
	          action,
	          rule,
	          syntheticEvent,
	          lastPromiseInQueue
	        );
	      });
	    }

	    lastPromiseInQueue = lastPromiseInQueue.then(function () {
	      logRuleCompleted(rule);
	    });

	    lastPromiseInQueue = lastPromiseInQueue.catch(function () {});

	    return lastPromiseInQueue;
	  };
	};

	var isPromiseLike = function (value) {
	  return Boolean(
	    value && typeof value === 'object' && typeof value.then === 'function'
	  );
	};


	var createEvaluateConditions = function (
	  executeDelegateModule,
	  isConditionMet,
	  logConditionNotMet,
	  logConditionError
	) {
	  return function (rule, syntheticEvent) {
	    var condition;

	    if (rule.conditions) {
	      for (var i = 0; i < rule.conditions.length; i++) {
	        condition = rule.conditions[i];

	        try {
	          var result = executeDelegateModule(condition, syntheticEvent, [
	            syntheticEvent
	          ]);

	          if (isPromiseLike(result)) {
	            throw new Error(
	              'Rule component sequencing must be enabled on the property ' +
	                'for this condition to function properly.'
	            );
	          }

	          if (!isConditionMet(condition, result)) {
	            logConditionNotMet(condition, rule);
	            return false;
	          }
	        } catch (e) {
	          logConditionError(condition, rule, e);
	          return false;
	        }
	      }
	    }

	    return true;
	  };
	};

	var createExecuteRule = function (evaluateConditions, runActions) {
	  return function (rule, normalizedSyntheticEvent) {
	    if (evaluateConditions(rule, normalizedSyntheticEvent)) {
	      runActions(rule, normalizedSyntheticEvent);
	    }
	  };
	};

	var createGetModuleDisplayNameByRuleComponent = function (moduleProvider) {
	  return function (ruleComponent) {
	    var moduleDefinition = moduleProvider.getModuleDefinition(
	      ruleComponent.modulePath
	    );
	    return (
	      (moduleDefinition && moduleDefinition.displayName) ||
	      ruleComponent.modulePath
	    );
	  };
	};

	var createGetSyntheticEventMeta = function (moduleProvider) {
	  return function (ruleEventPair) {
	    var rule = ruleEventPair.rule;
	    var event = ruleEventPair.event;

	    var moduleName = moduleProvider.getModuleDefinition(event.modulePath).name;
	    var extensionName = moduleProvider.getModuleExtensionName(event.modulePath);

	    return {
	      $type: extensionName + '.' + moduleName,
	      $rule: {
	        id: rule.id,
	        name: rule.name
	      }
	    };
	  };
	};

	var createInitEventModule = function (
	  triggerRule,
	  executeDelegateModule,
	  normalizeSyntheticEvent,
	  getErrorMessage,
	  getSyntheticEventMeta,
	  logger
	) {
	  return function (guardUntilAllInitialized, ruleEventPair) {
	    var rule = ruleEventPair.rule;
	    var event = ruleEventPair.event;
	    event.settings = event.settings || {};

	    try {
	      var syntheticEventMeta = getSyntheticEventMeta(ruleEventPair);

	      executeDelegateModule(event, null, [
	        function trigger(syntheticEvent) {

	          var normalizedSyntheticEvent = normalizeSyntheticEvent(
	            syntheticEventMeta,
	            syntheticEvent
	          );

	          guardUntilAllInitialized(function () {
	            triggerRule(normalizedSyntheticEvent, rule);
	          });
	        }
	      ]);
	    } catch (e) {
	      logger.error(getErrorMessage(event, rule, e));
	    }
	  };
	};

	var createLogActionError = function (
	  getRuleComponentErrorMessage,
	  getModuleDisplayNameByRuleComponent,
	  logger,
	  notifyMonitors
	) {
	  return function (action, rule, e) {
	    var actionDisplayName = getModuleDisplayNameByRuleComponent(action);

	    logger.error(getRuleComponentErrorMessage(actionDisplayName, rule.name, e));

	    notifyMonitors('ruleActionFailed', {
	      rule: rule,
	      action: action
	    });
	  };
	};

	var createLogConditionError = function (
	  getRuleComponentErrorMessage,
	  getModuleDisplayNameByRuleComponent,
	  logger,
	  notifyMonitors
	) {
	  return function (condition, rule, e) {
	    var conditionDisplayName = getModuleDisplayNameByRuleComponent(condition);

	    logger.error(
	      getRuleComponentErrorMessage(conditionDisplayName, rule.name, e)
	    );

	    notifyMonitors('ruleConditionFailed', {
	      rule: rule,
	      condition: condition
	    });
	  };
	};

	var createLogConditionNotMet = function (
	  getModuleDisplayNameByRuleComponent,
	  logger,
	  notifyMonitors
	) {
	  return function (condition, rule) {
	    var conditionDisplayName = getModuleDisplayNameByRuleComponent(condition);

	    logger.log(
	      'Condition "' +
	        conditionDisplayName +
	        '" for rule "' +
	        rule.name +
	        '" was not met.'
	    );

	    notifyMonitors('ruleConditionFailed', {
	      rule: rule,
	      condition: condition
	    });
	  };
	};

	var createLogRuleCompleted = function (logger, notifyMonitors) {
	  return function (rule) {
	    logger.log('Rule "' + rule.name + '" fired.');
	    notifyMonitors('ruleCompleted', {
	      rule: rule
	    });
	  };
	};

	var createRunActions = function (
	  executeDelegateModule,
	  logActionError,
	  logRuleCompleted
	) {
	  return function (rule, syntheticEvent) {
	    var action;

	    if (rule.actions) {
	      for (var i = 0; i < rule.actions.length; i++) {
	        action = rule.actions[i];
	        try {
	          executeDelegateModule(action, syntheticEvent, [syntheticEvent]);
	        } catch (e) {
	          logActionError(action, rule, e);
	          return;
	        }
	      }
	    }

	    logRuleCompleted(rule);
	  };
	};

	var createTriggerRule = function (
	  ruleComponentSequencingEnabled,
	  executeRule,
	  addRuleToQueue,
	  notifyMonitors
	) {
	  return function (normalizedSyntheticEvent, rule) {
	    notifyMonitors('ruleTriggered', {
	      rule: rule
	    });

	    if (ruleComponentSequencingEnabled) {
	      addRuleToQueue(rule, normalizedSyntheticEvent);
	    } else {
	      executeRule(rule, normalizedSyntheticEvent);
	    }
	  };
	};

	var getRuleComponentErrorMessage = function (ruleComponentName, ruleName, error) {
	  return (
	    'Failed to execute "' +
	    ruleComponentName +
	    '" for "' +
	    ruleName +
	    '" rule. ' +
	    error.message +
	    (error.stack ? '\n' + error.stack : '')
	  );
	};

	var isConditionMet = function (condition, result) {
	  return (result && !condition.negate) || (!result && condition.negate);
	};

	var triggerCallQueue = [];
	var eventModulesInitialized = false;

	var guardUntilAllInitialized = function (callback) {
	  if (!eventModulesInitialized) {
	    triggerCallQueue.push(callback);
	  } else {
	    callback();
	  }
	};

	var initRules = function (buildRuleExecutionOrder, rules, initEventModule) {
	  buildRuleExecutionOrder(rules).forEach(function (ruleEventPair) {
	    initEventModule(guardUntilAllInitialized, ruleEventPair);
	  });

	  eventModulesInitialized = true;
	  triggerCallQueue.forEach(function (triggerCall) {
	    triggerCall();
	  });

	  triggerCallQueue = [];
	};

	var normalizeRuleComponentError = function (e) {
	  if (!e) {
	    e = new Error(
	      'The extension triggered an error, but no error information was provided.'
	    );
	  }

	  if (!(e instanceof Error)) {
	    var stringifiedError =
	      typeof e === 'object' ? JSON.stringify(e) : String(e);
	    e = new Error(stringifiedError);
	  }

	  return e;
	};


	var isobject = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};




	function isObjectObject(o) {
	  return isobject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}

	var isPlainObject = function isPlainObject(o) {
	  var ctor,prot;

	  if (isObjectObject(o) === false) return false;

	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;

	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;

	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }

	  return true;
	};


	var normalizeSyntheticEvent = function (syntheticEventMeta, syntheticEvent) {
	  syntheticEvent = syntheticEvent || {};

	  if (isPlainObject(syntheticEvent)) {
	    syntheticEvent = reactorObjectAssign({}, syntheticEvent, syntheticEventMeta);
	  } else {
	    reactorObjectAssign(syntheticEvent, syntheticEventMeta);
	  }

	  if (!syntheticEvent.hasOwnProperty('type')) {
	    Object.defineProperty(syntheticEvent, 'type', {
	      get: function () {
	        logger.deprecation(
	          'Accessing event.type in Adobe Launch has been deprecated and will be ' +
	            'removed soon. Please use event.$type instead.'
	        );
	        return syntheticEvent.$type;
	      }
	    });
	  }

	  return syntheticEvent;
	};

	var createGetSharedModuleExports = function (extensions, moduleProvider) {
	  return function (extensionName, moduleName) {
	    var extension = extensions[extensionName];

	    if (extension) {
	      var modules = extension.modules;
	      if (modules) {
	        var referencePaths = Object.keys(modules);
	        for (var i = 0; i < referencePaths.length; i++) {
	          var referencePath = referencePaths[i];
	          var module = modules[referencePath];
	          if (module.shared && module.name === moduleName) {
	            return moduleProvider.getModuleExports(referencePath);
	          }
	        }
	      }
	    }
	  };
	};

	var createGetExtensionSettings = function (replaceTokens, settings) {
	  return function () {
	    return settings ? replaceTokens(settings) : {};
	  };
	};


	var createGetHostedLibFileUrl = function (
	  decorateWithDynamicHost,
	  hostedLibFilesBaseUrl,
	  minified
	) {
	  return function (file) {
	    if (minified) {
	      var fileParts = file.split('.');
	      fileParts.splice(fileParts.length - 1 || 1, 0, 'min');
	      file = fileParts.join('.');
	    }

	    return decorateWithDynamicHost(hostedLibFilesBaseUrl) + file;
	  };
	};

	var JS_EXTENSION = '.js';

	var dirname = function (path) {
	  return path.substr(0, path.lastIndexOf('/'));
	};

	var endsWith = function (str, suffix) {
	  return str.indexOf(suffix, str.length - suffix.length) !== -1;
	};

	var resolveRelativePath = function (fromPath, relativePath) {
	  if (!endsWith(relativePath, JS_EXTENSION)) {
	    relativePath = relativePath + JS_EXTENSION;
	  }

	  var relativePathSegments = relativePath.split('/');
	  var resolvedPathSegments = dirname(fromPath).split('/');

	  relativePathSegments.forEach(function (relativePathSegment) {
	    if (!relativePathSegment || relativePathSegment === '.') {
	      return;
	    } else if (relativePathSegment === '..') {
	      if (resolvedPathSegments.length) {
	        resolvedPathSegments.pop();
	      }
	    } else {
	      resolvedPathSegments.push(relativePathSegment);
	    }
	  });

	  return resolvedPathSegments.join('/');
	};


	var js_cookie = createCommonjsModule(function (module, exports) {
	(function (factory) {
		var registeredInModuleLoader;
		{
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}

		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}

		function init (converter) {
			function api() {}

			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}

				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}

				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}

					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}

				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}

				var jar = {};
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;

				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');

					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}

					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);

						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}

						jar[name] = cookie;

						if (key === name) {
							break;
						}
					} catch (e) {}
				}

				return key ? jar[key] : jar;
			}

			api.set = set;
			api.get = function (key) {
				return get(key, false );
			};
			api.getJSON = function (key) {
				return get(key, true );
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};

			api.defaults = {};

			api.withConverter = init;

			return api;
		}

		return init(function () {});
	}));
	});




	var reactorCookie = {
	  get: js_cookie.get,
	  set: js_cookie.set,
	  remove: js_cookie.remove
	};




	var getPromise = function(url, script) {
	  return new reactorPromise(function(resolve, reject) {
	    script.onload = function() {
	      resolve(script);
	    };

	    script.onerror = function() {
	      reject(new Error('Failed to load script ' + url));
	    };
	  });
	};

	var reactorLoadScript = function(url) {
	  var script = document.createElement('script');
	  script.src = url;
	  script.async = true;

	  var promise = getPromise(url, script);

	  document.getElementsByTagName('head')[0].appendChild(script);
	  return promise;
	};


	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	var decode = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	};


	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	};

	var encode = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};

	var querystring = createCommonjsModule(function (module, exports) {

	exports.decode = exports.parse = decode;
	exports.encode = exports.stringify = encode;
	});




	var reactorQueryString = {
	  parse: function(string) {
	    if (typeof string === 'string') {
	      string = string.trim().replace(/^[?#&]/, '');
	    }
	    return querystring.parse(string);
	  },
	  stringify: function(object) {
	    return querystring.stringify(object);
	  }
	};


	var CORE_MODULE_PREFIX = '@adobe/reactor-';

	var modules = {
	  cookie: reactorCookie,
	  document: reactorDocument,
	  'load-script': reactorLoadScript,
	  'object-assign': reactorObjectAssign,
	  promise: reactorPromise,
	  'query-string': reactorQueryString,
	  window: reactorWindow
	};

	var createPublicRequire = function (getModuleExportsByRelativePath) {
	  return function (key) {
	    if (key.indexOf(CORE_MODULE_PREFIX) === 0) {
	      var keyWithoutScope = key.substr(CORE_MODULE_PREFIX.length);
	      var module = modules[keyWithoutScope];

	      if (module) {
	        return module;
	      }
	    }

	    if (key.indexOf('./') === 0 || key.indexOf('../') === 0) {
	      return getModuleExportsByRelativePath(key);
	    }

	    throw new Error('Cannot resolve module "' + key + '".');
	  };
	};


	var hydrateModuleProvider = function (
	  container,
	  moduleProvider,
	  debugController,
	  replaceTokens,
	  getDataElementValue,
	  settingsFileTransformer,
	  decorateWithDynamicHost
	) {
	  var extensions = container.extensions;
	  var buildInfo = container.buildInfo;
	  var environment = container.environment;
	  var propertySettings = container.property.settings;

	  if (extensions) {
	    var getSharedModuleExports = createGetSharedModuleExports(
	      extensions,
	      moduleProvider
	    );

	    Object.keys(extensions).forEach(function (extensionName) {
	      var extension = extensions[extensionName];
	      var extensionSettings = extension.settings;
	      if (Array.isArray(extension.filePaths)) {
	        extensionSettings = settingsFileTransformer(
	          extensionSettings,
	          extension.filePaths
	        );
	      }
	      var getExtensionSettings = createGetExtensionSettings(
	        replaceTokens,
	        extensionSettings
	      );

	      if (extension.modules) {
	        var prefixedLogger = logger.createPrefixedLogger(extension.displayName);
	        var getHostedLibFileUrl = createGetHostedLibFileUrl(
	          decorateWithDynamicHost,
	          extension.hostedLibFilesBaseUrl,
	          buildInfo.minified
	        );
	        var turbine = {
	          buildInfo: buildInfo,
	          environment: environment,
	          property: {
	            name: container.property.name,
	            id: container.property.id
	          },
	          getDataElementValue: getDataElementValue,
	          getExtensionSettings: getExtensionSettings,
	          getHostedLibFileUrl: getHostedLibFileUrl,
	          getSharedModule: getSharedModuleExports,
	          logger: prefixedLogger,
	          propertySettings: propertySettings,
	          replaceTokens: replaceTokens,
	          onDebugChanged: debugController.onDebugChanged,
	          get debugEnabled() {
	            return debugController.getDebugEnabled();
	          }
	        };

	        Object.keys(extension.modules).forEach(function (referencePath) {
	          var module = extension.modules[referencePath];
	          var getModuleExportsByRelativePath = function (relativePath) {
	            var resolvedReferencePath = resolveRelativePath(
	              referencePath,
	              relativePath
	            );
	            return moduleProvider.getModuleExports(resolvedReferencePath);
	          };
	          var publicRequire = createPublicRequire(
	            getModuleExportsByRelativePath
	          );

	          moduleProvider.registerModule(
	            referencePath,
	            module,
	            extensionName,
	            publicRequire,
	            turbine
	          );
	        });
	      }
	    });

	    moduleProvider.hydrateCache();
	  }
	  return moduleProvider;
	};


	var hydrateSatelliteObject = function (
	  _satellite,
	  container,
	  setDebugEnabled,
	  getVar,
	  setCustomVar
	) {
	  var customScriptPrefixedLogger = logger.createPrefixedLogger('Custom Script');

	  _satellite.track = function (identifier) {
	    logger.log(
	      '"' + identifier + '" does not match any direct call identifiers.'
	    );
	  };

	  _satellite.getVisitorId = function () {
	    return null;
	  };

	  _satellite.property = {
	    name: container.property.name,
	    id: container.property.id
	  };

	  _satellite.company = container.company;

	  _satellite.buildInfo = container.buildInfo;

	  _satellite.environment = container.environment;

	  _satellite.logger = customScriptPrefixedLogger;

	  _satellite.notify = function (message, level) {
	    logger.deprecation(
	      '_satellite.notify is deprecated. Please use the `_satellite.logger` API.'
	    );

	    switch (level) {
	      case 3:
	        customScriptPrefixedLogger.info(message);
	        break;
	      case 4:
	        customScriptPrefixedLogger.warn(message);
	        break;
	      case 5:
	        customScriptPrefixedLogger.error(message);
	        break;
	      default:
	        customScriptPrefixedLogger.log(message);
	    }
	  };

	  _satellite.getVar = getVar;
	  _satellite.setVar = setCustomVar;

	  _satellite.setCookie = function (name, value, days) {
	    var optionsStr = '';
	    var options = {};

	    if (days) {
	      optionsStr = ', { expires: ' + days + ' }';
	      options.expires = days;
	    }

	    var msg =
	      '_satellite.setCookie is deprecated. Please use ' +
	      '_satellite.cookie.set("' +
	      name +
	      '", "' +
	      value +
	      '"' +
	      optionsStr +
	      ').';

	    logger.deprecation(msg);
	    reactorCookie.set(name, value, options);
	  };

	  _satellite.readCookie = function (name) {
	    logger.deprecation(
	      '_satellite.readCookie is deprecated. ' +
	        'Please use _satellite.cookie.get("' +
	        name +
	        '").'
	    );
	    return reactorCookie.get(name);
	  };

	  _satellite.removeCookie = function (name) {
	    logger.deprecation(
	      '_satellite.removeCookie is deprecated. ' +
	        'Please use _satellite.cookie.remove("' +
	        name +
	        '").'
	    );
	    reactorCookie.remove(name);
	  };

	  _satellite.cookie = reactorCookie;

	  _satellite.pageBottom = function () {};

	  _satellite.setDebug = setDebugEnabled;

	  var warningLogged = false;

	  Object.defineProperty(_satellite, '_container', {
	    get: function () {
	      if (!warningLogged) {
	        logger.warn(
	          '_satellite._container may change at any time and should only ' +
	            'be used for debugging.'
	        );
	        warningLogged = true;
	      }

	      return container;
	    }
	  });
	};


	function isArrayReference(str) {
	  return (
	    typeof str === 'string' &&
	    str.indexOf('[') !== -1 &&
	    str.indexOf(']') !== -1
	  );
	}
	function sanitizeArrayKey(pathStrSegment) {
	  return pathStrSegment.substr(
	    0,
	    pathStrSegment.indexOf('[')
	  );
	}

	function traverseIntoSettings(pathSegments, settings, decorateWithDynamicHost) {
	  if (!pathSegments.length || !isPlainObject(settings)) {
	    return;
	  }

	  var currentKey = pathSegments[0];

	  if (pathSegments.length === 1) {
	    if (
	      settings.hasOwnProperty(currentKey) &&
	      typeof settings[currentKey] === 'string'
	    ) {
	      settings[currentKey] = decorateWithDynamicHost(settings[currentKey]);
	    }
	    return;
	  }

	  var remainingPathSegments = pathSegments.slice(1);
	  if (isArrayReference(currentKey)) {
	    currentKey = sanitizeArrayKey(currentKey);
	    var settingsValue = settings[currentKey];
	    if (Array.isArray(settingsValue)) {
	      settingsValue.forEach(function (arrayEntryObject) {
	        return traverseIntoSettings(
	          remainingPathSegments,
	          arrayEntryObject,
	          decorateWithDynamicHost
	        );
	      });
	    }
	  } else {
	    return traverseIntoSettings(
	      remainingPathSegments,
	      settings[currentKey],
	      decorateWithDynamicHost
	    );
	  }
	}

	var createSettingsFileTransformer = function (isDynamicEnforced, decorateWithDynamicHost) {
	  return function (settings, filePaths, moduleReferencePath) {
	    if (
	      !isDynamicEnforced ||
	      !isPlainObject(settings) ||
	      !Object.keys(settings).length ||
	      !Array.isArray(filePaths) ||
	      !filePaths.length
	    ) {
	      return settings;
	    }

	    filePaths.forEach(function (filePathString) {
	      var isAdobeCustomCodeAction = Boolean(
	        moduleReferencePath != null &&
	          /^core\/.*actions.*\/customCode\.js$/.test(moduleReferencePath)
	      );
	      if (
	        isAdobeCustomCodeAction &&
	        filePathString === 'source' &&
	        !settings.isExternal
	      ) {
	        return;
	      }

	      traverseIntoSettings(
	        filePathString.split('.'),
	        settings,
	        decorateWithDynamicHost
	      );
	    });

	    return settings;
	  };
	};















































	var _satellite = window._satellite;

	if (_satellite && !window.__satelliteLoaded) {
	  window.__satelliteLoaded = true;

	  var container = _satellite.container;

	  delete _satellite.container;

	  var buildInfo = reactorObjectAssign({}, container.buildInfo);
	  Object.defineProperty(buildInfo, 'environment', {
	    get: function () {
	      logger.deprecation(
	        'container.buildInfo.environment is deprecated.' +
	          'Please use `container.environment.stage` instead'
	      );
	      return container.environment.stage;
	    }
	  });
	  container.buildInfo = buildInfo;

	  var localStorage = getNamespacedStorage('localStorage');
	  var debugController = createDebugController(localStorage, logger);

	  var currentScriptSource = '';
	  if (reactorDocument.currentScript && reactorDocument.currentScript.getAttribute('src')) {
	    currentScriptSource = reactorDocument.currentScript.getAttribute('src');
	  }
	  var dynamicHostResolver;
	  try {
	    dynamicHostResolver = createDynamicHostResolver(
	      currentScriptSource,
	      Boolean(container.company.dynamicCdnEnabled),
	      container.company.cdnAllowList,
	      debugController
	    );
	  } catch (e) {
	    logger.warn('Please review the following error:');
	    throw e; 
	  }

	  var settingsFileTransformer = createSettingsFileTransformer(
	    dynamicHostResolver.isDynamicEnforced,
	    dynamicHostResolver.decorateWithDynamicHost
	  );

	  var moduleProvider = createModuleProvider();

	  var replaceTokens;

	  var undefinedVarsReturnEmpty =
	    container.property.settings.undefinedVarsReturnEmpty;
	  var ruleComponentSequencingEnabled =
	    container.property.settings.ruleComponentSequencingEnabled;

	  var dataElements = container.dataElements || {};

	  var getDataElementDefinition = function (name) {
	    return dataElements[name];
	  };

	  var proxyReplaceTokens = function () {
	    return replaceTokens.apply(null, arguments);
	  };

	  var getDataElementValue = createGetDataElementValue(
	    moduleProvider,
	    getDataElementDefinition,
	    proxyReplaceTokens,
	    undefinedVarsReturnEmpty,
	    settingsFileTransformer
	  );

	  var customVars = {};
	  var setCustomVar = createSetCustomVar(customVars);

	  var isVar = createIsVar(customVars, getDataElementDefinition);

	  var getVar = createGetVar(
	    customVars,
	    getDataElementDefinition,
	    getDataElementValue
	  );

	  replaceTokens = createReplaceTokens(isVar, getVar, undefinedVarsReturnEmpty);

	  hydrateSatelliteObject(
	    _satellite,
	    container,
	    debugController.setDebugEnabled,
	    getVar,
	    setCustomVar
	  );

	  hydrateModuleProvider(
	    container,
	    moduleProvider,
	    debugController,
	    replaceTokens,
	    getDataElementValue,
	    settingsFileTransformer,
	    dynamicHostResolver.decorateWithDynamicHost
	  );

	  var notifyMonitors = createNotifyMonitors(_satellite);
	  var executeDelegateModule = createExecuteDelegateModule(
	    moduleProvider,
	    replaceTokens,
	    settingsFileTransformer
	  );

	  var getModuleDisplayNameByRuleComponent =
	    createGetModuleDisplayNameByRuleComponent(moduleProvider);
	  var logConditionNotMet = createLogConditionNotMet(
	    getModuleDisplayNameByRuleComponent,
	    logger,
	    notifyMonitors
	  );
	  var logConditionError = createLogConditionError(
	    getRuleComponentErrorMessage,
	    getModuleDisplayNameByRuleComponent,
	    logger,
	    notifyMonitors
	  );
	  var logActionError = createLogActionError(
	    getRuleComponentErrorMessage,
	    getModuleDisplayNameByRuleComponent,
	    logger,
	    notifyMonitors
	  );
	  var logRuleCompleted = createLogRuleCompleted(logger, notifyMonitors);

	  var evaluateConditions = createEvaluateConditions(
	    executeDelegateModule,
	    isConditionMet,
	    logConditionNotMet,
	    logConditionError
	  );
	  var runActions = createRunActions(
	    executeDelegateModule,
	    logActionError,
	    logRuleCompleted
	  );
	  var executeRule = createExecuteRule(evaluateConditions, runActions);

	  var addConditionToQueue = createAddConditionToQueue(
	    executeDelegateModule,
	    normalizeRuleComponentError,
	    isConditionMet,
	    logConditionError,
	    logConditionNotMet
	  );
	  var addActionToQueue = createAddActionToQueue(
	    executeDelegateModule,
	    normalizeRuleComponentError,
	    logActionError
	  );
	  var addRuleToQueue = createAddRuleToQueue(
	    addConditionToQueue,
	    addActionToQueue,
	    logRuleCompleted
	  );

	  var triggerRule = createTriggerRule(
	    ruleComponentSequencingEnabled,
	    executeRule,
	    addRuleToQueue,
	    notifyMonitors
	  );

	  var getSyntheticEventMeta = createGetSyntheticEventMeta(moduleProvider);

	  var initEventModule = createInitEventModule(
	    triggerRule,
	    executeDelegateModule,
	    normalizeSyntheticEvent,
	    getRuleComponentErrorMessage,
	    getSyntheticEventMeta,
	    logger
	  );

	  initRules(buildRuleExecutionOrder, container.rules || [], initEventModule);
	}

	var src = _satellite;

	return src;

})();


